import {gql} from '@apollo/client'
import * as Apollo from '@apollo/client'
import {NoteSortingKey} from 'notability-services-common-universal'
import {NotificationType} from 'notability-services-common-universal'
import {GalleryNoteContentType} from 'notability-services-common-universal'
import {FlaggedReason} from 'notability-services-common-universal'
import {GalleryNotesAdminEventType} from 'notability-services-common-universal'
import {UsersAdminEventType} from 'notability-services-common-universal'
import {SearchFilter} from 'notability-services-common-universal'
import {CommentReviewState} from 'notability-services-common-universal'
import {ExperimentEnrollmentStrategy} from 'notability-services-common-universal'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>}
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never}
export type Incremental<T> = T | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never}
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string}
  String: {input: string; output: string}
  Boolean: {input: boolean; output: boolean}
  Int: {input: number; output: number}
  Float: {input: number; output: number}
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: {input: any; output: any}
  /** GqlUUID scalar type that converts all UUIDs to lowercase */
  GqlUUID: {input: any; output: any}
  InstitutionOrderBy: {input: any; output: any}
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: {input: any; output: any}
  /** QuizQuestionId scalar type that represents a unique identifier for a quiz question */
  QuizQuestionId: {input: any; output: any}
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: {input: any; output: any}
}

export type AsrJob = {
  __typename?: 'ASRJob'
  audioCreationDate?: Maybe<Scalars['DateTime']['output']>
  audioDurationMs?: Maybe<Scalars['Float']['output']>
  beamSize?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['DateTime']['output']
  errorReason?: Maybe<ErrorReason>
  extension: Scalars['String']['output']
  isHistorical: Scalars['Boolean']['output']
  language?: Maybe<Scalars['String']['output']>
  processorVersion: Scalars['Float']['output']
  quizJobs?: Maybe<Array<QuizJob>>
  results?: Maybe<AsrJobResults>
  sha512Hash: Scalars['String']['output']
  status: AsrJobStatus
  summaryJobs?: Maybe<Array<SummaryJob>>
  updatedAt: Scalars['DateTime']['output']
  uploadPolicy?: Maybe<Scalars['String']['output']>
  whisperImplementation: WhisperImplementation
}

export type AsrJobResult = {
  __typename?: 'ASRJobResult'
  errorCode?: Maybe<AsrErrorCode>
  job?: Maybe<AsrJob>
  retryAfter?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AsrJobResultSegment = {
  __typename?: 'ASRJobResultSegment'
  confidence: Scalars['Float']['output']
  endTime: Scalars['Float']['output']
  speaker?: Maybe<Scalars['String']['output']>
  startTime: Scalars['Float']['output']
  text: Scalars['String']['output']
}

export type AsrJobResults = {
  __typename?: 'ASRJobResults'
  language: Scalars['String']['output']
  segments: Array<AsrJobResultSegment>
  sha512Hash: Scalars['ID']['output']
  speakers?: Maybe<Array<AsrJobSpeaker>>
  text: Scalars['String']['output']
}

export type AsrJobSpeaker = {
  __typename?: 'ASRJobSpeaker'
  id: Scalars['String']['output']
}

export enum AsrJobStatus {
  Completed = 'COMPLETED',
  PermanentError = 'PERMANENT_ERROR',
  Processing = 'PROCESSING',
  TransientError = 'TRANSIENT_ERROR',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export type AsrProcessorVersion = {
  __typename?: 'ASRProcessorVersion'
  processorVersion: Scalars['Float']['output']
}

export type AcceptBusinessInvitationParams = {
  name?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
  userId: Scalars['ID']['input']
}

export type AcceptOrganizationInviteParams = {
  fullName?: InputMaybe<Scalars['String']['input']>
}

export type AcceptPublicBusinessInvitationParams = {
  name: Scalars['String']['input']
  token: Scalars['String']['input']
}

export enum AccessLevel {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type AccountType = {
  __typename?: 'AccountType'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  maxNumberOfNotes: Scalars['Int']['output']
  maxNumberOfPublishedNotes: Scalars['Int']['output']
  maxUploadSize: Scalars['Float']['output']
  name: Scalars['String']['output']
}

export type AchievementBadge = {
  __typename?: 'AchievementBadge'
  awardedAt: Scalars['DateTime']['output']
  tier: Scalars['Int']['output']
  type: AchievementBadgeType
}

export enum AchievementBadgeType {
  CalendarConnected = 'CALENDAR_CONNECTED',
  Chat = 'CHAT',
  CompleteFlashcards = 'COMPLETE_FLASHCARDS',
  LearnActivity = 'LEARN_ACTIVITY',
  PerfectMixAndMatch = 'PERFECT_MIX_AND_MATCH',
  PerfectQuiz = 'PERFECT_QUIZ',
  Recording = 'RECORDING'
}

export type AchievementsResponse = {
  __typename?: 'AchievementsResponse'
  allBadges: Array<AchievementBadge>
  newBadges: Array<AchievementBadge>
}

export type ActiveQuizSession = {
  __typename?: 'ActiveQuizSession'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  folderId?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  mode: QuizSessionMode
  noteId?: Maybe<Scalars['String']['output']>
  numAnswered: Scalars['Int']['output']
  numCorrect: Scalars['Int']['output']
  numIncorrect: Scalars['Int']['output']
  numQuestions: Scalars['Int']['output']
  numSkipped: Scalars['Int']['output']
  quizQuestions: Array<QuizQuestionUnion>
  sourceNoteIds?: Maybe<Array<Scalars['String']['output']>>
  spacedRepetitionDueCount?: Maybe<Scalars['Int']['output']>
  spacedRepetitionNewCount?: Maybe<Scalars['Int']['output']>
  studyMaterialsBatchId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type AddBusinessDomainParams = {
  businessId: Scalars['ID']['input']
  domain: Scalars['String']['input']
}

export type AddBusinessUserParam = {
  email: Scalars['String']['input']
  role: BusinessUserRole
}

export type AddBusinessUsersParams = {
  businessId: Scalars['ID']['input']
  users: Array<AddBusinessUserParam>
}

export type AddBusinessUsersResponse = {
  __typename?: 'AddBusinessUsersResponse'
  created: Array<CreatedBusinessUser>
  failed: Array<FailedBusinessUser>
}

export type AddBusinessUsersResponseV2 = {
  __typename?: 'AddBusinessUsersResponseV2'
  created: Array<CreatedBusinessUser>
  failed: FailedBusinessUsersByReasonV2
}

export type AddNotePermissionsByEmailRequest = {
  noteId: Scalars['String']['input']
  permissions: Array<NotePermissionRequest>
}

export type AddNotePermissionsByEmailResponse = {
  __typename?: 'AddNotePermissionsByEmailResponse'
  created: Array<NotePermissionSuccess>
  failed: Array<NotePermissionFailure>
}

export type AddNoteToCollectionParams = {
  id: Scalars['String']['input']
  noteId: Scalars['String']['input']
}

export type AddOrganizationAdminParams = {
  fullName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  organizationAdminEmail: Scalars['String']['input']
  organizationId: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
}

export type AddOrganizationOwnerParams = {
  fullName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  organizationId: Scalars['String']['input']
  organizationOwnerEmail: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
}

export type AddOrganizationUserInput = {
  email: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  role: Scalars['String']['input']
}

export type AddOrganizationUserOutput = {
  __typename?: 'AddOrganizationUserOutput'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  role: Scalars['String']['output']
}

export type AddOrganizationUsersParams = {
  users: Array<AddOrganizationUserInput>
}

export type AddOrganizationUsersResponse = {
  __typename?: 'AddOrganizationUsersResponse'
  created: Array<AddOrganizationUserOutput>
  failed: Array<AddOrganizationUserOutput>
}

export type AddRecoveryEmailParams = {
  recoveryEmail: Scalars['String']['input']
}

export type AddSubscriberQuotaDummyUsageParams = {
  llmCost?: InputMaybe<Scalars['Float']['input']>
  numLiveTranscriptionSeconds?: InputMaybe<Scalars['Float']['input']>
  numQuestions?: InputMaybe<Scalars['Float']['input']>
  numSummaries?: InputMaybe<Scalars['Float']['input']>
  subscriberId: Scalars['ID']['input']
}

export type AddToStudyMaterialsBatchParams = {
  additionalFlashcards?: InputMaybe<Scalars['Float']['input']>
  additionalQuizQuestions?: InputMaybe<Scalars['Float']['input']>
  isShared?: InputMaybe<Scalars['Boolean']['input']>
  studyMaterialsBatchId: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type AddWorkspaceUserOutput = {
  __typename?: 'AddWorkspaceUserOutput'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  permissionLevel: WorkspacePermissionLevels
  reason?: Maybe<Scalars['String']['output']>
}

export type AddWorkspaceUsersInput = {
  email: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  permissionLevel: WorkspacePermissionLevels
}

export type AddWorkspaceUsersParams = {
  users: Array<AddWorkspaceUsersInput>
  workspaceId: Scalars['String']['input']
}

export type AddWorkspaceUsersResponse = {
  __typename?: 'AddWorkspaceUsersResponse'
  created: Array<AddWorkspaceUserOutput>
  failed: Array<AddWorkspaceUserOutput>
}

export type AdminEventSearchParams = {
  offset?: InputMaybe<Scalars['Float']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  userId: Scalars['String']['input']
}

export type AdminFuzzyUserSearchParams = {
  limit: Scalars['Float']['input']
  query: Scalars['String']['input']
  searchType?: InputMaybe<Scalars['String']['input']>
}

export type AdminGetCurrentLearnUsageParams = {
  subscriptionId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type AdminGetSendGridSuppressionsParams = {
  email: Scalars['String']['input']
}

export type AdminGetSubscriptionOverviewParams = {
  deviceId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type AdminGetUserDataParams = {
  email?: InputMaybe<Scalars['String']['input']>
  screenname?: InputMaybe<Scalars['String']['input']>
  transactionId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type AdminLearnQuotaCalculation = {
  __typename?: 'AdminLearnQuotaCalculation'
  cost: AdminLearnQuotaUsage
  mode: Scalars['String']['output']
  questions: AdminLearnQuotaUsage
}

export type AdminLearnQuotaCounts = {
  __typename?: 'AdminLearnQuotaCounts'
  quizCount: Scalars['Float']['output']
  summaryCount: Scalars['Float']['output']
}

export type AdminLearnQuotaResponse = {
  __typename?: 'AdminLearnQuotaResponse'
  calculation: AdminLearnQuotaCalculation
  counts: AdminLearnQuotaCounts
  quotaWindowStart: Scalars['DateTime']['output']
  usage: LearnQuotaUsage
}

export type AdminLearnQuotaUsage = {
  __typename?: 'AdminLearnQuotaUsage'
  hasExceededLearnQuotaUsage: Scalars['Boolean']['output']
  limit: Scalars['Float']['output']
  quotaUsagePercentage: Scalars['Float']['output']
  used: Scalars['Float']['output']
}

export type AdminSearchNoteWithTitleParams = {
  ownerId?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  userId?: InputMaybe<Scalars['String']['input']>
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type AdminSearchNoteWithTitleResponse = {
  __typename?: 'AdminSearchNoteWithTitleResponse'
  notes: Array<CollabNoteMetadata>
}

export type AdminSyncBusinessSubscriptionParams = {
  businessId: Scalars['ID']['input']
}

export type AdminUpdateBusinessSubscriptionParams = {
  businessId: Scalars['ID']['input']
  cancelAt?: InputMaybe<Scalars['Timestamp']['input']>
  canceledAt?: InputMaybe<Scalars['Timestamp']['input']>
  endedAt?: InputMaybe<Scalars['Timestamp']['input']>
  isTrialPeriod?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<StripeSubscriptionStatus>
  stripePriceId?: InputMaybe<Scalars['String']['input']>
  stripeProductId?: InputMaybe<Scalars['String']['input']>
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>
  subscriptionRenewalDate?: InputMaybe<Scalars['Timestamp']['input']>
  tier?: InputMaybe<StripeBusinessSubscriptionTier>
  trialEndAt?: InputMaybe<Scalars['Timestamp']['input']>
  trialEndedAt?: InputMaybe<Scalars['Timestamp']['input']>
}

export type AdminUserOrganization = {
  __typename?: 'AdminUserOrganization'
  organization: OrganizationDetails
  role: OrganizationRole
  status: OrganizationUserStatus
}

export type AiProfile = {
  __typename?: 'AiProfile'
  fieldOfStudy?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  quizDifficulty?: Maybe<AiQuizDifficulty>
  summaryDetail?: Maybe<AiSummaryDetail>
}

export enum AiQuizDifficulty {
  Easier = 'EASIER',
  Harder = 'HARDER'
}

export enum AiSummaryDetail {
  Brief = 'BRIEF',
  Detailed = 'DETAILED'
}

export type AllIndustriesResults = {
  __typename?: 'AllIndustriesResults'
  industries: Array<IndustryDetails>
}

export type AllOrganizationResults = {
  __typename?: 'AllOrganizationResults'
  organizationCount: Scalars['Int']['output']
  organizations: Array<OrganizationDetails>
}

export type AllPermissionedUsersForNoteRequest = {
  noteId: Scalars['String']['input']
  states?: InputMaybe<Array<NoteUserPermissionRequestState>>
}

export type AllPermissionedUsersForNoteResponse = {
  __typename?: 'AllPermissionedUsersForNoteResponse'
  permissionRequests: Array<PermissionRequest>
  permissionedUsers: Array<PermissionedUser>
}

export type AndroidSubscription = {
  __typename?: 'AndroidSubscription'
  autoRenewEnabled?: Maybe<Scalars['Boolean']['output']>
  expiryTime: Scalars['DateTime']['output']
  isTestPurchase: Scalars['Boolean']['output']
  productId: Scalars['String']['output']
  startTime: Scalars['DateTime']['output']
}

export type AppSettingsResponse = {
  __typename?: 'AppSettingsResponse'
  appSettings?: Maybe<Scalars['JSONObject']['output']>
  errorCode?: Maybe<Scalars['Float']['output']>
  success: Scalars['Boolean']['output']
}

export type AppStoreClassicStatus = {
  __typename?: 'AppStoreClassicStatus'
  createdAt: Scalars['DateTime']['output']
  deviceId: Scalars['String']['output']
  id: Scalars['String']['output']
  likelyFraud: Scalars['Boolean']['output']
  originalApplicationVersion: Scalars['String']['output']
  originalPurchaseDate: Scalars['DateTime']['output']
  updatedAt: Scalars['DateTime']['output']
  user?: Maybe<User>
}

export type AppStoreReceipt = {
  __typename?: 'AppStoreReceipt'
  deviceId?: Maybe<Scalars['String']['output']>
  environment: Scalars['String']['output']
  id: Scalars['Float']['output']
  isValid: Scalars['Boolean']['output']
  originalTransactionId?: Maybe<Scalars['String']['output']>
  parsedReceipt?: Maybe<Scalars['JSONObject']['output']>
  receipt?: Maybe<Scalars['String']['output']>
  receiptCreationDate: Scalars['DateTime']['output']
  updatedAt: Scalars['DateTime']['output']
  user?: Maybe<User>
}

export type AppStoreSubscription = {
  __typename?: 'AppStoreSubscription'
  activeDeviceCount: Scalars['Int']['output']
  deviceLimitEnforcementEnabled: Scalars['Boolean']['output']
  devices: Array<AppStoreSubscriptionDevice>
  environment: Scalars['String']['output']
  expirationDate: Scalars['DateTime']['output']
  expirationIntent?: Maybe<ExpirationIntent>
  gracePeriodExpiresAt?: Maybe<Scalars['DateTime']['output']>
  isInBillingRetryPeriod: Scalars['Boolean']['output']
  isInIntroOfferPeriod: Scalars['Boolean']['output']
  isTrialPeriod: Scalars['Boolean']['output']
  offerCodeRefName?: Maybe<Scalars['String']['output']>
  originalPurchaseDate: Scalars['DateTime']['output']
  originalTransactionId: Scalars['String']['output']
  overDeviceLimit: Scalars['Boolean']['output']
  productId: Scalars['String']['output']
  promotionalOfferId?: Maybe<Scalars['String']['output']>
  refundedDate?: Maybe<Scalars['DateTime']['output']>
  refundedReason?: Maybe<Scalars['Int']['output']>
  status: Scalars['String']['output']
  subscriber?: Maybe<Subscriber>
  tier: Scalars['String']['output']
  user?: Maybe<User>
}

export type AppStoreSubscriptionDevice = {
  __typename?: 'AppStoreSubscriptionDevice'
  countryCode?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>
  deviceId: Scalars['String']['output']
  id: Scalars['String']['output']
  latestReceiptAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type AppleReceiptParams = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  deviceId?: InputMaybe<Scalars['String']['input']>
  receipt?: InputMaybe<Scalars['String']['input']>
}

export type ApproveCommentParams = {
  commentId: Scalars['String']['input']
}

export type ApprovedBusinessDomain = {
  __typename?: 'ApprovedBusinessDomain'
  businessId: Scalars['ID']['output']
  businessName: Scalars['String']['output']
  createdAt: Scalars['Timestamp']['output']
  domain: Scalars['String']['output']
  id: Scalars['ID']['output']
  ownerEmail?: Maybe<Scalars['String']['output']>
  ownerName?: Maybe<Scalars['String']['output']>
}

export type AskChatQuestionParams = {
  image?: InputMaybe<ChatQuestionImage>
  noteId: Scalars['String']['input']
  studyMaterialsBatchId: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
  text: Scalars['String']['input']
}

export enum AsrErrorCode {
  JobAlreadyProcessed = 'JOB_ALREADY_PROCESSED',
  JobNotFound = 'JOB_NOT_FOUND',
  JobProcessing = 'JOB_PROCESSING',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotSubscribed = 'NOT_SUBSCRIBED',
  QuotaExceeded = 'QUOTA_EXCEEDED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type AssociateAppStoreTransactionsParams = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  signedAppTransaction?: InputMaybe<Scalars['String']['input']>
  transactions: Array<Scalars['String']['input']>
}

export type AttestDeviceParamsInput = {
  androidId: Scalars['String']['input']
  certificateChainBase64: Array<Scalars['String']['input']>
  integrityTokenBase64?: InputMaybe<Scalars['String']['input']>
  nonce: Scalars['String']['input']
}

export type AuthParams = {
  authToken?: InputMaybe<Scalars['String']['input']>
}

export type BatchGetUserSurveyResponsesParams = {
  userIds: Array<Scalars['String']['input']>
}

export type BioParams = {
  bio?: InputMaybe<Scalars['String']['input']>
  etsyUsername?: InputMaybe<Scalars['String']['input']>
  instagramUsername?: InputMaybe<Scalars['String']['input']>
  tikTokUsername?: InputMaybe<Scalars['String']['input']>
  twitterUsername?: InputMaybe<Scalars['String']['input']>
  youtubeUrl?: InputMaybe<Scalars['String']['input']>
}

export type BulkDeleteCustomAssetsParams = {
  customAssetIds: Array<Scalars['String']['input']>
}

export type Business = {
  __typename?: 'Business'
  createdAt: Scalars['Timestamp']['output']
  customAssets?: Maybe<Array<CustomAssetMetadata>>
  domains?: Maybe<Array<BusinessDomainInfo>>
  featureConfig: BusinessFeatureConfig
  id: Scalars['ID']['output']
  industry: Scalars['String']['output']
  members: Array<BusinessPersona>
  name: Scalars['String']['output']
  userCounts?: Maybe<BusinessUserCounts>
}

export type BusinessMembersArgs = {
  businessMembersParams?: InputMaybe<BusinessMembersParams>
}

export type BusinessDomainInfo = {
  __typename?: 'BusinessDomainInfo'
  createdAt: Scalars['Timestamp']['output']
  domain: Scalars['String']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  status: BusinessDomainStatus
}

export enum BusinessDomainStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type BusinessFeatureConfig = {
  __typename?: 'BusinessFeatureConfig'
  aiDisabled: Scalars['Boolean']['output']
  allowedExportTypes: Array<Scalars['String']['output']>
  capturePhotoAllowed: Scalars['Boolean']['output']
  employeeNoteAccessAllowed: Scalars['Boolean']['output']
  intuneEnabled: Scalars['Boolean']['output']
  linkSharingAllowed: Scalars['Boolean']['output']
  noteGalleryAllowed: Scalars['Boolean']['output']
  photoLibraryAllowed: Scalars['Boolean']['output']
  /** @deprecated Renamed to employeeNoteAccessAllowed, which stores the permissive state as true. */
  restrictEmployeeNoteAccess: Scalars['Boolean']['output']
  ssoRequirement: SsoRequirement
  webClipAllowed: Scalars['Boolean']['output']
}

export type BusinessLead = {
  __typename?: 'BusinessLead'
  createdAt: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  industry: Scalars['String']['output']
  name: Scalars['String']['output']
  organizationName: Scalars['String']['output']
  termsAcceptedAt: Scalars['DateTime']['output']
  type: StripeBusinessSubscriptionTier
  updatedAt: Scalars['DateTime']['output']
}

export type BusinessMagicLink = {
  __typename?: 'BusinessMagicLink'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['ID']['output']
  priceId: Scalars['String']['output']
  updatedAt: Scalars['Timestamp']['output']
}

export type BusinessMembersParams = {
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type BusinessPersona = {
  __typename?: 'BusinessPersona'
  deactivated?: Maybe<Scalars['Boolean']['output']>
  deactivatedAt?: Maybe<Scalars['Timestamp']['output']>
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<BusinessUserRole>
  status?: Maybe<BusinessUserStatus>
  userId?: Maybe<Scalars['ID']['output']>
}

export type BusinessPilotCustomerRegistration = {
  __typename?: 'BusinessPilotCustomerRegistration'
  adminTitle: Scalars['String']['output']
  companyAddress: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  creatorEmail: Scalars['String']['output']
  creatorFirstName: Scalars['String']['output']
  creatorLastName: Scalars['String']['output']
  id: Scalars['String']['output']
  orgName: Scalars['String']['output']
  phoneNumber: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BusinessSubscription = {
  __typename?: 'BusinessSubscription'
  cancelAt?: Maybe<Scalars['DateTime']['output']>
  cancelAtUnixMs?: Maybe<Scalars['Timestamp']['output']>
  daysRemainingOnTrial?: Maybe<Scalars['Float']['output']>
  hasPaymentMethod?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  memberLimit: Scalars['Int']['output']
  status: StripeSubscriptionStatus
  stripeSubscriptionId: Scalars['String']['output']
  tier: StripeBusinessSubscriptionTier
  trialEndAt?: Maybe<Scalars['Timestamp']['output']>
}

export type BusinessUser = {
  __typename?: 'BusinessUser'
  role: BusinessUserRole
  status: BusinessUserStatus
  tokenExpiresAt?: Maybe<Scalars['Timestamp']['output']>
  user?: Maybe<User>
}

export type BusinessUserCounts = {
  __typename?: 'BusinessUserCounts'
  activeAdmins: Scalars['Int']['output']
  activeMembers: Scalars['Int']['output']
  activeOwners: Scalars['Int']['output']
  inactive: Scalars['Int']['output']
  pending: Scalars['Int']['output']
}

export type BusinessUserDeactivationFastTrackParams = {
  emails: Array<Scalars['String']['input']>
}

export type BusinessUserPersona = {
  __typename?: 'BusinessUserPersona'
  personaType: PersonaType
}

export enum BusinessUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum BusinessUserStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Invited = 'INVITED'
}

export enum BusinessUserStatusFilter {
  Accepted = 'ACCEPTED',
  All = 'ALL',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Invited = 'INVITED'
}

export type CalendarEventInput = {
  /** Shared by every occurrence of a series; pass it unchanged from the calendar API */
  eventId: Scalars['String']['input']
  /** The occurrence's original start: an ISO 8601 date (2026-10-05) for an all-day event, or a date-time with an offset (2026-10-05T09:00:00-07:00) for a timed one. Omit or send null for a one-off event. */
  recurrenceId?: InputMaybe<Scalars['String']['input']>
}

export type CalendarEventNote = {
  __typename?: 'CalendarEventNote'
  eventId: Scalars['String']['output']
  noteId: Scalars['ID']['output']
  recurrenceId?: Maybe<Scalars['String']['output']>
}

export type CalendarLinks = {
  __typename?: 'CalendarLinks'
  folders: Array<CalendarSeriesFolder>
  notes: Array<CalendarEventNote>
}

export type CalendarSeriesFolder = {
  __typename?: 'CalendarSeriesFolder'
  eventId: Scalars['String']['output']
  folderId: Scalars['ID']['output']
}

export type CancelUserTrialSubscriptionParams = {
  trialUserId?: InputMaybe<Scalars['String']['input']>
}

export type Category = {
  __typename?: 'Category'
  contentType: GalleryContentType
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  /** @deprecated Categories are deprecated */
  isDefaultForPublishing: Scalars['Boolean']['output']
  /** @deprecated Categories are deprecated */
  localizedName: Scalars['String']['output']
  name: Scalars['String']['output']
  parentId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type ChangeAdminStatusParams = {
  isAdmin: Scalars['Boolean']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
}

export type ChangeBlockStatusParams = {
  doBlock: Scalars['Boolean']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
}

export type ChangeBusinessOwnerParams = {
  existingOwnerEmail: Scalars['String']['input']
  newOwnerEmail: Scalars['String']['input']
  newOwnerStripeSubscriptionId: Scalars['String']['input']
}

export type ChangeEmailParams = {
  email: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
}

export type ChangeScreennameParams = {
  newScreenname: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
}

export type ChatQuestionImage = {
  imageBase64Data: Scalars['String']['input']
  mimeType: Scalars['String']['input']
}

export type ChatbotThread = {
  __typename?: 'ChatbotThread'
  cacheCreationInputTokensUsed: Scalars['Int']['output']
  cacheReadInputTokensUsed: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  exchangeCount: Scalars['Int']['output']
  id: Scalars['String']['output']
  inputTokensUsed: Scalars['Int']['output']
  outputTokensUsed: Scalars['Int']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CheckEnrollmentAvailabilityParams = {
  clientId: Scalars['String']['input']
}

export type CollabDeleteLibraryParams = {
  userId: Scalars['String']['input']
}

export type CollabDevice = {
  __typename?: 'CollabDevice'
  deviceId: Scalars['String']['output']
  platform: Scalars['String']['output']
  users: Array<User>
}

export type CollabNoteEditor = {
  __typename?: 'CollabNoteEditor'
  deviceId: Scalars['String']['output']
  id: Scalars['ID']['output']
  note: CollabNoteMetadata
  permissions: CollabNotePermission
  platform?: Maybe<Scalars['String']['output']>
  siteId: Scalars['Float']['output']
  user: User
}

export enum CollabNoteIndexType {
  Handwriting = 'HANDWRITING',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Recording = 'RECORDING',
  Text = 'TEXT'
}

export type CollabNoteMetadata = {
  __typename?: 'CollabNoteMetadata'
  accessLevel: AccessLevel
  createdAt: Scalars['Timestamp']['output']
  deletedAt?: Maybe<Scalars['Timestamp']['output']>
  editors: Array<CollabNoteEditor>
  id: Scalars['String']['output']
  legacyNoteId?: Maybe<Scalars['String']['output']>
  mediaInsertions: Array<NoteMediaInsertion>
  mostRecentOpTime?: Maybe<Scalars['Timestamp']['output']>
  owner: User
  ownerId: Scalars['String']['output']
  permanentlyDeletedAt?: Maybe<Scalars['Timestamp']['output']>
  permissionRequests: Array<NoteUserPermissionRequest>
  /** @deprecated Use permissionScopeV2 instead */
  permissionScope: PermissionScope
  permissionScopeV2: PermissionScopeV2
  permissions: Array<CollabNotePermission>
  serverPublishTime: Scalars['Float']['output']
  subject?: Maybe<Subject>
  thumbnail?: Maybe<CollabNoteThumbnail>
  title?: Maybe<Scalars['String']['output']>
  titleOpLogicalTime?: Maybe<Scalars['Float']['output']>
  titleOpSiteId?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
  users: Array<CollabNoteUserMetadata>
  workspace: WorkspaceEntity
  workspaceId: Scalars['String']['output']
}

export type CollabNotePermission = {
  __typename?: 'CollabNotePermission'
  id: Scalars['ID']['output']
  note: CollabNoteMetadata
  role: CollabNoteRole
  user: User
}

export enum CollabNoteRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type CollabNoteThumbnail = {
  __typename?: 'CollabNoteThumbnail'
  id: Scalars['String']['output']
}

export type CollabNoteUserMetadata = {
  __typename?: 'CollabNoteUserMetadata'
  id: Scalars['ID']['output']
  isFavorited: Scalars['Boolean']['output']
  lastOpened?: Maybe<Scalars['Timestamp']['output']>
  note: CollabNoteMetadata
  noteId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export type CollabTestDataParams = {
  breadth: Scalars['Float']['input']
  depth: Scalars['Float']['input']
}

export type College = {
  __typename?: 'College'
  country: Scalars['String']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  website: Scalars['String']['output']
}

export type CollegeMajor = {
  __typename?: 'CollegeMajor'
  code: Scalars['Int']['output']
  major: Scalars['String']['output']
}

export type Comment = {
  __typename?: 'Comment'
  approvalState?: Maybe<CommentReviewState>
  author: User
  commentText: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  galleryNote: GalleryNote
  id: Scalars['ID']['output']
  parent?: Maybe<Comment>
  rejectionReason?: Maybe<Scalars['String']['output']>
  reviewedBy?: Maybe<User>
  updatedAt: Scalars['DateTime']['output']
}

export {CommentReviewState}

export type ConnectOAuthAccountParams = {
  authCode: Scalars['String']['input']
  codeVerifier?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<OAuthProvider>
  redirectUri?: InputMaybe<Scalars['String']['input']>
}

export type CreateAsrJobParams = {
  audioCreationDateMs: Scalars['Float']['input']
  audioDurationMs?: InputMaybe<Scalars['Float']['input']>
  deviceId?: InputMaybe<Scalars['String']['input']>
  extension?: InputMaybe<Scalars['String']['input']>
  generateStudyJobs?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  recordingCount?: InputMaybe<Scalars['Int']['input']>
  sha512Hash: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type CreateBusinessLeadParams = {
  email: Scalars['String']['input']
  industry: Scalars['String']['input']
  name: Scalars['String']['input']
  organizationName: Scalars['String']['input']
  termsAcceptedAt: Scalars['DateTime']['input']
  type: StripeBusinessSubscriptionTier
}

export type CreateBusinessParams = {
  industryId: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type CreateBusinessResponse = {
  __typename?: 'CreateBusinessResponse'
  business: Business
}

export type CreateCommentParams = {
  commentText: Scalars['String']['input']
  galleryNoteId: Scalars['String']['input']
}

export type CreateDivider = {
  id: Scalars['String']['input']
  legacyOrganizerId?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['String']['input']>
  siblingOrder: Scalars['Float']['input']
  title: Scalars['String']['input']
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type CreateFolder = {
  emoji?: InputMaybe<Scalars['String']['input']>
  hexColor: Scalars['String']['input']
  id: Scalars['String']['input']
  isLocked: Scalars['Boolean']['input']
  legacyOrganizerId?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['String']['input']>
  siblingOrder: Scalars['Float']['input']
  title: Scalars['String']['input']
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type CreateMagicLinkParams = {
  email: Scalars['String']['input']
  isFromWebApp?: InputMaybe<Scalars['Boolean']['input']>
  isRedeem?: InputMaybe<Scalars['Boolean']['input']>
  period?: InputMaybe<Scalars['String']['input']>
  referralCode?: InputMaybe<Scalars['String']['input']>
  signUp: Scalars['Boolean']['input']
  tier?: InputMaybe<Scalars['String']['input']>
  vanityCode?: InputMaybe<Scalars['String']['input']>
}

export type CreateNote = {
  createdAt: Scalars['Timestamp']['input']
  deviceId: Scalars['String']['input']
  folderId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  isFavorited?: InputMaybe<Scalars['Boolean']['input']>
  lastOpened?: InputMaybe<Scalars['Timestamp']['input']>
  legacyNoteId?: InputMaybe<Scalars['String']['input']>
  linkAccessLevel: AccessLevel
  linkPermissionScope: PermissionScope
  subjectId?: InputMaybe<Scalars['String']['input']>
  templateId?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type CreateNoteCollectionParams = {
  isOfficialContent?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  officialCollectionId?: InputMaybe<Scalars['String']['input']>
}

export type CreateOrgParams = {
  comments?: InputMaybe<Scalars['String']['input']>
  contractAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>
  creatorEmail: Scalars['String']['input']
  creatorFullName?: InputMaybe<Scalars['String']['input']>
  creatorJobTitle?: InputMaybe<Scalars['String']['input']>
  educationLevelsProvided?: InputMaybe<Array<EducationLevel>>
  industry?: InputMaybe<Scalars['String']['input']>
  isAsmEnrolled?: InputMaybe<Scalars['Boolean']['input']>
  mdmPlatform?: InputMaybe<Scalars['String']['input']>
  orgName: Scalars['String']['input']
  organizationType?: InputMaybe<OrganizationType>
  phone?: InputMaybe<Scalars['String']['input']>
  seatCount: Scalars['Int']['input']
}

export type CreatePublicBusinessInvitationParams = {
  businessId: Scalars['ID']['input']
}

export type CreateSubject = {
  emoji?: InputMaybe<Scalars['String']['input']>
  hexColor: Scalars['String']['input']
  id: Scalars['String']['input']
  isLocked: Scalars['Boolean']['input']
  legacyOrganizerId?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['String']['input']>
  siblingOrder: Scalars['Float']['input']
  title: Scalars['String']['input']
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type CreateTestBusinessParams = {
  customerId?: InputMaybe<Scalars['String']['input']>
  industry: Scalars['String']['input']
  name: Scalars['String']['input']
  ownerEmail: Scalars['String']['input']
}

export type CreateTestBusinessResponse = {
  __typename?: 'CreateTestBusinessResponse'
  business: Business
  owner: User
}

export type CreateTrialSubscriptionParams = {
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>
  trialLengthInDays?: InputMaybe<Scalars['Float']['input']>
  trialUserId: Scalars['String']['input']
}

export type CreateVppEmailDomainParams = {
  emailDomain: Scalars['String']['input']
}

export type CreateWorkspaceInput = {
  defaultPermissionLevel?: InputMaybe<WorkspacePermissionLevels>
  description: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type CreatedBusinessUser = {
  __typename?: 'CreatedBusinessUser'
  email: Scalars['String']['output']
  emailSent: Scalars['Boolean']['output']
  role: BusinessUserRole
  userId: Scalars['String']['output']
}

export type CustomAssetMetadata = {
  __typename?: 'CustomAssetMetadata'
  businessId?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  legacyAssetId?: Maybe<Scalars['String']['output']>
  mediaUpload: MediaUploadStatus
  name: Scalars['String']['output']
  type: CustomAssetType
  updatedAt?: Maybe<Scalars['Timestamp']['output']>
  userId: Scalars['String']['output']
}

export type CustomAssetQueryParams = {
  type?: InputMaybe<CustomAssetType>
}

export type CustomAssetQueryResult = {
  __typename?: 'CustomAssetQueryResult'
  stickers: Array<CustomAssetMetadata>
  templates: Array<CustomAssetMetadata>
}

export enum CustomAssetType {
  Sticker = 'STICKER',
  Template = 'TEMPLATE'
}

export type DeactivateBusinessUserParams = {
  businessId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type DeactivateBusinessUserResponse = {
  __typename?: 'DeactivateBusinessUserResponse'
  deactivatedAt: Scalars['Timestamp']['output']
}

export type DeactivateOrganizationUsersParams = {
  deactivateUserEmails: Array<Scalars['String']['input']>
  orgId: Scalars['String']['input']
}

export type DegradedStateParams = {
  setDegraded: Scalars['Boolean']['input']
}

export type DeleteChatbotThreadParams = {
  chatbotThreadId: Scalars['String']['input']
}

export type DeleteCommentParams = {
  commentId: Scalars['String']['input']
}

export type DeleteCustomAssetParams = {
  customAssetId: Scalars['String']['input']
}

export type DeleteExperimentParams = {
  id: Scalars['String']['input']
}

export type DeleteFolder = {
  childrenHash?: InputMaybe<Scalars['String']['input']>
  deleteNotes?: InputMaybe<Scalars['Boolean']['input']>
  folderId: Scalars['String']['input']
}

export type DeleteGlobalOverrideValueParams = {
  key: Scalars['String']['input']
}

export type DeleteNote = {
  noteId: Scalars['String']['input']
}

export type DeleteNoteCollectionParams = {
  id: Scalars['String']['input']
}

export type DeleteOrganizer = {
  childrenHash?: InputMaybe<Scalars['String']['input']>
  deleteNotes?: InputMaybe<Scalars['Boolean']['input']>
  organizerId: Scalars['String']['input']
}

export type DeletePromoParams = {
  id: Scalars['String']['input']
}

export type DeleteSubscriptionOverrideParams = {
  /** (Optional) The reason for removing the override */
  notes?: InputMaybe<Scalars['String']['input']>
  /** The id of the override to delete */
  overrideId: Scalars['String']['input']
}

export type DeleteVppEmailDomainParams = {
  emailDomain: Scalars['String']['input']
}

export type DeleteWorkspace = {
  workspaceId: Scalars['String']['input']
}

export type DeleteWorkspaceInput = {
  workspaceId: Scalars['String']['input']
}

export type DenyBusinessJoinRequestParams = {
  businessId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

export type DenyNoteAccessInput = {
  notePermissionRequestId: Scalars['String']['input']
}

export type DesktopStatus = {
  __typename?: 'DesktopStatus'
  arches?: Maybe<Array<Scalars['String']['output']>>
  blocks: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<User>
  id: Scalars['ID']['output']
  message: Scalars['JSONObject']['output']
  operatorNote: Scalars['String']['output']
  platforms?: Maybe<Array<Scalars['String']['output']>>
  removedAt?: Maybe<Scalars['DateTime']['output']>
  showAboveVersion?: Maybe<Scalars['String']['output']>
  showBelowVersion?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
  url: Scalars['String']['output']
  versions?: Maybe<Array<Scalars['String']['output']>>
}

export type DesktopStatusContextParams = {
  arch?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

export type DesktopStatusParams = {
  arches?: InputMaybe<Array<Scalars['String']['input']>>
  blocks: Scalars['Boolean']['input']
  id?: InputMaybe<Scalars['String']['input']>
  message: Scalars['JSONObject']['input']
  operatorNote: Scalars['String']['input']
  platforms?: InputMaybe<Array<Scalars['String']['input']>>
  showAboveVersion?: InputMaybe<Scalars['String']['input']>
  showBelowVersion?: InputMaybe<Scalars['String']['input']>
  url: Scalars['String']['input']
  versions?: InputMaybe<Array<Scalars['String']['input']>>
}

export type DesktopStatusPreview = {
  __typename?: 'DesktopStatusPreview'
  blocks: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  shows: Scalars['Boolean']['output']
  suppressedBy?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type DeviceAttestationChallenge = {
  __typename?: 'DeviceAttestationChallenge'
  nonce: Scalars['String']['output']
}

export type DeviceAttestationVerdict = {
  __typename?: 'DeviceAttestationVerdict'
  attested: Scalars['Boolean']['output']
  brand?: Maybe<Scalars['String']['output']>
  model?: Maybe<Scalars['String']['output']>
  refusalReason?: Maybe<Scalars['String']['output']>
}

export type DeviceTrialContextInput = {
  installSource?: InputMaybe<Scalars['String']['input']>
  isSystemUser?: InputMaybe<Scalars['Boolean']['input']>
}

export type DeviceTrialOffer = {
  __typename?: 'DeviceTrialOffer'
  available: Scalars['Boolean']['output']
  mayRetry: Scalars['Boolean']['output']
  refusalReason?: Maybe<Scalars['String']['output']>
}

export type DeviceTrialRedemption = {
  __typename?: 'DeviceTrialRedemption'
  mayRetry: Scalars['Boolean']['output']
  redeemed: Scalars['Boolean']['output']
  refusalReason?: Maybe<Scalars['String']['output']>
}

export type DisableDevicesForSubscriptionsParams = {
  transactionId: Scalars['String']['input']
}

export type DisconnectOAuthAccountParams = {
  id: Scalars['ID']['input']
}

export type DiscoverFeedParams = {
  language?: InputMaybe<Scalars['String']['input']>
  notesPerRow?: InputMaybe<Scalars['Int']['input']>
  tagRowCount?: InputMaybe<Scalars['Int']['input']>
}

export type DiscoverFeedRow = {
  __typename?: 'DiscoverFeedRow'
  collectionId?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  kind: DiscoverRowKind
  notes: Array<GalleryNote>
  title: Scalars['String']['output']
}

export enum DiscoverRowKind {
  Collection = 'COLLECTION',
  Tag = 'TAG',
  Templates = 'TEMPLATES'
}

export type DiscussionDialogueChoice = {
  __typename?: 'DiscussionDialogueChoice'
  conceptsCovered?: Maybe<Array<Scalars['String']['output']>>
  id: Scalars['String']['output']
  preResponse?: Maybe<Scalars['String']['output']>
  preResponseMood?: Maybe<Scalars['String']['output']>
  scriptAction?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  topicId?: Maybe<Scalars['String']['output']>
}

export type DiscussionDialogueNode = {
  __typename?: 'DiscussionDialogueNode'
  choices: Array<DiscussionDialogueChoice>
  expressionMood?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  writeInPrompt?: Maybe<Scalars['String']['output']>
}

export type DiscussionHistoryEntryInput = {
  speaker: Scalars['String']['input']
  text: Scalars['String']['input']
}

export type DiscussionTopic = {
  __typename?: 'DiscussionTopic'
  concepts: Array<Scalars['String']['output']>
  id: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type DiscussionTopicInput = {
  concepts: Array<Scalars['String']['input']>
  conceptsCovered: Array<Scalars['String']['input']>
  id: Scalars['String']['input']
  title: Scalars['String']['input']
}

export type Divider = {
  __typename?: 'Divider'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  legacyOrganizerId?: Maybe<Scalars['String']['output']>
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']['output']>
  siblingOrder: Scalars['Float']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
  workspace: WorkspaceEntity
  workspaceId: Scalars['ID']['output']
}

export type DowngradeBusinessUserParams = {
  businessId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type DowngradeBusinessUserResponse = {
  __typename?: 'DowngradeBusinessUserResponse'
  success: Scalars['Boolean']['output']
}

export type DownloadCustomAssetParams = {
  customAssetId: Scalars['String']['input']
}

export type DownloadCustomAssetResult = {
  __typename?: 'DownloadCustomAssetResult'
  mediaDownloadSignedUrl: Scalars['String']['output']
}

export type DownloadedGalleryNote = {
  __typename?: 'DownloadedGalleryNote'
  createdAt: Scalars['DateTime']['output']
  galleryNote: GalleryNote
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export type EditBusinessUserRoleFailure = {
  __typename?: 'EditBusinessUserRoleFailure'
  email: Scalars['String']['output']
  reason: Scalars['String']['output']
  role: BusinessUserRole
}

export type EditBusinessUserRoleInput = {
  email: Scalars['String']['input']
  role: BusinessUserRole
}

export type EditBusinessUserRoleResponse = {
  __typename?: 'EditBusinessUserRoleResponse'
  failures: Array<EditBusinessUserRoleFailure>
  successes: Array<EditBusinessUserRoleSuccess>
}

export type EditBusinessUserRoleSuccess = {
  __typename?: 'EditBusinessUserRoleSuccess'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  role: BusinessUserRole
  status: BusinessUserStatus
  userId: Scalars['ID']['output']
}

export type EditParams = {
  commentsEnabled: Scalars['Boolean']['input']
  contentType: Scalars['String']['input']
  description: Scalars['String']['input']
  id: Scalars['String']['input']
  language?: InputMaybe<Scalars['String']['input']>
  noteName: Scalars['String']['input']
  tags: Array<Scalars['String']['input']>
}

export type EditUserWorkspacePermissionRequest = {
  email: Scalars['String']['input']
  level: WorkspacePermissionLevels
  workspaceId: Scalars['String']['input']
}

export type EditWorkspaceInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  setPermissionLevel?: InputMaybe<SetDefaultPermissionLevel>
  workspaceId: Scalars['String']['input']
}

export enum EducationLevel {
  ContinuingEducation = 'CONTINUING_EDUCATION',
  K_12 = 'K_12',
  Other = 'OTHER',
  PostGraduate = 'POST_GRADUATE',
  University = 'UNIVERSITY',
  Vocational = 'VOCATIONAL'
}

export type EducatorUserPersona = {
  __typename?: 'EducatorUserPersona'
  personaType: PersonaType
}

export type EligibleBusinessDomain = {
  __typename?: 'EligibleBusinessDomain'
  businessId: Scalars['ID']['output']
  businessName: Scalars['String']['output']
}

export type EnableGalleryAccessParams = {
  clientId?: InputMaybe<Scalars['String']['input']>
}

export type EnrollmentLimits = {
  __typename?: 'EnrollmentLimits'
  clientId: Scalars['ID']['output']
  /** @deprecated Legacy support for link sharing. Always returns true. */
  enabled: Scalars['Boolean']['output']
  /** @deprecated Legacy support for note gallery. Always returns true. */
  noteGalleryEnabled: Scalars['Boolean']['output']
}

export enum ErrorCode {
  InvalidMutation = 'InvalidMutation',
  InvalidUuid = 'InvalidUUID',
  NotFound = 'NotFound',
  ServerError = 'ServerError',
  Unauthorized = 'Unauthorized'
}

export enum ErrorReason {
  AttemptsExhausted = 'ATTEMPTS_EXHAUSTED',
  SpeechNotDetected = 'SPEECH_NOT_DETECTED'
}

export type Experiment = {
  __typename?: 'Experiment'
  analyticsPanelUrl?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  enrolledUsers: Array<ExperimentEnrollment>
  enrollmentStrategy: ExperimentEnrollmentStrategy
  id: Scalars['ID']['output']
  targetEnrollmentPct: Scalars['Float']['output']
}

export type ExperimentData = {
  __typename?: 'ExperimentData'
  experiments: Array<ExperimentPlacement>
  values: Array<ExperimentValueOverride>
}

export type ExperimentDataParams = {
  anonymousId?: InputMaybe<Scalars['String']['input']>
  buildNumber?: InputMaybe<Scalars['Float']['input']>
  languageCode?: InputMaybe<Scalars['String']['input']>
  subscriptionTier?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type ExperimentEnrollment = {
  __typename?: 'ExperimentEnrollment'
  anonymousId: Scalars['String']['output']
  experiment: Experiment
  id: Scalars['ID']['output']
  inVariantGroup: Scalars['Boolean']['output']
  isOverride: Scalars['Boolean']['output']
  user?: Maybe<User>
}

export type ExperimentEnrollmentOverrideQueryParams = {
  experimentId: Scalars['String']['input']
}

export type ExperimentEnrollmentParams = {
  experimentId: Scalars['String']['input']
  inVariantGroup: Scalars['Boolean']['input']
  screenname: Scalars['String']['input']
}

export {ExperimentEnrollmentStrategy}

export type ExperimentParams = {
  analyticsPanelUrl?: InputMaybe<Scalars['String']['input']>
  codeFilters?: InputMaybe<Array<Scalars['String']['input']>>
  description: Scalars['String']['input']
  enrollmentStrategy: ExperimentEnrollmentStrategy
  freeformValues?: InputMaybe<Array<ExperimentValueMapping>>
  id: Scalars['String']['input']
  matchType?: InputMaybe<Scalars['String']['input']>
  structuredValues?: InputMaybe<Array<ExperimentValueMapping>>
  targetEnrollmentPct?: InputMaybe<Scalars['Float']['input']>
}

export type ExperimentPlacement = {
  __typename?: 'ExperimentPlacement'
  experimentName: Scalars['String']['output']
  variantName: Scalars['String']['output']
}

export type ExperimentValueMapping = {
  controlVal: Scalars['String']['input']
  valueKey: Scalars['String']['input']
  variantVal: Scalars['String']['input']
}

export type ExperimentValueOverride = {
  __typename?: 'ExperimentValueOverride'
  parameterName: Scalars['String']['output']
  value: Scalars['String']['output']
}

export enum ExpirationIntent {
  BillingError = 'BILLING_ERROR',
  CustomerCancelled = 'CUSTOMER_CANCELLED',
  PriceIncreased = 'PRICE_INCREASED',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE',
  UnknownError = 'UNKNOWN_ERROR'
}

export type FailedBusinessUser = {
  __typename?: 'FailedBusinessUser'
  email: Scalars['String']['output']
  reason: Scalars['String']['output']
  role: BusinessUserRole
}

export type FailedBusinessUsersByReasonV2 = {
  __typename?: 'FailedBusinessUsersByReasonV2'
  businessUserAlreadyInvited: Array<Scalars['String']['output']>
  cannotBeInMultipleBusinesses: Array<Scalars['String']['output']>
  cannotInviteBusinessOwner: Array<Scalars['String']['output']>
  disposableEmailNotAllowed: Array<Scalars['String']['output']>
  emailValidationError: Array<Scalars['String']['output']>
}

export type FailedMutation = {
  __typename?: 'FailedMutation'
  error: ErrorCode
  errorInfo?: Maybe<Scalars['String']['output']>
  idempotencyKey: Scalars['String']['output']
}

export type FailedResendReason = {
  __typename?: 'FailedResendReason'
  businessUserAlreadyAcceptedInvite: Array<Scalars['String']['output']>
  businessUserAlreadyInvited: Array<Scalars['String']['output']>
  notInBusiness: Array<Scalars['String']['output']>
}

export type FavoriteNotesParams = {
  numberToGet?: InputMaybe<Scalars['Int']['input']>
}

export type FavoritedGalleryNotesParams = {
  contentType?: InputMaybe<GalleryNoteContentType>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type FeatureFlagEvaluation = {
  __typename?: 'FeatureFlagEvaluation'
  available: Scalars['Boolean']['output']
  flag: Scalars['String']['output']
  hasInternalAccess: Scalars['Boolean']['output']
  /** @deprecated optIn status was removed; always false */
  hasOptInAccess: Scalars['Boolean']['output']
  remoteValue: Scalars['String']['output']
  remoteValueSource: Scalars['String']['output']
  remotelyEnabled: Scalars['Boolean']['output']
  status: Scalars['String']['output']
}

export type FeatureFlagEvaluationParams = {
  flag: Scalars['String']['input']
  randomizationId?: InputMaybe<Scalars['String']['input']>
}

export type FeaturedCollectionsAndNotesParams = {
  limit: Scalars['Float']['input']
}

export type FillInTheBlank = {
  __typename?: 'FillInTheBlank'
  definition: Scalars['String']['output']
  questionId: Scalars['String']['output']
  questionIndex: Scalars['Int']['output']
  sourceNoteId?: Maybe<Scalars['String']['output']>
  status: QuizQuestionStatus
  term: Scalars['String']['output']
  type: QuizSessionQuestionType
  userResponseFillInTheBlank?: Maybe<Scalars['String']['output']>
}

export type FlagParams = {
  note: Scalars['String']['input']
  reason: Scalars['String']['input']
  reporterComment?: InputMaybe<Scalars['String']['input']>
}

export type FlagProfileParams = {
  profileSection: ProfileSection
  profileToFlagId: Scalars['String']['input']
  reason: Scalars['String']['input']
  reporterComment?: InputMaybe<Scalars['String']['input']>
}

export type FlaggedContent = {
  __typename?: 'FlaggedContent'
  context: Scalars['String']['output']
  flaggedTerm: Scalars['String']['output']
}

export type FlaggedNote = {
  __typename?: 'FlaggedNote'
  createdAt: Scalars['DateTime']['output']
  flaggedReason: FlaggedReason
  galleryNote: GalleryNote
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export {FlaggedReason}

export type Flashcard = {
  __typename?: 'Flashcard'
  definition: Scalars['String']['output']
  questionId: Scalars['String']['output']
  questionIndex: Scalars['Int']['output']
  sourceNoteId?: Maybe<Scalars['String']['output']>
  status: QuizQuestionStatus
  term: Scalars['String']['output']
  type: QuizSessionQuestionType
}

export type FlashcardContentInput = {
  flashcards: Array<QuizFlashcardInput>
}

export type FlashcardDueCount = {
  __typename?: 'FlashcardDueCount'
  dueCount: Scalars['Int']['output']
  noteId: Scalars['String']['output']
  truncated: Scalars['Boolean']['output']
}

export type FlashcardDueCountsParams = {
  noteIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum FlashcardRating {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM',
  Skip = 'SKIP'
}

export type Folder = {
  __typename?: 'Folder'
  color: Scalars['String']['output']
  createdAt: Scalars['Timestamp']['output']
  emoji?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  legacyOrganizerId?: Maybe<Scalars['String']['output']>
  locked: Scalars['Boolean']['output']
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']['output']>
  siblingOrder: Scalars['Float']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['Timestamp']['output']
  user: User
  workspace: WorkspaceEntity
  workspaceId: Scalars['ID']['output']
}

export type FolderQuizParams = {
  folderId: Scalars['String']['input']
  noteIds?: InputMaybe<Array<Scalars['String']['input']>>
  startNew?: InputMaybe<Scalars['Boolean']['input']>
}

export type FolderStudyConfig = {
  __typename?: 'FolderStudyConfig'
  enabled: Scalars['Boolean']['output']
  maxNotes: Scalars['Int']['output']
  minNotes: Scalars['Int']['output']
}

export type FollowPair = {
  __typename?: 'FollowPair'
  followedId: Scalars['String']['output']
  followerId: Scalars['String']['output']
  isFollowing: Scalars['Boolean']['output']
}

export type FollowParams = {
  userIdToFollow: Scalars['String']['input']
}

export type Following = {
  __typename?: 'Following'
  followed: User
}

export type FollowingMetadata = {
  __typename?: 'FollowingMetadata'
  createdAt: Scalars['DateTime']['output']
  newNotesAvailable: Scalars['Boolean']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export type FollowingUsersParameters = {
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type ForceResetMigrationsRequest = {
  userId: Scalars['String']['input']
}

export type FreeNamespaceParams = {
  pullRequestId: Scalars['Float']['input']
}

export type FullNameParams = {
  fullName: Scalars['String']['input']
}

export enum GalleryContentType {
  Any = 'ANY',
  Templates = 'TEMPLATES'
}

export type GalleryNote = {
  __typename?: 'GalleryNote'
  activeTags: Array<Scalars['String']['output']>
  adminEvents: Array<GalleryNoteAdminEvent>
  category?: Maybe<Category>
  clientId: Scalars['String']['output']
  collabNoteId?: Maybe<Scalars['String']['output']>
  commentsEnabled: Scalars['Boolean']['output']
  containsPencil: Scalars['Boolean']['output']
  containsStudyTape: Scalars['Boolean']['output']
  contentType: GalleryNoteContentType
  createdAt: Scalars['DateTime']['output']
  description: Scalars['String']['output']
  downloadURL: Scalars['String']['output']
  downloadedGalleryNotes: Array<DownloadedGalleryNote>
  downloads: Scalars['Float']['output']
  flaggedNotes: Array<FlaggedNote>
  id: Scalars['String']['output']
  isSubscriberForBackfill: Scalars['Boolean']['output']
  language?: Maybe<Scalars['String']['output']>
  likedGalleryNotes: Array<LikedGalleryNote>
  likes: Scalars['Float']['output']
  mentionedProfiles: Array<UserProfile>
  name: Scalars['String']['output']
  noteUploadedAt?: Maybe<Scalars['DateTime']['output']>
  notifications: Array<Notification>
  ntbUploadedAt?: Maybe<Scalars['DateTime']['output']>
  parentNoteId?: Maybe<Scalars['String']['output']>
  passedReviewAtFlagCount: Scalars['Float']['output']
  pdfUploadedAt?: Maybe<Scalars['DateTime']['output']>
  popularScore: Scalars['Float']['output']
  previewCount: Scalars['Float']['output']
  previewImages: Array<Scalars['String']['output']>
  previewUploadCount: Scalars['Float']['output']
  rating: Scalars['Float']['output']
  remixCount: Scalars['Float']['output']
  rootNoteId?: Maybe<Scalars['String']['output']>
  tags?: Maybe<Array<GalleryNoteTag>>
  trendingScoreCalculatedAt: Scalars['DateTime']['output']
  triageState: TriageState
  updatedAt: Scalars['DateTime']['output']
  url: Scalars['String']['output']
  user: User
  viewCount: Scalars['Float']['output']
}

export type GalleryNoteDownloadUrlArgs = {
  fileType: Scalars['String']['input']
}

export type GalleryNoteAdminEvent = {
  __typename?: 'GalleryNoteAdminEvent'
  createdAt: Scalars['DateTime']['output']
  eventType: GalleryNotesAdminEventType
  flaggedReason?: Maybe<FlaggedReason>
  galleryNote: GalleryNote
  galleryNoteName: Scalars['String']['output']
  id: Scalars['String']['output']
  systemNotes?: Maybe<Scalars['String']['output']>
  triggeringUser?: Maybe<User>
  triggeringUserEmail: Scalars['String']['output']
  triggeringUserNotes?: Maybe<Scalars['String']['output']>
}

export type GalleryNoteAndSimilar = {
  __typename?: 'GalleryNoteAndSimilar'
  note: GalleryNote
  similarNotes: Array<GalleryNote>
}

export type GalleryNoteAndSimilarParams = {
  id: Scalars['String']['input']
  language?: InputMaybe<Scalars['String']['input']>
  totalSimilarNotes?: InputMaybe<Scalars['Int']['input']>
}

export {GalleryNoteContentType}

export type GalleryNoteResults = {
  __typename?: 'GalleryNoteResults'
  results: Array<GalleryNote>
  totalCount: Scalars['Float']['output']
}

export type GalleryNoteTag = {
  __typename?: 'GalleryNoteTag'
  createdAt: Scalars['DateTime']['output']
  createdByUser?: Maybe<User>
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export {GalleryNotesAdminEventType}

export type GalleryProfileParams = {
  screenname: Scalars['String']['input']
}

export type GenerateCollabLinkParams = {
  noteId: Scalars['GqlUUID']['input']
  permission?: InputMaybe<Scalars['String']['input']>
}

export type GenerateDiscussionDialogueParams = {
  activeTopicId?: InputMaybe<Scalars['String']['input']>
  conversationHistory: Array<DiscussionHistoryEntryInput>
  justCompletedTopic?: InputMaybe<Scalars['Boolean']['input']>
  newConceptsBeingCovered?: InputMaybe<Array<Scalars['String']['input']>>
  noteContent: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
  topics?: InputMaybe<Array<DiscussionTopicInput>>
}

export type GenerateSiteIdParams = {
  deviceId: Scalars['GqlUUID']['input']
  noteId: Scalars['GqlUUID']['input']
}

export type GenerateStudyMaterialsBatchParams = {
  asrJobSha512Hashes?: InputMaybe<Array<Scalars['String']['input']>>
  clientNoteId?: InputMaybe<Scalars['String']['input']>
  delaySummary?: InputMaybe<Scalars['Boolean']['input']>
  existingBatchId?: InputMaybe<Scalars['String']['input']>
  handwrittenText?: InputMaybe<Scalars['String']['input']>
  includeFlashcards?: InputMaybe<Scalars['Boolean']['input']>
  includeQuizzes?: InputMaybe<Scalars['Boolean']['input']>
  isServerManaged?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  noteText?: InputMaybe<Scalars['String']['input']>
  numFlashcards?: InputMaybe<Scalars['Float']['input']>
  numQuizQuestions?: InputMaybe<Scalars['Float']['input']>
  pdfText?: InputMaybe<Scalars['String']['input']>
  promptGroup?: InputMaybe<Scalars['String']['input']>
  promptOptions?: InputMaybe<Array<Scalars['String']['input']>>
  studyMaterials?: InputMaybe<Array<StudyMaterialParams>>
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type GetAsrJobParams = {
  sha512Hash: Scalars['String']['input']
}

export type GetAllBusinessesItem = {
  __typename?: 'GetAllBusinessesItem'
  admin?: Maybe<BusinessUser>
  business: Business
  /** True when the owner is the only member and there are no shared libraries. */
  isEmpty: Scalars['Boolean']['output']
  /** Accepted, non-deactivated members, including the owner. */
  memberCount: Scalars['Int']['output']
  /** Shared libraries that have not been deleted. */
  sharedLibraryCount: Scalars['Int']['output']
  subscription?: Maybe<BusinessSubscription>
}

export type GetAllBusinessesParams = {
  adminEmail?: InputMaybe<Scalars['String']['input']>
  adminName?: InputMaybe<Scalars['String']['input']>
  businessName?: InputMaybe<Scalars['String']['input']>
  page: Scalars['Float']['input']
  pageSize: Scalars['Float']['input']
  sortOrder: Scalars['String']['input']
}

export type GetAllBusinessesResponse = {
  __typename?: 'GetAllBusinessesResponse'
  businessCount: Scalars['Float']['output']
  businesses: Array<GetAllBusinessesItem>
}

export type GetAllCommentsParams = {
  authorId?: InputMaybe<Scalars['String']['input']>
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
  reviewState?: InputMaybe<Scalars['String']['input']>
}

export type GetAllOrganizationsParams = {
  isApproved?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetAllSubscriptionInfoParams = {
  deviceId?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  transactionId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type GetAllSubscriptionsOverDeviceLimitParams = {
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

export type GetAllSubscriptionsOverDeviceLimitResult = {
  __typename?: 'GetAllSubscriptionsOverDeviceLimitResult'
  deviceLimitEnforcementEnabled: Scalars['Boolean']['output']
  numDevices: Scalars['Float']['output']
  subscriptionId: Scalars['String']['output']
}

export type GetBuildMetadataParams = {
  buildNamespace: Scalars['String']['input']
}

export type GetBuildMetadataResult = {
  __typename?: 'GetBuildMetadataResult'
  author: Scalars['String']['output']
  authorAvatar?: Maybe<Scalars['String']['output']>
  prBody: Scalars['String']['output']
  prLink: Scalars['String']['output']
  prNumber: Scalars['Float']['output']
  title: Scalars['String']['output']
}

export type GetCalendarLinksParams = {
  events: Array<CalendarEventInput>
}

export type GetChatHistoryParams = {
  noteId: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type GetChatbotThreadsParams = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type GetCollatedFlaggedNoteInfoParams = {
  userId: Scalars['ID']['input']
}

export type GetCollatedFlaggedNoteInfoResult = {
  __typename?: 'GetCollatedFlaggedNoteInfoResult'
  flaggedNotes: Array<GalleryNote>
  flaggingUser: User
}

export type GetCurrentQuotaUsageParams = {
  deviceId?: InputMaybe<Scalars['String']['input']>
  subscriptionId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type GetFuzzyScreennameMatchesParams = {
  limit: Scalars['Float']['input']
  screenname: Scalars['String']['input']
}

export type GetInstitutionsParams = {
  ascending: Scalars['Boolean']['input']
  institutionNameSearch: Scalars['String']['input']
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
  orderBy: Scalars['InstitutionOrderBy']['input']
}

export type GetInstitutionsResult = {
  __typename?: 'GetInstitutionsResult'
  count: Scalars['Float']['output']
  institutions: Array<InstitutionWithDeviceCount>
}

export type GetInvitedUserStatusParams = {
  token: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type GetInvitedUserStatusResponse = {
  __typename?: 'GetInvitedUserStatusResponse'
  migrated: Scalars['Boolean']['output']
}

export type GetLearnQuotaUsageParams = {
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type GetLibraryCountsParams = {
  userId: Scalars['ID']['input']
}

export type GetMigrationsParams = {
  userId: Scalars['ID']['input']
}

export type GetNoteRootCommentsParams = {
  limit: Scalars['Float']['input']
  noteId: Scalars['String']['input']
  offset: Scalars['Float']['input']
}

export type GetNotesParameters = {
  language?: InputMaybe<Scalars['String']['input']>
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

export type GetNotificationsParams = {
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

export type GetOpCountsParams = {
  noteId: Scalars['String']['input']
}

export type GetOrCreateSummaryJobParams = {
  clientNoteId: Scalars['String']['input']
  studyMaterialGroup?: InputMaybe<Scalars['String']['input']>
}

export type GetOrganizationParams = {
  organizationId: Scalars['String']['input']
}

export type GetQuizJobContentParams = {
  quizJobId: Scalars['String']['input']
}

export type GetQuizQuestionExplanationParams = {
  questionId?: InputMaybe<Scalars['QuizQuestionId']['input']>
  questionIndex?: InputMaybe<Scalars['Float']['input']>
  quizJobId?: InputMaybe<Scalars['String']['input']>
}

export type GetQuizSessionsParams = {
  folderId?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  noteId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<QuizSessionStatusFilter>
}

export type GetRecentReleasesParams = {
  tag: Scalars['String']['input']
}

export type GetSendGridEventsParams = {
  ascending: Scalars['Boolean']['input']
  email?: InputMaybe<Scalars['String']['input']>
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

export type GetStripeCustomerPortalParams = {
  redirectUrl: Scalars['String']['input']
}

export type GetStudyMaterialsBatchParams = {
  clientNoteId?: InputMaybe<Scalars['String']['input']>
  studyMaterialsBatchId?: InputMaybe<Scalars['String']['input']>
}

export type GetSubscriptionDisputeInfoParams = {
  /** A Stripe subscription id (sub_…) or a stripe_consumer_subscriptions.id uuid. */
  subscriptionId: Scalars['String']['input']
}

export type GetSubscriptionInfoParams = {
  userId: Scalars['String']['input']
}

export type GetSummaryJobContentParams = {
  summaryJobId: Scalars['String']['input']
}

export type GetTopTagParams = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
}

export type GetUnmigratedGalleryNotesParams = {
  ignoreIds?: InputMaybe<Array<Scalars['String']['input']>>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type GetUnmigratedGalleryNotesResult = {
  __typename?: 'GetUnmigratedGalleryNotesResult'
  notes: Array<UnmigratedGalleryNote>
}

export type GetUserIsFollowedParams = {
  followedId: Scalars['String']['input']
}

export type GetUserSharedNotesParams = {
  userId: Scalars['ID']['input']
}

export type GetUserTrialSubscriptionParams = {
  trialUserId?: InputMaybe<Scalars['String']['input']>
}

export type GetUsersForWorkspaceResponse = {
  __typename?: 'GetUsersForWorkspaceResponse'
  email: Scalars['String']['output']
  level: WorkspacePermissionLevels
  name?: Maybe<Scalars['String']['output']>
}

export type GetVppEmailDomainParams = {
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

export type GetViableSubscriptionParams = {
  subscriptionId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type GetWorkspaceUsersParams = {
  workspaceId: Scalars['ID']['input']
}

export enum GraduationTerm {
  Fall = 'FALL',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type GrantNoteAccessInput = {
  grantedRole: CollabNoteRole
  notePermissionRequestId: Scalars['String']['input']
}

export type GrantSubscriptionOverrideParams = {
  /** email of the user to grant the subscription to */
  email: Scalars['String']['input']
  expirationDate: Scalars['DateTime']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  overrideReason: Scalars['String']['input']
  overrideTier: SubscriptionTier
}

export type HiddenProfilesParams = {
  offset?: InputMaybe<Scalars['Float']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

export type HiddenProfilesResults = {
  __typename?: 'HiddenProfilesResults'
  results: Array<UserProfile>
  totalCount: Scalars['Float']['output']
}

export type HideCommentParams = {
  commentId: Scalars['String']['input']
  rejectionReason?: InputMaybe<Scalars['String']['input']>
}

export type IndexTimestamp = {
  __typename?: 'IndexTimestamp'
  lastUpdated: Scalars['Timestamp']['output']
  type: CollabNoteIndexType
}

export type IndustryDetails = {
  __typename?: 'IndustryDetails'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type InstitutionWithDeviceCount = {
  __typename?: 'InstitutionWithDeviceCount'
  createdAt: Scalars['DateTime']['output']
  deviceCount: Scalars['Int']['output']
  id: Scalars['String']['output']
  licenseEnforcement: LicenseEnforcement
  licenseEnforcementExpiration?: Maybe<Scalars['DateTime']['output']>
  name: Scalars['String']['output']
}

export type InvitableUser = {
  __typename?: 'InvitableUser'
  businessUserId: Scalars['ID']['output']
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export enum LearnErrorReason {
  BucketResultNotFound = 'BUCKET_RESULT_NOT_FOUND',
  InputTooShort = 'INPUT_TOO_SHORT',
  InsufficientContext = 'INSUFFICIENT_CONTEXT',
  JobObsolete = 'JOB_OBSOLETE',
  LlmImproperSchema = 'LLM_IMPROPER_SCHEMA',
  LlmInvalidJson = 'LLM_INVALID_JSON',
  LlmUnexpectedResponse = 'LLM_UNEXPECTED_RESPONSE',
  ProcessingFailure = 'PROCESSING_FAILURE',
  ResultRetrievalFailure = 'RESULT_RETRIEVAL_FAILURE',
  TranscriptDoesNotExist = 'TRANSCRIPT_DOES_NOT_EXIST'
}

export type LearnQuotaUsage = {
  __typename?: 'LearnQuotaUsage'
  hasExceededLearnQuotaUsage: Scalars['Boolean']['output']
  quotaUsagePercentage: Scalars['Float']['output']
}

export enum LearnQuotaWindowType {
  Lifetime = 'lifetime',
  Monthly = 'monthly'
}

export type LibraryCounts = {
  __typename?: 'LibraryCounts'
  legacyNotesCount: Scalars['Float']['output']
  notesCount: Scalars['Float']['output']
  notesWithoutOpsCount: Scalars['Float']['output']
  organizersCount: Scalars['Float']['output']
  unfiledNotesCount: Scalars['Float']['output']
}

export type LibraryId = {
  /** required for type: CloudKit */
  icloudUserId?: InputMaybe<Scalars['String']['input']>
  /** required for type: NotabilityServer */
  serverUserId?: InputMaybe<Scalars['String']['input']>
  type: LibraryType
  /** required for type: NotabilityServer */
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type LibraryState = {
  __typename?: 'LibraryState'
  /** A list of workspace ids that a user can no longer access, either through deletion or permission changes */
  deletedWorkspaces?: Maybe<Array<Scalars['String']['output']>>
  permanentlyDeletedNotes?: Maybe<Array<Scalars['String']['output']>>
  /** null if full state reload */
  priorSequenceId?: Maybe<Scalars['Int']['output']>
  privateSpace?: Maybe<Workspace>
  sequenceId: Scalars['Int']['output']
  /** shared notes dont belong to any workspace */
  sharedNotes?: Maybe<Array<NoteV2>>
  sharedSpaces?: Maybe<Array<Workspace>>
}

export enum LibraryType {
  CloudKit = 'CloudKit',
  Legacy = 'Legacy',
  LocalCollab = 'LocalCollab',
  NotabilityServer = 'NotabilityServer'
}

export enum LicenseEnforcement {
  None = 'NONE',
  Strict = 'STRICT',
  Warning = 'WARNING'
}

export type LikeParams = {
  note: Scalars['String']['input']
}

export type LikedGalleryNote = {
  __typename?: 'LikedGalleryNote'
  createdAt: Scalars['DateTime']['output']
  galleryNote: GalleryNote
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export type LikedNotePair = {
  __typename?: 'LikedNotePair'
  likesNote: Scalars['Boolean']['output']
  noteId: Scalars['String']['output']
}

export type LikingUsersParameters = {
  limit: Scalars['Float']['input']
  noteId: Scalars['String']['input']
  offset: Scalars['Float']['input']
}

export type LinkCollabNoteToCalendarEventParams = {
  event: CalendarEventInput
  noteId: Scalars['ID']['input']
}

export type LinkFolderToCalendarSeriesParams = {
  /** Shared by every occurrence of a series; pass it unchanged from the calendar API */
  eventId: Scalars['String']['input']
  folderId: Scalars['ID']['input']
}

export type LinkShareSettings = {
  __typename?: 'LinkShareSettings'
  linkAccessLevel: AccessLevel
  /** @deprecated Use linkPermissionScopeV2 instead */
  linkPermissionScope: PermissionScope
  linkPermissionScopeV2: PermissionScopeV2
}

export type Locale = {
  __typename?: 'Locale'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  languageCode: Scalars['String']['output']
}

export type LoginParams = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
  turnstileToken?: InputMaybe<Scalars['String']['input']>
}

export type LoginProvider = {
  __typename?: 'LoginProvider'
  provider: OAuthProvider
  verified: Scalars['Boolean']['output']
}

export type MagicLinkLoginParams = {
  magicLinkUUID: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MarkFeedAsViewedParams = {
  viewedUpTo: Scalars['String']['input']
}

export type MarkNotificationsSeenParams = {
  notificationIds: Array<Scalars['String']['input']>
}

/** A third-party AI app's live access to the user's notes over MCP. */
export type McpConnection = {
  __typename?: 'McpConnection'
  clientName: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MediaUploadStatus = {
  __typename?: 'MediaUploadStatus'
  createdAt: Scalars['DateTime']['output']
  customAssets: Array<CustomAssetMetadata>
  id: Scalars['String']['output']
  noteMediaInsertions: Array<NoteMediaInsertion>
  sha512Hash: Scalars['String']['output']
  sizeInBytes: Scalars['Float']['output']
  status: MediaUploadStatusEnum
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum MediaUploadStatusEnum {
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Uploaded = 'UPLOADED'
}

export type MetadataLibraryRequest = {
  /** null to request a full state reset in the response */
  partialUpdateSequenceId?: InputMaybe<Scalars['Int']['input']>
}

/** One-Of: expects exactly one mutation property to be set */
export type MetadataMutation = {
  createDivider?: InputMaybe<CreateDivider>
  createFolder?: InputMaybe<CreateFolder>
  createNote?: InputMaybe<CreateNote>
  createSubject?: InputMaybe<CreateSubject>
  deleteFolder?: InputMaybe<DeleteFolder>
  deleteNote?: InputMaybe<DeleteNote>
  deleteOrganizer?: InputMaybe<DeleteOrganizer>
  deleteWorkspace?: InputMaybe<DeleteWorkspace>
  idempotencyKey: Scalars['String']['input']
  modifyFolder?: InputMaybe<ModifyFolder>
  modifyNote?: InputMaybe<ModifyNote>
  modifyOrganizer?: InputMaybe<ModifyOrganizer>
  permanentlyDeleteNote?: InputMaybe<PermanentlyDeleteNote>
  undeleteNote?: InputMaybe<UndeleteNote>
}

export type MigratingDevice = {
  __typename?: 'MigratingDevice'
  appVersion?: Maybe<Scalars['String']['output']>
  controllingDeviceId: Scalars['String']['output']
  controllingDeviceName: Scalars['String']['output']
  id: Scalars['String']['output']
  source: ResponseLibraryId
  startDate: Scalars['Timestamp']['output']
  startSource?: Maybe<Scalars['String']['output']>
  target: ResponseLibraryId
}

export type MixAndMatch = {
  __typename?: 'MixAndMatch'
  flashcards: Array<Flashcard>
  type: QuizSessionQuestionType
}

export type ModifyBusinessParams = {
  industry?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ModifyFolder = {
  emoji?: InputMaybe<Scalars['String']['input']>
  folderId: Scalars['String']['input']
  hexColor?: InputMaybe<Scalars['String']['input']>
  isLocked?: InputMaybe<Scalars['Boolean']['input']>
  moveToParent?: InputMaybe<MoveToFolder>
  siblingOrder?: InputMaybe<Scalars['Float']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ModifyMetadataRequest = {
  mutations: Array<MetadataMutation>
  /** null to request a full state reset in the response */
  partialUpdateSequenceId?: InputMaybe<Scalars['Int']['input']>
}

export type ModifyMetadataResponse = {
  __typename?: 'ModifyMetadataResponse'
  failedMutations: Array<FailedMutation>
  state: LibraryState
  successfulMutations: Array<Scalars['String']['output']>
}

export type ModifyNote = {
  isFavorited?: InputMaybe<Scalars['Boolean']['input']>
  lastOpened?: InputMaybe<Scalars['Timestamp']['input']>
  linkAccessLevel?: InputMaybe<AccessLevel>
  linkPermissionScope?: InputMaybe<PermissionScope>
  linkPermissionScopeV2?: InputMaybe<PermissionScopeV2>
  moveToFolder?: InputMaybe<MoveToFolder>
  moveToSubject?: InputMaybe<MoveToOrganizer>
  noteId: Scalars['String']['input']
  permissions?: InputMaybe<Array<PermissionChange>>
}

export type ModifyOrgParams = {
  newName: Scalars['String']['input']
  orgId: Scalars['String']['input']
}

export type ModifyOrganizationLicenseParams = {
  expiration?: InputMaybe<Scalars['DateTime']['input']>
  licenseId: Scalars['String']['input']
  maxSeats?: InputMaybe<Scalars['Float']['input']>
}

export type ModifyOrganizer = {
  moveToParent?: InputMaybe<MoveToOrganizer>
  organizerId: Scalars['String']['input']
  siblingOrder?: InputMaybe<Scalars['Float']['input']>
  subjectEmoji?: InputMaybe<Scalars['String']['input']>
  subjectHexColor?: InputMaybe<Scalars['String']['input']>
  subjectIsLocked?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ModifyTrialExpirationParams = {
  trialUserId: Scalars['String']['input']
  updatedExpirationDate: Scalars['DateTime']['input']
}

export type MoveToFolder = {
  /** null to unfile */
  parentId?: InputMaybe<Scalars['String']['input']>
  /** Must be set when moving to new workspace */
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type MoveToOrganizer = {
  /** null to unfile */
  parentId?: InputMaybe<Scalars['String']['input']>
  /** Must be set when moving to new workspace */
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type MultipleChoice = {
  __typename?: 'MultipleChoice'
  answers: MultipleChoiceAnswers
  correctAnswer: Scalars['String']['output']
  question: Scalars['String']['output']
  questionId: Scalars['String']['output']
  questionIndex: Scalars['Int']['output']
  sourceNoteId?: Maybe<Scalars['String']['output']>
  status: QuizQuestionStatus
  type: QuizSessionQuestionType
  userResponseMultipleChoice?: Maybe<MultipleChoiceResponse>
}

export type MultipleChoiceAnswers = {
  __typename?: 'MultipleChoiceAnswers'
  A: Scalars['String']['output']
  B: Scalars['String']['output']
  C: Scalars['String']['output']
  D: Scalars['String']['output']
}

export enum MultipleChoiceResponse {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export type Mutation = {
  __typename?: 'Mutation'
  acceptBusinessInvitation: User
  acceptBusinessJoinSuggestion: Scalars['Boolean']['output']
  acceptOrganizationInvite: Scalars['Boolean']['output']
  acceptPublicBusinessInvitation: User
  addBusinessDomain: BusinessDomainInfo
  /** @deprecated use addBusinessUsersV2 instead */
  addBusinessUsers: AddBusinessUsersResponse
  addBusinessUsersV2: AddBusinessUsersResponseV2
  /** @deprecated enrollment limits are lifted */
  addEnrollmentRecord: EnrollmentLimits
  addNotePermissionsByEmail: AddNotePermissionsByEmailResponse
  addNoteToCollection: NoteCollection
  /** @deprecated Use addOrganizationOwner */
  addOrganizationAdmin: Scalars['Boolean']['output']
  addOrganizationOwner: Scalars['Boolean']['output']
  addOrganizationUsers: AddOrganizationUsersResponse
  addRecoveryEmail: Scalars['Boolean']['output']
  addSubscriberQuotaDummyUsage: AdminLearnQuotaResponse
  addToStudyMaterialsBatch: StudyMaterialsBatch
  addWorkspaceUsers: AddWorkspaceUsersResponse
  adminSimulateQuota: Scalars['Boolean']['output']
  /** Syncs our subscription record to match the live Stripe subscription. */
  adminSyncBusinessSubscription: Scalars['Boolean']['output']
  /** Overwrites subscription fields in our DB without touching Stripe. For QA testing — use adminSyncBusinessSubscription to restore real data. */
  adminUpdateBusinessSubscription: Scalars['Boolean']['output']
  approveComment: Scalars['ID']['output']
  askChatQuestion: Array<StudyChatMessage>
  assignAllUsersToExperiments: Scalars['Boolean']['output']
  associateAppStoreTransactions: SubscriptionOverview
  attestDevice: DeviceAttestationVerdict
  bulkDeleteCustomAssets: Scalars['Boolean']['output']
  businessUserDeactivationFastTrack: Scalars['Boolean']['output']
  cancelPendingRecoveryEmail: Scalars['Boolean']['output']
  cancelTrial: Scalars['Boolean']['output']
  changeAdminStatus: Scalars['Boolean']['output']
  changeBlockStatus: Scalars['Boolean']['output']
  changeBusinessOwner: Business
  changeEmail: Scalars['String']['output']
  changeScreenname: Scalars['String']['output']
  checkDeviceTrialOffer: DeviceTrialOffer
  computeTopTags: Scalars['String']['output']
  connectOAuthAccount: OAuthConnectedAccount
  createASRJob: AsrJobResult
  createBusiness: CreateBusinessResponse
  createBusinessLead: BusinessLead
  createBusinessMagicLink: BusinessMagicLink
  createCollection: Scalars['String']['output']
  createComment: Comment
  createDesktopStatus: DesktopStatus
  createExperiment: Experiment
  createMagicLink: Scalars['Boolean']['output']
  createOrganization: Organization
  createPromoNotification: PromoNotification
  createPublicBusinessInvitation: PublicBusinessInvitation
  createTestBusiness: CreateTestBusinessResponse
  /** @deprecated Trial Subscriptions are deprecated. */
  createTrialSubscription: TrialSubscription
  createVPPEmailDomain: VppAllowlistEmail
  createWorkspaceForBusiness: WorkspaceEntity
  createWorkspaceForOrganization: WorkspaceEntity
  deactivateBusinessUser: DeactivateBusinessUserResponse
  deactivateOrganizationUsers: Scalars['Boolean']['output']
  deleteAccount: Scalars['Boolean']['output']
  deleteBusiness: Scalars['Boolean']['output']
  deleteBusinessCustomAssets: Scalars['Boolean']['output']
  deleteBusinessDomain: Scalars['Boolean']['output']
  deleteChatbotThread: Scalars['Boolean']['output']
  deleteCollection: Scalars['Boolean']['output']
  deleteComment: Scalars['ID']['output']
  deleteCustomAsset: Scalars['Boolean']['output']
  deleteExperiment: Scalars['Boolean']['output']
  deleteGlobalOverrideValue: Scalars['String']['output']
  deletePromoNotification: Scalars['String']['output']
  deleteSubscriptionOverride: Scalars['Boolean']['output']
  deleteUserCollabLibrary: OrganizerMutationResult
  deleteVPPEmailDomain: Scalars['Boolean']['output']
  deleteWorkspaceForBusiness: WorkspaceEntity
  deleteWorkspaceForOrganization: WorkspaceEntity
  denyBusinessJoinRequest: Scalars['Boolean']['output']
  denyNoteAccess: Scalars['Boolean']['output']
  disableDevicesForSubscriptions: Scalars['Boolean']['output']
  disconnectOAuthAccount: Scalars['Boolean']['output']
  dismissBusinessJoinSuggestion: Scalars['Boolean']['output']
  dismissGuidelines: Scalars['Boolean']['output']
  downgradeBusinessUser: DowngradeBusinessUserResponse
  editBusinessUserRole: EditBusinessUserRoleResponse
  editDesktopStatus: DesktopStatus
  editExperiment: Scalars['Boolean']['output']
  editNote: GalleryNote
  editPromoNotification: PromoNotification
  editUserWorkspacePermission: Scalars['Boolean']['output']
  editWorkspaceForBusiness: WorkspaceEntity
  editWorkspaceForOrganization: WorkspaceEntity
  /** @deprecated enrollment limits are lifted */
  enableGalleryAccess: EnrollmentLimits
  enroll: User
  flagNote: GalleryNote
  flagNoteFamilyTree: Array<GalleryNote>
  flagProfile: Scalars['Boolean']['output']
  followUser: FollowPair
  forceResetMigrations: Scalars['Boolean']['output']
  freeNamespace: Scalars['Boolean']['output']
  generateCollabLinkToken: Scalars['String']['output']
  /** @deprecated The Generate Test Organizers developer panel was its only client; use the generate-collab-note-portfolio script instead. */
  generateCollabTestDataForUser: OrganizerMutationResult
  generateDiscussionDialogue: DiscussionDialogueNode
  generateSiteId: Scalars['Float']['output']
  generateStudyMaterialsBatch: StudyMaterialsBatch
  getOrCreateSummaryJob: SummaryJob
  grantNoteAccess: Scalars['Boolean']['output']
  grantSubscriptionOverride: Scalars['Boolean']['output']
  hideComment: Scalars['ID']['output']
  likeNote: GalleryNote
  linkCollabNoteToCalendarEvent: CollabNoteMetadata
  /** Files a recurring calendar series into a folder for the calling user, returning the series' folder: an existing one if another device linked first. */
  linkFolderToCalendarSeries: Organizer
  loginViaMagicLink: User
  markFeedAsViewed: Scalars['Boolean']['output']
  markNotificationsSeen: Scalars['Boolean']['output']
  modifyBusiness: Scalars['Boolean']['output']
  /** @deprecated Use the metadata websocket for mutations */
  modifyMetadata: ModifyMetadataResponse
  modifyOrganization: Scalars['Boolean']['output']
  modifyOrganizationLicense: Scalars['Boolean']['output']
  modifyTrialExpiration: Scalars['Boolean']['output']
  noteViewed: Scalars['Boolean']['output']
  patchBusinessSubscription: PatchBusinessSubscriptionResult
  permissionBusinessUserForWorkspaceNote: Scalars['Boolean']['output']
  prepareCustomAsset: PrepareCustomAssetUploadResult
  prepareMediaUpload: PrepareMediaUploadResult
  preparePublish: PublishResult
  processAppleReceipt: SubscriptionResult
  processVPPReceipt: VppAccountResult
  publishTemplate: CustomAssetMetadata
  reactivateBusinessUser: Scalars['Boolean']['output']
  recoverDeletedNote: Scalars['Boolean']['output']
  redeemDeviceTrial: DeviceTrialRedemption
  referralLink?: Maybe<ReferralLink>
  registerPilotBusiness: BusinessPilotCustomerRegistration
  reloadEnvironmentCache: Scalars['Boolean']['output']
  removeAppSetting: AppSettingsResponse
  removeBusinessDomain: Scalars['Boolean']['output']
  removeDesktopStatus: DesktopStatus
  removeExperimentEnrollmentOverride: Scalars['Boolean']['output']
  removeNoteFromCollection: Scalars['Boolean']['output']
  removePermissionForWorkspaceNote: Scalars['Boolean']['output']
  removeRecoveryEmail: Scalars['Boolean']['output']
  removeUserSurveyResponseKeys: UserSurveyResponse
  removeWorkspaceUsers: Scalars['Boolean']['output']
  renameCustomAsset: CustomAssetMetadata
  renameUser: Scalars['Boolean']['output']
  reorderNoteCollectionNote: Scalars['Boolean']['output']
  reportComment: Scalars['ID']['output']
  reprocessASRJob: AsrJobResult
  requestDeviceAttestationChallenge: DeviceAttestationChallenge
  requestNoteAccess: RequestNoteAccessResponse
  requestOAuthAccessToken: OAuthAccessToken
  resendBusinessUserInvitations: ResendBusinessUserInvitationsResponse
  resendOrganizationInvite: Scalars['Boolean']['output']
  resetOrganizationSeatUsage: Scalars['Boolean']['output']
  resetSubscriberQuotas: AdminLearnQuotaResponse
  resolveAchievements: AchievementsResponse
  restoreOrganization: Scalars['Boolean']['output']
  restoreSoftDeletedWorkspaceForBusiness: WorkspaceEntity
  reviewBusinessDomain: Scalars['Boolean']['output']
  reviewFlaggedProfile: Scalars['Boolean']['output']
  reviewOrganization: Scalars['Boolean']['output']
  revokeCollabLink: Scalars['Boolean']['output']
  revokeMcpConnection: Scalars['Boolean']['output']
  revokePublicBusinessInvitation: PublicBusinessInvitation
  setAiProfile: AiProfile
  setAppSetting: AppSettingsResponse
  setBusinessDomainEnabled: BusinessDomainInfo
  setCollegeAndMajor: Scalars['Boolean']['output']
  setGalleryDegraded: Scalars['Boolean']['output']
  setGlobalOverrideValue: Scalars['Boolean']['output']
  setIgnoreFlags: UserProfile
  setLanguage: GalleryNote
  setLicenseEnforcement: Scalars['Boolean']['output']
  setLicenseEnforcementExpiration: Scalars['Boolean']['output']
  setMigratingDevice: SetMigratingDeviceResponse
  setPromoAsDraft: PromoNotification
  setUserSurveyResponse: UserSurveyResponse
  shareCustomAsset: Scalars['Boolean']['output']
  startDiscussion: StartDiscussionResult
  stopSharing: Scalars['Boolean']['output']
  syncQuizSession: SyncQuizSessionResponse
  toggleDeviceLimitEnforcement: AppStoreSubscription
  triageNote: TriageResult
  unfollowUser: FollowPair
  unlikeNote: GalleryNote
  unlinkCollabNoteFromCalendarEvent: Scalars['Boolean']['output']
  unlinkFolderFromCalendarSeries: Scalars['Boolean']['output']
  unlockUserAccount: Scalars['Boolean']['output']
  unpublish: Scalars['Boolean']['output']
  unpublishTemplate: CustomAssetMetadata
  updateBio: UserProfile
  updateBusinessFeatureConfig: BusinessFeatureConfig
  updateBusinessTrialMemberLimit: BusinessSubscription
  updateCollection: NoteCollection
  updateCookies: Scalars['String']['output']
  updateExperimentData: ExperimentData
  updateFullName: Scalars['Boolean']['output']
  updateLearnSettings: Scalars['Boolean']['output']
  updateOrganizationDetails: Scalars['Boolean']['output']
  updateProfile: UserProfile
  updateUserExperimentEnrollmentOverride: ExperimentEnrollment
  updateUserLanguage: Scalars['Boolean']['output']
  upload: UploadResult
  uploadUserGeneratedQuiz?: Maybe<Scalars['Boolean']['output']>
  validateGalaxyStorePurchase: ValidateGalaxyStorePurchasePayload
  validatePlayStoreOneTimePurchase: ValidatePlayStoreOneTimePurchasePayload
  validatePlayStorePurchaseToken: ValidatePlayStorePurchaseTokenPayload
  visitCollabLink: Scalars['String']['output']
}

export type MutationAcceptBusinessInvitationArgs = {
  acceptBusinessInvitationParams: AcceptBusinessInvitationParams
}

export type MutationAcceptOrganizationInviteArgs = {
  acceptOrganizationInviteParams: AcceptOrganizationInviteParams
}

export type MutationAcceptPublicBusinessInvitationArgs = {
  acceptPublicBusinessInvitation: AcceptPublicBusinessInvitationParams
}

export type MutationAddBusinessDomainArgs = {
  addBusinessDomainParams: AddBusinessDomainParams
}

export type MutationAddBusinessUsersArgs = {
  addBusinessUsersParams: AddBusinessUsersParams
}

export type MutationAddBusinessUsersV2Args = {
  addBusinessUsersParams: AddBusinessUsersParams
}

export type MutationAddNotePermissionsByEmailArgs = {
  addNotePermissionsByEmailRequest: AddNotePermissionsByEmailRequest
}

export type MutationAddNoteToCollectionArgs = {
  addNoteToCollectionParams: AddNoteToCollectionParams
}

export type MutationAddOrganizationAdminArgs = {
  addOrganizationAdminParams: AddOrganizationAdminParams
}

export type MutationAddOrganizationOwnerArgs = {
  addOrganizationOwnerParams: AddOrganizationOwnerParams
}

export type MutationAddOrganizationUsersArgs = {
  addOrganizationUsersParams: AddOrganizationUsersParams
}

export type MutationAddRecoveryEmailArgs = {
  addRecoveryEmailParams: AddRecoveryEmailParams
}

export type MutationAddSubscriberQuotaDummyUsageArgs = {
  addSubscriberQuotaDummyUsageParams: AddSubscriberQuotaDummyUsageParams
}

export type MutationAddToStudyMaterialsBatchArgs = {
  addToStudyMaterialsBatchParams: AddToStudyMaterialsBatchParams
}

export type MutationAddWorkspaceUsersArgs = {
  addWorkspaceUsersParams: AddWorkspaceUsersParams
}

export type MutationAdminSimulateQuotaArgs = {
  simulateASRQuotaParams: SimulateAsrQuotaParams
}

export type MutationAdminSyncBusinessSubscriptionArgs = {
  adminSyncBusinessSubscriptionParams: AdminSyncBusinessSubscriptionParams
}

export type MutationAdminUpdateBusinessSubscriptionArgs = {
  adminUpdateBusinessSubscriptionParams: AdminUpdateBusinessSubscriptionParams
}

export type MutationApproveCommentArgs = {
  approveCommentParams: ApproveCommentParams
}

export type MutationAskChatQuestionArgs = {
  askChatQuestionParams: AskChatQuestionParams
}

export type MutationAssociateAppStoreTransactionsArgs = {
  associateAppStoreTransactionsParams: AssociateAppStoreTransactionsParams
}

export type MutationAttestDeviceArgs = {
  attestDeviceParams: AttestDeviceParamsInput
}

export type MutationBulkDeleteCustomAssetsArgs = {
  bulkDeleteCustomAssetsParams: BulkDeleteCustomAssetsParams
}

export type MutationBusinessUserDeactivationFastTrackArgs = {
  businessUserDeactivationFastTrackParams: BusinessUserDeactivationFastTrackParams
}

export type MutationCancelTrialArgs = {
  cancelUserTrialSubscriptionParams: CancelUserTrialSubscriptionParams
}

export type MutationChangeAdminStatusArgs = {
  changeAdminStatusParams: ChangeAdminStatusParams
}

export type MutationChangeBlockStatusArgs = {
  changeBlockStatusParams: ChangeBlockStatusParams
}

export type MutationChangeBusinessOwnerArgs = {
  changeBusinessOwnerParams: ChangeBusinessOwnerParams
}

export type MutationChangeEmailArgs = {
  changeEmailParams: ChangeEmailParams
}

export type MutationChangeScreennameArgs = {
  changeScreennameParams: ChangeScreennameParams
}

export type MutationCheckDeviceTrialOfferArgs = {
  attestDeviceParams: AttestDeviceParamsInput
  clientContext?: InputMaybe<DeviceTrialContextInput>
}

export type MutationConnectOAuthAccountArgs = {
  params: ConnectOAuthAccountParams
}

export type MutationCreateAsrJobArgs = {
  createASRJobParams: CreateAsrJobParams
}

export type MutationCreateBusinessArgs = {
  createBusinessParams: CreateBusinessParams
}

export type MutationCreateBusinessLeadArgs = {
  createBusinessLeadParams: CreateBusinessLeadParams
}

export type MutationCreateBusinessMagicLinkArgs = {
  priceId: Scalars['String']['input']
}

export type MutationCreateCollectionArgs = {
  createNoteCollectionParams: CreateNoteCollectionParams
}

export type MutationCreateCommentArgs = {
  createCommentParams: CreateCommentParams
}

export type MutationCreateDesktopStatusArgs = {
  desktopStatusParams: DesktopStatusParams
}

export type MutationCreateExperimentArgs = {
  experimentParams: ExperimentParams
}

export type MutationCreateMagicLinkArgs = {
  createMagicLinkParams: CreateMagicLinkParams
}

export type MutationCreateOrganizationArgs = {
  createOrgParams: CreateOrgParams
}

export type MutationCreatePromoNotificationArgs = {
  promoNotificationParams: PromoNotificationParams
}

export type MutationCreatePublicBusinessInvitationArgs = {
  createPublicBusinessInvitationParams: CreatePublicBusinessInvitationParams
}

export type MutationCreateTestBusinessArgs = {
  createTestBusinessParams: CreateTestBusinessParams
}

export type MutationCreateTrialSubscriptionArgs = {
  createTrialSubscriptionParams: CreateTrialSubscriptionParams
}

export type MutationCreateVppEmailDomainArgs = {
  createVPPEmailDomainParams: CreateVppEmailDomainParams
}

export type MutationCreateWorkspaceForBusinessArgs = {
  CreateWorkspaceInput: CreateWorkspaceInput
}

export type MutationCreateWorkspaceForOrganizationArgs = {
  CreateWorkspaceInput: CreateWorkspaceInput
}

export type MutationDeactivateBusinessUserArgs = {
  DeactivateBusinessUserParams: DeactivateBusinessUserParams
}

export type MutationDeactivateOrganizationUsersArgs = {
  deactivateOrganizationUsersParams: DeactivateOrganizationUsersParams
}

export type MutationDeleteBusinessCustomAssetsArgs = {
  bulkDeleteCustomAssetsParams: BulkDeleteCustomAssetsParams
}

export type MutationDeleteBusinessDomainArgs = {
  domainId: Scalars['ID']['input']
}

export type MutationDeleteChatbotThreadArgs = {
  deleteChatbotThreadParams: DeleteChatbotThreadParams
}

export type MutationDeleteCollectionArgs = {
  deleteNoteCollectionParams: DeleteNoteCollectionParams
}

export type MutationDeleteCommentArgs = {
  deleteCommentParams: DeleteCommentParams
}

export type MutationDeleteCustomAssetArgs = {
  deleteCustomAssetParams: DeleteCustomAssetParams
}

export type MutationDeleteExperimentArgs = {
  deleteExperimentParams: DeleteExperimentParams
}

export type MutationDeleteGlobalOverrideValueArgs = {
  deleteGlobalOverrideValueParams: DeleteGlobalOverrideValueParams
}

export type MutationDeletePromoNotificationArgs = {
  deletePromoParams: DeletePromoParams
}

export type MutationDeleteSubscriptionOverrideArgs = {
  deleteSubscriptionOverrideParams: DeleteSubscriptionOverrideParams
}

export type MutationDeleteUserCollabLibraryArgs = {
  collabDeleteLibraryParams: CollabDeleteLibraryParams
}

export type MutationDeleteVppEmailDomainArgs = {
  deleteVPPEmailDomainParams: DeleteVppEmailDomainParams
}

export type MutationDeleteWorkspaceForBusinessArgs = {
  DeleteWorkspaceInput: DeleteWorkspaceInput
}

export type MutationDeleteWorkspaceForOrganizationArgs = {
  DeleteWorkspaceInput: DeleteWorkspaceInput
}

export type MutationDenyBusinessJoinRequestArgs = {
  denyBusinessJoinRequestParams: DenyBusinessJoinRequestParams
}

export type MutationDenyNoteAccessArgs = {
  denyNoteAccessInput: DenyNoteAccessInput
}

export type MutationDisableDevicesForSubscriptionsArgs = {
  disableDevicesForSubscriptionsParams: DisableDevicesForSubscriptionsParams
}

export type MutationDisconnectOAuthAccountArgs = {
  params: DisconnectOAuthAccountParams
}

export type MutationDowngradeBusinessUserArgs = {
  downgradeBusinessUserParams: DowngradeBusinessUserParams
}

export type MutationEditBusinessUserRoleArgs = {
  users: Array<EditBusinessUserRoleInput>
}

export type MutationEditDesktopStatusArgs = {
  desktopStatusParams: DesktopStatusParams
}

export type MutationEditExperimentArgs = {
  experimentParams: ExperimentParams
}

export type MutationEditNoteArgs = {
  editParams: EditParams
}

export type MutationEditPromoNotificationArgs = {
  promoNotificationParams: PromoNotificationParams
}

export type MutationEditUserWorkspacePermissionArgs = {
  EditUserWorkspacePermissionRequest: EditUserWorkspacePermissionRequest
}

export type MutationEditWorkspaceForBusinessArgs = {
  EditWorkspaceInput: EditWorkspaceInput
}

export type MutationEditWorkspaceForOrganizationArgs = {
  DeleteWorkspaceInput: EditWorkspaceInput
}

export type MutationEnableGalleryAccessArgs = {
  params: EnableGalleryAccessParams
}

export type MutationEnrollArgs = {
  userEnrollmentParams: UserEnrollmentParams
}

export type MutationFlagNoteArgs = {
  flagParams: FlagParams
}

export type MutationFlagNoteFamilyTreeArgs = {
  flagParams: FlagParams
}

export type MutationFlagProfileArgs = {
  flagProfileParams: FlagProfileParams
}

export type MutationFollowUserArgs = {
  followParams: FollowParams
}

export type MutationForceResetMigrationsArgs = {
  forceResetMigrationsRequest: ForceResetMigrationsRequest
}

export type MutationFreeNamespaceArgs = {
  freeNamespaceParams: FreeNamespaceParams
}

export type MutationGenerateCollabLinkTokenArgs = {
  generateCollabLinkParams: GenerateCollabLinkParams
}

export type MutationGenerateCollabTestDataForUserArgs = {
  collabTestDataParams: CollabTestDataParams
}

export type MutationGenerateDiscussionDialogueArgs = {
  params: GenerateDiscussionDialogueParams
}

export type MutationGenerateSiteIdArgs = {
  generateSiteIdParams: GenerateSiteIdParams
}

export type MutationGenerateStudyMaterialsBatchArgs = {
  generateStudyMaterialsBatchParams: GenerateStudyMaterialsBatchParams
}

export type MutationGetOrCreateSummaryJobArgs = {
  getOrCreateSummaryJobParams: GetOrCreateSummaryJobParams
}

export type MutationGrantNoteAccessArgs = {
  grantNoteAccessInput: GrantNoteAccessInput
}

export type MutationGrantSubscriptionOverrideArgs = {
  grantSubscriptionOverrideParams: GrantSubscriptionOverrideParams
}

export type MutationHideCommentArgs = {
  hideCommentParams: HideCommentParams
}

export type MutationLikeNoteArgs = {
  likeParams: LikeParams
}

export type MutationLinkCollabNoteToCalendarEventArgs = {
  params: LinkCollabNoteToCalendarEventParams
}

export type MutationLinkFolderToCalendarSeriesArgs = {
  params: LinkFolderToCalendarSeriesParams
}

export type MutationLoginViaMagicLinkArgs = {
  magicLinkLoginParams: MagicLinkLoginParams
}

export type MutationMarkFeedAsViewedArgs = {
  markFeedAsViewedParams: MarkFeedAsViewedParams
}

export type MutationMarkNotificationsSeenArgs = {
  markNotificationsSeenParams: MarkNotificationsSeenParams
}

export type MutationModifyBusinessArgs = {
  modifyBusinessParams: ModifyBusinessParams
}

export type MutationModifyMetadataArgs = {
  modifyMetadataRequest: ModifyMetadataRequest
}

export type MutationModifyOrganizationArgs = {
  modifyOrgParams: ModifyOrgParams
}

export type MutationModifyOrganizationLicenseArgs = {
  modifyOrganizationLicenseParams: ModifyOrganizationLicenseParams
}

export type MutationModifyTrialExpirationArgs = {
  modifyTrialExpirationParams: ModifyTrialExpirationParams
}

export type MutationNoteViewedArgs = {
  viewedNote: ViewedNoteParameters
}

export type MutationPatchBusinessSubscriptionArgs = {
  patchBusinessSubscriptionParams: PatchBusinessSubscriptionParams
}

export type MutationPermissionBusinessUserForWorkspaceNoteArgs = {
  permissionBusinessUserForWorkspaceNoteRequest: PermissionBusinessUserForWorkspaceNoteRequest
}

export type MutationPrepareCustomAssetArgs = {
  prepareCustomAssetUploadParams: PrepareCustomAssetUploadParams
}

export type MutationPrepareMediaUploadArgs = {
  prepareMediaUploadParams: PrepareMediaUploadParams
}

export type MutationPreparePublishArgs = {
  publishParams: PublishParams
}

export type MutationProcessAppleReceiptArgs = {
  receiptParams: AppleReceiptParams
}

export type MutationProcessVppReceiptArgs = {
  vppReceiptParams: VppReceiptParams
}

export type MutationPublishTemplateArgs = {
  publishTemplateParams: PublishTemplateParams
}

export type MutationReactivateBusinessUserArgs = {
  reactivateBusinessUserParams: ReactivateBusinessUserParams
}

export type MutationRecoverDeletedNoteArgs = {
  recoverDeletedNoteParams: RecoverDeletedNoteParams
}

export type MutationRedeemDeviceTrialArgs = {
  attestDeviceParams: AttestDeviceParamsInput
  clientContext?: InputMaybe<DeviceTrialContextInput>
}

export type MutationRegisterPilotBusinessArgs = {
  registerPilotBusinessParams: RegisterPilotBusinessParams
}

export type MutationRemoveAppSettingArgs = {
  removeAppSettingParams: RemoveAppSettingParams
}

export type MutationRemoveBusinessDomainArgs = {
  domainId: Scalars['ID']['input']
}

export type MutationRemoveDesktopStatusArgs = {
  removeDesktopStatusParams: RemoveDesktopStatusParams
}

export type MutationRemoveExperimentEnrollmentOverrideArgs = {
  removeExperimentEnrollmentOverrideParams: RemoveExperimentEnrollmentOverrideParams
}

export type MutationRemoveNoteFromCollectionArgs = {
  removeNoteFromCollectionParams: RemoveNoteFromCollectionParams
}

export type MutationRemovePermissionForWorkspaceNoteArgs = {
  removePermissionForWorkspaceNoteRequest: RemovePermissionForWorkspaceNoteRequest
}

export type MutationRemoveUserSurveyResponseKeysArgs = {
  removeUserSurveyResponseKeysParams: RemoveUserSurveyResponseKeysParams
}

export type MutationRemoveWorkspaceUsersArgs = {
  removeWorkspaceUsersParams: RemoveWorkspaceUsersParams
}

export type MutationRenameCustomAssetArgs = {
  renameCustomAssetParams: RenameCustomAssetParams
}

export type MutationRenameUserArgs = {
  renameUserParams: RenameUserParams
}

export type MutationReorderNoteCollectionNoteArgs = {
  reorderNoteCollectionNoteParams: ReorderNoteCollectionNoteParams
}

export type MutationReportCommentArgs = {
  reportCommentParams: ReportCommentParams
}

export type MutationReprocessAsrJobArgs = {
  reprocessASRJobParams: ReprocessAsrJobParams
}

export type MutationRequestNoteAccessArgs = {
  requestNoteAccessInput: RequestNoteAccessInput
}

export type MutationRequestOAuthAccessTokenArgs = {
  params: RequestOAuthAccessTokenParams
}

export type MutationResendBusinessUserInvitationsArgs = {
  ResendBusinessUserInvitationsParams: ResendBusinessUserInvitationsParams
}

export type MutationResendOrganizationInviteArgs = {
  resendOrganizationInviteParams: ResendOrganizationInviteParams
}

export type MutationResetOrganizationSeatUsageArgs = {
  resetOrganizationSeatUsageParams: ResetOrganizationSeatUsageParams
}

export type MutationResetSubscriberQuotasArgs = {
  resetSubscriberQuotasParams: ResetSubscriberQuotasParams
}

export type MutationResolveAchievementsArgs = {
  resolveAchievementsParams: ResolveAchievementsParams
}

export type MutationRestoreOrganizationArgs = {
  restoreOrganizationParams: RestoreOrganizationParams
}

export type MutationRestoreSoftDeletedWorkspaceForBusinessArgs = {
  RestoreWorkspaceInput: RestoreWorkspaceInput
}

export type MutationReviewBusinessDomainArgs = {
  reviewBusinessDomainParams: ReviewBusinessDomainParams
}

export type MutationReviewFlaggedProfileArgs = {
  reviewFlaggedProfileParams: ReviewFlaggedProfileParam
}

export type MutationReviewOrganizationArgs = {
  reviewOrganizationParams: ReviewOrganizationParams
}

export type MutationRevokeCollabLinkArgs = {
  revokeCollabLinkParams: RevokeCollabLinkParams
}

export type MutationRevokeMcpConnectionArgs = {
  params: RevokeMcpConnectionParams
}

export type MutationRevokePublicBusinessInvitationArgs = {
  revokePublicBusinessInvitationParams: RevokePublicBusinessInvitationParams
}

export type MutationSetAiProfileArgs = {
  setAiProfileParams: SetAiProfileParams
}

export type MutationSetAppSettingArgs = {
  setAppSettingParams: SetAppSettingParams
}

export type MutationSetBusinessDomainEnabledArgs = {
  setBusinessDomainEnabledParams: SetBusinessDomainEnabledParams
}

export type MutationSetCollegeAndMajorArgs = {
  setCollegeAndMajorParams: SetCollegeAndMajorParams
}

export type MutationSetGalleryDegradedArgs = {
  degradedStateParams: DegradedStateParams
}

export type MutationSetGlobalOverrideValueArgs = {
  setGlobalOverrideValueParams: SetGlobalOverrideValueParams
}

export type MutationSetIgnoreFlagsArgs = {
  setIgnoreFlagsParams: SetIgnoreFlagsParams
}

export type MutationSetLanguageArgs = {
  languageParams: SetLanguageParams
}

export type MutationSetLicenseEnforcementArgs = {
  setLicenseEnforcementParams: SetLicenseEnforcementParams
}

export type MutationSetLicenseEnforcementExpirationArgs = {
  setLicenseEnforcementExpirationParams: SetLicenseEnforcementExpirationParams
}

export type MutationSetMigratingDeviceArgs = {
  setMigratingDeviceRequest: SetMigratingDeviceRequest
}

export type MutationSetPromoAsDraftArgs = {
  promoDraftParams: PromoDraftParams
}

export type MutationSetUserSurveyResponseArgs = {
  setUserSurveyResponseParams: SetUserSurveyResponseParams
}

export type MutationShareCustomAssetArgs = {
  shareCustomAssetParams: ShareCustomAssetParams
}

export type MutationStartDiscussionArgs = {
  params: StartDiscussionParams
}

export type MutationStopSharingArgs = {
  stopParams: StopParams
}

export type MutationSyncQuizSessionArgs = {
  syncQuizSessionParams: SyncQuizSessionParams
}

export type MutationToggleDeviceLimitEnforcementArgs = {
  toggleDeviceLimitEnforcementParams: ToggleDeviceLimitEnforcementParams
}

export type MutationTriageNoteArgs = {
  triageNoteParams: TriageNoteParams
}

export type MutationUnfollowUserArgs = {
  unfollowParams: UnfollowParams
}

export type MutationUnlikeNoteArgs = {
  unlikeParams: LikeParams
}

export type MutationUnlinkCollabNoteFromCalendarEventArgs = {
  params: UnlinkCollabNoteFromCalendarEventParams
}

export type MutationUnlinkFolderFromCalendarSeriesArgs = {
  params: UnlinkFolderFromCalendarSeriesParams
}

export type MutationUnlockUserAccountArgs = {
  unlockUserAccountParams: UnlockUserAccountParams
}

export type MutationUnpublishArgs = {
  unpublishParams: UnpublishParams
}

export type MutationUnpublishTemplateArgs = {
  publishTemplateParams: PublishTemplateParams
}

export type MutationUpdateBioArgs = {
  bioParams: BioParams
}

export type MutationUpdateBusinessFeatureConfigArgs = {
  updateBusinessFeatureConfigParams: UpdateBusinessFeatureConfigParams
}

export type MutationUpdateBusinessTrialMemberLimitArgs = {
  updateBusinessTrialMemberLimitParams: UpdateBusinessTrialMemberLimitParams
}

export type MutationUpdateCollectionArgs = {
  updateNoteCollectionParams: UpdateNoteCollectionParams
}

export type MutationUpdateCookiesArgs = {
  updateCookiesParams: UpdateCookiesParams
}

export type MutationUpdateExperimentDataArgs = {
  experimentDataParams: ExperimentDataParams
}

export type MutationUpdateFullNameArgs = {
  fullNameParams: FullNameParams
}

export type MutationUpdateLearnSettingsArgs = {
  updateLearnSettingsParams: UpdateLearnSettingsParams
}

export type MutationUpdateOrganizationDetailsArgs = {
  updateOrganizationDetailsParams: UpdateOrganizationDetailsParams
}

export type MutationUpdateProfileArgs = {
  profileParams: ProfileParams
}

export type MutationUpdateUserExperimentEnrollmentOverrideArgs = {
  experimentEnrollmentParams: ExperimentEnrollmentParams
}

export type MutationUpdateUserLanguageArgs = {
  updateUserLanguageParams: UpdateUserLanguageParams
}

export type MutationUploadArgs = {
  uploadParams: UploadParams
}

export type MutationUploadUserGeneratedQuizArgs = {
  uploadUserGeneratedQuiz: UploadUserGeneratedQuizParams
}

export type MutationValidateGalaxyStorePurchaseArgs = {
  input: ValidateGalaxyStorePurchaseInput
}

export type MutationValidatePlayStoreOneTimePurchaseArgs = {
  input: ValidatePlayStoreOneTimePurchaseInput
}

export type MutationValidatePlayStorePurchaseTokenArgs = {
  input: ValidatePlayStorePurchaseTokenInput
}

export type MutationVisitCollabLinkArgs = {
  visitCollabLinkParams: VisitCollabLinkParams
}

export type Note = {
  __typename?: 'Note'
  clientId: Scalars['String']['output']
  clientModifiedDate: Scalars['DateTime']['output']
  createdDate: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  lastUpdateDate: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  noteUploadedAt?: Maybe<Scalars['DateTime']['output']>
  pdfUploadedAt?: Maybe<Scalars['DateTime']['output']>
  /** @deprecated No longer used */
  updatedDate: Scalars['DateTime']['output']
  url: Scalars['String']['output']
}

export type NoteActivity = {
  __typename?: 'NoteActivity'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>
  noteId: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type NoteCollection = {
  __typename?: 'NoteCollection'
  id: Scalars['String']['output']
  isFeatured: Scalars['Boolean']['output']
  isOfficialContent: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  notes: Array<GalleryNote>
  owner: User
}

export type NoteCollectionListResults = {
  __typename?: 'NoteCollectionListResults'
  results: Array<NoteCollection>
  totalCount: Scalars['Float']['output']
}

export type NoteCollectionNotesParams = {
  id: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
}

export type NoteCollectionParams = {
  collectionId: Scalars['String']['input']
}

export type NoteCollectionWithCount = {
  __typename?: 'NoteCollectionWithCount'
  collection: NoteCollection
  totalCount: Scalars['Float']['output']
}

export enum NoteLayoutMode {
  Paged = 'PAGED',
  Pageless = 'PAGELESS',
  Whiteboard = 'WHITEBOARD'
}

export type NoteMediaInsertion = {
  __typename?: 'NoteMediaInsertion'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  insertionOpLogicalTime: Scalars['Float']['output']
  insertionOpSiteId: Scalars['Float']['output']
  mediaExtension?: Maybe<Scalars['String']['output']>
  mediaType?: Maybe<Scalars['String']['output']>
  mediaUpload: MediaUploadStatus
  note: CollabNoteMetadata
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type NotePermissionFailure = {
  __typename?: 'NotePermissionFailure'
  email: Scalars['String']['output']
  reason: Scalars['String']['output']
}

export type NotePermissionRequest = {
  email: Scalars['String']['input']
  permissionLevel: CollabNoteRole
}

export type NotePermissionRequestV2 = {
  __typename?: 'NotePermissionRequestV2'
  accessLevel: CollabNoteRole
  id: Scalars['String']['output']
  state: NoteUserPermissionRequestState
  userId: Scalars['String']['output']
}

export type NotePermissionSuccess = {
  __typename?: 'NotePermissionSuccess'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  permissionLevel: CollabNoteRole
  userId?: Maybe<Scalars['String']['output']>
}

export enum NoteReadinessStatus {
  Locked = 'LOCKED',
  Ready = 'READY',
  Unavailable = 'UNAVAILABLE',
  WillGenerate = 'WILL_GENERATE'
}

export type NoteRenderData = {
  __typename?: 'NoteRenderData'
  data: Scalars['String']['output']
}

export type NoteRendererParams = {
  noteId: Scalars['String']['input']
}

export {NoteSortingKey}

export type NoteStudyReadiness = {
  __typename?: 'NoteStudyReadiness'
  memorize: NoteReadinessStatus
  noteId: Scalars['String']['output']
  practice: NoteReadinessStatus
  test: NoteReadinessStatus
}

export type NoteUserPermissionRequest = {
  __typename?: 'NoteUserPermissionRequest'
  accessLevel: CollabNoteRole
  collabNote: CollabNoteMetadata
  state: NoteUserPermissionRequestState
  user: User
}

export enum NoteUserPermissionRequestState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type NoteV2 = {
  __typename?: 'NoteV2'
  createdAt: Scalars['Timestamp']['output']
  deletedAt?: Maybe<Scalars['Timestamp']['output']>
  folderId?: Maybe<Scalars['String']['output']>
  hasRecordings: Scalars['Boolean']['output']
  hasUserShares: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  indexTimestamps?: Maybe<Array<IndexTimestamp>>
  isFavorited: Scalars['Boolean']['output']
  lastOpened?: Maybe<Scalars['Timestamp']['output']>
  layoutMode?: Maybe<NoteLayoutMode>
  legacyNoteId?: Maybe<Scalars['String']['output']>
  linkShareSettings: LinkShareSettings
  mostRecentOpTime?: Maybe<Scalars['Timestamp']['output']>
  permissionRequests?: Maybe<Array<NotePermissionRequestV2>>
  subjectId?: Maybe<Scalars['String']['output']>
  templateId?: Maybe<Scalars['String']['output']>
  templateType?: Maybe<Scalars['String']['output']>
  thumbnailOp?: Maybe<OpId>
  thumbnailUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  titleOp?: Maybe<OpId>
  updatedAt: Scalars['Timestamp']['output']
  userPermission: UserPermission
  workspaceId?: Maybe<Scalars['ID']['output']>
}

export type Notification = {
  __typename?: 'Notification'
  comment?: Maybe<Comment>
  createdAt: Scalars['DateTime']['output']
  eventCount: Scalars['Float']['output']
  galleryNote?: Maybe<GalleryNote>
  id: Scalars['ID']['output']
  lastNotificationActionAt: Scalars['DateTime']['output']
  notificationEvents: Array<NotificationEvent>
  promoNotification?: Maybe<PromoNotification>
  recipient: User
  seen: Scalars['Boolean']['output']
  type: NotificationType
}

export type NotificationEvent = {
  __typename?: 'NotificationEvent'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  notification: Notification
  triggeringUser?: Maybe<User>
}

export {NotificationType}

/** A short-lived provider access token. Sensitive — do not log or persist. */
export type OAuthAccessToken = {
  __typename?: 'OAuthAccessToken'
  accessToken: Scalars['String']['output']
  expiresAt: Scalars['DateTime']['output']
  grantedScopes: Array<Scalars['String']['output']>
}

export type OAuthConnectedAccount = {
  __typename?: 'OAuthConnectedAccount'
  createdAt: Scalars['DateTime']['output']
  grantedScopes: Array<Scalars['String']['output']>
  healthStatus: OAuthConnectionHealthStatus
  id: Scalars['ID']['output']
  provider: OAuthProvider
  providerAccountEmail: Scalars['String']['output']
}

export enum OAuthConnectionHealthStatus {
  Healthy = 'HEALTHY',
  RefreshFailing = 'REFRESH_FAILING',
  Revoked = 'REVOKED'
}

export enum OAuthProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type OfficialCollectionNotesParams = {
  limit?: InputMaybe<Scalars['Float']['input']>
  officialId: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
}

export type OpCounts = {
  __typename?: 'OpCounts'
  coldStorage: Scalars['Float']['output']
  onstream: Scalars['Float']['output']
}

export type OpId = {
  __typename?: 'OpId'
  siteId: Scalars['Int']['output']
  timestamp: Scalars['Int']['output']
}

export type Organization = {
  __typename?: 'Organization'
  approved: Scalars['Boolean']['output']
  approvedAt?: Maybe<Scalars['DateTime']['output']>
  comments?: Maybe<Scalars['String']['output']>
  contractAcceptedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']['output']
  industry?: Maybe<Scalars['String']['output']>
  isAsmEnrolled: Scalars['Boolean']['output']
  license?: Maybe<OrganizationLicense>
  mdmPlatform?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  organizationType: OrganizationType
  rejectionReason?: Maybe<Scalars['String']['output']>
  sentLicenseReminderEmailAt?: Maybe<Scalars['DateTime']['output']>
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  subscription?: Maybe<OrganizationSubscription>
  termsAcceptedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  userMappings: Array<OrganizationUser>
}

export type OrganizationAdminDetails = {
  __typename?: 'OrganizationAdminDetails'
  approved: Scalars['Boolean']['output']
  email: Scalars['String']['output']
  hasValidSubscription: Scalars['Boolean']['output']
  industry?: Maybe<Scalars['String']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  licenseKey?: Maybe<Scalars['String']['output']>
  maxSeats: Scalars['Int']['output']
  mdmPlatform?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  organizationDeletedAt?: Maybe<Scalars['DateTime']['output']>
  organizationId: Scalars['String']['output']
  organizationName: Scalars['String']['output']
  organizationStatus: OrganizationStatus
  organizationType: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  role: OrganizationRole
  subscriptionCancelAt?: Maybe<Scalars['DateTime']['output']>
  subscriptionStatus?: Maybe<Scalars['String']['output']>
  usedSeats: Scalars['Int']['output']
}

export type OrganizationAdminQueryParams = {
  userId: Scalars['String']['input']
}

export type OrganizationAdminSummary = {
  __typename?: 'OrganizationAdminSummary'
  email: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  userId: Scalars['String']['output']
}

export type OrganizationAdminView = {
  __typename?: 'OrganizationAdminView'
  approved: Scalars['Boolean']['output']
  createdAt: Scalars['Timestamp']['output']
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']['output']
  industry?: Maybe<Scalars['String']['output']>
  organizationName: Scalars['String']['output']
  organizationType: Scalars['String']['output']
  role: OrganizationRole
  status: OrganizationStatus
}

export type OrganizationDetails = {
  __typename?: 'OrganizationDetails'
  adminCreatorEmail?: Maybe<Scalars['String']['output']>
  admins: Array<OrganizationAdminSummary>
  approved: Scalars['Boolean']['output']
  approvedAt?: Maybe<Scalars['Timestamp']['output']>
  contractAcceptedAt?: Maybe<Scalars['Timestamp']['output']>
  createdAt: Scalars['Timestamp']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']['output']
  industry?: Maybe<Scalars['String']['output']>
  licenseKey?: Maybe<Scalars['String']['output']>
  maxSeats: Scalars['Int']['output']
  mdmPlatform?: Maybe<Scalars['String']['output']>
  organizationName: Scalars['String']['output']
  organizationType: Scalars['String']['output']
  organizationUsers: Array<OrganizationUserSummary>
  owner: OrganizationAdminSummary
  sentLicenseReminderEmailAt?: Maybe<Scalars['Timestamp']['output']>
  status: OrganizationStatus
  subscriptionStatus: OrganizationSubscriptionStatus
  termsAcceptedAt?: Maybe<Scalars['Timestamp']['output']>
  usedSeats: Scalars['Int']['output']
}

export type OrganizationDetailsOrganizationUsersArgs = {
  organizationUsersParams?: InputMaybe<OrganizationUsersParams>
}

export type OrganizationEmailEvents = {
  __typename?: 'OrganizationEmailEvents'
  count: Scalars['Float']['output']
  events: Array<SendGridEvent>
}

export type OrganizationLicense = {
  __typename?: 'OrganizationLicense'
  createdAt: Scalars['DateTime']['output']
  expiration: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  maxSeats: Scalars['Float']['output']
  organization: Organization
  updatedAt: Scalars['DateTime']['output']
  usedSeats: Scalars['Float']['output']
}

export type OrganizationMemberView = {
  __typename?: 'OrganizationMemberView'
  approved: Scalars['Boolean']['output']
  createdAt: Scalars['Timestamp']['output']
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']['output']
  industry?: Maybe<Scalars['String']['output']>
  organizationName: Scalars['String']['output']
  organizationType: Scalars['String']['output']
  role: OrganizationRole
  status: OrganizationStatus
}

export type OrganizationOwnerView = {
  __typename?: 'OrganizationOwnerView'
  adminCreatorEmail?: Maybe<Scalars['String']['output']>
  admins: Array<OrganizationAdminSummary>
  approved: Scalars['Boolean']['output']
  approvedAt?: Maybe<Scalars['Timestamp']['output']>
  contractAcceptedAt?: Maybe<Scalars['Timestamp']['output']>
  createdAt: Scalars['Timestamp']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']['output']
  industry?: Maybe<Scalars['String']['output']>
  licenseKey?: Maybe<Scalars['String']['output']>
  maxSeats: Scalars['Int']['output']
  mdmPlatform?: Maybe<Scalars['String']['output']>
  organizationName: Scalars['String']['output']
  organizationType: Scalars['String']['output']
  role: OrganizationRole
  sentLicenseReminderEmailAt?: Maybe<Scalars['Timestamp']['output']>
  status: OrganizationStatus
  subscriptionStatus: OrganizationSubscriptionStatus
  termsAcceptedAt?: Maybe<Scalars['Timestamp']['output']>
  usedSeats: Scalars['Int']['output']
}

export enum OrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum OrganizationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type OrganizationSubscription = {
  __typename?: 'OrganizationSubscription'
  cancelAt?: Maybe<Scalars['DateTime']['output']>
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  endedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  organization: Organization
  status: StripeSubscriptionStatus
  stripePriceId: Scalars['String']['output']
  stripeProductId: Scalars['String']['output']
  stripeSubscriptionId: Scalars['String']['output']
  trialEndedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum OrganizationSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  None = 'NONE',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum OrganizationType {
  B2B = 'B2B',
  Edu = 'EDU'
}

export type OrganizationUser = {
  __typename?: 'OrganizationUser'
  createdAt: Scalars['DateTime']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  organization: Organization
  phone?: Maybe<Scalars['String']['output']>
  role: OrganizationRole
  status: OrganizationUserStatus
  user: User
}

export enum OrganizationUserStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Invited = 'INVITED'
}

export type OrganizationUserSummary = {
  __typename?: 'OrganizationUserSummary'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  role: Scalars['String']['output']
  status: Scalars['String']['output']
  userId: Scalars['String']['output']
}

export type OrganizationUsersParams = {
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type OrganizationView = OrganizationAdminView | OrganizationMemberView | OrganizationOwnerView

export type Organizer = {
  __typename?: 'Organizer'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  legacyOrganizerId?: Maybe<Scalars['String']['output']>
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']['output']>
  siblingOrder: Scalars['Float']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
  workspace: WorkspaceEntity
  workspaceId: Scalars['ID']['output']
}

export type OrganizerMutationResult = {
  __typename?: 'OrganizerMutationResult'
  appSettings?: Maybe<Scalars['JSONObject']['output']>
  errorCode?: Maybe<Scalars['Float']['output']>
  notes: Array<CollabNoteUserMetadata>
  organizers: Array<OrganizerType>
  success: Scalars['Boolean']['output']
}

export type OrganizerType = Divider | Folder | Subject

export enum OrganizerTypeKey {
  Divider = 'DIVIDER',
  Folder = 'FOLDER',
  Subject = 'SUBJECT'
}

export type OrganizerV2 = {
  __typename?: 'OrganizerV2'
  id: Scalars['String']['output']
  legacyOrganizerId?: Maybe<Scalars['String']['output']>
  organizerType: OrganizerTypeKey
  parentId?: Maybe<Scalars['String']['output']>
  siblingOrder: Scalars['Float']['output']
  /** exists for Subjects only */
  subjectEmoji?: Maybe<Scalars['String']['output']>
  /** exists for Subjects only */
  subjectHexColor?: Maybe<Scalars['String']['output']>
  /** exists for Subjects only */
  subjectIsLocked?: Maybe<Scalars['Boolean']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['Timestamp']['output']
  workspaceId?: Maybe<Scalars['ID']['output']>
}

export type PagingParams = {
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
}

export type ParentNoteParams = {
  ancestorNoteIds: Array<Scalars['String']['input']>
}

export type PatchBusinessSubscriptionParams = {
  businessId: Scalars['String']['input']
  forcePatchCustomerId: Scalars['Boolean']['input']
  stripeSubscriptionId: Scalars['String']['input']
}

export type PatchBusinessSubscriptionResult = {
  __typename?: 'PatchBusinessSubscriptionResult'
  success: Scalars['Boolean']['output']
}

export type PendingBusinessDomain = {
  __typename?: 'PendingBusinessDomain'
  businessId: Scalars['ID']['output']
  businessName: Scalars['String']['output']
  createdAt: Scalars['Timestamp']['output']
  domain: Scalars['String']['output']
  id: Scalars['ID']['output']
  ownerEmail?: Maybe<Scalars['String']['output']>
  ownerName?: Maybe<Scalars['String']['output']>
}

export type PendingRecoveryEmailChange = {
  __typename?: 'PendingRecoveryEmailChange'
  email: Scalars['String']['output']
  expiresAt: Scalars['DateTime']['output']
}

export type PermanentlyDeleteNote = {
  noteId: Scalars['String']['input']
}

export type PermissionBusinessUserForWorkspaceNoteRequest = {
  email: Scalars['String']['input']
  noteId: Scalars['String']['input']
  permissionLevel: AccessLevel
}

export type PermissionChange = {
  /** null to revoke permission */
  accessLevel?: InputMaybe<AccessLevel>
  userId: Scalars['String']['input']
}

export type PermissionRequest = {
  __typename?: 'PermissionRequest'
  accessLevel: CollabNoteRole
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  requestId: Scalars['String']['output']
  state: NoteUserPermissionRequestState
  userId: Scalars['String']['output']
}

export enum PermissionScope {
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export enum PermissionScopeV2 {
  BusinessWide = 'BUSINESS_WIDE',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type PermissionedUser = {
  __typename?: 'PermissionedUser'
  accessLevel: CollabNoteRole
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  userId: Scalars['String']['output']
}

export type Persona = BusinessUserPersona | EducatorUserPersona | PersonalUserPersona | StudentUserPersona

export enum PersonaType {
  Business = 'BUSINESS',
  Educator = 'EDUCATOR',
  Personal = 'PERSONAL',
  Student = 'STUDENT'
}

export type PersonalUserPersona = {
  __typename?: 'PersonalUserPersona'
  personaType: PersonaType
}

export type PrepareCustomAssetUploadParams = {
  businessId?: InputMaybe<Scalars['ID']['input']>
  legacyAssetId?: InputMaybe<Scalars['String']['input']>
  md5Hash: Scalars['String']['input']
  name: Scalars['String']['input']
  sha512Hash: Scalars['String']['input']
  sizeInBytes: Scalars['Float']['input']
  type: CustomAssetType
}

export type PrepareCustomAssetUploadResult = {
  __typename?: 'PrepareCustomAssetUploadResult'
  customAssetId: Scalars['String']['output']
  mediaUploadSignedUrl?: Maybe<Scalars['String']['output']>
  uploadStatus: MediaUploadStatusEnum
}

export type PrepareMediaUploadParams = {
  md5Hash: Scalars['String']['input']
  sha512Hash: Scalars['String']['input']
  sizeInBytes: Scalars['Float']['input']
}

export type PrepareMediaUploadResult = {
  __typename?: 'PrepareMediaUploadResult'
  mediaUploadSignedUrl?: Maybe<Scalars['String']['output']>
  uploadStatus: Scalars['String']['output']
}

export type PreviewDesktopStatusParams = {
  candidate: DesktopStatusParams
  context: DesktopStatusContextParams
}

export type ProfileParams = {
  name?: InputMaybe<Scalars['String']['input']>
  screenname: Scalars['String']['input']
}

export enum ProfileSection {
  Avatar = 'AVATAR',
  Description = 'DESCRIPTION',
  Multiple = 'MULTIPLE',
  SocialLinks = 'SOCIAL_LINKS'
}

export type PromoDraftParams = {
  id: Scalars['String']['input']
  isDraft: Scalars['Boolean']['input']
}

export type PromoNotification = {
  __typename?: 'PromoNotification'
  author: User
  endDate: Scalars['DateTime']['output']
  href: Scalars['String']['output']
  id: Scalars['ID']['output']
  isDraft: Scalars['Boolean']['output']
  notifications: Array<Notification>
  startDate: Scalars['DateTime']['output']
  translationKey: Scalars['String']['output']
}

export type PromoNotificationParams = {
  endDate: Scalars['DateTime']['input']
  href: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['DateTime']['input']
  translationKey: Scalars['String']['input']
}

export type PublicBusinessInvitation = {
  __typename?: 'PublicBusinessInvitation'
  active: Scalars['Boolean']['output']
  businessId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  token: Scalars['String']['output']
}

export type PublishParams = {
  audioDurationSeconds: Scalars['Float']['input']
  categoryId?: InputMaybe<Scalars['String']['input']>
  clientNoteId: Scalars['String']['input']
  collabNoteId?: InputMaybe<Scalars['String']['input']>
  containsMedia?: InputMaybe<Scalars['Boolean']['input']>
  containsPencil?: InputMaybe<Scalars['Boolean']['input']>
  containsStudyTape?: InputMaybe<Scalars['Boolean']['input']>
  contentType?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  language?: InputMaybe<Scalars['String']['input']>
  noteName: Scalars['String']['input']
  pageCount: Scalars['Float']['input']
  parentNoteId?: InputMaybe<Scalars['String']['input']>
  previewCount: Scalars['Float']['input']
  searchIndexes?: InputMaybe<SearchIndexParams>
  serverPublishId?: InputMaybe<Scalars['String']['input']>
  tags: Array<Scalars['String']['input']>
}

export type PublishResult = {
  __typename?: 'PublishResult'
  galleryNote: GalleryNote
  imageUploadPolicies: Array<Scalars['String']['output']>
  noteUploadPolicy: Scalars['String']['output']
  ntbUploadPolicy: Scalars['String']['output']
  pdfUploadPolicy: Scalars['String']['output']
}

export type PublishTemplateParams = {
  customAssetId: Scalars['ID']['input']
}

export type Query = {
  __typename?: 'Query'
  achievements: AchievementsResponse
  adminFuzzyUserSearch: Array<Scalars['String']['output']>
  /** @deprecated Use galleryNoteSearch instead */
  adminGalleryNoteSearch: Array<GalleryNote>
  adminGetCurrentLearnUsage: AdminLearnQuotaResponse
  adminGetSendGridSuppressions: Array<SendGridSuppressionListing>
  adminGetSubscriptionOverview?: Maybe<SubscriptionOverview>
  adminGetUserData: User
  adminSearchNoteWithTitle: AdminSearchNoteWithTitleResponse
  approvedBusinessDomains: Array<ApprovedBusinessDomain>
  batchGetUserSurveyResponses: Array<UserSurveyResponse>
  /** @deprecated enrollment limits are lifted */
  checkEnrollmentAvailability: EnrollmentLimits
  desktopStatuses: Array<DesktopStatus>
  discoverFeed: Array<DiscoverFeedRow>
  downloadCustomAsset: DownloadCustomAssetResult
  featureFlagEvaluation: FeatureFlagEvaluation
  flashcardDueCounts: Array<FlashcardDueCount>
  /** @deprecated Use galleryNoteSearch instead */
  followedGalleryNoteSearch: Array<GalleryNote>
  galleryNoteAndSimilar: GalleryNoteAndSimilar
  galleryNoteSearch: Array<GalleryNote>
  galleryProfile: UserProfile
  getASRJob: AsrJobResult
  getAllBusinesses: GetAllBusinessesResponse
  /** @deprecated Categories are deprecated */
  getAllCategories: Array<Category>
  getAllComments: Array<Comment>
  getAllIndustries: AllIndustriesResults
  getAllOrganizations: AllOrganizationResults
  getAllPermissionedUsersForNote: AllPermissionedUsersForNoteResponse
  getAllSubscriptionInfo: SubscriptionInfo
  getAllSubscriptionsOverDeviceLimit: Array<GetAllSubscriptionsOverDeviceLimitResult>
  getBuildMetadata: GetBuildMetadataResult
  /** The calling user's notes linked to these events, and folders linked to their series. Each note result echoes the requested eventId and recurrenceId. */
  getCalendarLinks: CalendarLinks
  getChatHistory: Array<StudyChatMessage>
  getChatbotThreads: Array<ChatbotThread>
  getCollatedFlaggedNoteInfo: Array<GetCollatedFlaggedNoteInfoResult>
  getCollegeMajors: Array<CollegeMajor>
  getCurrentASRProcessorVersion: AsrProcessorVersion
  getCurrentQuotaUsage: QuotaUsage
  /** @deprecated Use User.customAssets field resolver */
  getCustomAssets: CustomAssetQueryResult
  getExperimentEnrollmentOverrides: Array<ExperimentEnrollment>
  getFavoriteNotes: Array<CollabNoteMetadata>
  getFeatureFlagsForUser: Array<Scalars['String']['output']>
  getFeaturedCollections: Array<NoteCollection>
  getFeaturedCollectionsAndNotes: Array<NoteCollectionWithCount>
  getFeaturedNotes: GalleryNoteResults
  getFuzzyScreennameMatches: Array<Scalars['String']['output']>
  getInstitutions: GetInstitutionsResult
  getInvitedUserStatus: GetInvitedUserStatusResponse
  /** @deprecated UserResolver.subscriptionOverview() includes quotas now replacing this query. */
  getLearnQuotaUsage: LearnQuotaUsage
  getLibraryCounts: LibraryCounts
  getMigrations: Array<MigratingDevice>
  getNoteCollection?: Maybe<NoteCollection>
  getNoteCollectionsForUser: NoteCollectionListResults
  getNoteRendererData?: Maybe<NoteRenderData>
  getNoteRootComments: Array<Comment>
  getNotes: Array<GalleryNote>
  getNotesForCollection: GalleryNoteResults
  getNotesForOfficialCollection: GalleryNoteResults
  getNotifications: Array<Notification>
  getOfficialNoteCollections: NoteCollectionListResults
  getOrganization: OrganizationDetails
  /** @deprecated Use getOrganization.owner field resolver */
  getOrganizationAdmin: OrganizationAdminDetails
  getOrganizationsAwaitingApproval: Array<Organization>
  getParentNote?: Maybe<GalleryNote>
  getPublishersFollowedByUser: Array<User>
  getQuestionableNoteContent: Array<SearchIndexFlagInfo>
  getQuizJobContent?: Maybe<Scalars['String']['output']>
  getQuizQuestionExplanation?: Maybe<Scalars['String']['output']>
  getQuizSessions: Array<QuizSession>
  getRecentCollabNotes: Array<CollabNoteMetadata>
  getRecentReleases: Array<ReleaseNote>
  getRecentlyDeletedWorkspacesForBusiness: Array<WorkspaceUserMetadata>
  getSendGridEvents: OrganizationEmailEvents
  getSiteUserMappings: Array<SiteUserMapping>
  getStripeCustomerPortal: StripeCustomerPortal
  getStudyMaterialsBatch: StudyMaterialsBatch
  getSubscriptionDisputeInfo: SubscriptionDisputeInfo
  getSubscriptionInfoForUser: UserSubscriptionResult
  getSummaryJobContent?: Maybe<Scalars['String']['output']>
  getTopTags: Array<TopTag>
  getTranslationMappings: Array<TranslationMapping>
  getUnmigratedGalleryNotes: GetUnmigratedGalleryNotesResult
  getUserAdminEvents: Array<UserAdminEvent>
  getUserIsFollowed: FollowPair
  getUserLikesNotes: Array<LikedNotePair>
  getUserNoteAdminEvents: Array<GalleryNoteAdminEvent>
  getUserSharedNotes: Array<Note>
  getUserSubscriptionInfo?: Maybe<UserSubscriptionResult>
  getUserSurveyResponse: UserSurveyResponse
  getUserTrialSubscription?: Maybe<TrialSubscription>
  getUsersFollowingPublisher: Array<User>
  getUsersForWorkspace: Array<GetUsersForWorkspaceResponse>
  getUsersWhoLikedNote: Array<User>
  getVPPEmailDomains: Array<VppAllowlistEmail>
  getViableSubscription?: Maybe<AppStoreSubscription>
  getWorkspaces: Array<WorkspaceUserMetadata>
  getWorldColleges: Array<College>
  getYoutubeTranscript: YouTubeTranscriptResult
  hiddenProfiles: HiddenProfilesResults
  /** @deprecated Use user.isOrganizationOwner */
  isCurrentUserOrganizationAdmin: Scalars['Boolean']['output']
  login: User
  /** @deprecated Use verifyAuth */
  me: User
  newFollowingNotesAvailable: Scalars['Boolean']['output']
  opCounts: OpCounts
  pendingBusinessDomains: Array<PendingBusinessDomain>
  previewDesktopStatus: DesktopStatusPreview
  previewLiveDesktopStatus: DesktopStatusPreview
  publicBusinessInvitations: Array<PublicBusinessInvitation>
  /** @deprecated Use the metadata websocket for library state */
  retrieveMetadataLibrary: LibraryState
  searchInvitableUsers: SearchInvitableUsersResponse
  searchSubscriptionDisputes: SubscriptionDisputeSearch
  triageNoteSearch: TriageSearchResults
  userDownloadedNotes: Array<GalleryNote>
  userFavoritedNotes: Array<GalleryNote>
  userNotes: Array<GalleryNote>
  validateBusinessInvitation: ValidateBusinessInvitationResponse
  validatePublicBusinessInvitation: PublicBusinessInvitation
  verifyAuth: User
}

export type QueryAdminFuzzyUserSearchArgs = {
  adminFuzzyUserSearchParams: AdminFuzzyUserSearchParams
}

export type QueryAdminGalleryNoteSearchArgs = {
  searchParams: SearchParams
}

export type QueryAdminGetCurrentLearnUsageArgs = {
  adminGetCurrentLearnUsageParams: AdminGetCurrentLearnUsageParams
}

export type QueryAdminGetSendGridSuppressionsArgs = {
  adminGetSendGridSuppressionsParams: AdminGetSendGridSuppressionsParams
}

export type QueryAdminGetSubscriptionOverviewArgs = {
  adminGetSubscriptionOverviewParams: AdminGetSubscriptionOverviewParams
}

export type QueryAdminGetUserDataArgs = {
  adminGetUserDataParams: AdminGetUserDataParams
}

export type QueryAdminSearchNoteWithTitleArgs = {
  adminSearchNoteWithTitleParams: AdminSearchNoteWithTitleParams
}

export type QueryBatchGetUserSurveyResponsesArgs = {
  batchGetUserSurveyResponsesParams: BatchGetUserSurveyResponsesParams
}

export type QueryCheckEnrollmentAvailabilityArgs = {
  params: CheckEnrollmentAvailabilityParams
}

export type QueryDesktopStatusesArgs = {
  includeRemoved?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryDiscoverFeedArgs = {
  discoverFeedParams: DiscoverFeedParams
}

export type QueryDownloadCustomAssetArgs = {
  downloadCustomAssetParams: DownloadCustomAssetParams
}

export type QueryFeatureFlagEvaluationArgs = {
  featureFlagEvaluationParams: FeatureFlagEvaluationParams
}

export type QueryFlashcardDueCountsArgs = {
  flashcardDueCountsParams?: InputMaybe<FlashcardDueCountsParams>
}

export type QueryFollowedGalleryNoteSearchArgs = {
  followedNoteSearchParams: SearchParams
}

export type QueryGalleryNoteAndSimilarArgs = {
  galleryNoteAndSimilarParams: GalleryNoteAndSimilarParams
}

export type QueryGalleryNoteSearchArgs = {
  searchParams: SearchParams
}

export type QueryGalleryProfileArgs = {
  galleryProfileParams: GalleryProfileParams
}

export type QueryGetAsrJobArgs = {
  getASRJobParams: GetAsrJobParams
}

export type QueryGetAllBusinessesArgs = {
  getAllBusinessesParams: GetAllBusinessesParams
}

export type QueryGetAllCommentsArgs = {
  getAllCommentsParams: GetAllCommentsParams
}

export type QueryGetAllOrganizationsArgs = {
  getAllOrganizationsParams?: InputMaybe<GetAllOrganizationsParams>
}

export type QueryGetAllPermissionedUsersForNoteArgs = {
  allPermissionedUsersForNoteRequest: AllPermissionedUsersForNoteRequest
}

export type QueryGetAllSubscriptionInfoArgs = {
  getAllSubscriptionInfoParams: GetAllSubscriptionInfoParams
}

export type QueryGetAllSubscriptionsOverDeviceLimitArgs = {
  getAllSubscriptionsOverDeviceLimitParams: GetAllSubscriptionsOverDeviceLimitParams
}

export type QueryGetBuildMetadataArgs = {
  getBuildMetadataParams: GetBuildMetadataParams
}

export type QueryGetCalendarLinksArgs = {
  params: GetCalendarLinksParams
}

export type QueryGetChatHistoryArgs = {
  getChatHistoryParams: GetChatHistoryParams
}

export type QueryGetChatbotThreadsArgs = {
  getChatbotThreadsParams: GetChatbotThreadsParams
}

export type QueryGetCollatedFlaggedNoteInfoArgs = {
  getCollatedFlaggedNoteInfoParams: GetCollatedFlaggedNoteInfoParams
}

export type QueryGetCurrentQuotaUsageArgs = {
  getCurrentQuotaUsageParams: GetCurrentQuotaUsageParams
}

export type QueryGetCustomAssetsArgs = {
  customAssetQueryParams: CustomAssetQueryParams
}

export type QueryGetExperimentEnrollmentOverridesArgs = {
  experimentEnrollmentOverrideQueryParams: ExperimentEnrollmentOverrideQueryParams
}

export type QueryGetFavoriteNotesArgs = {
  favoriteNotesParams: FavoriteNotesParams
}

export type QueryGetFeaturedCollectionsAndNotesArgs = {
  featuredCollectionsAndNotesParams: FeaturedCollectionsAndNotesParams
}

export type QueryGetFeaturedNotesArgs = {
  featuredNotesParams: PagingParams
}

export type QueryGetFuzzyScreennameMatchesArgs = {
  getFuzzyScreennameMatchesParams: GetFuzzyScreennameMatchesParams
}

export type QueryGetInstitutionsArgs = {
  getInstitutionsParams: GetInstitutionsParams
}

export type QueryGetInvitedUserStatusArgs = {
  getInvitedUserStatusParams: GetInvitedUserStatusParams
}

export type QueryGetLearnQuotaUsageArgs = {
  getLearnQuotaUsageParams: GetLearnQuotaUsageParams
}

export type QueryGetLibraryCountsArgs = {
  getLibraryCountsParams: GetLibraryCountsParams
}

export type QueryGetMigrationsArgs = {
  getMigrationsParams: GetMigrationsParams
}

export type QueryGetNoteCollectionArgs = {
  noteCollectionParams: NoteCollectionParams
}

export type QueryGetNoteCollectionsForUserArgs = {
  userNoteCollectionsParams: UserNoteCollectionsParams
}

export type QueryGetNoteRendererDataArgs = {
  noteRendererParams: NoteRendererParams
}

export type QueryGetNoteRootCommentsArgs = {
  getNoteRootCommentsParams: GetNoteRootCommentsParams
}

export type QueryGetNotesArgs = {
  getNotesParams: GetNotesParameters
}

export type QueryGetNotesForCollectionArgs = {
  noteCollectionNotesParams: NoteCollectionNotesParams
}

export type QueryGetNotesForOfficialCollectionArgs = {
  officialCollectionNotesParams: OfficialCollectionNotesParams
}

export type QueryGetNotificationsArgs = {
  getNotificationsParams: GetNotificationsParams
}

export type QueryGetOfficialNoteCollectionsArgs = {
  pagingParams: PagingParams
}

export type QueryGetOrganizationArgs = {
  getOrganizationParams: GetOrganizationParams
}

export type QueryGetOrganizationAdminArgs = {
  organizationAdminQueryParams: OrganizationAdminQueryParams
}

export type QueryGetParentNoteArgs = {
  parentNoteParams: ParentNoteParams
}

export type QueryGetPublishersFollowedByUserArgs = {
  followingUsersParameters: FollowingUsersParameters
}

export type QueryGetQuestionableNoteContentArgs = {
  questionableNoteContentParams: QuestionableNoteContentParams
}

export type QueryGetQuizJobContentArgs = {
  getQuizJobContentParams: GetQuizJobContentParams
}

export type QueryGetQuizQuestionExplanationArgs = {
  getQuizQuestionExplanationParams: GetQuizQuestionExplanationParams
}

export type QueryGetQuizSessionsArgs = {
  getQuizSessionsParams: GetQuizSessionsParams
}

export type QueryGetRecentCollabNotesArgs = {
  recentNotesParams: RecentNotesParams
}

export type QueryGetRecentReleasesArgs = {
  params: GetRecentReleasesParams
}

export type QueryGetSendGridEventsArgs = {
  getSendGridEventsParams: GetSendGridEventsParams
}

export type QueryGetSiteUserMappingsArgs = {
  siteUserMappingQueryParams: SiteUserMappingQueryParams
}

export type QueryGetStripeCustomerPortalArgs = {
  getStripeCustomerPortalParams: GetStripeCustomerPortalParams
}

export type QueryGetStudyMaterialsBatchArgs = {
  getStudyMaterialsBatchParams: GetStudyMaterialsBatchParams
}

export type QueryGetSubscriptionDisputeInfoArgs = {
  getSubscriptionDisputeInfoParams: GetSubscriptionDisputeInfoParams
}

export type QueryGetSummaryJobContentArgs = {
  getSummaryJobContentParams: GetSummaryJobContentParams
}

export type QueryGetTopTagsArgs = {
  getTopTagsParams?: InputMaybe<GetTopTagParams>
}

export type QueryGetTranslationMappingsArgs = {
  translationMappingParams: TranslationMappingParams
}

export type QueryGetUnmigratedGalleryNotesArgs = {
  getUnmigratedGalleryNotesParams: GetUnmigratedGalleryNotesParams
}

export type QueryGetUserAdminEventsArgs = {
  adminEventSearchParams: AdminEventSearchParams
}

export type QueryGetUserIsFollowedArgs = {
  getUserIsFollowedParams: GetUserIsFollowedParams
}

export type QueryGetUserLikesNotesArgs = {
  userLikesNotesParameters: UserLikesNotesParameters
}

export type QueryGetUserNoteAdminEventsArgs = {
  adminEventSearchParams: AdminEventSearchParams
}

export type QueryGetUserSharedNotesArgs = {
  getUserSharedNotesParams: GetUserSharedNotesParams
}

export type QueryGetUserSubscriptionInfoArgs = {
  getSubscriptionInfoParams: GetSubscriptionInfoParams
}

export type QueryGetUserTrialSubscriptionArgs = {
  getUserTrialSubscriptionParams: GetUserTrialSubscriptionParams
}

export type QueryGetUsersFollowingPublisherArgs = {
  followingUsersParameters: FollowingUsersParameters
}

export type QueryGetUsersForWorkspaceArgs = {
  GetWorkspaceUsersParams: GetWorkspaceUsersParams
}

export type QueryGetUsersWhoLikedNoteArgs = {
  likingUsersParameters: LikingUsersParameters
}

export type QueryGetVppEmailDomainsArgs = {
  getVPPEmailDomainParams: GetVppEmailDomainParams
}

export type QueryGetViableSubscriptionArgs = {
  getViableSubscriptionParams: GetViableSubscriptionParams
}

export type QueryGetYoutubeTranscriptArgs = {
  youtubeTranscriptParams: YoutubeTranscriptParams
}

export type QueryHiddenProfilesArgs = {
  hiddenProfilesParams: HiddenProfilesParams
}

export type QueryLoginArgs = {
  loginParams: LoginParams
}

export type QueryMeArgs = {
  authParams?: InputMaybe<AuthParams>
}

export type QueryOpCountsArgs = {
  getOpCountsParams: GetOpCountsParams
}

export type QueryPreviewDesktopStatusArgs = {
  previewDesktopStatusParams: PreviewDesktopStatusParams
}

export type QueryPreviewLiveDesktopStatusArgs = {
  context: DesktopStatusContextParams
}

export type QueryPublicBusinessInvitationsArgs = {
  businessId: Scalars['ID']['input']
}

export type QueryRetrieveMetadataLibraryArgs = {
  metadataLibraryRequest: MetadataLibraryRequest
}

export type QuerySearchInvitableUsersArgs = {
  searchInvitableUsersParams: SearchInvitableUsersParams
}

export type QuerySearchSubscriptionDisputesArgs = {
  searchSubscriptionDisputesParams: SearchSubscriptionDisputesParams
}

export type QueryTriageNoteSearchArgs = {
  triageSearchParams: TriageSearchParams
}

export type QueryUserDownloadedNotesArgs = {
  userNotesParams: UserNotesParameters
}

export type QueryUserFavoritedNotesArgs = {
  userNotesParams: UserFavoritedNotesParameters
}

export type QueryUserNotesArgs = {
  userNotesParams: UserNotesParameters
}

export type QueryValidateBusinessInvitationArgs = {
  ValidateBusinessInvitationParams: ValidateBusinessInvitationParams
}

export type QueryValidatePublicBusinessInvitationArgs = {
  token: Scalars['String']['input']
}

export type QueryVerifyAuthArgs = {
  authParams?: InputMaybe<AuthParams>
}

export type QuestionPromise = {
  __typename?: 'QuestionPromise'
  questionId: Scalars['String']['output']
  quizJobId: Scalars['String']['output']
  sourceNoteId?: Maybe<Scalars['String']['output']>
  type: QuizSessionQuestionType
}

export type QuestionableNoteContentParams = {
  noteId: Scalars['String']['input']
}

export type QuizFlashcardInput = {
  answerExplanation?: InputMaybe<Scalars['String']['input']>
  definition: Scalars['String']['input']
  term: Scalars['String']['input']
}

export type QuizJob = {
  __typename?: 'QuizJob'
  cacheCreationInputTokensUsed: Scalars['Float']['output']
  cacheReadInputTokensUsed: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  errorReason?: Maybe<LearnErrorReason>
  id: Scalars['String']['output']
  inputTokensUsed: Scalars['Float']['output']
  numQuestions?: Maybe<Scalars['Int']['output']>
  outputTokensUsed: Scalars['Float']['output']
  promptKey?: Maybe<Scalars['String']['output']>
  status: QuizJobStatus
  studyMaterialsBatch?: Maybe<StudyMaterialsBatch>
  studyMaterialsBatchId: Scalars['String']['output']
  subscriber?: Maybe<Subscriber>
  type: QuizJobType
  updatedAt: Scalars['DateTime']['output']
  userUploaded: Scalars['Boolean']['output']
}

export enum QuizJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING'
}

export enum QuizJobType {
  Flashcard = 'FLASHCARD',
  Quiz = 'QUIZ',
  TrueOrFalse = 'TRUE_OR_FALSE'
}

export type QuizNoteOutcome = {
  __typename?: 'QuizNoteOutcome'
  noteId: Scalars['String']['output']
  status: QuizNoteStatus
}

export enum QuizNoteStatus {
  Inaccessible = 'INACCESSIBLE',
  Locked = 'LOCKED',
  LowContent = 'LOW_CONTENT',
  NoStudyMaterials = 'NO_STUDY_MATERIALS',
  Ready = 'READY'
}

export type QuizQuestionCompletionParams = {
  questionIndex: Scalars['Int']['input']
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>
  status: QuizQuestionStatus
  userResponseFillInTheBlank?: InputMaybe<Scalars['String']['input']>
  userResponseFlashcard?: InputMaybe<FlashcardRating>
  userResponseMultipleChoice?: InputMaybe<MultipleChoiceResponse>
}

export enum QuizQuestionStatus {
  Correct = 'CORRECT',
  Flagged = 'FLAGGED',
  Incorrect = 'INCORRECT',
  Skipped = 'SKIPPED',
  Unanswered = 'UNANSWERED'
}

export type QuizQuestionUnion =
  | FillInTheBlank
  | Flashcard
  | MixAndMatch
  | MultipleChoice
  | QuestionPromise
  | TrueOrFalse

export type QuizSession = {
  __typename?: 'QuizSession'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  folderId?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  mode: QuizSessionMode
  noteId?: Maybe<Scalars['String']['output']>
  numAnswered: Scalars['Int']['output']
  numCorrect: Scalars['Int']['output']
  numIncorrect: Scalars['Int']['output']
  numQuestions: Scalars['Int']['output']
  numSkipped: Scalars['Int']['output']
  sourceNoteIds?: Maybe<Array<Scalars['String']['output']>>
  studyMaterialsBatchId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum QuizSessionMode {
  Exam = 'EXAM',
  ExamMultipleChoice = 'EXAM_MULTIPLE_CHOICE',
  PracticeFillInTheBlank = 'PRACTICE_FILL_IN_THE_BLANK',
  PracticeFlashcards = 'PRACTICE_FLASHCARDS',
  PracticeMixAndMatch = 'PRACTICE_MIX_AND_MATCH',
  PracticeMultipleChoice = 'PRACTICE_MULTIPLE_CHOICE',
  PracticeTrueOrFalse = 'PRACTICE_TRUE_OR_FALSE',
  SpacedRepetitionFlashcards = 'SPACED_REPETITION_FLASHCARDS'
}

export enum QuizSessionQuestionType {
  FillInTheBlank = 'FILL_IN_THE_BLANK',
  Flashcard = 'FLASHCARD',
  MixAndMatch = 'MIX_AND_MATCH',
  MultipleChoice = 'MULTIPLE_CHOICE',
  QuestionPromise = 'QUESTION_PROMISE',
  TrueOrFalse = 'TRUE_OR_FALSE'
}

export enum QuizSessionStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Completed = 'COMPLETED'
}

export type QuizSessionTypeParams = {
  folder?: InputMaybe<FolderQuizParams>
  mode: QuizSessionMode
  noteId?: InputMaybe<Scalars['String']['input']>
  studyMaterialsBatchId?: InputMaybe<Scalars['String']['input']>
}

export type QuizSessionUpdateParams = {
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>
  quizQuestionCompletions: Array<QuizQuestionCompletionParams>
  quizSessionId: Scalars['String']['input']
}

export type QuizStatistics = {
  __typename?: 'QuizStatistics'
  questionsAnswered: Scalars['Int']['output']
  questionsCorrect: Scalars['Int']['output']
  questionsSkipped: Scalars['Int']['output']
  quizCount: Scalars['Int']['output']
}

export type QuotaUsage = {
  __typename?: 'QuotaUsage'
  exceeded: Scalars['Boolean']['output']
  quotaUsage: Scalars['String']['output']
  retryAfter?: Maybe<Scalars['String']['output']>
}

export type ReactivateBusinessUserParams = {
  businessId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type RecentNotesParams = {
  numberToGet?: InputMaybe<Scalars['Float']['input']>
}

export type RecoverDeletedNoteParams = {
  noteId: Scalars['String']['input']
}

export type ReferralLink = {
  __typename?: 'ReferralLink'
  code: Scalars['String']['output']
  maxRedemptions: Scalars['Int']['output']
  redemptionCount: Scalars['Int']['output']
  tier: ReferralTier
  url: Scalars['String']['output']
}

export enum ReferralTier {
  Light = 'light',
  Premium = 'premium',
  Pro = 'pro'
}

export type RegisterPilotBusinessParams = {
  adminTitle: Scalars['String']['input']
  companyAddress: Scalars['String']['input']
  creatorEmail: Scalars['String']['input']
  creatorFirstName: Scalars['String']['input']
  creatorLastName: Scalars['String']['input']
  orgName: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
}

export type ReinvitedBusinessUser = {
  __typename?: 'ReinvitedBusinessUser'
  email: Scalars['String']['output']
  emailSent: Scalars['Boolean']['output']
  role: BusinessUserRole
  userId: Scalars['String']['output']
}

export type ReleaseNote = {
  __typename?: 'ReleaseNote'
  body: Scalars['String']['output']
  draft: Scalars['Boolean']['output']
  htmlUrl?: Maybe<Scalars['String']['output']>
  publishedAt: Scalars['DateTime']['output']
  tag: Scalars['String']['output']
}

export type RemoveAppSettingParams = {
  key: Scalars['String']['input']
}

export type RemoveDesktopStatusParams = {
  id: Scalars['String']['input']
}

export type RemoveExperimentEnrollmentOverrideParams = {
  experimentId: Scalars['String']['input']
  screenname: Scalars['String']['input']
}

export type RemoveNoteFromCollectionParams = {
  id: Scalars['String']['input']
  noteId: Scalars['String']['input']
}

export type RemovePermissionForWorkspaceNoteRequest = {
  email: Scalars['String']['input']
  noteId: Scalars['String']['input']
}

export type RemoveUserSurveyResponseKeysParams = {
  keys: Array<Scalars['String']['input']>
}

export type RemoveWorkspaceUsersParams = {
  emails: Array<Scalars['String']['input']>
  workspaceId: Scalars['String']['input']
}

export type RenameCustomAssetParams = {
  customAssetId: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type RenameUserParams = {
  newName: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type ReorderNoteCollectionNoteParams = {
  beforeNoteId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  noteId: Scalars['String']['input']
}

export type ReportCommentParams = {
  commentId: Scalars['String']['input']
  flaggingReason: Scalars['String']['input']
}

export type ReprocessAsrJobParams = {
  audioCreationDateMs: Scalars['Float']['input']
  audioDurationMs?: InputMaybe<Scalars['Float']['input']>
  deviceId?: InputMaybe<Scalars['String']['input']>
  extension?: InputMaybe<Scalars['String']['input']>
  generateStudyJobs?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  recordingCount?: InputMaybe<Scalars['Int']['input']>
  sha512Hash: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type RequestNoteAccessInput = {
  accessLevel: CollabNoteRole
  noteId: Scalars['String']['input']
}

export type RequestNoteAccessResponse = {
  __typename?: 'RequestNoteAccessResponse'
  permissionRequestId: Scalars['String']['output']
}

export type RequestOAuthAccessTokenParams = {
  connectedAccountId: Scalars['ID']['input']
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>
  requiredScopes: Array<Scalars['String']['input']>
}

export type ResendBusinessUserInvitationsParams = {
  businessId: Scalars['ID']['input']
  emails: Array<Scalars['String']['input']>
}

export type ResendBusinessUserInvitationsResponse = {
  __typename?: 'ResendBusinessUserInvitationsResponse'
  failed: FailedResendReason
  resent: Array<ReinvitedBusinessUser>
}

export type ResendOrganizationInviteParams = {
  orgId: Scalars['String']['input']
  resendInviteUserEmails: Array<Scalars['String']['input']>
}

export type ResetOrganizationSeatUsageParams = {
  licenseKey: Scalars['String']['input']
}

export type ResetSubscriberQuotasParams = {
  subscriberId: Scalars['ID']['input']
}

export type ResolveAchievementsParams = {
  calendarConnected?: InputMaybe<Scalars['Boolean']['input']>
  numRecordings?: InputMaybe<Scalars['Int']['input']>
}

export type ResponseLibraryId = {
  __typename?: 'ResponseLibraryId'
  icloudUserId?: Maybe<Scalars['String']['output']>
  serverUserId?: Maybe<Scalars['String']['output']>
  type: LibraryType
  workspaceId?: Maybe<Scalars['String']['output']>
}

export type RestoreOrganizationParams = {
  organizationId: Scalars['String']['input']
}

export type RestoreWorkspaceInput = {
  workspaceId: Scalars['String']['input']
}

export type ReviewBusinessDomainParams = {
  domainId: Scalars['ID']['input']
  isApproved: Scalars['Boolean']['input']
}

export type ReviewFlaggedProfileParam = {
  notes: Scalars['String']['input']
  outcome: Scalars['String']['input']
  profileOwnerId: Scalars['String']['input']
}

export type ReviewOrganizationParams = {
  expiration?: InputMaybe<Scalars['DateTime']['input']>
  isApproved: Scalars['Boolean']['input']
  maxSeats?: InputMaybe<Scalars['Int']['input']>
  organizationId: Scalars['String']['input']
  rejectionReason?: InputMaybe<Scalars['String']['input']>
}

export type RevokeCollabLinkParams = {
  token: Scalars['String']['input']
}

export type RevokeMcpConnectionParams = {
  id: Scalars['ID']['input']
}

export type RevokePublicBusinessInvitationParams = {
  businessId: Scalars['ID']['input']
  invitationId: Scalars['ID']['input']
}

export enum SsoRequirement {
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  None = 'NONE'
}

export {SearchFilter}

export type SearchIndexFlagInfo = {
  __typename?: 'SearchIndexFlagInfo'
  content: Array<FlaggedContent>
  origin: Scalars['String']['output']
  reason: Scalars['String']['output']
}

export type SearchIndexParams = {
  handwritingIndex?: InputMaybe<Scalars['String']['input']>
  imageIndex?: InputMaybe<Scalars['String']['input']>
  pdfIndex?: InputMaybe<Scalars['String']['input']>
  recordingIndex?: InputMaybe<Scalars['String']['input']>
  textIndex?: InputMaybe<Scalars['String']['input']>
}

export type SearchInvitableUsersParams = {
  businessId: Scalars['String']['input']
  emailQuery: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Float']['input']>
  noteId?: InputMaybe<Scalars['String']['input']>
  workspaceId?: InputMaybe<Scalars['String']['input']>
}

export type SearchInvitableUsersResponse = {
  __typename?: 'SearchInvitableUsersResponse'
  users: Array<InvitableUser>
}

export type SearchParams = {
  contentType?: InputMaybe<GalleryNoteContentType>
  filters?: InputMaybe<Array<SearchFilter>>
  followedToInclude?: InputMaybe<Array<Scalars['String']['input']>>
  forUserInChina?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  rootNoteId?: InputMaybe<Scalars['String']['input']>
  screenname?: InputMaybe<Scalars['String']['input']>
  searchType?: InputMaybe<Scalars['String']['input']>
  sortingParam?: InputMaybe<NoteSortingKey>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  trendingTimeframe?: InputMaybe<Scalars['Float']['input']>
}

export type SearchSubscriptionDisputesParams = {
  /** An email, a users or stripe_consumer_subscriptions uuid, or a Stripe subscription (sub_), customer (cus_), payment intent (pi_), or dispute (dp_/du_) id. */
  query: Scalars['String']['input']
}

export type SendGridEvent = {
  __typename?: 'SendGridEvent'
  createdAt: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  event: Scalars['JSONObject']['output']
  id: Scalars['String']['output']
}

export type SendGridSuppressionListing = {
  __typename?: 'SendGridSuppressionListing'
  error?: Maybe<Scalars['String']['output']>
  /** Null when the lookup failed; see error. */
  listed?: Maybe<Scalars['Boolean']['output']>
  listedAt?: Maybe<Scalars['DateTime']['output']>
  name: Scalars['String']['output']
  reason?: Maybe<Scalars['String']['output']>
}

export enum ServerMigrationErrorCode {
  MigratingDeviceExists = 'MigratingDeviceExists',
  ValidationError = 'ValidationError'
}

export type SetAiProfileParams = {
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  quizDifficulty?: InputMaybe<AiQuizDifficulty>
  summaryDetail?: InputMaybe<AiSummaryDetail>
}

export type SetAppSettingParams = {
  key: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export type SetBusinessDomainEnabledParams = {
  domainId: Scalars['ID']['input']
  enabled: Scalars['Boolean']['input']
}

export type SetCollegeAndMajorParams = {
  collegeId?: InputMaybe<Scalars['String']['input']>
  educationLevel?: InputMaybe<EducationLevel>
  graduationTerm?: InputMaybe<GraduationTerm>
  graduationYear?: InputMaybe<Scalars['Int']['input']>
  majorCode?: InputMaybe<Scalars['Int']['input']>
  useType?: InputMaybe<UserUseType>
}

export type SetDefaultPermissionLevel = {
  defaultPermissionLevel?: InputMaybe<WorkspacePermissionLevels>
}

export type SetGlobalOverrideValueParams = {
  key: Scalars['String']['input']
  override: Scalars['String']['input']
}

export type SetIgnoreFlagsParams = {
  ignoreFlags: Scalars['Boolean']['input']
  userId: Scalars['ID']['input']
}

export type SetLanguageParams = {
  id: Scalars['String']['input']
  language?: InputMaybe<Scalars['String']['input']>
}

export type SetLicenseEnforcementExpirationParams = {
  institutionId: Scalars['String']['input']
  licenseEnforcementExpiration: Scalars['DateTime']['input']
}

export type SetLicenseEnforcementParams = {
  institutionId: Scalars['String']['input']
  licenseEnforcement: LicenseEnforcement
}

export type SetMigratingDeviceRequest = {
  appVersion?: InputMaybe<Scalars['String']['input']>
  controllingDeviceId: Scalars['String']['input']
  controllingDeviceName: Scalars['String']['input']
  id: Scalars['String']['input']
  organizerCreations?: InputMaybe<Array<MetadataMutation>>
  source: LibraryId
  startDate: Scalars['Timestamp']['input']
  startSource?: InputMaybe<Scalars['String']['input']>
  /** type should always be NotabilityServer */
  target: LibraryId
}

export type SetMigratingDeviceResponse = {
  __typename?: 'SetMigratingDeviceResponse'
  /** Null if success = true */
  errorCode?: Maybe<ServerMigrationErrorCode>
  /** Null if success = true */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** Null if success = false */
  migratingDevice?: Maybe<MigratingDevice>
  success: Scalars['Boolean']['output']
}

export type SetUserSurveyResponseParams = {
  surveyFields: Array<UserSurveyFieldInput>
}

export type ShareCustomAssetParams = {
  customAssetId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type SimulateAsrQuotaParams = {
  simulateOverQuota: Scalars['Boolean']['input']
}

export type SiteUserMapping = {
  __typename?: 'SiteUserMapping'
  avatarUrl?: Maybe<Scalars['String']['output']>
  siteIds: Array<Scalars['Int']['output']>
  userId: Scalars['GqlUUID']['output']
  userName: Scalars['String']['output']
}

export type SiteUserMappingQueryParams = {
  noteId: Scalars['GqlUUID']['input']
}

export type StartDiscussionParams = {
  noteText: Scalars['String']['input']
  subscriptionId?: InputMaybe<Scalars['String']['input']>
}

export type StartDiscussionResult = {
  __typename?: 'StartDiscussionResult'
  introText: Scalars['String']['output']
  title: Scalars['String']['output']
  topics: Array<DiscussionTopic>
}

export type StopParams = {
  serverNoteId: Scalars['String']['input']
}

export enum StripeBusinessSubscriptionTier {
  Business = 'business',
  BusinessPro = 'business_pro'
}

export type StripeConsumerSubscription = {
  __typename?: 'StripeConsumerSubscription'
  cancelAt?: Maybe<Scalars['DateTime']['output']>
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  endedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isCanceled: Scalars['Boolean']['output']
  isExpired: Scalars['Boolean']['output']
  status: StripeSubscriptionStatus
  stripePriceId: Scalars['String']['output']
  stripeProductId: Scalars['String']['output']
  stripeSubscriptionId: Scalars['String']['output']
  subscriptionRenewalDate?: Maybe<Scalars['DateTime']['output']>
  tier: StripeConsumerSubscriptionTier
  trialEndAt?: Maybe<Scalars['Timestamp']['output']>
  trialEndedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export enum StripeConsumerSubscriptionTier {
  Light = 'light',
  Premium = 'premium',
  Pro = 'pro'
}

export type StripeCustomerPortal = {
  __typename?: 'StripeCustomerPortal'
  redirectUrl: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type StripeSubscriptionSnapshot = {
  __typename?: 'StripeSubscriptionSnapshot'
  cancelAt?: Maybe<Scalars['DateTime']['output']>
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  collectionMethod?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>
  customerEmail?: Maybe<Scalars['String']['output']>
  customerName?: Maybe<Scalars['String']['output']>
  dashboardCustomerUrl?: Maybe<Scalars['String']['output']>
  dashboardSubscriptionUrl: Scalars['String']['output']
  endedAt?: Maybe<Scalars['DateTime']['output']>
  latestInvoiceId?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  status: Scalars['String']['output']
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  stripePriceId?: Maybe<Scalars['String']['output']>
  stripeProductId?: Maybe<Scalars['String']['output']>
  /** The product's display name in Stripe. */
  stripeProductName?: Maybe<Scalars['String']['output']>
  stripeSubscriptionId: Scalars['String']['output']
  tier?: Maybe<StripeConsumerSubscriptionTier>
  trialEnd?: Maybe<Scalars['DateTime']['output']>
}

export enum StripeSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type StudentUserPersona = {
  __typename?: 'StudentUserPersona'
  collegeId?: Maybe<Scalars['String']['output']>
  educationLevel?: Maybe<EducationLevel>
  graduationTerm?: Maybe<GraduationTerm>
  graduationYear?: Maybe<Scalars['Int']['output']>
  majorCode?: Maybe<Scalars['Int']['output']>
  personaType: PersonaType
}

export type StudyChatImage = {
  __typename?: 'StudyChatImage'
  imageBase64Data: Scalars['String']['output']
  mimeType: Scalars['String']['output']
}

export type StudyChatMessage = {
  __typename?: 'StudyChatMessage'
  content: Scalars['String']['output']
  image?: Maybe<StudyChatImage>
  role: StudyChatMessageRole
  studyChatExchangeId: Scalars['String']['output']
  timestamp: Scalars['DateTime']['output']
}

export enum StudyChatMessageRole {
  Assistant = 'assistant',
  User = 'user'
}

export type StudyMaterial = {
  __typename?: 'StudyMaterial'
  contentHash: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['String']['output']
  quizJob?: Maybe<QuizJob>
  source: StudyMaterialSource
  studyMaterialsBatch?: Maybe<StudyMaterialsBatch>
  studyMaterialsBatchId: Scalars['String']['output']
  summaryJob?: Maybe<SummaryJob>
  updatedAt: Scalars['DateTime']['output']
}

export type StudyMaterialParams = {
  content: Scalars['String']['input']
  group?: InputMaybe<Scalars['String']['input']>
  type: StudyMaterialSource
}

export enum StudyMaterialSource {
  LiveTranscript = 'LIVE_TRANSCRIPT',
  NoteHandwriting = 'NOTE_HANDWRITING',
  NotePdf = 'NOTE_PDF',
  NoteText = 'NOTE_TEXT'
}

export type StudyMaterialsBatch = {
  __typename?: 'StudyMaterialsBatch'
  asrJobs?: Maybe<Array<AsrJob>>
  clientNoteId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['String']['output']
  isServerManaged: Scalars['Boolean']['output']
  language?: Maybe<Scalars['String']['output']>
  noteQuizJobs?: Maybe<Array<QuizJob>>
  promptGroup?: Maybe<Scalars['String']['output']>
  quizJobs?: Maybe<Array<QuizJob>>
  studyMaterials?: Maybe<Array<StudyMaterial>>
  summaryJobs?: Maybe<Array<SummaryJob>>
  summaryOfSummaries?: Maybe<SummaryJob>
  takeawaysSummary?: Maybe<SummaryJob>
  updatedAt: Scalars['DateTime']['output']
}

export type Subject = {
  __typename?: 'Subject'
  color: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  emoji?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  legacyOrganizerId?: Maybe<Scalars['String']['output']>
  locked: Scalars['Boolean']['output']
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']['output']>
  siblingOrder: Scalars['Float']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
  workspace: WorkspaceEntity
  workspaceId: Scalars['ID']['output']
}

export type Subscriber = {
  __typename?: 'Subscriber'
  appStoreSubscription?: Maybe<AppStoreSubscription>
  id: Scalars['String']['output']
  user?: Maybe<User>
  userId: Scalars['String']['output']
}

export type Subscription = {
  __typename?: 'Subscription'
  details: SubscriptionDetails
  expirationDate?: Maybe<Scalars['Timestamp']['output']>
  gracePeriodEndDate?: Maybe<Scalars['Timestamp']['output']>
  renewalDate?: Maybe<Scalars['Timestamp']['output']>
  source: SubscriptionSource
  tier: SubscriptionTier
}

export type SubscriptionAuditFieldChange = {
  __typename?: 'SubscriptionAuditFieldChange'
  /** The column that changed. */
  field: Scalars['String']['output']
  /** The value after the write; null when the column was unset or dropped. */
  newValue?: Maybe<Scalars['String']['output']>
  /** The value before the write; null when the column was unset or absent. */
  oldValue?: Maybe<Scalars['String']['output']>
}

export type SubscriptionAuditRow = {
  __typename?: 'SubscriptionAuditRow'
  /** Only the columns whose value the write changed. */
  changes: Array<SubscriptionAuditFieldChange>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  type: Scalars['String']['output']
}

export type SubscriptionDetails =
  | AndroidSubscription
  | AppStoreSubscription
  | BusinessSubscription
  | StripeConsumerSubscription
  | SubscriptionOverride
  | TrialSubscription

export type SubscriptionDisputeInfo = {
  __typename?: 'SubscriptionDisputeInfo'
  auditRows: Array<SubscriptionAuditRow>
  database?: Maybe<StripeConsumerSubscription>
  /** The account our row grants entitlement to. */
  owner?: Maybe<SubscriptionDisputeUser>
  /** The id that was looked up, trimmed. */
  query: Scalars['String']['output']
  relatedUsers: Array<SubscriptionDisputeUser>
  stripe?: Maybe<StripeSubscriptionSnapshot>
  /** Set when Stripe could not be reached or knows no such subscription. */
  stripeLookupError?: Maybe<Scalars['String']['output']>
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>
  warnings: Array<SubscriptionDisputeWarning>
}

export type SubscriptionDisputeMatch = {
  __typename?: 'SubscriptionDisputeMatch'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** Every way the search term led to this subscription. */
  matchReasons: Array<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  stripeSubscriptionId: Scalars['String']['output']
  tier?: Maybe<StripeConsumerSubscriptionTier>
}

export type SubscriptionDisputeSearch = {
  __typename?: 'SubscriptionDisputeSearch'
  /** Newest first. */
  matches: Array<SubscriptionDisputeMatch>
  /** The search term, trimmed. */
  query: Scalars['String']['output']
  warnings: Array<SubscriptionDisputeWarning>
}

export type SubscriptionDisputeUser = {
  __typename?: 'SubscriptionDisputeUser'
  activity: UserActivity
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  /** Why this account turned up in the lookup. */
  matchReason: Scalars['String']['output']
  stripeCustomerId?: Maybe<Scalars['String']['output']>
}

export type SubscriptionDisputeWarning = {
  __typename?: 'SubscriptionDisputeWarning'
  message: Scalars['String']['output']
  severity: SubscriptionDisputeWarningSeverity
}

export enum SubscriptionDisputeWarningSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type SubscriptionFeatureQuota = {
  __typename?: 'SubscriptionFeatureQuota'
  isUsageExceeded: Scalars['Boolean']['output']
  quotaWindowType?: Maybe<LearnQuotaWindowType>
  usagePercentage: Scalars['Float']['output']
}

export type SubscriptionFeatureQuotaView = {
  __typename?: 'SubscriptionFeatureQuotaView'
  learnQuestionUploads: SubscriptionFeatureQuota
  learnQuestions: SubscriptionFeatureQuota
  learnSummaries: SubscriptionFeatureQuota
  liveTranscription: SubscriptionFeatureQuota
  youtubeTranscripts: SubscriptionFeatureQuota
}

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo'
  bestSubscription?: Maybe<AppStoreSubscription>
  classicStatuses: Array<AppStoreClassicStatus>
  devices: Array<AppStoreSubscriptionDevice>
  overrides: Array<SubscriptionOverride>
  receipts: Array<AppStoreReceipt>
  subscriptions: Array<AppStoreSubscription>
  users: Array<User>
}

export type SubscriptionOverride = {
  __typename?: 'SubscriptionOverride'
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<User>
  expirationDate: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  overrideReason?: Maybe<Scalars['String']['output']>
  overrideTier: SubscriptionTier
}

export type SubscriptionOverview = {
  __typename?: 'SubscriptionOverview'
  current?: Maybe<Subscription>
  prior?: Maybe<Subscription>
  quotas: SubscriptionFeatureQuotaView
  tier: UserTier
}

export type SubscriptionResult = {
  __typename?: 'SubscriptionResult'
  error: Scalars['Int']['output']
  isClassic: Scalars['Boolean']['output']
  subscription?: Maybe<AppStoreSubscription>
}

/** Enum representing subscription sources */
export enum SubscriptionSource {
  AppStoreConsumer = 'AppStoreConsumer',
  CustomOverride = 'CustomOverride',
  CustomTrial = 'CustomTrial',
  GooglePlayStore = 'GooglePlayStore',
  SamsungGalaxyStore = 'SamsungGalaxyStore',
  StripeBusiness = 'StripeBusiness',
  StripeConsumer = 'StripeConsumer',
  StripeOrganization = 'StripeOrganization'
}

export enum SubscriptionTier {
  Business = 'business',
  BusinessPro = 'business_pro',
  Legacy = 'legacy',
  Light = 'light',
  Premium = 'premium',
  Pro = 'pro',
  Starter = 'starter',
  Vpp = 'vpp'
}

export type SummaryJob = {
  __typename?: 'SummaryJob'
  cacheCreationInputTokensUsed: Scalars['Float']['output']
  cacheReadInputTokensUsed: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  errorReason?: Maybe<LearnErrorReason>
  id: Scalars['String']['output']
  inputTokensUsed: Scalars['Float']['output']
  outputTokensUsed: Scalars['Float']['output']
  promptKey?: Maybe<Scalars['String']['output']>
  status: SummaryJobStatus
  studyMaterialsBatch?: Maybe<StudyMaterialsBatch>
  subscriber?: Maybe<Subscriber>
  updatedAt: Scalars['DateTime']['output']
}

export enum SummaryJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING'
}

export type SyncQuizSessionParams = {
  quizSessionUpdateParams?: InputMaybe<QuizSessionUpdateParams>
  quizTypeParams: QuizSessionTypeParams
}

export type SyncQuizSessionResponse = {
  __typename?: 'SyncQuizSessionResponse'
  activeQuizSession?: Maybe<ActiveQuizSession>
  lastCompletedQuizSession?: Maybe<QuizSession>
  noteOutcomes?: Maybe<Array<QuizNoteOutcome>>
}

export type ToggleDeviceLimitEnforcementParams = {
  notes?: InputMaybe<Scalars['String']['input']>
  originalTransactionId: Scalars['ID']['input']
  setEnabled: Scalars['Boolean']['input']
}

export type TopTag = {
  __typename?: 'TopTag'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  noteCount: Scalars['Float']['output']
}

export type TranslationMapping = {
  __typename?: 'TranslationMapping'
  locale: Scalars['String']['output']
  tKey: Scalars['String']['output']
  text: Scalars['String']['output']
}

export type TranslationMappingParams = {
  tKeys: Array<Scalars['String']['input']>
}

export type TriageNoteParams = {
  adminNotes?: InputMaybe<Scalars['String']['input']>
  noteId: Scalars['String']['input']
  triageState: Scalars['String']['input']
}

export type TriageResult = {
  __typename?: 'TriageResult'
  noteId: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  triageState: Scalars['String']['output']
}

export type TriageSearchParams = {
  filter: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

export type TriageSearchResults = {
  __typename?: 'TriageSearchResults'
  results: Array<GalleryNote>
  totalCount: Scalars['Float']['output']
}

export enum TriageState {
  Approved = 'APPROVED',
  AwaitingTriage = 'AWAITING_TRIAGE',
  Quarantined = 'QUARANTINED'
}

export type TrialSubscription = {
  __typename?: 'TrialSubscription'
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  daysRemainingOnTrial?: Maybe<Scalars['Float']['output']>
  expirationDate: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  trialLengthInDays: Scalars['Float']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type TrueOrFalse = {
  __typename?: 'TrueOrFalse'
  correctAnswer: Scalars['Boolean']['output']
  questionId: Scalars['String']['output']
  questionIndex: Scalars['Int']['output']
  sourceNoteId?: Maybe<Scalars['String']['output']>
  statement: Scalars['String']['output']
  status: QuizQuestionStatus
  type: QuizSessionQuestionType
}

export type UndeleteNote = {
  noteId: Scalars['String']['input']
}

export type UnfollowParams = {
  userIdToUnfollow: Scalars['String']['input']
}

export type UnlinkCollabNoteFromCalendarEventParams = {
  noteId: Scalars['ID']['input']
}

export type UnlinkFolderFromCalendarSeriesParams = {
  /** Shared by every occurrence of a series; pass it unchanged from the calendar API */
  eventId: Scalars['String']['input']
}

export type UnlockUserAccountParams = {
  userId: Scalars['String']['input']
}

export type UnmigratedGalleryNote = {
  __typename?: 'UnmigratedGalleryNote'
  creatorId: Scalars['String']['output']
  downloadUrl: Scalars['String']['output']
  id: Scalars['String']['output']
  uploadPolicy: Scalars['String']['output']
}

export type UnpublishParams = {
  serverPublishId: Scalars['String']['input']
}

export type UpdateBusinessFeatureConfigParams = {
  aiDisabled?: InputMaybe<Scalars['Boolean']['input']>
  allowedExportTypes?: InputMaybe<Array<Scalars['String']['input']>>
  businessId: Scalars['ID']['input']
  capturePhotoAllowed?: InputMaybe<Scalars['Boolean']['input']>
  employeeNoteAccessAllowed?: InputMaybe<Scalars['Boolean']['input']>
  intuneEnabled?: InputMaybe<Scalars['Boolean']['input']>
  linkSharingAllowed?: InputMaybe<Scalars['Boolean']['input']>
  noteGalleryAllowed?: InputMaybe<Scalars['Boolean']['input']>
  photoLibraryAllowed?: InputMaybe<Scalars['Boolean']['input']>
  /** Deprecated: use employeeNoteAccessAllowed, which stores the permissive state as true. */
  restrictEmployeeNoteAccess?: InputMaybe<Scalars['Boolean']['input']>
  ssoRequirement?: InputMaybe<SsoRequirement>
  webClipAllowed?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateBusinessTrialMemberLimitParams = {
  businessId: Scalars['String']['input']
  newLimit: Scalars['Int']['input']
}

export type UpdateCookiesParams = {
  cookieStatus: Scalars['String']['input']
}

export type UpdateLearnSettingsParams = {
  isAiEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateNoteCollectionParams = {
  id: Scalars['String']['input']
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
}

export type UpdateOrganizationDetailsParams = {
  newIndustry?: InputMaybe<Scalars['String']['input']>
  newOrganizationName?: InputMaybe<Scalars['String']['input']>
  orgId: Scalars['String']['input']
}

export type UpdateUserLanguageParams = {
  newLanguage: Scalars['String']['input']
}

export type UploadParams = {
  clientModifiedDate: Scalars['String']['input']
  clientNoteId: Scalars['String']['input']
  noteName: Scalars['String']['input']
  serverNoteId?: InputMaybe<Scalars['String']['input']>
}

export type UploadResult = {
  __typename?: 'UploadResult'
  note: Note
  noteUploadPolicy: Scalars['String']['output']
  pdfUploadPolicy: Scalars['String']['output']
}

export type UploadUserGeneratedQuizParams = {
  noteId: Scalars['String']['input']
  uploadedFlashcard?: InputMaybe<FlashcardContentInput>
}

export type User = {
  __typename?: 'User'
  accountDeletionTime?: Maybe<Scalars['DateTime']['output']>
  accountType: AccountType
  adminEvents?: Maybe<Array<UserAdminEvent>>
  adminOrganization?: Maybe<AdminUserOrganization>
  aiProfile?: Maybe<AiProfile>
  authToken?: Maybe<Scalars['String']['output']>
  baseSubscription?: Maybe<AppStoreSubscription>
  bestAvailableSubscription?: Maybe<AppStoreSubscription>
  business?: Maybe<Business>
  businessUser?: Maybe<BusinessUser>
  classicStatus: Array<AppStoreClassicStatus>
  collabDevices: Array<CollabDevice>
  collections?: Maybe<Array<NoteCollection>>
  /** @deprecated Use User.persona instead */
  college?: Maybe<College>
  connectedOAuthAccounts: Array<OAuthConnectedAccount>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customAssets: UserCustomAssetResult
  dismissGuidelines: Scalars['Boolean']['output']
  /** @deprecated Use User.persona instead */
  educationLevel?: Maybe<EducationLevel>
  eligibleBusinessDomain?: Maybe<EligibleBusinessDomain>
  email: Scalars['String']['output']
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>
  favoritedGalleryNotes: Array<GalleryNote>
  featureFlags: Array<Scalars['String']['output']>
  folderStudyConfig?: Maybe<FolderStudyConfig>
  folderStudyReadiness?: Maybe<Array<NoteStudyReadiness>>
  following: Array<Following>
  followingMetadata?: Maybe<FollowingMetadata>
  galleryNotes: Array<GalleryNote>
  /** @deprecated Use User.persona instead */
  graduationYear?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** When this user was first seen opening the iPad app. Null means we have not seen them do so, which is not the same as them never having done so: it is only recorded from late October 2026 onwards, and was not backfilled. */
  ipadFirstOpenAt?: Maybe<Scalars['DateTime']['output']>
  isAdmin?: Maybe<Scalars['Boolean']['output']>
  isAiEnabled: Scalars['Boolean']['output']
  isBlocked: Scalars['Boolean']['output']
  isEmailVerified: Scalars['Boolean']['output']
  isLocked: Scalars['Boolean']['output']
  isOrganizationOwner: Scalars['Boolean']['output']
  legacyMigrations: Array<MigratingDevice>
  /** @deprecated Use the metadata websocket for library state */
  library: LibraryState
  loginProviders: Array<LoginProvider>
  /** @deprecated Use User.persona instead */
  major?: Maybe<CollegeMajor>
  mcpConnections: Array<McpConnection>
  name?: Maybe<Scalars['String']['output']>
  newNotesAvailable: Scalars['Boolean']['output']
  notes: Array<Note>
  notificationEvents: Array<NotificationEvent>
  notifications: Array<Notification>
  numComments: Scalars['Float']['output']
  numHiddenComments: Scalars['Float']['output']
  numNotificationsUnseen: Scalars['Float']['output']
  /** @deprecated Use User.organizationView instead */
  organization?: Maybe<OrganizationDetails>
  organizationView?: Maybe<OrganizationView>
  pendingRecoveryEmailChange?: Maybe<PendingRecoveryEmailChange>
  persona: Persona
  privateWorkspaceId: Scalars['String']['output']
  profile?: Maybe<UserProfile>
  promoNotifications: Array<PromoNotification>
  quizStatistics: QuizStatistics
  recoveryEmail?: Maybe<Scalars['String']['output']>
  settings?: Maybe<UserSettings>
  stripeConsumerSubscription?: Maybe<StripeConsumerSubscription>
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  subscriber?: Maybe<Subscriber>
  subscriptionOverrides: Array<SubscriptionOverride>
  subscriptionOverview: SubscriptionOverview
  subscriptions: Array<AppStoreSubscription>
  testEnrollments: Array<ExperimentEnrollment>
  trialSubscription?: Maybe<TrialSubscription>
  triggeredGalleryNoteAdminEvents?: Maybe<Array<GalleryNoteAdminEvent>>
  triggeredUserAdminEvents?: Maybe<Array<UserAdminEvent>>
  useType?: Maybe<UserUseType>
  userStatus: UserStatus
  verificationHash: Scalars['String']['output']
}

export type UserBusinessArgs = {
  status?: InputMaybe<BusinessUserStatusFilter>
}

export type UserBusinessUserArgs = {
  status?: InputMaybe<BusinessUserStatusFilter>
}

export type UserCustomAssetsArgs = {
  userCustomAssetRequest: UserCustomAssetRequest
}

export type UserFavoritedGalleryNotesArgs = {
  favoritedGalleryNotesParams: FavoritedGalleryNotesParams
}

export type UserFolderStudyReadinessArgs = {
  noteIds: Array<Scalars['String']['input']>
}

export type UserLibraryArgs = {
  userLibraryRequest: UserLibraryRequest
}

export type UserActivity = {
  __typename?: 'UserActivity'
  accountCreatedAt: Scalars['DateTime']['output']
  desktopFirstLaunchedAt?: Maybe<Scalars['DateTime']['output']>
  firstNoteCreatedAt?: Maybe<Scalars['DateTime']['output']>
  lastLegacyNoteUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  lastNoteEditedAt?: Maybe<Scalars['DateTime']['output']>
  lastNoteOpenedAt?: Maybe<Scalars['DateTime']['output']>
  lastTranscriptionAt?: Maybe<Scalars['DateTime']['output']>
  legacyNoteCount: Scalars['Int']['output']
  noteCount: Scalars['Int']['output']
  recentNotes: Array<NoteActivity>
  transcriptionCount: Scalars['Int']['output']
}

export type UserAdminEvent = {
  __typename?: 'UserAdminEvent'
  createdAt: Scalars['DateTime']['output']
  eventType: UsersAdminEventType
  id: Scalars['String']['output']
  systemNotes?: Maybe<Scalars['String']['output']>
  targetedUser?: Maybe<User>
  targetedUserEmail: Scalars['String']['output']
  targetedUserScreenname?: Maybe<Scalars['String']['output']>
  triggeringUser?: Maybe<User>
  triggeringUserEmail: Scalars['String']['output']
  triggeringUserNotes?: Maybe<Scalars['String']['output']>
}

export type UserCustomAssetRequest = {
  type?: InputMaybe<CustomAssetType>
}

export type UserCustomAssetResult = {
  __typename?: 'UserCustomAssetResult'
  stickers: Array<CustomAssetMetadata>
  templates: Array<CustomAssetMetadata>
}

export type UserEnrollmentParams = {
  email: Scalars['String']['input']
  isFromWebApp?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  referralCode?: InputMaybe<Scalars['String']['input']>
  screenname?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
}

export type UserFavoritedNotesParameters = {
  limit?: InputMaybe<Scalars['Float']['input']>
  offset: Scalars['Float']['input']
  screenname: Scalars['String']['input']
}

export type UserLibraryRequest = {
  /** null to request a full state reset in the response */
  partialUpdateSequenceId?: InputMaybe<Scalars['Int']['input']>
}

export type UserLikesNotesParameters = {
  noteIds: Array<Scalars['String']['input']>
}

export type UserNoteCollectionsParams = {
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  userId: Scalars['String']['input']
}

export type UserNotesParameters = {
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
  screenname: Scalars['String']['input']
}

export type UserPermission = {
  __typename?: 'UserPermission'
  ownerId: Scalars['String']['output']
  /** true IFF explicitly permissioned from owner */
  sharedWithMe: Scalars['Boolean']['output']
  userAccessLevel: AccessLevel
}

export type UserProfile = {
  __typename?: 'UserProfile'
  avatarUpdatedAt?: Maybe<Scalars['DateTime']['output']>
  avatarUrl?: Maybe<Scalars['String']['output']>
  bio?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  etsyUsername?: Maybe<Scalars['String']['output']>
  followerCount: Scalars['Int']['output']
  followingCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  ignoreFlagging: Scalars['Boolean']['output']
  instagramUsername?: Maybe<Scalars['String']['output']>
  isFollowedByMe: Scalars['Boolean']['output']
  noteCount: Scalars['Int']['output']
  screenname?: Maybe<Scalars['String']['output']>
  tikTokUsername?: Maybe<Scalars['String']['output']>
  twitterUsername?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
  user: User
  userId: Scalars['ID']['output']
  youtubeUrl?: Maybe<Scalars['String']['output']>
}

export type UserProfileAvatarUrlArgs = {
  small?: InputMaybe<Scalars['Boolean']['input']>
}

export type UserSettings = {
  __typename?: 'UserSettings'
  appSettings?: Maybe<Scalars['JSONObject']['output']>
  id: Scalars['ID']['output']
  language?: Maybe<Scalars['String']['output']>
  libraryCount: Scalars['Float']['output']
  locale: Locale
  updatedAt: Scalars['DateTime']['output']
  user: User
}

export enum UserStatus {
  Active = 'ACTIVE',
  OrgInvited = 'ORG_INVITED',
  PendingDeletion = 'PENDING_DELETION'
}

export type UserSubscriptionResult = {
  __typename?: 'UserSubscriptionResult'
  isClassicUser: Scalars['Boolean']['output']
  subscriptionExpirationDate?: Maybe<Scalars['DateTime']['output']>
  subscriptionRenewalDate?: Maybe<Scalars['DateTime']['output']>
  subscriptionSource?: Maybe<Scalars['String']['output']>
  subscriptionTier?: Maybe<Scalars['String']['output']>
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>
  trialLengthInDays?: Maybe<Scalars['Float']['output']>
}

export type UserSurveyFieldInput = {
  key: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export type UserSurveyFieldOutput = {
  __typename?: 'UserSurveyFieldOutput'
  key: Scalars['String']['output']
  value?: Maybe<Scalars['String']['output']>
}

export type UserSurveyResponse = {
  __typename?: 'UserSurveyResponse'
  surveyFields: Array<UserSurveyFieldOutput>
  userId: Scalars['String']['output']
}

/** Enum representing all user tiers (basic and subscription) */
export enum UserTier {
  Business = 'business',
  BusinessBasic = 'business_basic',
  BusinessPro = 'business_pro',
  Classic = 'classic',
  Legacy = 'legacy',
  Lifetime = 'lifetime',
  Light = 'light',
  Premium = 'premium',
  Pro = 'pro',
  Starter = 'starter',
  Vpp = 'vpp'
}

export enum UserUseType {
  Business = 'BUSINESS',
  Educator = 'EDUCATOR',
  Personal = 'PERSONAL',
  Student = 'STUDENT'
}

export {UsersAdminEventType}

export type VppAccountResult = {
  __typename?: 'VPPAccountResult'
  customerType: Scalars['String']['output']
  error: Scalars['Int']['output']
  institutionName?: Maybe<Scalars['String']['output']>
  licenseEnforcement: LicenseEnforcement
  licenseEnforcementExpiration?: Maybe<Scalars['DateTime']['output']>
  organizationId?: Maybe<Scalars['String']['output']>
  organizationName?: Maybe<Scalars['String']['output']>
  subscription?: Maybe<VppSubscription>
}

export type VppAllowlistEmail = {
  __typename?: 'VPPAllowlistEmail'
  createdAt: Scalars['DateTime']['output']
  emailDomain: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type VppReceiptParams = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  deviceId?: InputMaybe<Scalars['String']['input']>
  licenseKey?: InputMaybe<Scalars['String']['input']>
  receipt: Scalars['String']['input']
}

export type VppSubscription = {
  __typename?: 'VPPSubscription'
  active: Scalars['Boolean']['output']
  expirationDate: Scalars['DateTime']['output']
  productId: Scalars['String']['output']
  tier: Scalars['String']['output']
}

export type ValidateBusinessInvitationParams = {
  token: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type ValidateBusinessInvitationResponse = {
  __typename?: 'ValidateBusinessInvitationResponse'
  businessName: Scalars['String']['output']
  userName?: Maybe<Scalars['String']['output']>
}

export type ValidateGalaxyStorePurchaseInput = {
  purchaseId: Scalars['String']['input']
}

export type ValidateGalaxyStorePurchasePayload = {
  __typename?: 'ValidateGalaxyStorePurchasePayload'
  success: Scalars['Boolean']['output']
}

export type ValidatePlayStoreOneTimePurchaseInput = {
  productId: Scalars['String']['input']
  purchaseToken: Scalars['String']['input']
}

export type ValidatePlayStoreOneTimePurchasePayload = {
  __typename?: 'ValidatePlayStoreOneTimePurchasePayload'
  success: Scalars['Boolean']['output']
}

export type ValidatePlayStorePurchaseTokenInput = {
  purchaseToken: Scalars['String']['input']
}

export type ValidatePlayStorePurchaseTokenPayload = {
  __typename?: 'ValidatePlayStorePurchaseTokenPayload'
  success: Scalars['Boolean']['output']
}

export type ViewedNoteParameters = {
  noteId: Scalars['String']['input']
}

export type VisitCollabLinkParams = {
  token: Scalars['String']['input']
}

export enum WhisperImplementation {
  Distil = 'DISTIL',
  Faster = 'FASTER',
  FasterBatched = 'FASTER_BATCHED'
}

export type Workspace = {
  __typename?: 'Workspace'
  businessId?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  creatorId: Scalars['ID']['output']
  /** @deprecated Use defaultPermissionLevelV2 */
  defaultPermissionLevel?: Maybe<WorkspacePermissionLevels>
  defaultPermissionLevelV2?: Maybe<WorkspacePermissionLevels>
  deletedAt?: Maybe<Scalars['Timestamp']['output']>
  description?: Maybe<Scalars['String']['output']>
  folders?: Maybe<Array<Folder>>
  id: Scalars['String']['output']
  notes?: Maybe<Array<NoteV2>>
  /** @deprecated workspaces no longer have organizationId. Use businessId instead */
  organizationId?: Maybe<Scalars['ID']['output']>
  organizers?: Maybe<Array<OrganizerV2>>
  title: Scalars['String']['output']
  /** @deprecated Not currently implemented and as defined is not inline with current product asks */
  userPermission: UserPermission
  /** @deprecated Use workspacePermissionLevelV2 */
  workspacePermissionLevel: WorkspacePermissionLevels
  workspacePermissionLevelV2: WorkspacePermissionLevels
}

export type WorkspaceEntity = {
  __typename?: 'WorkspaceEntity'
  business?: Maybe<Business>
  businessId?: Maybe<Scalars['ID']['output']>
  /** @deprecated Use createdAtUnix instead */
  createdAt: Scalars['DateTime']['output']
  createdAtUnix: Scalars['Timestamp']['output']
  creatorId: Scalars['ID']['output']
  defaultPermissionLevel?: Maybe<WorkspacePermissionLevels>
  deletedAt?: Maybe<Scalars['Timestamp']['output']>
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  /** @deprecated workspaces no longer have organizationId. Use businessId instead */
  organizationId?: Maybe<Scalars['ID']['output']>
  permanentlyDeletedAt?: Maybe<Scalars['Timestamp']['output']>
  private: Scalars['Boolean']['output']
}

export enum WorkspacePermissionLevels {
  Commenter = 'COMMENTER',
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type WorkspaceUserMetadata = {
  __typename?: 'WorkspaceUserMetadata'
  /** @deprecated Use levelV2 instead */
  level: WorkspacePermissionLevels
  levelV2: WorkspacePermissionLevels
  user?: Maybe<User>
  userId: Scalars['ID']['output']
  workspace?: Maybe<WorkspaceEntity>
  workspaceId: Scalars['ID']['output']
}

export type YouTubeTranscriptResult = {
  __typename?: 'YouTubeTranscriptResult'
  track: YouTubeTranscriptTrack
  videoId: Scalars['String']['output']
}

export type YouTubeTranscriptSegment = {
  __typename?: 'YouTubeTranscriptSegment'
  duration: Scalars['Float']['output']
  start: Scalars['Float']['output']
  text: Scalars['String']['output']
}

export type YouTubeTranscriptTrack = {
  __typename?: 'YouTubeTranscriptTrack'
  isGenerated: Scalars['Boolean']['output']
  languageCode: Scalars['String']['output']
  segments: Array<YouTubeTranscriptSegment>
}

export type YoutubeTranscriptParams = {
  preferredLanguages?: InputMaybe<Array<Scalars['String']['input']>>
  subscriptionId?: InputMaybe<Scalars['String']['input']>
  videoId: Scalars['String']['input']
}

export type GalleryNoteInfoFragment = {
  __typename?: 'GalleryNote'
  id: string
  name: string
  viewCount: number
  commentsEnabled: boolean
  previewCount: number
  description: string
  updatedAt: any
  createdAt: any
  triageState: TriageState
  contentType: GalleryNoteContentType
  parentNoteId?: string | null
  rootNoteId?: string | null
  likes: number
  remixCount: number
  clientId: string
  ntbUploadedAt?: any | null
  user: {
    __typename?: 'User'
    id: string
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
  }
  tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
}

export type NoteCollectionInfoFragment = {
  __typename?: 'NoteCollection'
  id: string
  name: string
  isOfficialContent: boolean
  isFeatured: boolean
}

export type CommentInfoFragment = {
  __typename?: 'Comment'
  id: string
  createdAt: any
  commentText: string
  parent?: {__typename?: 'Comment'; id: string} | null
  author: {
    __typename?: 'User'
    id: string
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUrl?: string | null} | null
  }
}

export type PromoNotificationFragment = {
  __typename?: 'PromoNotification'
  id: string
  startDate: any
  endDate: any
  translationKey: string
  href: string
  isDraft: boolean
  author: {
    __typename?: 'User'
    id: string
    name?: string | null
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
  }
}

export type DesktopStatusFragment = {
  __typename?: 'DesktopStatus'
  id: string
  message: any
  url: string
  platforms?: Array<string> | null
  arches?: Array<string> | null
  versions?: Array<string> | null
  showBelowVersion?: string | null
  showAboveVersion?: string | null
  blocks: boolean
  operatorNote: string
  removedAt?: any | null
  createdAt: any
  createdBy?: {__typename?: 'User'; id: string; email: string} | null
}

export type TestOverrideFragment = {
  __typename?: 'ExperimentEnrollment'
  inVariantGroup: boolean
  isOverride: boolean
  user?: {__typename?: 'User'; profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null} | null
  experiment: {__typename?: 'Experiment'; id: string}
}

export type CreateCollectionMutationVariables = Exact<{
  createNoteCollectionParams: CreateNoteCollectionParams
}>

export type CreateCollectionMutation = {__typename?: 'Mutation'; createCollection: string}

export type DeleteCollectionMutationVariables = Exact<{
  deleteNoteCollectionParams: DeleteNoteCollectionParams
}>

export type DeleteCollectionMutation = {__typename?: 'Mutation'; deleteCollection: boolean}

export type AddNoteToCollectionMutationVariables = Exact<{
  addNoteToCollectionParams: AddNoteToCollectionParams
}>

export type AddNoteToCollectionMutation = {
  __typename?: 'Mutation'
  addNoteToCollection: {
    __typename?: 'NoteCollection'
    id: string
    name: string
    isOfficialContent: boolean
    isFeatured: boolean
  }
}

export type ReorderNoteCollectionNoteMutationVariables = Exact<{
  reorderNoteCollectionNoteParams: ReorderNoteCollectionNoteParams
}>

export type ReorderNoteCollectionNoteMutation = {__typename?: 'Mutation'; reorderNoteCollectionNote: boolean}

export type RemoveNoteFromCollectionMutationVariables = Exact<{
  removeNoteFromCollectionParams: RemoveNoteFromCollectionParams
}>

export type RemoveNoteFromCollectionMutation = {__typename?: 'Mutation'; removeNoteFromCollection: boolean}

export type GetNoteCollectionQueryVariables = Exact<{
  noteCollectionParams: NoteCollectionParams
}>

export type GetNoteCollectionQuery = {
  __typename?: 'Query'
  getNoteCollection?: {
    __typename?: 'NoteCollection'
    id: string
    name: string
    owner: {
      __typename?: 'User'
      name?: string | null
      profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null
    }
  } | null
}

export type GetOfficialNoteCollectionsQueryVariables = Exact<{
  pagingParams: PagingParams
}>

export type GetOfficialNoteCollectionsQuery = {
  __typename?: 'Query'
  getOfficialNoteCollections: {
    __typename?: 'NoteCollectionListResults'
    totalCount: number
    results: Array<{__typename?: 'NoteCollection'; id: string; name: string}>
  }
}

export type GetNoteCollectionsForUserQueryVariables = Exact<{
  userNoteCollectionsParams: UserNoteCollectionsParams
}>

export type GetNoteCollectionsForUserQuery = {
  __typename?: 'Query'
  getNoteCollectionsForUser: {
    __typename?: 'NoteCollectionListResults'
    totalCount: number
    results: Array<{__typename?: 'NoteCollection'; id: string; name: string}>
  }
}

export type UpdateCollectionMutationVariables = Exact<{
  updateNoteCollectionParams: UpdateNoteCollectionParams
}>

export type UpdateCollectionMutation = {
  __typename?: 'Mutation'
  updateCollection: {
    __typename?: 'NoteCollection'
    id: string
    name: string
    isOfficialContent: boolean
    isFeatured: boolean
  }
}

export type GetNotesForCollectionQueryVariables = Exact<{
  noteCollectionNotesParams: NoteCollectionNotesParams
}>

export type GetNotesForCollectionQuery = {
  __typename?: 'Query'
  getNotesForCollection: {
    __typename?: 'GalleryNoteResults'
    totalCount: number
    results: Array<{
      __typename?: 'GalleryNote'
      id: string
      name: string
      viewCount: number
      commentsEnabled: boolean
      previewCount: number
      description: string
      updatedAt: any
      createdAt: any
      triageState: TriageState
      contentType: GalleryNoteContentType
      parentNoteId?: string | null
      rootNoteId?: string | null
      likes: number
      remixCount: number
      clientId: string
      ntbUploadedAt?: any | null
      user: {
        __typename?: 'User'
        id: string
        profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
      }
      tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
    }>
  }
}

export type GetNotesForOfficialCollectionQueryVariables = Exact<{
  officialCollectionNotesParams: OfficialCollectionNotesParams
}>

export type GetNotesForOfficialCollectionQuery = {
  __typename?: 'Query'
  getNotesForOfficialCollection: {
    __typename?: 'GalleryNoteResults'
    totalCount: number
    results: Array<{
      __typename?: 'GalleryNote'
      id: string
      name: string
      viewCount: number
      commentsEnabled: boolean
      previewCount: number
      description: string
      updatedAt: any
      createdAt: any
      triageState: TriageState
      contentType: GalleryNoteContentType
      parentNoteId?: string | null
      rootNoteId?: string | null
      likes: number
      remixCount: number
      clientId: string
      ntbUploadedAt?: any | null
      user: {
        __typename?: 'User'
        id: string
        profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
      }
      tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
    }>
  }
}

export type LikeNoteMutationVariables = Exact<{
  likeParams: LikeParams
}>

export type LikeNoteMutation = {__typename?: 'Mutation'; likeNote: {__typename?: 'GalleryNote'; id: string}}

export type FlagNoteMutationVariables = Exact<{
  flagParams: FlagParams
}>

export type FlagNoteMutation = {__typename?: 'Mutation'; flagNote: {__typename?: 'GalleryNote'; id: string}}

export type FlagNoteFamilyTreeMutationVariables = Exact<{
  flagParams: FlagParams
}>

export type FlagNoteFamilyTreeMutation = {
  __typename?: 'Mutation'
  flagNoteFamilyTree: Array<{
    __typename?: 'GalleryNote'
    id: string
    name: string
    viewCount: number
    commentsEnabled: boolean
    previewCount: number
    description: string
    updatedAt: any
    createdAt: any
    triageState: TriageState
    contentType: GalleryNoteContentType
    parentNoteId?: string | null
    rootNoteId?: string | null
    likes: number
    remixCount: number
    clientId: string
    ntbUploadedAt?: any | null
    user: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
  }>
}

export type GetNotesQueryVariables = Exact<{
  getNotesParams: GetNotesParameters
}>

export type GetNotesQuery = {
  __typename?: 'Query'
  getNotes: Array<{
    __typename?: 'GalleryNote'
    id: string
    name: string
    viewCount: number
    commentsEnabled: boolean
    previewCount: number
    description: string
    updatedAt: any
    createdAt: any
    triageState: TriageState
    contentType: GalleryNoteContentType
    parentNoteId?: string | null
    rootNoteId?: string | null
    likes: number
    remixCount: number
    clientId: string
    ntbUploadedAt?: any | null
    user: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
  }>
}

export type GetFeatureFlagsForUserQueryVariables = Exact<{[key: string]: never}>

export type GetFeatureFlagsForUserQuery = {__typename?: 'Query'; getFeatureFlagsForUser: Array<string>}

export type MeQueryVariables = Exact<{[key: string]: never}>

export type MeQuery = {
  __typename?: 'Query'
  me: {
    __typename?: 'User'
    id: string
    featureFlags: Array<string>
    profile?: {__typename?: 'UserProfile'; avatarUpdatedAt?: any | null} | null
  }
}

export type UpdateProfileMutationVariables = Exact<{
  profileParams: ProfileParams
}>

export type UpdateProfileMutation = {
  __typename?: 'Mutation'
  updateProfile: {__typename?: 'UserProfile'; id: string; screenname?: string | null}
}

export type FlagProfileMutationVariables = Exact<{
  flagProfileParams: FlagProfileParams
}>

export type FlagProfileMutation = {__typename?: 'Mutation'; flagProfile: boolean}

export type ReviewFlaggedProfileMutationVariables = Exact<{
  reviewFlaggedProfileParams: ReviewFlaggedProfileParam
}>

export type ReviewFlaggedProfileMutation = {__typename?: 'Mutation'; reviewFlaggedProfile: boolean}

export type FreeNamespaceMutationVariables = Exact<{
  freeNamespaceParams: FreeNamespaceParams
}>

export type FreeNamespaceMutation = {__typename?: 'Mutation'; freeNamespace: boolean}

export type ReloadEnvironmentCacheMutationVariables = Exact<{[key: string]: never}>

export type ReloadEnvironmentCacheMutation = {__typename?: 'Mutation'; reloadEnvironmentCache: boolean}

export type UpdateBioMutationVariables = Exact<{
  bioParams: BioParams
}>

export type UpdateBioMutation = {
  __typename?: 'Mutation'
  updateBio: {
    __typename?: 'UserProfile'
    id: string
    bio?: string | null
    twitterUsername?: string | null
    tikTokUsername?: string | null
    instagramUsername?: string | null
    youtubeUrl?: string | null
    etsyUsername?: string | null
  }
}

export type CreateMagicLinkMutationVariables = Exact<{
  createMagicLinkParams: CreateMagicLinkParams
}>

export type CreateMagicLinkMutation = {__typename?: 'Mutation'; createMagicLink: boolean}

export type GetUserNotesQueryVariables = Exact<{
  getNotesParams: UserNotesParameters
}>

export type GetUserNotesQuery = {
  __typename?: 'Query'
  userNotes: Array<{
    __typename?: 'GalleryNote'
    id: string
    name: string
    viewCount: number
    commentsEnabled: boolean
    previewCount: number
    description: string
    updatedAt: any
    createdAt: any
    triageState: TriageState
    contentType: GalleryNoteContentType
    parentNoteId?: string | null
    rootNoteId?: string | null
    likes: number
    remixCount: number
    clientId: string
    ntbUploadedAt?: any | null
    user: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
  }>
}

export type GetUserFavoritedNotesQueryVariables = Exact<{
  getNotesParams: UserFavoritedNotesParameters
}>

export type GetUserFavoritedNotesQuery = {
  __typename?: 'Query'
  userFavoritedNotes: Array<{
    __typename?: 'GalleryNote'
    id: string
    name: string
    viewCount: number
    commentsEnabled: boolean
    previewCount: number
    description: string
    updatedAt: any
    createdAt: any
    triageState: TriageState
    contentType: GalleryNoteContentType
    parentNoteId?: string | null
    rootNoteId?: string | null
    likes: number
    remixCount: number
    clientId: string
    ntbUploadedAt?: any | null
    user: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
  }>
}

export type GetUserDownloadedNotesQueryVariables = Exact<{
  getNotesParams: UserNotesParameters
}>

export type GetUserDownloadedNotesQuery = {
  __typename?: 'Query'
  userDownloadedNotes: Array<{
    __typename?: 'GalleryNote'
    id: string
    name: string
    viewCount: number
    commentsEnabled: boolean
    previewCount: number
    description: string
    updatedAt: any
    createdAt: any
    triageState: TriageState
    contentType: GalleryNoteContentType
    parentNoteId?: string | null
    rootNoteId?: string | null
    likes: number
    remixCount: number
    clientId: string
    ntbUploadedAt?: any | null
    user: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
  }>
}

export type EditNoteMutationVariables = Exact<{
  editNotesParams: EditParams
}>

export type EditNoteMutation = {
  __typename?: 'Mutation'
  editNote: {
    __typename?: 'GalleryNote'
    id: string
    description: string
    language?: string | null
    contentType: GalleryNoteContentType
    name: string
    commentsEnabled: boolean
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
    mentionedProfiles: Array<{
      __typename?: 'UserProfile'
      screenname?: string | null
      avatarUpdatedAt?: any | null
      user: {__typename?: 'User'; id: string}
    }>
  }
}

export type SetLanguageMutationVariables = Exact<{
  setLanguageParams: SetLanguageParams
}>

export type SetLanguageMutation = {
  __typename?: 'Mutation'
  setLanguage: {__typename?: 'GalleryNote'; id: string; language?: string | null}
}

export type GalleryNoteSearchQueryVariables = Exact<{
  searchParams: SearchParams
}>

export type GalleryNoteSearchQuery = {
  __typename?: 'Query'
  galleryNoteSearch: Array<{
    __typename?: 'GalleryNote'
    language?: string | null
    id: string
    name: string
    viewCount: number
    commentsEnabled: boolean
    previewCount: number
    description: string
    updatedAt: any
    createdAt: any
    triageState: TriageState
    contentType: GalleryNoteContentType
    parentNoteId?: string | null
    rootNoteId?: string | null
    likes: number
    remixCount: number
    clientId: string
    ntbUploadedAt?: any | null
    user: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
    tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
  }>
}

export type TriageNoteMutationVariables = Exact<{
  triageNoteParams: TriageNoteParams
}>

export type TriageNoteMutation = {
  __typename?: 'Mutation'
  triageNote: {__typename?: 'TriageResult'; noteId: string; triageState: string}
}

export type TriageNoteSearchQueryVariables = Exact<{
  triageSearchParams: TriageSearchParams
}>

export type TriageNoteSearchQuery = {
  __typename?: 'Query'
  triageNoteSearch: {
    __typename?: 'TriageSearchResults'
    totalCount: number
    results: Array<{
      __typename?: 'GalleryNote'
      id: string
      name: string
      viewCount: number
      commentsEnabled: boolean
      previewCount: number
      description: string
      updatedAt: any
      createdAt: any
      triageState: TriageState
      contentType: GalleryNoteContentType
      parentNoteId?: string | null
      rootNoteId?: string | null
      likes: number
      remixCount: number
      clientId: string
      ntbUploadedAt?: any | null
      user: {
        __typename?: 'User'
        id: string
        profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
      }
      tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
    }>
  }
}

export type HiddenProfilesQueryVariables = Exact<{
  hiddenProfilesParams: HiddenProfilesParams
}>

export type HiddenProfilesQuery = {
  __typename?: 'Query'
  hiddenProfiles: {
    __typename?: 'HiddenProfilesResults'
    totalCount: number
    results: Array<{
      __typename?: 'UserProfile'
      id: string
      screenname?: string | null
      user: {__typename?: 'User'; id: string; profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null}
    }>
  }
}

export type UnlikeNoteMutationVariables = Exact<{
  unlikeNoteParams: LikeParams
}>

export type UnlikeNoteMutation = {__typename?: 'Mutation'; unlikeNote: {__typename?: 'GalleryNote'; id: string}}

export type PreparePublishMutationVariables = Exact<{
  publishParams: PublishParams
}>

export type PreparePublishMutation = {
  __typename?: 'Mutation'
  preparePublish: {
    __typename?: 'PublishResult'
    noteUploadPolicy: string
    pdfUploadPolicy: string
    imageUploadPolicies: Array<string>
    galleryNote: {__typename?: 'GalleryNote'; id: string}
  }
}

export type UnpublishMutationVariables = Exact<{
  unpublishParams: UnpublishParams
}>

export type UnpublishMutation = {__typename?: 'Mutation'; unpublish: boolean}

export type NoteViewedMutationVariables = Exact<{
  viewedNoteParams: ViewedNoteParameters
}>

export type NoteViewedMutation = {__typename?: 'Mutation'; noteViewed: boolean}

export type FollowUserMutationVariables = Exact<{
  followParams: FollowParams
}>

export type FollowUserMutation = {
  __typename?: 'Mutation'
  followUser: {__typename?: 'FollowPair'; followedId: string; followerId: string; isFollowing: boolean}
}

export type UnfollowUserMutationVariables = Exact<{
  unfollowParams: UnfollowParams
}>

export type UnfollowUserMutation = {
  __typename?: 'Mutation'
  unfollowUser: {__typename?: 'FollowPair'; followedId: string; followerId: string; isFollowing: boolean}
}

export type GetUserIsFollowedQueryVariables = Exact<{
  getUserIsFollowedParams: GetUserIsFollowedParams
}>

export type GetUserIsFollowedQuery = {
  __typename?: 'Query'
  getUserIsFollowed: {__typename?: 'FollowPair'; followedId: string; followerId: string; isFollowing: boolean}
}

export type UnlockUserAccountMutationVariables = Exact<{
  unlockUserAccountParams: UnlockUserAccountParams
}>

export type UnlockUserAccountMutation = {__typename?: 'Mutation'; unlockUserAccount: boolean}

export type AdminGetUserDataQueryVariables = Exact<{
  adminGetUserDataParams: AdminGetUserDataParams
}>

export type AdminGetUserDataQuery = {
  __typename?: 'Query'
  adminGetUserData: {
    __typename?: 'User'
    id: string
    name?: string | null
    email: string
    emailVerifiedAt?: any | null
    userStatus: UserStatus
    isAdmin?: boolean | null
    isBlocked: boolean
    isLocked: boolean
    accountDeletionTime?: any | null
    createdAt?: any | null
    numComments: number
    numHiddenComments: number
    loginProviders: Array<{__typename?: 'LoginProvider'; provider: OAuthProvider; verified: boolean}>
    bestAvailableSubscription?: {__typename?: 'AppStoreSubscription'; tier: string} | null
    baseSubscription?: {__typename?: 'AppStoreSubscription'; tier: string} | null
    subscriptions: Array<{
      __typename?: 'AppStoreSubscription'
      originalTransactionId: string
      originalPurchaseDate: any
      productId: string
      expirationDate: any
      status: string
      isTrialPeriod: boolean
      isInIntroOfferPeriod: boolean
      refundedDate?: any | null
      refundedReason?: number | null
      deviceLimitEnforcementEnabled: boolean
      overDeviceLimit: boolean
      activeDeviceCount: number
      gracePeriodExpiresAt?: any | null
      expirationIntent?: ExpirationIntent | null
      isInBillingRetryPeriod: boolean
      tier: string
    }>
    subscriptionOverrides: Array<{
      __typename?: 'SubscriptionOverride'
      id: string
      createdAt: any
      expirationDate: any
      overrideTier: SubscriptionTier
      overrideReason?: string | null
      createdBy?: {__typename?: 'User'; email: string} | null
    }>
    stripeConsumerSubscription?: {
      __typename?: 'StripeConsumerSubscription'
      status: StripeSubscriptionStatus
      updatedAt: any
      createdAt: any
      endedAt?: any | null
      trialEndAt?: any | null
      trialEndedAt?: any | null
      tier: StripeConsumerSubscriptionTier
      stripeSubscriptionId: string
      stripePriceId: string
      stripeProductId: string
    } | null
    classicStatus: Array<{
      __typename?: 'AppStoreClassicStatus'
      id: string
      originalApplicationVersion: string
      originalPurchaseDate: any
      deviceId: string
      likelyFraud: boolean
      createdAt: any
      updatedAt: any
    }>
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; ignoreFlagging: boolean} | null
    subscriber?: {__typename?: 'Subscriber'; id: string} | null
    business?: {__typename?: 'Business'; id: string; name: string; industry: string} | null
    businessUser?: {
      __typename?: 'BusinessUser'
      role: BusinessUserRole
      status: BusinessUserStatus
      tokenExpiresAt?: any | null
    } | null
    adminOrganization?: {
      __typename?: 'AdminUserOrganization'
      role: OrganizationRole
      status: OrganizationUserStatus
      organization: {
        __typename?: 'OrganizationDetails'
        id: string
        organizationName: string
        organizationType: string
        status: OrganizationStatus
        subscriptionStatus: OrganizationSubscriptionStatus
        usedSeats: number
        maxSeats: number
      }
    } | null
    quizStatistics: {
      __typename?: 'QuizStatistics'
      questionsCorrect: number
      questionsSkipped: number
      questionsAnswered: number
      quizCount: number
    }
  }
}

export type GetLibraryCountsQueryVariables = Exact<{
  getLibraryCountsParams: GetLibraryCountsParams
}>

export type GetLibraryCountsQuery = {
  __typename?: 'Query'
  getLibraryCounts: {
    __typename?: 'LibraryCounts'
    notesCount: number
    legacyNotesCount: number
    organizersCount: number
    notesWithoutOpsCount: number
    unfiledNotesCount: number
  }
}

export type GetMigrationsQueryVariables = Exact<{
  getMigrationsParams: GetMigrationsParams
}>

export type GetMigrationsQuery = {
  __typename?: 'Query'
  getMigrations: Array<{
    __typename?: 'MigratingDevice'
    id: string
    controllingDeviceName: string
    controllingDeviceId: string
    startDate: any
    source: {
      __typename?: 'ResponseLibraryId'
      type: LibraryType
      icloudUserId?: string | null
      serverUserId?: string | null
      workspaceId?: string | null
    }
    target: {
      __typename?: 'ResponseLibraryId'
      type: LibraryType
      icloudUserId?: string | null
      serverUserId?: string | null
      workspaceId?: string | null
    }
  }>
}

export type GetUserAdminEventsQueryVariables = Exact<{
  adminEventSearchParams: AdminEventSearchParams
}>

export type GetUserAdminEventsQuery = {
  __typename?: 'Query'
  getUserAdminEvents: Array<{
    __typename?: 'UserAdminEvent'
    id: string
    eventType: UsersAdminEventType
    createdAt: any
    systemNotes?: string | null
    triggeringUserEmail: string
    triggeringUserNotes?: string | null
  }>
}

export type GetUserNoteAdminEventsQueryVariables = Exact<{
  adminEventSearchParams: AdminEventSearchParams
}>

export type GetUserNoteAdminEventsQuery = {
  __typename?: 'Query'
  getUserNoteAdminEvents: Array<{
    __typename?: 'GalleryNoteAdminEvent'
    id: string
    eventType: GalleryNotesAdminEventType
    createdAt: any
    systemNotes?: string | null
    triggeringUserEmail: string
    triggeringUserNotes?: string | null
    flaggedReason?: FlaggedReason | null
    galleryNote: {
      __typename?: 'GalleryNote'
      id: string
      name: string
      viewCount: number
      commentsEnabled: boolean
      previewCount: number
      description: string
      updatedAt: any
      createdAt: any
      triageState: TriageState
      contentType: GalleryNoteContentType
      parentNoteId?: string | null
      rootNoteId?: string | null
      likes: number
      remixCount: number
      clientId: string
      ntbUploadedAt?: any | null
      user: {
        __typename?: 'User'
        id: string
        profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
      }
      tags?: Array<{__typename?: 'GalleryNoteTag'; name: string}> | null
    }
  }>
}

export type GetPublishersFollowedByUserQueryVariables = Exact<{
  followingUsersParameters: FollowingUsersParameters
}>

export type GetPublishersFollowedByUserQuery = {
  __typename?: 'Query'
  getPublishersFollowedByUser: Array<{
    __typename?: 'User'
    id: string
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
  }>
}

export type GetUsersFollowingPublisherQueryVariables = Exact<{
  followingUsersParameters: FollowingUsersParameters
}>

export type GetUsersFollowingPublisherQuery = {
  __typename?: 'Query'
  getUsersFollowingPublisher: Array<{
    __typename?: 'User'
    id: string
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
  }>
}

export type GetUsersWhoLikedNoteQueryVariables = Exact<{
  likingUsersParameters: LikingUsersParameters
}>

export type GetUsersWhoLikedNoteQuery = {
  __typename?: 'Query'
  getUsersWhoLikedNote: Array<{
    __typename?: 'User'
    id: string
    profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
  }>
}

export type GetNoteRendererDataQueryVariables = Exact<{
  noteRendererParams: NoteRendererParams
}>

export type GetNoteRendererDataQuery = {
  __typename?: 'Query'
  getNoteRendererData?: {__typename?: 'NoteRenderData'; data: string} | null
}

export type GetQuestionableNoteContentQueryVariables = Exact<{
  questionableNoteContentParams: QuestionableNoteContentParams
}>

export type GetQuestionableNoteContentQuery = {
  __typename?: 'Query'
  getQuestionableNoteContent: Array<{
    __typename?: 'SearchIndexFlagInfo'
    reason: string
    origin: string
    content: Array<{__typename?: 'FlaggedContent'; flaggedTerm: string; context: string}>
  }>
}

export type MarkFeedAsViewedMutationVariables = Exact<{
  markFeedAsViewedParams: MarkFeedAsViewedParams
}>

export type MarkFeedAsViewedMutation = {__typename?: 'Mutation'; markFeedAsViewed: boolean}

export type UpdateCookiesMutationVariables = Exact<{
  updateCookiesParams: UpdateCookiesParams
}>

export type UpdateCookiesMutation = {__typename?: 'Mutation'; updateCookies: string}

export type ChangeScreennameMutationVariables = Exact<{
  changeScreennameParams: ChangeScreennameParams
}>

export type ChangeScreennameMutation = {__typename?: 'Mutation'; changeScreenname: string}

export type ChangeEmailMutationVariables = Exact<{
  changeEmailParams: ChangeEmailParams
}>

export type ChangeEmailMutation = {__typename?: 'Mutation'; changeEmail: string}

export type ChangeAdminStatusMutationVariables = Exact<{
  changeAdminStatusParams: ChangeAdminStatusParams
}>

export type ChangeAdminStatusMutation = {__typename?: 'Mutation'; changeAdminStatus: boolean}

export type ChangeBlockStatusMutationVariables = Exact<{
  changeBlockStatusParams: ChangeBlockStatusParams
}>

export type ChangeBlockStatusMutation = {__typename?: 'Mutation'; changeBlockStatus: boolean}

export type GetFuzzyScreennameMatchesQueryVariables = Exact<{
  getFuzzyScreennameMatchesParams: GetFuzzyScreennameMatchesParams
}>

export type GetFuzzyScreennameMatchesQuery = {__typename?: 'Query'; getFuzzyScreennameMatches: Array<string>}

export type AdminFuzzyUserSearchQueryVariables = Exact<{
  adminFuzzyUserSearchParams: AdminFuzzyUserSearchParams
}>

export type AdminFuzzyUserSearchQuery = {__typename?: 'Query'; adminFuzzyUserSearch: Array<string>}

export type GetNotificationsQueryVariables = Exact<{
  getNotificationsParams: GetNotificationsParams
}>

export type GetNotificationsQuery = {
  __typename?: 'Query'
  getNotifications: Array<{
    __typename?: 'Notification'
    id: string
    type: NotificationType
    seen: boolean
    eventCount: number
    createdAt: any
    lastNotificationActionAt: any
    galleryNote?: {__typename?: 'GalleryNote'; id: string; name: string; previewImages: Array<string>} | null
    promoNotification?: {__typename?: 'PromoNotification'; translationKey: string; href: string} | null
    notificationEvents: Array<{
      __typename?: 'NotificationEvent'
      id: string
      triggeringUser?: {
        __typename?: 'User'
        id: string
        profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
      } | null
    }>
  }>
}

export type MarkNotificationsSeenMutationVariables = Exact<{
  markNotificationsSeenParams: MarkNotificationsSeenParams
}>

export type MarkNotificationsSeenMutation = {__typename?: 'Mutation'; markNotificationsSeen: boolean}

export type CreatePromoNotificationMutationVariables = Exact<{
  promoNotificationParams: PromoNotificationParams
}>

export type CreatePromoNotificationMutation = {
  __typename?: 'Mutation'
  createPromoNotification: {
    __typename?: 'PromoNotification'
    id: string
    startDate: any
    endDate: any
    translationKey: string
    href: string
    isDraft: boolean
    author: {
      __typename?: 'User'
      id: string
      name?: string | null
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
  }
}

export type DeletePromoNotificationMutationVariables = Exact<{
  deletePromoParams: DeletePromoParams
}>

export type DeletePromoNotificationMutation = {__typename?: 'Mutation'; deletePromoNotification: string}

export type EditPromoNotificationMutationVariables = Exact<{
  promoNotificationParams: PromoNotificationParams
}>

export type EditPromoNotificationMutation = {
  __typename?: 'Mutation'
  editPromoNotification: {
    __typename?: 'PromoNotification'
    id: string
    startDate: any
    endDate: any
    translationKey: string
    href: string
    isDraft: boolean
    author: {
      __typename?: 'User'
      id: string
      name?: string | null
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
  }
}

export type SetPromoAsDraftMutationVariables = Exact<{
  promoDraftParams: PromoDraftParams
}>

export type SetPromoAsDraftMutation = {
  __typename?: 'Mutation'
  setPromoAsDraft: {
    __typename?: 'PromoNotification'
    id: string
    startDate: any
    endDate: any
    translationKey: string
    href: string
    isDraft: boolean
    author: {
      __typename?: 'User'
      id: string
      name?: string | null
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUpdatedAt?: any | null} | null
    }
  }
}

export type GetDesktopStatusesQueryVariables = Exact<{
  includeRemoved: Scalars['Boolean']['input']
}>

export type GetDesktopStatusesQuery = {
  __typename?: 'Query'
  desktopStatuses: Array<{
    __typename?: 'DesktopStatus'
    id: string
    message: any
    url: string
    platforms?: Array<string> | null
    arches?: Array<string> | null
    versions?: Array<string> | null
    showBelowVersion?: string | null
    showAboveVersion?: string | null
    blocks: boolean
    operatorNote: string
    removedAt?: any | null
    createdAt: any
    createdBy?: {__typename?: 'User'; id: string; email: string} | null
  }>
}

export type PreviewDesktopStatusQueryVariables = Exact<{
  previewDesktopStatusParams: PreviewDesktopStatusParams
}>

export type PreviewDesktopStatusQuery = {
  __typename?: 'Query'
  previewDesktopStatus: {
    __typename?: 'DesktopStatusPreview'
    shows: boolean
    message?: string | null
    url?: string | null
    blocks: boolean
    suppressedBy?: string | null
  }
}

export type PreviewLiveDesktopStatusQueryVariables = Exact<{
  context: DesktopStatusContextParams
}>

export type PreviewLiveDesktopStatusQuery = {
  __typename?: 'Query'
  previewLiveDesktopStatus: {
    __typename?: 'DesktopStatusPreview'
    shows: boolean
    message?: string | null
    url?: string | null
    blocks: boolean
    suppressedBy?: string | null
  }
}

export type CreateDesktopStatusMutationVariables = Exact<{
  desktopStatusParams: DesktopStatusParams
}>

export type CreateDesktopStatusMutation = {
  __typename?: 'Mutation'
  createDesktopStatus: {
    __typename?: 'DesktopStatus'
    id: string
    message: any
    url: string
    platforms?: Array<string> | null
    arches?: Array<string> | null
    versions?: Array<string> | null
    showBelowVersion?: string | null
    showAboveVersion?: string | null
    blocks: boolean
    operatorNote: string
    removedAt?: any | null
    createdAt: any
    createdBy?: {__typename?: 'User'; id: string; email: string} | null
  }
}

export type EditDesktopStatusMutationVariables = Exact<{
  desktopStatusParams: DesktopStatusParams
}>

export type EditDesktopStatusMutation = {
  __typename?: 'Mutation'
  editDesktopStatus: {
    __typename?: 'DesktopStatus'
    id: string
    message: any
    url: string
    platforms?: Array<string> | null
    arches?: Array<string> | null
    versions?: Array<string> | null
    showBelowVersion?: string | null
    showAboveVersion?: string | null
    blocks: boolean
    operatorNote: string
    removedAt?: any | null
    createdAt: any
    createdBy?: {__typename?: 'User'; id: string; email: string} | null
  }
}

export type RemoveDesktopStatusMutationVariables = Exact<{
  removeDesktopStatusParams: RemoveDesktopStatusParams
}>

export type RemoveDesktopStatusMutation = {
  __typename?: 'Mutation'
  removeDesktopStatus: {
    __typename?: 'DesktopStatus'
    id: string
    message: any
    url: string
    platforms?: Array<string> | null
    arches?: Array<string> | null
    versions?: Array<string> | null
    showBelowVersion?: string | null
    showAboveVersion?: string | null
    blocks: boolean
    operatorNote: string
    removedAt?: any | null
    createdAt: any
    createdBy?: {__typename?: 'User'; id: string; email: string} | null
  }
}

export type GetTranslationMappingsQueryVariables = Exact<{
  translationMappingParams: TranslationMappingParams
}>

export type GetTranslationMappingsQuery = {
  __typename?: 'Query'
  getTranslationMappings: Array<{__typename?: 'TranslationMapping'; locale: string; tKey: string; text: string}>
}

export type DeleteSubscriptionOverrideMutationVariables = Exact<{
  deleteSubscriptionOverrideParams: DeleteSubscriptionOverrideParams
}>

export type DeleteSubscriptionOverrideMutation = {__typename?: 'Mutation'; deleteSubscriptionOverride: boolean}

export type GrantSubscriptionOverrideMutationVariables = Exact<{
  grantSubscriptionOverrideParams: GrantSubscriptionOverrideParams
}>

export type GrantSubscriptionOverrideMutation = {__typename?: 'Mutation'; grantSubscriptionOverride: boolean}

export type RecoverDeletedNoteMutationVariables = Exact<{
  recoverDeletedNoteParams: RecoverDeletedNoteParams
}>

export type RecoverDeletedNoteMutation = {__typename?: 'Mutation'; recoverDeletedNote: boolean}

export type DisableDevicesForSubscriptionsMutationVariables = Exact<{
  disableDevicesForSubscriptionsParams: DisableDevicesForSubscriptionsParams
}>

export type DisableDevicesForSubscriptionsMutation = {__typename?: 'Mutation'; disableDevicesForSubscriptions: boolean}

export type GetUserLikesNotesQueryVariables = Exact<{
  userLikesNotesParameters: UserLikesNotesParameters
}>

export type GetUserLikesNotesQuery = {
  __typename?: 'Query'
  getUserLikesNotes: Array<{__typename?: 'LikedNotePair'; noteId: string; likesNote: boolean}>
}

export type GetAllCommentsQueryVariables = Exact<{
  getAllCommentsParams: GetAllCommentsParams
}>

export type GetAllCommentsQuery = {
  __typename?: 'Query'
  getAllComments: Array<{
    __typename?: 'Comment'
    id: string
    createdAt: any
    commentText: string
    approvalState?: CommentReviewState | null
    rejectionReason?: string | null
    parent?: {__typename?: 'Comment'; id: string} | null
    author: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUrl?: string | null} | null
    }
    galleryNote: {__typename?: 'GalleryNote'; id: string; name: string}
  }>
}

export type GetNoteRootCommentsQueryVariables = Exact<{
  getNoteRootCommentsParams: GetNoteRootCommentsParams
}>

export type GetNoteRootCommentsQuery = {
  __typename?: 'Query'
  getNoteRootComments: Array<{
    __typename?: 'Comment'
    id: string
    createdAt: any
    commentText: string
    parent?: {__typename?: 'Comment'; id: string} | null
    author: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUrl?: string | null} | null
    }
  }>
}

export type ApproveCommentMutationVariables = Exact<{
  approveCommentParams: ApproveCommentParams
}>

export type ApproveCommentMutation = {__typename?: 'Mutation'; approveComment: string}

export type SetGalleryDegradedMutationVariables = Exact<{
  degradedStateParams: DegradedStateParams
}>

export type SetGalleryDegradedMutation = {__typename?: 'Mutation'; setGalleryDegraded: boolean}

export type HideCommentMutationVariables = Exact<{
  hideCommentParams: HideCommentParams
}>

export type HideCommentMutation = {__typename?: 'Mutation'; hideComment: string}

export type CreateCommentMutationVariables = Exact<{
  createCommentParams: CreateCommentParams
}>

export type CreateCommentMutation = {
  __typename?: 'Mutation'
  createComment: {
    __typename?: 'Comment'
    id: string
    createdAt: any
    commentText: string
    parent?: {__typename?: 'Comment'; id: string} | null
    author: {
      __typename?: 'User'
      id: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; avatarUrl?: string | null} | null
    }
  }
}

export type ReportCommentMutationVariables = Exact<{
  reportCommentParams: ReportCommentParams
}>

export type ReportCommentMutation = {__typename?: 'Mutation'; reportComment: string}

export type DeleteCommentMutationVariables = Exact<{
  deleteCommentParams: DeleteCommentParams
}>

export type DeleteCommentMutation = {__typename?: 'Mutation'; deleteComment: string}

export type GetAllSubscriptionsOverDeviceLimitQueryVariables = Exact<{
  getAllSubscriptionsOverDeviceLimitParams: GetAllSubscriptionsOverDeviceLimitParams
}>

export type GetAllSubscriptionsOverDeviceLimitQuery = {
  __typename?: 'Query'
  getAllSubscriptionsOverDeviceLimit: Array<{
    __typename?: 'GetAllSubscriptionsOverDeviceLimitResult'
    subscriptionId: string
    numDevices: number
    deviceLimitEnforcementEnabled: boolean
  }>
}

export type ToggleDeviceLimitEnforcementMutationVariables = Exact<{
  toggleDeviceLimitEnforcementParams: ToggleDeviceLimitEnforcementParams
}>

export type ToggleDeviceLimitEnforcementMutation = {
  __typename?: 'Mutation'
  toggleDeviceLimitEnforcement: {__typename?: 'AppStoreSubscription'; deviceLimitEnforcementEnabled: boolean}
}

export type DismissGuidelinesMutationVariables = Exact<{[key: string]: never}>

export type DismissGuidelinesMutation = {__typename?: 'Mutation'; dismissGuidelines: boolean}

export type CreateExperimentMutationVariables = Exact<{
  experimentParams: ExperimentParams
}>

export type CreateExperimentMutation = {
  __typename?: 'Mutation'
  createExperiment: {__typename?: 'Experiment'; id: string; description: string; targetEnrollmentPct: number}
}

export type AssignAllUsersToExperimentsMutationVariables = Exact<{[key: string]: never}>

export type AssignAllUsersToExperimentsMutation = {__typename?: 'Mutation'; assignAllUsersToExperiments: boolean}

export type EditExperimentMutationVariables = Exact<{
  experimentParams: ExperimentParams
}>

export type EditExperimentMutation = {__typename?: 'Mutation'; editExperiment: boolean}

export type DeleteExperimentMutationVariables = Exact<{
  deleteExperimentParams: DeleteExperimentParams
}>

export type DeleteExperimentMutation = {__typename?: 'Mutation'; deleteExperiment: boolean}

export type GetExperimentEnrollmentOverridesQueryVariables = Exact<{
  experimentEnrollmentOverrideQueryParams: ExperimentEnrollmentOverrideQueryParams
}>

export type GetExperimentEnrollmentOverridesQuery = {
  __typename?: 'Query'
  getExperimentEnrollmentOverrides: Array<{
    __typename?: 'ExperimentEnrollment'
    inVariantGroup: boolean
    isOverride: boolean
    user?: {__typename?: 'User'; profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null} | null
    experiment: {__typename?: 'Experiment'; id: string}
  }>
}

export type RemoveExperimentEnrollmentOverrideMutationVariables = Exact<{
  removeExperimentEnrollmentOverrideParams: RemoveExperimentEnrollmentOverrideParams
}>

export type RemoveExperimentEnrollmentOverrideMutation = {
  __typename?: 'Mutation'
  removeExperimentEnrollmentOverride: boolean
}

export type UpdateUserExperimentEnrollmentOverrideMutationVariables = Exact<{
  experimentEnrollmentParams: ExperimentEnrollmentParams
}>

export type UpdateUserExperimentEnrollmentOverrideMutation = {
  __typename?: 'Mutation'
  updateUserExperimentEnrollmentOverride: {
    __typename?: 'ExperimentEnrollment'
    inVariantGroup: boolean
    isOverride: boolean
    user?: {__typename?: 'User'; profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null} | null
    experiment: {__typename?: 'Experiment'; id: string}
  }
}

export type CreateAsrJobMutationVariables = Exact<{
  createASRJobParams: CreateAsrJobParams
}>

export type CreateAsrJobMutation = {
  __typename?: 'Mutation'
  createASRJob: {
    __typename?: 'ASRJobResult'
    success: boolean
    errorCode?: AsrErrorCode | null
    job?: {
      __typename?: 'ASRJob'
      uploadPolicy?: string | null
      status: AsrJobStatus
      whisperImplementation: WhisperImplementation
      beamSize?: number | null
      results?: {
        __typename?: 'ASRJobResults'
        text: string
        segments: Array<{
          __typename?: 'ASRJobResultSegment'
          startTime: number
          endTime: number
          confidence: number
          text: string
          speaker?: string | null
        }>
        speakers?: Array<{__typename?: 'ASRJobSpeaker'; id: string}> | null
      } | null
    } | null
  }
}

export type ReprocessAsrJobMutationVariables = Exact<{
  reprocessASRJobParams: ReprocessAsrJobParams
}>

export type ReprocessAsrJobMutation = {
  __typename?: 'Mutation'
  reprocessASRJob: {
    __typename?: 'ASRJobResult'
    success: boolean
    errorCode?: AsrErrorCode | null
    job?: {
      __typename?: 'ASRJob'
      uploadPolicy?: string | null
      status: AsrJobStatus
      results?: {
        __typename?: 'ASRJobResults'
        text: string
        segments: Array<{
          __typename?: 'ASRJobResultSegment'
          startTime: number
          endTime: number
          confidence: number
          text: string
        }>
      } | null
    } | null
  }
}

export type GetCurrentAsrProcessorVersionQueryVariables = Exact<{[key: string]: never}>

export type GetCurrentAsrProcessorVersionQuery = {
  __typename?: 'Query'
  getCurrentASRProcessorVersion: {__typename?: 'ASRProcessorVersion'; processorVersion: number}
}

export type GetAsrJobQueryVariables = Exact<{
  getASRJobParams: GetAsrJobParams
}>

export type GetAsrJobQuery = {
  __typename?: 'Query'
  getASRJob: {
    __typename?: 'ASRJobResult'
    success: boolean
    errorCode?: AsrErrorCode | null
    job?: {
      __typename?: 'ASRJob'
      sha512Hash: string
      audioDurationMs?: number | null
      status: AsrJobStatus
      whisperImplementation: WhisperImplementation
      beamSize?: number | null
      results?: {
        __typename?: 'ASRJobResults'
        text: string
        segments: Array<{
          __typename?: 'ASRJobResultSegment'
          startTime: number
          endTime: number
          confidence: number
          text: string
          speaker?: string | null
        }>
        speakers?: Array<{__typename?: 'ASRJobSpeaker'; id: string}> | null
      } | null
      quizJobs?: Array<{
        __typename?: 'QuizJob'
        id: string
        status: QuizJobStatus
        errorReason?: LearnErrorReason | null
      }> | null
      summaryJobs?: Array<{
        __typename?: 'SummaryJob'
        id: string
        status: SummaryJobStatus
        errorReason?: LearnErrorReason | null
      }> | null
    } | null
  }
}

export type GetAsrJobMetaQueryVariables = Exact<{
  getASRJobParams: GetAsrJobParams
}>

export type GetAsrJobMetaQuery = {
  __typename?: 'Query'
  getASRJob: {
    __typename?: 'ASRJobResult'
    success: boolean
    errorCode?: AsrErrorCode | null
    job?: {
      __typename?: 'ASRJob'
      sha512Hash: string
      audioDurationMs?: number | null
      status: AsrJobStatus
      whisperImplementation: WhisperImplementation
      beamSize?: number | null
      audioCreationDate?: any | null
      language?: string | null
      quizJobs?: Array<{
        __typename?: 'QuizJob'
        id: string
        status: QuizJobStatus
        errorReason?: LearnErrorReason | null
      }> | null
      summaryJobs?: Array<{
        __typename?: 'SummaryJob'
        id: string
        status: SummaryJobStatus
        errorReason?: LearnErrorReason | null
      }> | null
    } | null
  }
}

export type GetUserSharedNotesQueryVariables = Exact<{
  getUserSharedNotesParams: GetUserSharedNotesParams
}>

export type GetUserSharedNotesQuery = {
  __typename?: 'Query'
  getUserSharedNotes: Array<{__typename?: 'Note'; name: string; createdDate: any; id: string}>
}

export type SetIgnoreFlagsMutationVariables = Exact<{
  setIgnoreFlagsParams: SetIgnoreFlagsParams
}>

export type SetIgnoreFlagsMutation = {
  __typename?: 'Mutation'
  setIgnoreFlags: {__typename?: 'UserProfile'; id: string; ignoreFlagging: boolean}
}

export type UpdateUserLanguageMutationVariables = Exact<{
  updateUserLanguageParams: UpdateUserLanguageParams
}>

export type UpdateUserLanguageMutation = {__typename?: 'Mutation'; updateUserLanguage: boolean}

export type GetAllSubscriptionInfoQueryVariables = Exact<{
  getAllSubscriptionInfoParams: GetAllSubscriptionInfoParams
}>

export type GetAllSubscriptionInfoQuery = {
  __typename?: 'Query'
  getAllSubscriptionInfo: {
    __typename?: 'SubscriptionInfo'
    bestSubscription?: {
      __typename?: 'AppStoreSubscription'
      deviceLimitEnforcementEnabled: boolean
      originalTransactionId: string
      originalPurchaseDate: any
      productId: string
      expirationDate: any
      gracePeriodExpiresAt?: any | null
      expirationIntent?: ExpirationIntent | null
      status: string
      isTrialPeriod: boolean
      isInIntroOfferPeriod: boolean
      isInBillingRetryPeriod: boolean
      promotionalOfferId?: string | null
      offerCodeRefName?: string | null
      refundedDate?: any | null
      refundedReason?: number | null
      tier: string
      user?: {
        __typename?: 'User'
        id: string
        profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null
      } | null
      devices: Array<{
        __typename?: 'AppStoreSubscriptionDevice'
        id: string
        deviceId: string
        countryCode?: string | null
        latestReceiptAt?: any | null
        deactivatedAt?: any | null
        createdAt: any
        updatedAt: any
      }>
    } | null
    subscriptions: Array<{
      __typename?: 'AppStoreSubscription'
      deviceLimitEnforcementEnabled: boolean
      originalTransactionId: string
      originalPurchaseDate: any
      productId: string
      expirationDate: any
      gracePeriodExpiresAt?: any | null
      expirationIntent?: ExpirationIntent | null
      status: string
      isTrialPeriod: boolean
      isInIntroOfferPeriod: boolean
      isInBillingRetryPeriod: boolean
      promotionalOfferId?: string | null
      offerCodeRefName?: string | null
      refundedDate?: any | null
      refundedReason?: number | null
      tier: string
    }>
    devices: Array<{
      __typename?: 'AppStoreSubscriptionDevice'
      id: string
      deviceId: string
      countryCode?: string | null
      latestReceiptAt?: any | null
      deactivatedAt?: any | null
      createdAt: any
      updatedAt: any
    }>
    users: Array<{
      __typename?: 'User'
      id: string
      email: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null} | null
    }>
    overrides: Array<{
      __typename?: 'SubscriptionOverride'
      id: string
      createdAt: any
      expirationDate: any
      overrideTier: SubscriptionTier
      overrideReason?: string | null
      createdBy?: {__typename?: 'User'; id: string; email: string} | null
    }>
    classicStatuses: Array<{
      __typename?: 'AppStoreClassicStatus'
      id: string
      deviceId: string
      originalApplicationVersion: string
      originalPurchaseDate: any
      likelyFraud: boolean
      createdAt: any
      updatedAt: any
    }>
    receipts: Array<{
      __typename?: 'AppStoreReceipt'
      id: number
      parsedReceipt?: any | null
      deviceId?: string | null
      environment: string
      isValid: boolean
      originalTransactionId?: string | null
      receipt?: string | null
      receiptCreationDate: any
      updatedAt: any
    }>
  }
}

export type GetCollatedFlaggedNoteInfoQueryVariables = Exact<{
  getCollatedFlaggedNoteInfoParams: GetCollatedFlaggedNoteInfoParams
}>

export type GetCollatedFlaggedNoteInfoQuery = {
  __typename?: 'Query'
  getCollatedFlaggedNoteInfo: Array<{
    __typename?: 'GetCollatedFlaggedNoteInfoResult'
    flaggingUser: {
      __typename?: 'User'
      id: string
      email: string
      profile?: {__typename?: 'UserProfile'; screenname?: string | null; ignoreFlagging: boolean} | null
    }
    flaggedNotes: Array<{__typename?: 'GalleryNote'; id: string; name: string}>
  }>
}

export type ComputeTopTagsMutationVariables = Exact<{[key: string]: never}>

export type ComputeTopTagsMutation = {__typename?: 'Mutation'; computeTopTags: string}

export type SetGlobalOverrideValueMutationVariables = Exact<{
  setGlobalOverrideValueParams: SetGlobalOverrideValueParams
}>

export type SetGlobalOverrideValueMutation = {__typename?: 'Mutation'; setGlobalOverrideValue: boolean}

export type DeleteGlobalOverrideValueMutationVariables = Exact<{
  deleteGlobalOverrideValueParams: DeleteGlobalOverrideValueParams
}>

export type DeleteGlobalOverrideValueMutation = {__typename?: 'Mutation'; deleteGlobalOverrideValue: string}

export type AdminSimulateQuotaMutationVariables = Exact<{
  simulateASRQuotaParams: SimulateAsrQuotaParams
}>

export type AdminSimulateQuotaMutation = {__typename?: 'Mutation'; adminSimulateQuota: boolean}

export type GetCurrentQuotaUsageQueryVariables = Exact<{
  getCurrentQuotaUsageParams: GetCurrentQuotaUsageParams
}>

export type GetCurrentQuotaUsageQuery = {
  __typename?: 'Query'
  getCurrentQuotaUsage: {__typename?: 'QuotaUsage'; exceeded: boolean; quotaUsage: string; retryAfter?: string | null}
}

export type OrganizationDetailsFragment = {
  __typename?: 'OrganizationDetails'
  id: string
  organizationName: string
  organizationType: string
  licenseKey?: string | null
  educationLevelsProvided: Array<EducationLevel>
  industry?: string | null
  usedSeats: number
  maxSeats: number
  createdAt: any
  mdmPlatform?: string | null
  approved: boolean
  deletedAt?: any | null
  contractAcceptedAt?: any | null
  adminCreatorEmail?: string | null
  subscriptionStatus: OrganizationSubscriptionStatus
  admins: Array<{
    __typename?: 'OrganizationAdminSummary'
    userId: string
    name?: string | null
    email: string
    jobTitle?: string | null
    phone?: string | null
  }>
}

export type GetAllOrganizationsQueryVariables = Exact<{
  getAllOrganizationsParams: GetAllOrganizationsParams
}>

export type GetAllOrganizationsQuery = {
  __typename?: 'Query'
  getAllOrganizations: {
    __typename?: 'AllOrganizationResults'
    organizationCount: number
    organizations: Array<{
      __typename?: 'OrganizationDetails'
      id: string
      organizationName: string
      organizationType: string
      licenseKey?: string | null
      educationLevelsProvided: Array<EducationLevel>
      industry?: string | null
      usedSeats: number
      maxSeats: number
      createdAt: any
      mdmPlatform?: string | null
      approved: boolean
      deletedAt?: any | null
      contractAcceptedAt?: any | null
      adminCreatorEmail?: string | null
      subscriptionStatus: OrganizationSubscriptionStatus
      admins: Array<{
        __typename?: 'OrganizationAdminSummary'
        userId: string
        name?: string | null
        email: string
        jobTitle?: string | null
        phone?: string | null
      }>
    }>
  }
}

export type GetAllBusinessesQueryVariables = Exact<{
  getAllBusinessesParams: GetAllBusinessesParams
}>

export type GetAllBusinessesQuery = {
  __typename?: 'Query'
  getAllBusinesses: {
    __typename?: 'GetAllBusinessesResponse'
    businessCount: number
    businesses: Array<{
      __typename?: 'GetAllBusinessesItem'
      memberCount: number
      sharedLibraryCount: number
      isEmpty: boolean
      business: {__typename?: 'Business'; id: string; name: string; industry: string; createdAt: any}
      admin?: {
        __typename?: 'BusinessUser'
        user?: {__typename?: 'User'; id: string; name?: string | null; email: string} | null
      } | null
      subscription?: {
        __typename?: 'BusinessSubscription'
        id: string
        status: StripeSubscriptionStatus
        tier: StripeBusinessSubscriptionTier
        stripeSubscriptionId: string
        memberLimit: number
      } | null
    }>
  }
}

export type UpdateBusinessTrialMemberLimitMutationVariables = Exact<{
  updateBusinessTrialMemberLimitParams: UpdateBusinessTrialMemberLimitParams
}>

export type UpdateBusinessTrialMemberLimitMutation = {
  __typename?: 'Mutation'
  updateBusinessTrialMemberLimit: {__typename?: 'BusinessSubscription'; id: string; memberLimit: number}
}

export type OrganizationFragment = {
  __typename?: 'Organization'
  id: string
  name: string
  organizationType: OrganizationType
  approved: boolean
  educationLevelsProvided: Array<EducationLevel>
  isAsmEnrolled: boolean
  mdmPlatform?: string | null
  comments?: string | null
  createdAt: any
  updatedAt?: any | null
  deletedAt?: any | null
  industry?: string | null
  license?: {__typename?: 'OrganizationLicense'; id: string; maxSeats: number} | null
  userMappings: Array<{
    __typename?: 'OrganizationUser'
    jobTitle?: string | null
    role: OrganizationRole
    phone?: string | null
    user: {__typename?: 'User'; name?: string | null; email: string}
  }>
}

export type GetOrganizationsAwaitingApprovalQueryVariables = Exact<{[key: string]: never}>

export type GetOrganizationsAwaitingApprovalQuery = {
  __typename?: 'Query'
  getOrganizationsAwaitingApproval: Array<{
    __typename?: 'Organization'
    id: string
    name: string
    organizationType: OrganizationType
    approved: boolean
    educationLevelsProvided: Array<EducationLevel>
    isAsmEnrolled: boolean
    mdmPlatform?: string | null
    comments?: string | null
    createdAt: any
    updatedAt?: any | null
    deletedAt?: any | null
    industry?: string | null
    license?: {__typename?: 'OrganizationLicense'; id: string; maxSeats: number} | null
    userMappings: Array<{
      __typename?: 'OrganizationUser'
      jobTitle?: string | null
      role: OrganizationRole
      phone?: string | null
      user: {__typename?: 'User'; name?: string | null; email: string}
    }>
  }>
}

export type ReviewOrganizationMutationVariables = Exact<{
  reviewOrganizationParams: ReviewOrganizationParams
}>

export type ReviewOrganizationMutation = {__typename?: 'Mutation'; reviewOrganization: boolean}

export type PendingBusinessDomainFragment = {
  __typename?: 'PendingBusinessDomain'
  id: string
  domain: string
  createdAt: any
  businessId: string
  businessName: string
  ownerEmail?: string | null
  ownerName?: string | null
}

export type PendingBusinessDomainsQueryVariables = Exact<{[key: string]: never}>

export type PendingBusinessDomainsQuery = {
  __typename?: 'Query'
  pendingBusinessDomains: Array<{
    __typename?: 'PendingBusinessDomain'
    id: string
    domain: string
    createdAt: any
    businessId: string
    businessName: string
    ownerEmail?: string | null
    ownerName?: string | null
  }>
}

export type ReviewBusinessDomainMutationVariables = Exact<{
  reviewBusinessDomainParams: ReviewBusinessDomainParams
}>

export type ReviewBusinessDomainMutation = {__typename?: 'Mutation'; reviewBusinessDomain: boolean}

export type ApprovedBusinessDomainFragment = {
  __typename?: 'ApprovedBusinessDomain'
  id: string
  domain: string
  createdAt: any
  businessId: string
  businessName: string
  ownerEmail?: string | null
  ownerName?: string | null
}

export type ApprovedBusinessDomainsQueryVariables = Exact<{[key: string]: never}>

export type ApprovedBusinessDomainsQuery = {
  __typename?: 'Query'
  approvedBusinessDomains: Array<{
    __typename?: 'ApprovedBusinessDomain'
    id: string
    domain: string
    createdAt: any
    businessId: string
    businessName: string
    ownerEmail?: string | null
    ownerName?: string | null
  }>
}

export type DeleteBusinessDomainMutationVariables = Exact<{
  domainId: Scalars['ID']['input']
}>

export type DeleteBusinessDomainMutation = {__typename?: 'Mutation'; deleteBusinessDomain: boolean}

export type RestoreOrganizationMutationVariables = Exact<{
  restoreOrganizationParams: RestoreOrganizationParams
}>

export type RestoreOrganizationMutation = {__typename?: 'Mutation'; restoreOrganization: boolean}

export type AdminSearchNoteWithTitleQueryVariables = Exact<{
  adminSearchNoteWithTitleParams: AdminSearchNoteWithTitleParams
}>

export type AdminSearchNoteWithTitleQuery = {
  __typename?: 'Query'
  adminSearchNoteWithTitle: {
    __typename?: 'AdminSearchNoteWithTitleResponse'
    notes: Array<{
      __typename?: 'CollabNoteMetadata'
      id: string
      title?: string | null
      deletedAt?: any | null
      permanentlyDeletedAt?: any | null
      createdAt: any
      updatedAt: any
      legacyNoteId?: string | null
      ownerId: string
      workspaceId: string
    }>
  }
}

export type RenameUserMutationVariables = Exact<{
  renameUserParams: RenameUserParams
}>

export type RenameUserMutation = {__typename?: 'Mutation'; renameUser: boolean}

export type GetOrganizationQueryVariables = Exact<{
  getOrganizationParams: GetOrganizationParams
}>

export type GetOrganizationQuery = {
  __typename?: 'Query'
  getOrganization: {
    __typename?: 'OrganizationDetails'
    id: string
    organizationName: string
    organizationType: string
    licenseKey?: string | null
    educationLevelsProvided: Array<EducationLevel>
    industry?: string | null
    usedSeats: number
    maxSeats: number
    createdAt: any
    mdmPlatform?: string | null
    approved: boolean
    deletedAt?: any | null
    contractAcceptedAt?: any | null
    adminCreatorEmail?: string | null
    subscriptionStatus: OrganizationSubscriptionStatus
    admins: Array<{
      __typename?: 'OrganizationAdminSummary'
      userId: string
      name?: string | null
      email: string
      jobTitle?: string | null
      phone?: string | null
    }>
  }
}

export type ModifyOrganizationLicenseMutationVariables = Exact<{
  modifyOrganizationLicenseParams: ModifyOrganizationLicenseParams
}>

export type ModifyOrganizationLicenseMutation = {__typename?: 'Mutation'; modifyOrganizationLicense: boolean}

export type ResetOrganizationSeatUsageMutationVariables = Exact<{
  resetOrganizationSeatUsageParams: ResetOrganizationSeatUsageParams
}>

export type ResetOrganizationSeatUsageMutation = {__typename?: 'Mutation'; resetOrganizationSeatUsage: boolean}

export type GetSummaryJobContentQueryVariables = Exact<{
  getSummaryJobContentParams: GetSummaryJobContentParams
}>

export type GetSummaryJobContentQuery = {__typename?: 'Query'; getSummaryJobContent?: string | null}

export type GetQuizJobContentQueryVariables = Exact<{
  getQuizJobContentParams: GetQuizJobContentParams
}>

export type GetQuizJobContentQuery = {__typename?: 'Query'; getQuizJobContent?: string | null}

export type GetInstitutionsQueryVariables = Exact<{
  getInstitutionsParams: GetInstitutionsParams
}>

export type GetInstitutionsQuery = {
  __typename?: 'Query'
  getInstitutions: {
    __typename?: 'GetInstitutionsResult'
    count: number
    institutions: Array<{
      __typename?: 'InstitutionWithDeviceCount'
      id: string
      name: string
      deviceCount: number
      createdAt: any
      licenseEnforcement: LicenseEnforcement
      licenseEnforcementExpiration?: any | null
    }>
  }
}

export type SetLicenseEnforcementMutationVariables = Exact<{
  setLicenseEnforcementParams: SetLicenseEnforcementParams
}>

export type SetLicenseEnforcementMutation = {__typename?: 'Mutation'; setLicenseEnforcement: boolean}

export type SetLicenseEnforcementExpirationMutationVariables = Exact<{
  setLicenseEnforcementExpirationParams: SetLicenseEnforcementExpirationParams
}>

export type SetLicenseEnforcementExpirationMutation = {
  __typename?: 'Mutation'
  setLicenseEnforcementExpiration: boolean
}

export type GenerateStudyMaterialsBatchMutationVariables = Exact<{
  generateStudyMaterialsBatchParams: GenerateStudyMaterialsBatchParams
}>

export type GenerateStudyMaterialsBatchMutation = {
  __typename?: 'Mutation'
  generateStudyMaterialsBatch: {
    __typename?: 'StudyMaterialsBatch'
    id: string
    promptGroup?: string | null
    language?: string | null
    studyMaterials?: Array<{
      __typename?: 'StudyMaterial'
      contentHash: string
      source: StudyMaterialSource
      quizJob?: {
        __typename?: 'QuizJob'
        id: string
        status: QuizJobStatus
        errorReason?: LearnErrorReason | null
      } | null
      summaryJob?: {
        __typename?: 'SummaryJob'
        id: string
        status: SummaryJobStatus
        errorReason?: LearnErrorReason | null
      } | null
    }> | null
  }
}

export type GetStudyMaterialsBatchQueryVariables = Exact<{
  getStudyMaterialsBatchParams: GetStudyMaterialsBatchParams
}>

export type GetStudyMaterialsBatchQuery = {
  __typename?: 'Query'
  getStudyMaterialsBatch: {
    __typename?: 'StudyMaterialsBatch'
    id: string
    promptGroup?: string | null
    language?: string | null
    studyMaterials?: Array<{
      __typename?: 'StudyMaterial'
      contentHash: string
      source: StudyMaterialSource
      quizJob?: {
        __typename?: 'QuizJob'
        id: string
        status: QuizJobStatus
        errorReason?: LearnErrorReason | null
      } | null
      summaryJob?: {
        __typename?: 'SummaryJob'
        id: string
        status: SummaryJobStatus
        errorReason?: LearnErrorReason | null
      } | null
    }> | null
  }
}

export type CreateOrganizationMutationVariables = Exact<{
  createOrgParams: CreateOrgParams
}>

export type CreateOrganizationMutation = {
  __typename?: 'Mutation'
  createOrganization: {
    __typename?: 'Organization'
    id: string
    name: string
    approved: boolean
    isAsmEnrolled: boolean
    educationLevelsProvided: Array<EducationLevel>
    mdmPlatform?: string | null
    organizationType: OrganizationType
    industry?: string | null
    contractAcceptedAt?: any | null
    license?: {__typename?: 'OrganizationLicense'; id: string; maxSeats: number} | null
  }
}

export type ChangeBusinessOwnerMutationVariables = Exact<{
  changeBusinessOwnerParams: ChangeBusinessOwnerParams
}>

export type ChangeBusinessOwnerMutation = {
  __typename?: 'Mutation'
  changeBusinessOwner: {__typename?: 'Business'; id: string; name: string}
}

export type AdminSyncBusinessSubscriptionMutationVariables = Exact<{
  adminSyncBusinessSubscriptionParams: AdminSyncBusinessSubscriptionParams
}>

export type AdminSyncBusinessSubscriptionMutation = {__typename?: 'Mutation'; adminSyncBusinessSubscription: boolean}

export type AdminUpdateBusinessSubscriptionMutationVariables = Exact<{
  adminUpdateBusinessSubscriptionParams: AdminUpdateBusinessSubscriptionParams
}>

export type AdminUpdateBusinessSubscriptionMutation = {
  __typename?: 'Mutation'
  adminUpdateBusinessSubscription: boolean
}

export type CreateTestBusinessMutationVariables = Exact<{
  createTestBusinessParams: CreateTestBusinessParams
}>

export type CreateTestBusinessMutation = {
  __typename?: 'Mutation'
  createTestBusiness: {
    __typename?: 'CreateTestBusinessResponse'
    business: {__typename?: 'Business'; name: string}
    owner: {__typename?: 'User'; id: string; email: string}
  }
}

export type PatchBusinessSubscriptionMutationVariables = Exact<{
  patchBusinessSubscriptionParams: PatchBusinessSubscriptionParams
}>

export type PatchBusinessSubscriptionMutation = {
  __typename?: 'Mutation'
  patchBusinessSubscription: {__typename?: 'PatchBusinessSubscriptionResult'; success: boolean}
}

export type GetViableSubscriptionQueryVariables = Exact<{
  getViableSubscriptionParams: GetViableSubscriptionParams
}>

export type GetViableSubscriptionQuery = {
  __typename?: 'Query'
  getViableSubscription?: {
    __typename?: 'AppStoreSubscription'
    originalTransactionId: string
    originalPurchaseDate: any
    productId: string
    expirationDate: any
    status: string
    isTrialPeriod: boolean
    isInIntroOfferPeriod: boolean
    refundedDate?: any | null
    refundedReason?: number | null
    overDeviceLimit: boolean
    gracePeriodExpiresAt?: any | null
    expirationIntent?: ExpirationIntent | null
    isInBillingRetryPeriod: boolean
    tier: string
  } | null
}

export type GetSendGridEventsQueryVariables = Exact<{
  getSendGridEventsParams: GetSendGridEventsParams
}>

export type GetSendGridEventsQuery = {
  __typename?: 'Query'
  getSendGridEvents: {
    __typename?: 'OrganizationEmailEvents'
    count: number
    events: Array<{__typename?: 'SendGridEvent'; id: string; email: string; createdAt: any; event: any}>
  }
}

export type AdminGetSendGridSuppressionsQueryVariables = Exact<{
  adminGetSendGridSuppressionsParams: AdminGetSendGridSuppressionsParams
}>

export type AdminGetSendGridSuppressionsQuery = {
  __typename?: 'Query'
  adminGetSendGridSuppressions: Array<{
    __typename?: 'SendGridSuppressionListing'
    name: string
    listed?: boolean | null
    listedAt?: any | null
    reason?: string | null
    error?: string | null
  }>
}

export type CreateTrialSubscriptionMutationVariables = Exact<{
  createTrialSubscriptionParams: CreateTrialSubscriptionParams
}>

export type CreateTrialSubscriptionMutation = {
  __typename?: 'Mutation'
  createTrialSubscription: {
    __typename?: 'TrialSubscription'
    id: string
    expirationDate: any
    canceledAt?: any | null
    trialLengthInDays: number
    daysRemainingOnTrial?: number | null
  }
}

export type ModifyTrialExpirationMutationVariables = Exact<{
  modifyTrialExpirationParams: ModifyTrialExpirationParams
}>

export type ModifyTrialExpirationMutation = {__typename?: 'Mutation'; modifyTrialExpiration: boolean}

export type CancelTrialMutationVariables = Exact<{
  cancelUserTrialSubscriptionParams: CancelUserTrialSubscriptionParams
}>

export type CancelTrialMutation = {__typename?: 'Mutation'; cancelTrial: boolean}

export type GetUserTrialSubscriptionQueryVariables = Exact<{
  getUserTrialSubscriptionParams: GetUserTrialSubscriptionParams
}>

export type GetUserTrialSubscriptionQuery = {
  __typename?: 'Query'
  getUserTrialSubscription?: {
    __typename?: 'TrialSubscription'
    id: string
    expirationDate: any
    canceledAt?: any | null
    trialLengthInDays: number
    daysRemainingOnTrial?: number | null
  } | null
}

export type GetUserSubscriptionInfoQueryVariables = Exact<{
  getSubscriptionInfoParams: GetSubscriptionInfoParams
}>

export type GetUserSubscriptionInfoQuery = {
  __typename?: 'Query'
  getUserSubscriptionInfo?: {
    __typename?: 'UserSubscriptionResult'
    isClassicUser: boolean
    subscriptionTier?: string | null
    subscriptionSource?: string | null
    trialLengthInDays?: number | null
    trialExpirationDate?: any | null
    subscriptionRenewalDate?: any | null
  } | null
}

export type AdminGetCurrentLearnUsageQueryVariables = Exact<{
  adminGetCurrentLearnUsageParams: AdminGetCurrentLearnUsageParams
}>

export type AdminGetCurrentLearnUsageQuery = {
  __typename?: 'Query'
  adminGetCurrentLearnUsage: {
    __typename?: 'AdminLearnQuotaResponse'
    quotaWindowStart: any
    usage: {__typename?: 'LearnQuotaUsage'; hasExceededLearnQuotaUsage: boolean; quotaUsagePercentage: number}
    counts: {__typename?: 'AdminLearnQuotaCounts'; quizCount: number; summaryCount: number}
    calculation: {
      __typename?: 'AdminLearnQuotaCalculation'
      mode: string
      cost: {
        __typename?: 'AdminLearnQuotaUsage'
        used: number
        limit: number
        hasExceededLearnQuotaUsage: boolean
        quotaUsagePercentage: number
      }
      questions: {
        __typename?: 'AdminLearnQuotaUsage'
        used: number
        limit: number
        hasExceededLearnQuotaUsage: boolean
        quotaUsagePercentage: number
      }
    }
  }
}

export type AdminGetSubscriptionOverviewQueryVariables = Exact<{
  adminGetSubscriptionOverviewParams: AdminGetSubscriptionOverviewParams
}>

export type AdminGetSubscriptionOverviewQuery = {
  __typename?: 'Query'
  adminGetSubscriptionOverview?: {
    __typename?: 'SubscriptionOverview'
    tier: UserTier
    quotas: {
      __typename?: 'SubscriptionFeatureQuotaView'
      learnQuestions: {__typename?: 'SubscriptionFeatureQuota'; isUsageExceeded: boolean; usagePercentage: number}
      learnQuestionUploads: {__typename?: 'SubscriptionFeatureQuota'; isUsageExceeded: boolean; usagePercentage: number}
      learnSummaries: {__typename?: 'SubscriptionFeatureQuota'; isUsageExceeded: boolean; usagePercentage: number}
      liveTranscription: {__typename?: 'SubscriptionFeatureQuota'; isUsageExceeded: boolean; usagePercentage: number}
      youtubeTranscripts: {__typename?: 'SubscriptionFeatureQuota'; isUsageExceeded: boolean; usagePercentage: number}
    }
    current?: {
      __typename?: 'Subscription'
      expirationDate?: any | null
      renewalDate?: any | null
      source: SubscriptionSource
      tier: SubscriptionTier
      details:
        | {__typename: 'AndroidSubscription'}
        | {__typename: 'AppStoreSubscription'; expirationDate: any}
        | {__typename: 'BusinessSubscription'}
        | {__typename: 'StripeConsumerSubscription'; subscriptionRenewalDate?: any | null}
        | {__typename: 'SubscriptionOverride'; expirationDate: any}
        | {
            __typename: 'TrialSubscription'
            daysRemainingOnTrial?: number | null
            expirationDate: any
            trialLengthInDays: number
          }
    } | null
    prior?: {
      __typename?: 'Subscription'
      expirationDate?: any | null
      source: SubscriptionSource
      tier: SubscriptionTier
      details:
        | {__typename: 'AndroidSubscription'}
        | {__typename: 'AppStoreSubscription'; expirationDate: any}
        | {__typename: 'BusinessSubscription'}
        | {__typename: 'StripeConsumerSubscription'; endedAt?: any | null}
        | {__typename: 'SubscriptionOverride'; expirationDate: any}
        | {__typename: 'TrialSubscription'; expirationDate: any; trialLengthInDays: number}
    } | null
  } | null
}

export type GetStripeCustomerPortalQueryVariables = Exact<{
  getStripeCustomerPortalParams: GetStripeCustomerPortalParams
}>

export type GetStripeCustomerPortalQuery = {
  __typename?: 'Query'
  getStripeCustomerPortal: {__typename?: 'StripeCustomerPortal'; url: string; redirectUrl: string}
}

export type OpCountsQueryVariables = Exact<{
  getOpCountsParams: GetOpCountsParams
}>

export type OpCountsQuery = {
  __typename?: 'Query'
  opCounts: {__typename?: 'OpCounts'; onstream: number; coldStorage: number}
}

export type FeatureFlagEvaluationQueryVariables = Exact<{
  featureFlagEvaluationParams: FeatureFlagEvaluationParams
}>

export type FeatureFlagEvaluationQuery = {
  __typename?: 'Query'
  featureFlagEvaluation: {
    __typename?: 'FeatureFlagEvaluation'
    flag: string
    status: string
    available: boolean
    remoteValue: string
    remoteValueSource: string
    hasInternalAccess: boolean
    remotelyEnabled: boolean
  }
}

export type FetchUserCollabDevicesQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type FetchUserCollabDevicesQuery = {
  __typename?: 'Query'
  adminGetUserData: {
    __typename?: 'User'
    id: string
    collabDevices: Array<{
      __typename?: 'CollabDevice'
      deviceId: string
      platform: string
      users: Array<{__typename?: 'User'; id: string; email: string}>
    }>
  }
}

export type ResetSubscriberQuotasMutationVariables = Exact<{
  resetSubscriberQuotasParams: ResetSubscriberQuotasParams
}>

export type ResetSubscriberQuotasMutation = {
  __typename?: 'Mutation'
  resetSubscriberQuotas: {
    __typename?: 'AdminLearnQuotaResponse'
    quotaWindowStart: any
    usage: {__typename?: 'LearnQuotaUsage'; hasExceededLearnQuotaUsage: boolean; quotaUsagePercentage: number}
    counts: {__typename?: 'AdminLearnQuotaCounts'; quizCount: number; summaryCount: number}
    calculation: {
      __typename?: 'AdminLearnQuotaCalculation'
      mode: string
      cost: {
        __typename?: 'AdminLearnQuotaUsage'
        used: number
        limit: number
        hasExceededLearnQuotaUsage: boolean
        quotaUsagePercentage: number
      }
      questions: {
        __typename?: 'AdminLearnQuotaUsage'
        used: number
        limit: number
        hasExceededLearnQuotaUsage: boolean
        quotaUsagePercentage: number
      }
    }
  }
}

export type AddSubscriberQuotaDummyUsageMutationVariables = Exact<{
  addSubscriberQuotaDummyUsageParams: AddSubscriberQuotaDummyUsageParams
}>

export type AddSubscriberQuotaDummyUsageMutation = {
  __typename?: 'Mutation'
  addSubscriberQuotaDummyUsage: {
    __typename?: 'AdminLearnQuotaResponse'
    quotaWindowStart: any
    usage: {__typename?: 'LearnQuotaUsage'; hasExceededLearnQuotaUsage: boolean; quotaUsagePercentage: number}
    counts: {__typename?: 'AdminLearnQuotaCounts'; quizCount: number; summaryCount: number}
    calculation: {
      __typename?: 'AdminLearnQuotaCalculation'
      mode: string
      cost: {
        __typename?: 'AdminLearnQuotaUsage'
        used: number
        limit: number
        hasExceededLearnQuotaUsage: boolean
        quotaUsagePercentage: number
      }
      questions: {
        __typename?: 'AdminLearnQuotaUsage'
        used: number
        limit: number
        hasExceededLearnQuotaUsage: boolean
        quotaUsagePercentage: number
      }
    }
  }
}

export type SubscriptionDisputeUserFragment = {
  __typename?: 'SubscriptionDisputeUser'
  id: string
  email: string
  stripeCustomerId?: string | null
  matchReason: string
  activity: {
    __typename?: 'UserActivity'
    accountCreatedAt: any
    noteCount: number
    firstNoteCreatedAt?: any | null
    lastNoteEditedAt?: any | null
    lastNoteOpenedAt?: any | null
    legacyNoteCount: number
    lastLegacyNoteUpdatedAt?: any | null
    transcriptionCount: number
    lastTranscriptionAt?: any | null
    desktopFirstLaunchedAt?: any | null
    recentNotes: Array<{
      __typename?: 'NoteActivity'
      noteId: string
      title?: string | null
      createdAt: any
      lastEditedAt?: any | null
      lastOpenedAt?: any | null
      deletedAt?: any | null
    }>
  }
}

export type GetSubscriptionDisputeInfoQueryVariables = Exact<{
  getSubscriptionDisputeInfoParams: GetSubscriptionDisputeInfoParams
}>

export type GetSubscriptionDisputeInfoQuery = {
  __typename?: 'Query'
  getSubscriptionDisputeInfo: {
    __typename?: 'SubscriptionDisputeInfo'
    query: string
    stripeSubscriptionId?: string | null
    stripeLookupError?: string | null
    warnings: Array<{
      __typename?: 'SubscriptionDisputeWarning'
      severity: SubscriptionDisputeWarningSeverity
      message: string
    }>
    stripe?: {
      __typename?: 'StripeSubscriptionSnapshot'
      stripeSubscriptionId: string
      status: string
      tier?: StripeConsumerSubscriptionTier | null
      stripePriceId?: string | null
      stripeProductId?: string | null
      stripeProductName?: string | null
      stripeCustomerId?: string | null
      customerEmail?: string | null
      customerName?: string | null
      createdAt: any
      startDate?: any | null
      currentPeriodEnd?: any | null
      cancelAt?: any | null
      canceledAt?: any | null
      endedAt?: any | null
      trialEnd?: any | null
      collectionMethod?: string | null
      latestInvoiceId?: string | null
      dashboardSubscriptionUrl: string
      dashboardCustomerUrl?: string | null
    } | null
    database?: {
      __typename?: 'StripeConsumerSubscription'
      id: string
      status: StripeSubscriptionStatus
      tier: StripeConsumerSubscriptionTier
      stripeSubscriptionId: string
      stripePriceId: string
      stripeProductId: string
      subscriptionRenewalDate?: any | null
      trialEndAt?: any | null
      cancelAt?: any | null
      canceledAt?: any | null
      endedAt?: any | null
      createdAt: any
      updatedAt: any
    } | null
    owner?: {
      __typename?: 'SubscriptionDisputeUser'
      id: string
      email: string
      stripeCustomerId?: string | null
      matchReason: string
      activity: {
        __typename?: 'UserActivity'
        accountCreatedAt: any
        noteCount: number
        firstNoteCreatedAt?: any | null
        lastNoteEditedAt?: any | null
        lastNoteOpenedAt?: any | null
        legacyNoteCount: number
        lastLegacyNoteUpdatedAt?: any | null
        transcriptionCount: number
        lastTranscriptionAt?: any | null
        desktopFirstLaunchedAt?: any | null
        recentNotes: Array<{
          __typename?: 'NoteActivity'
          noteId: string
          title?: string | null
          createdAt: any
          lastEditedAt?: any | null
          lastOpenedAt?: any | null
          deletedAt?: any | null
        }>
      }
    } | null
    relatedUsers: Array<{
      __typename?: 'SubscriptionDisputeUser'
      id: string
      email: string
      stripeCustomerId?: string | null
      matchReason: string
      activity: {
        __typename?: 'UserActivity'
        accountCreatedAt: any
        noteCount: number
        firstNoteCreatedAt?: any | null
        lastNoteEditedAt?: any | null
        lastNoteOpenedAt?: any | null
        legacyNoteCount: number
        lastLegacyNoteUpdatedAt?: any | null
        transcriptionCount: number
        lastTranscriptionAt?: any | null
        desktopFirstLaunchedAt?: any | null
        recentNotes: Array<{
          __typename?: 'NoteActivity'
          noteId: string
          title?: string | null
          createdAt: any
          lastEditedAt?: any | null
          lastOpenedAt?: any | null
          deletedAt?: any | null
        }>
      }
    }>
    auditRows: Array<{
      __typename?: 'SubscriptionAuditRow'
      id: string
      type: string
      createdAt: any
      changes: Array<{
        __typename?: 'SubscriptionAuditFieldChange'
        field: string
        oldValue?: string | null
        newValue?: string | null
      }>
    }>
  }
}

export type SearchSubscriptionDisputesQueryVariables = Exact<{
  searchSubscriptionDisputesParams: SearchSubscriptionDisputesParams
}>

export type SearchSubscriptionDisputesQuery = {
  __typename?: 'Query'
  searchSubscriptionDisputes: {
    __typename?: 'SubscriptionDisputeSearch'
    query: string
    warnings: Array<{
      __typename?: 'SubscriptionDisputeWarning'
      severity: SubscriptionDisputeWarningSeverity
      message: string
    }>
    matches: Array<{
      __typename?: 'SubscriptionDisputeMatch'
      stripeSubscriptionId: string
      status?: string | null
      tier?: StripeConsumerSubscriptionTier | null
      stripeCustomerId?: string | null
      createdAt?: any | null
      matchReasons: Array<string>
    }>
  }
}

export const GalleryNoteInfoFragmentDoc = gql`
  fragment galleryNoteInfo on GalleryNote {
    id
    name
    user {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
    viewCount
    commentsEnabled
    previewCount
    description
    updatedAt
    createdAt
    triageState
    contentType
    tags {
      name
    }
    parentNoteId
    rootNoteId
    likes
    remixCount
    clientId
    ntbUploadedAt
  }
`
export const NoteCollectionInfoFragmentDoc = gql`
  fragment noteCollectionInfo on NoteCollection {
    id
    name
    isOfficialContent
    isFeatured
  }
`
export const CommentInfoFragmentDoc = gql`
  fragment commentInfo on Comment {
    id
    parent {
      id
    }
    author {
      id
      profile {
        screenname
        avatarUrl
      }
    }
    createdAt
    commentText
  }
`
export const PromoNotificationFragmentDoc = gql`
  fragment promoNotification on PromoNotification {
    id
    author {
      id
      name
      profile {
        screenname
        avatarUpdatedAt
      }
    }
    startDate
    endDate
    translationKey
    href
    isDraft
  }
`
export const DesktopStatusFragmentDoc = gql`
  fragment desktopStatus on DesktopStatus {
    id
    message
    url
    platforms
    arches
    versions
    showBelowVersion
    showAboveVersion
    blocks
    operatorNote
    removedAt
    createdAt
    createdBy {
      id
      email
    }
  }
`
export const TestOverrideFragmentDoc = gql`
  fragment testOverride on ExperimentEnrollment {
    inVariantGroup
    isOverride
    user {
      profile {
        screenname
      }
    }
    experiment {
      id
    }
  }
`
export const OrganizationDetailsFragmentDoc = gql`
  fragment organizationDetails on OrganizationDetails {
    id
    admins {
      userId
      name
      email
      jobTitle
      phone
    }
    organizationName
    organizationType
    licenseKey
    educationLevelsProvided
    industry
    usedSeats
    maxSeats
    createdAt
    mdmPlatform
    approved
    deletedAt
    contractAcceptedAt
    adminCreatorEmail
    subscriptionStatus
  }
`
export const OrganizationFragmentDoc = gql`
  fragment organization on Organization {
    id
    name
    organizationType
    approved
    educationLevelsProvided
    isAsmEnrolled
    mdmPlatform
    comments
    createdAt
    updatedAt
    deletedAt
    industry
    license {
      id
      maxSeats
    }
    userMappings {
      user {
        name
        email
      }
      jobTitle
      role
      phone
    }
  }
`
export const PendingBusinessDomainFragmentDoc = gql`
  fragment pendingBusinessDomain on PendingBusinessDomain {
    id
    domain
    createdAt
    businessId
    businessName
    ownerEmail
    ownerName
  }
`
export const ApprovedBusinessDomainFragmentDoc = gql`
  fragment approvedBusinessDomain on ApprovedBusinessDomain {
    id
    domain
    createdAt
    businessId
    businessName
    ownerEmail
    ownerName
  }
`
export const SubscriptionDisputeUserFragmentDoc = gql`
  fragment subscriptionDisputeUser on SubscriptionDisputeUser {
    id
    email
    stripeCustomerId
    matchReason
    activity {
      accountCreatedAt
      noteCount
      firstNoteCreatedAt
      lastNoteEditedAt
      lastNoteOpenedAt
      legacyNoteCount
      lastLegacyNoteUpdatedAt
      transcriptionCount
      lastTranscriptionAt
      desktopFirstLaunchedAt
      recentNotes {
        noteId
        title
        createdAt
        lastEditedAt
        lastOpenedAt
        deletedAt
      }
    }
  }
`
export const CreateCollectionDocument = gql`
  mutation createCollection($createNoteCollectionParams: CreateNoteCollectionParams!) {
    createCollection(createNoteCollectionParams: $createNoteCollectionParams)
  }
`
export type CreateCollectionMutationFn = Apollo.MutationFunction<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      createNoteCollectionParams: // value for 'createNoteCollectionParams'
 *   },
 * });
 */
export function useCreateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(
    CreateCollectionDocument,
    options
  )
}
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>
export const DeleteCollectionDocument = gql`
  mutation deleteCollection($deleteNoteCollectionParams: DeleteNoteCollectionParams!) {
    deleteCollection(deleteNoteCollectionParams: $deleteNoteCollectionParams)
  }
`
export type DeleteCollectionMutationFn = Apollo.MutationFunction<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      deleteNoteCollectionParams: // value for 'deleteNoteCollectionParams'
 *   },
 * });
 */
export function useDeleteCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteCollectionMutation, DeleteCollectionMutationVariables>(
    DeleteCollectionDocument,
    options
  )
}
export type DeleteCollectionMutationHookResult = ReturnType<typeof useDeleteCollectionMutation>
export type DeleteCollectionMutationResult = Apollo.MutationResult<DeleteCollectionMutation>
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>
export const AddNoteToCollectionDocument = gql`
  mutation addNoteToCollection($addNoteToCollectionParams: AddNoteToCollectionParams!) {
    addNoteToCollection(addNoteToCollectionParams: $addNoteToCollectionParams) {
      ...noteCollectionInfo
    }
  }
  ${NoteCollectionInfoFragmentDoc}
`
export type AddNoteToCollectionMutationFn = Apollo.MutationFunction<
  AddNoteToCollectionMutation,
  AddNoteToCollectionMutationVariables
>

/**
 * __useAddNoteToCollectionMutation__
 *
 * To run a mutation, you first call `useAddNoteToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToCollectionMutation, { data, loading, error }] = useAddNoteToCollectionMutation({
 *   variables: {
 *      addNoteToCollectionParams: // value for 'addNoteToCollectionParams'
 *   },
 * });
 */
export function useAddNoteToCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<AddNoteToCollectionMutation, AddNoteToCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AddNoteToCollectionMutation, AddNoteToCollectionMutationVariables>(
    AddNoteToCollectionDocument,
    options
  )
}
export type AddNoteToCollectionMutationHookResult = ReturnType<typeof useAddNoteToCollectionMutation>
export type AddNoteToCollectionMutationResult = Apollo.MutationResult<AddNoteToCollectionMutation>
export type AddNoteToCollectionMutationOptions = Apollo.BaseMutationOptions<
  AddNoteToCollectionMutation,
  AddNoteToCollectionMutationVariables
>
export const ReorderNoteCollectionNoteDocument = gql`
  mutation reorderNoteCollectionNote($reorderNoteCollectionNoteParams: ReorderNoteCollectionNoteParams!) {
    reorderNoteCollectionNote(reorderNoteCollectionNoteParams: $reorderNoteCollectionNoteParams)
  }
`
export type ReorderNoteCollectionNoteMutationFn = Apollo.MutationFunction<
  ReorderNoteCollectionNoteMutation,
  ReorderNoteCollectionNoteMutationVariables
>

/**
 * __useReorderNoteCollectionNoteMutation__
 *
 * To run a mutation, you first call `useReorderNoteCollectionNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderNoteCollectionNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderNoteCollectionNoteMutation, { data, loading, error }] = useReorderNoteCollectionNoteMutation({
 *   variables: {
 *      reorderNoteCollectionNoteParams: // value for 'reorderNoteCollectionNoteParams'
 *   },
 * });
 */
export function useReorderNoteCollectionNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderNoteCollectionNoteMutation,
    ReorderNoteCollectionNoteMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReorderNoteCollectionNoteMutation, ReorderNoteCollectionNoteMutationVariables>(
    ReorderNoteCollectionNoteDocument,
    options
  )
}
export type ReorderNoteCollectionNoteMutationHookResult = ReturnType<typeof useReorderNoteCollectionNoteMutation>
export type ReorderNoteCollectionNoteMutationResult = Apollo.MutationResult<ReorderNoteCollectionNoteMutation>
export type ReorderNoteCollectionNoteMutationOptions = Apollo.BaseMutationOptions<
  ReorderNoteCollectionNoteMutation,
  ReorderNoteCollectionNoteMutationVariables
>
export const RemoveNoteFromCollectionDocument = gql`
  mutation removeNoteFromCollection($removeNoteFromCollectionParams: RemoveNoteFromCollectionParams!) {
    removeNoteFromCollection(removeNoteFromCollectionParams: $removeNoteFromCollectionParams)
  }
`
export type RemoveNoteFromCollectionMutationFn = Apollo.MutationFunction<
  RemoveNoteFromCollectionMutation,
  RemoveNoteFromCollectionMutationVariables
>

/**
 * __useRemoveNoteFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveNoteFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNoteFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNoteFromCollectionMutation, { data, loading, error }] = useRemoveNoteFromCollectionMutation({
 *   variables: {
 *      removeNoteFromCollectionParams: // value for 'removeNoteFromCollectionParams'
 *   },
 * });
 */
export function useRemoveNoteFromCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveNoteFromCollectionMutation, RemoveNoteFromCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RemoveNoteFromCollectionMutation, RemoveNoteFromCollectionMutationVariables>(
    RemoveNoteFromCollectionDocument,
    options
  )
}
export type RemoveNoteFromCollectionMutationHookResult = ReturnType<typeof useRemoveNoteFromCollectionMutation>
export type RemoveNoteFromCollectionMutationResult = Apollo.MutationResult<RemoveNoteFromCollectionMutation>
export type RemoveNoteFromCollectionMutationOptions = Apollo.BaseMutationOptions<
  RemoveNoteFromCollectionMutation,
  RemoveNoteFromCollectionMutationVariables
>
export const GetNoteCollectionDocument = gql`
  query getNoteCollection($noteCollectionParams: NoteCollectionParams!) {
    getNoteCollection(noteCollectionParams: $noteCollectionParams) {
      id
      name
      owner {
        name
        profile {
          screenname
        }
      }
    }
  }
`

/**
 * __useGetNoteCollectionQuery__
 *
 * To run a query within a React component, call `useGetNoteCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteCollectionQuery({
 *   variables: {
 *      noteCollectionParams: // value for 'noteCollectionParams'
 *   },
 * });
 */
export function useGetNoteCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>(GetNoteCollectionDocument, options)
}
export function useGetNoteCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>(
    GetNoteCollectionDocument,
    options
  )
}
export type GetNoteCollectionQueryHookResult = ReturnType<typeof useGetNoteCollectionQuery>
export type GetNoteCollectionLazyQueryHookResult = ReturnType<typeof useGetNoteCollectionLazyQuery>
export type GetNoteCollectionQueryResult = Apollo.QueryResult<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>
export const GetOfficialNoteCollectionsDocument = gql`
  query getOfficialNoteCollections($pagingParams: PagingParams!) {
    getOfficialNoteCollections(pagingParams: $pagingParams) {
      results {
        id
        name
      }
      totalCount
    }
  }
`

/**
 * __useGetOfficialNoteCollectionsQuery__
 *
 * To run a query within a React component, call `useGetOfficialNoteCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficialNoteCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficialNoteCollectionsQuery({
 *   variables: {
 *      pagingParams: // value for 'pagingParams'
 *   },
 * });
 */
export function useGetOfficialNoteCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>(
    GetOfficialNoteCollectionsDocument,
    options
  )
}
export function useGetOfficialNoteCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>(
    GetOfficialNoteCollectionsDocument,
    options
  )
}
export type GetOfficialNoteCollectionsQueryHookResult = ReturnType<typeof useGetOfficialNoteCollectionsQuery>
export type GetOfficialNoteCollectionsLazyQueryHookResult = ReturnType<typeof useGetOfficialNoteCollectionsLazyQuery>
export type GetOfficialNoteCollectionsQueryResult = Apollo.QueryResult<
  GetOfficialNoteCollectionsQuery,
  GetOfficialNoteCollectionsQueryVariables
>
export const GetNoteCollectionsForUserDocument = gql`
  query getNoteCollectionsForUser($userNoteCollectionsParams: UserNoteCollectionsParams!) {
    getNoteCollectionsForUser(userNoteCollectionsParams: $userNoteCollectionsParams) {
      results {
        id
        name
      }
      totalCount
    }
  }
`

/**
 * __useGetNoteCollectionsForUserQuery__
 *
 * To run a query within a React component, call `useGetNoteCollectionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteCollectionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteCollectionsForUserQuery({
 *   variables: {
 *      userNoteCollectionsParams: // value for 'userNoteCollectionsParams'
 *   },
 * });
 */
export function useGetNoteCollectionsForUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>(
    GetNoteCollectionsForUserDocument,
    options
  )
}
export function useGetNoteCollectionsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>(
    GetNoteCollectionsForUserDocument,
    options
  )
}
export type GetNoteCollectionsForUserQueryHookResult = ReturnType<typeof useGetNoteCollectionsForUserQuery>
export type GetNoteCollectionsForUserLazyQueryHookResult = ReturnType<typeof useGetNoteCollectionsForUserLazyQuery>
export type GetNoteCollectionsForUserQueryResult = Apollo.QueryResult<
  GetNoteCollectionsForUserQuery,
  GetNoteCollectionsForUserQueryVariables
>
export const UpdateCollectionDocument = gql`
  mutation updateCollection($updateNoteCollectionParams: UpdateNoteCollectionParams!) {
    updateCollection(updateNoteCollectionParams: $updateNoteCollectionParams) {
      ...noteCollectionInfo
    }
  }
  ${NoteCollectionInfoFragmentDoc}
`
export type UpdateCollectionMutationFn = Apollo.MutationFunction<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      updateNoteCollectionParams: // value for 'updateNoteCollectionParams'
 *   },
 * });
 */
export function useUpdateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(
    UpdateCollectionDocument,
    options
  )
}
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>
export const GetNotesForCollectionDocument = gql`
  query getNotesForCollection($noteCollectionNotesParams: NoteCollectionNotesParams!) {
    getNotesForCollection(noteCollectionNotesParams: $noteCollectionNotesParams) {
      results {
        ...galleryNoteInfo
      }
      totalCount
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetNotesForCollectionQuery__
 *
 * To run a query within a React component, call `useGetNotesForCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForCollectionQuery({
 *   variables: {
 *      noteCollectionNotesParams: // value for 'noteCollectionNotesParams'
 *   },
 * });
 */
export function useGetNotesForCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>(
    GetNotesForCollectionDocument,
    options
  )
}
export function useGetNotesForCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>(
    GetNotesForCollectionDocument,
    options
  )
}
export type GetNotesForCollectionQueryHookResult = ReturnType<typeof useGetNotesForCollectionQuery>
export type GetNotesForCollectionLazyQueryHookResult = ReturnType<typeof useGetNotesForCollectionLazyQuery>
export type GetNotesForCollectionQueryResult = Apollo.QueryResult<
  GetNotesForCollectionQuery,
  GetNotesForCollectionQueryVariables
>
export const GetNotesForOfficialCollectionDocument = gql`
  query getNotesForOfficialCollection($officialCollectionNotesParams: OfficialCollectionNotesParams!) {
    getNotesForOfficialCollection(officialCollectionNotesParams: $officialCollectionNotesParams) {
      results {
        ...galleryNoteInfo
      }
      totalCount
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetNotesForOfficialCollectionQuery__
 *
 * To run a query within a React component, call `useGetNotesForOfficialCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForOfficialCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForOfficialCollectionQuery({
 *   variables: {
 *      officialCollectionNotesParams: // value for 'officialCollectionNotesParams'
 *   },
 * });
 */
export function useGetNotesForOfficialCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotesForOfficialCollectionQuery, GetNotesForOfficialCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotesForOfficialCollectionQuery, GetNotesForOfficialCollectionQueryVariables>(
    GetNotesForOfficialCollectionDocument,
    options
  )
}
export function useGetNotesForOfficialCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotesForOfficialCollectionQuery,
    GetNotesForOfficialCollectionQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotesForOfficialCollectionQuery, GetNotesForOfficialCollectionQueryVariables>(
    GetNotesForOfficialCollectionDocument,
    options
  )
}
export type GetNotesForOfficialCollectionQueryHookResult = ReturnType<typeof useGetNotesForOfficialCollectionQuery>
export type GetNotesForOfficialCollectionLazyQueryHookResult = ReturnType<
  typeof useGetNotesForOfficialCollectionLazyQuery
>
export type GetNotesForOfficialCollectionQueryResult = Apollo.QueryResult<
  GetNotesForOfficialCollectionQuery,
  GetNotesForOfficialCollectionQueryVariables
>
export const LikeNoteDocument = gql`
  mutation likeNote($likeParams: LikeParams!) {
    likeNote(likeParams: $likeParams) {
      id
    }
  }
`
export type LikeNoteMutationFn = Apollo.MutationFunction<LikeNoteMutation, LikeNoteMutationVariables>

/**
 * __useLikeNoteMutation__
 *
 * To run a mutation, you first call `useLikeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeNoteMutation, { data, loading, error }] = useLikeNoteMutation({
 *   variables: {
 *      likeParams: // value for 'likeParams'
 *   },
 * });
 */
export function useLikeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<LikeNoteMutation, LikeNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<LikeNoteMutation, LikeNoteMutationVariables>(LikeNoteDocument, options)
}
export type LikeNoteMutationHookResult = ReturnType<typeof useLikeNoteMutation>
export type LikeNoteMutationResult = Apollo.MutationResult<LikeNoteMutation>
export type LikeNoteMutationOptions = Apollo.BaseMutationOptions<LikeNoteMutation, LikeNoteMutationVariables>
export const FlagNoteDocument = gql`
  mutation flagNote($flagParams: FlagParams!) {
    flagNote(flagParams: $flagParams) {
      id
    }
  }
`
export type FlagNoteMutationFn = Apollo.MutationFunction<FlagNoteMutation, FlagNoteMutationVariables>

/**
 * __useFlagNoteMutation__
 *
 * To run a mutation, you first call `useFlagNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagNoteMutation, { data, loading, error }] = useFlagNoteMutation({
 *   variables: {
 *      flagParams: // value for 'flagParams'
 *   },
 * });
 */
export function useFlagNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<FlagNoteMutation, FlagNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FlagNoteMutation, FlagNoteMutationVariables>(FlagNoteDocument, options)
}
export type FlagNoteMutationHookResult = ReturnType<typeof useFlagNoteMutation>
export type FlagNoteMutationResult = Apollo.MutationResult<FlagNoteMutation>
export type FlagNoteMutationOptions = Apollo.BaseMutationOptions<FlagNoteMutation, FlagNoteMutationVariables>
export const FlagNoteFamilyTreeDocument = gql`
  mutation flagNoteFamilyTree($flagParams: FlagParams!) {
    flagNoteFamilyTree(flagParams: $flagParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`
export type FlagNoteFamilyTreeMutationFn = Apollo.MutationFunction<
  FlagNoteFamilyTreeMutation,
  FlagNoteFamilyTreeMutationVariables
>

/**
 * __useFlagNoteFamilyTreeMutation__
 *
 * To run a mutation, you first call `useFlagNoteFamilyTreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagNoteFamilyTreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagNoteFamilyTreeMutation, { data, loading, error }] = useFlagNoteFamilyTreeMutation({
 *   variables: {
 *      flagParams: // value for 'flagParams'
 *   },
 * });
 */
export function useFlagNoteFamilyTreeMutation(
  baseOptions?: Apollo.MutationHookOptions<FlagNoteFamilyTreeMutation, FlagNoteFamilyTreeMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FlagNoteFamilyTreeMutation, FlagNoteFamilyTreeMutationVariables>(
    FlagNoteFamilyTreeDocument,
    options
  )
}
export type FlagNoteFamilyTreeMutationHookResult = ReturnType<typeof useFlagNoteFamilyTreeMutation>
export type FlagNoteFamilyTreeMutationResult = Apollo.MutationResult<FlagNoteFamilyTreeMutation>
export type FlagNoteFamilyTreeMutationOptions = Apollo.BaseMutationOptions<
  FlagNoteFamilyTreeMutation,
  FlagNoteFamilyTreeMutationVariables
>
export const GetNotesDocument = gql`
  query getNotes($getNotesParams: GetNotesParameters!) {
    getNotes(getNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options)
}
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options)
}
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>
export const GetFeatureFlagsForUserDocument = gql`
  query getFeatureFlagsForUser {
    getFeatureFlagsForUser
  }
`

/**
 * __useGetFeatureFlagsForUserQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>(
    GetFeatureFlagsForUserDocument,
    options
  )
}
export function useGetFeatureFlagsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>(
    GetFeatureFlagsForUserDocument,
    options
  )
}
export type GetFeatureFlagsForUserQueryHookResult = ReturnType<typeof useGetFeatureFlagsForUserQuery>
export type GetFeatureFlagsForUserLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsForUserLazyQuery>
export type GetFeatureFlagsForUserQueryResult = Apollo.QueryResult<
  GetFeatureFlagsForUserQuery,
  GetFeatureFlagsForUserQueryVariables
>
export const MeDocument = gql`
  query me {
    me {
      id
      featureFlags
      profile {
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>
export const UpdateProfileDocument = gql`
  mutation updateProfile($profileParams: ProfileParams!) {
    updateProfile(profileParams: $profileParams) {
      id
      screenname
    }
  }
`
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      profileParams: // value for 'profileParams'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options)
}
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>
export const FlagProfileDocument = gql`
  mutation flagProfile($flagProfileParams: FlagProfileParams!) {
    flagProfile(flagProfileParams: $flagProfileParams)
  }
`
export type FlagProfileMutationFn = Apollo.MutationFunction<FlagProfileMutation, FlagProfileMutationVariables>

/**
 * __useFlagProfileMutation__
 *
 * To run a mutation, you first call `useFlagProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagProfileMutation, { data, loading, error }] = useFlagProfileMutation({
 *   variables: {
 *      flagProfileParams: // value for 'flagProfileParams'
 *   },
 * });
 */
export function useFlagProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<FlagProfileMutation, FlagProfileMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FlagProfileMutation, FlagProfileMutationVariables>(FlagProfileDocument, options)
}
export type FlagProfileMutationHookResult = ReturnType<typeof useFlagProfileMutation>
export type FlagProfileMutationResult = Apollo.MutationResult<FlagProfileMutation>
export type FlagProfileMutationOptions = Apollo.BaseMutationOptions<FlagProfileMutation, FlagProfileMutationVariables>
export const ReviewFlaggedProfileDocument = gql`
  mutation reviewFlaggedProfile($reviewFlaggedProfileParams: ReviewFlaggedProfileParam!) {
    reviewFlaggedProfile(reviewFlaggedProfileParams: $reviewFlaggedProfileParams)
  }
`
export type ReviewFlaggedProfileMutationFn = Apollo.MutationFunction<
  ReviewFlaggedProfileMutation,
  ReviewFlaggedProfileMutationVariables
>

/**
 * __useReviewFlaggedProfileMutation__
 *
 * To run a mutation, you first call `useReviewFlaggedProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewFlaggedProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewFlaggedProfileMutation, { data, loading, error }] = useReviewFlaggedProfileMutation({
 *   variables: {
 *      reviewFlaggedProfileParams: // value for 'reviewFlaggedProfileParams'
 *   },
 * });
 */
export function useReviewFlaggedProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewFlaggedProfileMutation, ReviewFlaggedProfileMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReviewFlaggedProfileMutation, ReviewFlaggedProfileMutationVariables>(
    ReviewFlaggedProfileDocument,
    options
  )
}
export type ReviewFlaggedProfileMutationHookResult = ReturnType<typeof useReviewFlaggedProfileMutation>
export type ReviewFlaggedProfileMutationResult = Apollo.MutationResult<ReviewFlaggedProfileMutation>
export type ReviewFlaggedProfileMutationOptions = Apollo.BaseMutationOptions<
  ReviewFlaggedProfileMutation,
  ReviewFlaggedProfileMutationVariables
>
export const FreeNamespaceDocument = gql`
  mutation freeNamespace($freeNamespaceParams: FreeNamespaceParams!) {
    freeNamespace(freeNamespaceParams: $freeNamespaceParams)
  }
`
export type FreeNamespaceMutationFn = Apollo.MutationFunction<FreeNamespaceMutation, FreeNamespaceMutationVariables>

/**
 * __useFreeNamespaceMutation__
 *
 * To run a mutation, you first call `useFreeNamespaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreeNamespaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freeNamespaceMutation, { data, loading, error }] = useFreeNamespaceMutation({
 *   variables: {
 *      freeNamespaceParams: // value for 'freeNamespaceParams'
 *   },
 * });
 */
export function useFreeNamespaceMutation(
  baseOptions?: Apollo.MutationHookOptions<FreeNamespaceMutation, FreeNamespaceMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FreeNamespaceMutation, FreeNamespaceMutationVariables>(FreeNamespaceDocument, options)
}
export type FreeNamespaceMutationHookResult = ReturnType<typeof useFreeNamespaceMutation>
export type FreeNamespaceMutationResult = Apollo.MutationResult<FreeNamespaceMutation>
export type FreeNamespaceMutationOptions = Apollo.BaseMutationOptions<
  FreeNamespaceMutation,
  FreeNamespaceMutationVariables
>
export const ReloadEnvironmentCacheDocument = gql`
  mutation reloadEnvironmentCache {
    reloadEnvironmentCache
  }
`
export type ReloadEnvironmentCacheMutationFn = Apollo.MutationFunction<
  ReloadEnvironmentCacheMutation,
  ReloadEnvironmentCacheMutationVariables
>

/**
 * __useReloadEnvironmentCacheMutation__
 *
 * To run a mutation, you first call `useReloadEnvironmentCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReloadEnvironmentCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reloadEnvironmentCacheMutation, { data, loading, error }] = useReloadEnvironmentCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useReloadEnvironmentCacheMutation(
  baseOptions?: Apollo.MutationHookOptions<ReloadEnvironmentCacheMutation, ReloadEnvironmentCacheMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReloadEnvironmentCacheMutation, ReloadEnvironmentCacheMutationVariables>(
    ReloadEnvironmentCacheDocument,
    options
  )
}
export type ReloadEnvironmentCacheMutationHookResult = ReturnType<typeof useReloadEnvironmentCacheMutation>
export type ReloadEnvironmentCacheMutationResult = Apollo.MutationResult<ReloadEnvironmentCacheMutation>
export type ReloadEnvironmentCacheMutationOptions = Apollo.BaseMutationOptions<
  ReloadEnvironmentCacheMutation,
  ReloadEnvironmentCacheMutationVariables
>
export const UpdateBioDocument = gql`
  mutation updateBio($bioParams: BioParams!) {
    updateBio(bioParams: $bioParams) {
      id
      bio
      twitterUsername
      tikTokUsername
      instagramUsername
      youtubeUrl
      etsyUsername
    }
  }
`
export type UpdateBioMutationFn = Apollo.MutationFunction<UpdateBioMutation, UpdateBioMutationVariables>

/**
 * __useUpdateBioMutation__
 *
 * To run a mutation, you first call `useUpdateBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBioMutation, { data, loading, error }] = useUpdateBioMutation({
 *   variables: {
 *      bioParams: // value for 'bioParams'
 *   },
 * });
 */
export function useUpdateBioMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateBioMutation, UpdateBioMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateBioMutation, UpdateBioMutationVariables>(UpdateBioDocument, options)
}
export type UpdateBioMutationHookResult = ReturnType<typeof useUpdateBioMutation>
export type UpdateBioMutationResult = Apollo.MutationResult<UpdateBioMutation>
export type UpdateBioMutationOptions = Apollo.BaseMutationOptions<UpdateBioMutation, UpdateBioMutationVariables>
export const CreateMagicLinkDocument = gql`
  mutation createMagicLink($createMagicLinkParams: CreateMagicLinkParams!) {
    createMagicLink(createMagicLinkParams: $createMagicLinkParams)
  }
`
export type CreateMagicLinkMutationFn = Apollo.MutationFunction<
  CreateMagicLinkMutation,
  CreateMagicLinkMutationVariables
>

/**
 * __useCreateMagicLinkMutation__
 *
 * To run a mutation, you first call `useCreateMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMagicLinkMutation, { data, loading, error }] = useCreateMagicLinkMutation({
 *   variables: {
 *      createMagicLinkParams: // value for 'createMagicLinkParams'
 *   },
 * });
 */
export function useCreateMagicLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>(CreateMagicLinkDocument, options)
}
export type CreateMagicLinkMutationHookResult = ReturnType<typeof useCreateMagicLinkMutation>
export type CreateMagicLinkMutationResult = Apollo.MutationResult<CreateMagicLinkMutation>
export type CreateMagicLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateMagicLinkMutation,
  CreateMagicLinkMutationVariables
>
export const GetUserNotesDocument = gql`
  query getUserNotes($getNotesParams: UserNotesParameters!) {
    userNotes(userNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserNotesQuery__
 *
 * To run a query within a React component, call `useGetUserNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetUserNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserNotesQuery, GetUserNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserNotesQuery, GetUserNotesQueryVariables>(GetUserNotesDocument, options)
}
export function useGetUserNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotesQuery, GetUserNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserNotesQuery, GetUserNotesQueryVariables>(GetUserNotesDocument, options)
}
export type GetUserNotesQueryHookResult = ReturnType<typeof useGetUserNotesQuery>
export type GetUserNotesLazyQueryHookResult = ReturnType<typeof useGetUserNotesLazyQuery>
export type GetUserNotesQueryResult = Apollo.QueryResult<GetUserNotesQuery, GetUserNotesQueryVariables>
export const GetUserFavoritedNotesDocument = gql`
  query getUserFavoritedNotes($getNotesParams: UserFavoritedNotesParameters!) {
    userFavoritedNotes(userNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserFavoritedNotesQuery__
 *
 * To run a query within a React component, call `useGetUserFavoritedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoritedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoritedNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetUserFavoritedNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>(
    GetUserFavoritedNotesDocument,
    options
  )
}
export function useGetUserFavoritedNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>(
    GetUserFavoritedNotesDocument,
    options
  )
}
export type GetUserFavoritedNotesQueryHookResult = ReturnType<typeof useGetUserFavoritedNotesQuery>
export type GetUserFavoritedNotesLazyQueryHookResult = ReturnType<typeof useGetUserFavoritedNotesLazyQuery>
export type GetUserFavoritedNotesQueryResult = Apollo.QueryResult<
  GetUserFavoritedNotesQuery,
  GetUserFavoritedNotesQueryVariables
>
export const GetUserDownloadedNotesDocument = gql`
  query getUserDownloadedNotes($getNotesParams: UserNotesParameters!) {
    userDownloadedNotes(userNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserDownloadedNotesQuery__
 *
 * To run a query within a React component, call `useGetUserDownloadedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDownloadedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDownloadedNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetUserDownloadedNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>(
    GetUserDownloadedNotesDocument,
    options
  )
}
export function useGetUserDownloadedNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>(
    GetUserDownloadedNotesDocument,
    options
  )
}
export type GetUserDownloadedNotesQueryHookResult = ReturnType<typeof useGetUserDownloadedNotesQuery>
export type GetUserDownloadedNotesLazyQueryHookResult = ReturnType<typeof useGetUserDownloadedNotesLazyQuery>
export type GetUserDownloadedNotesQueryResult = Apollo.QueryResult<
  GetUserDownloadedNotesQuery,
  GetUserDownloadedNotesQueryVariables
>
export const EditNoteDocument = gql`
  mutation editNote($editNotesParams: EditParams!) {
    editNote(editParams: $editNotesParams) {
      id
      description
      language
      tags {
        name
      }
      contentType
      name
      commentsEnabled
      mentionedProfiles {
        screenname
        avatarUpdatedAt
        user {
          id
        }
      }
    }
  }
`
export type EditNoteMutationFn = Apollo.MutationFunction<EditNoteMutation, EditNoteMutationVariables>

/**
 * __useEditNoteMutation__
 *
 * To run a mutation, you first call `useEditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNoteMutation, { data, loading, error }] = useEditNoteMutation({
 *   variables: {
 *      editNotesParams: // value for 'editNotesParams'
 *   },
 * });
 */
export function useEditNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<EditNoteMutation, EditNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditNoteMutation, EditNoteMutationVariables>(EditNoteDocument, options)
}
export type EditNoteMutationHookResult = ReturnType<typeof useEditNoteMutation>
export type EditNoteMutationResult = Apollo.MutationResult<EditNoteMutation>
export type EditNoteMutationOptions = Apollo.BaseMutationOptions<EditNoteMutation, EditNoteMutationVariables>
export const SetLanguageDocument = gql`
  mutation setLanguage($setLanguageParams: SetLanguageParams!) {
    setLanguage(languageParams: $setLanguageParams) {
      id
      language
    }
  }
`
export type SetLanguageMutationFn = Apollo.MutationFunction<SetLanguageMutation, SetLanguageMutationVariables>

/**
 * __useSetLanguageMutation__
 *
 * To run a mutation, you first call `useSetLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLanguageMutation, { data, loading, error }] = useSetLanguageMutation({
 *   variables: {
 *      setLanguageParams: // value for 'setLanguageParams'
 *   },
 * });
 */
export function useSetLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<SetLanguageMutation, SetLanguageMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetLanguageMutation, SetLanguageMutationVariables>(SetLanguageDocument, options)
}
export type SetLanguageMutationHookResult = ReturnType<typeof useSetLanguageMutation>
export type SetLanguageMutationResult = Apollo.MutationResult<SetLanguageMutation>
export type SetLanguageMutationOptions = Apollo.BaseMutationOptions<SetLanguageMutation, SetLanguageMutationVariables>
export const GalleryNoteSearchDocument = gql`
  query galleryNoteSearch($searchParams: SearchParams!) {
    galleryNoteSearch(searchParams: $searchParams) {
      ...galleryNoteInfo
      language
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGalleryNoteSearchQuery__
 *
 * To run a query within a React component, call `useGalleryNoteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryNoteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryNoteSearchQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useGalleryNoteSearchQuery(
  baseOptions: Apollo.QueryHookOptions<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>(GalleryNoteSearchDocument, options)
}
export function useGalleryNoteSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>(
    GalleryNoteSearchDocument,
    options
  )
}
export type GalleryNoteSearchQueryHookResult = ReturnType<typeof useGalleryNoteSearchQuery>
export type GalleryNoteSearchLazyQueryHookResult = ReturnType<typeof useGalleryNoteSearchLazyQuery>
export type GalleryNoteSearchQueryResult = Apollo.QueryResult<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>
export const TriageNoteDocument = gql`
  mutation triageNote($triageNoteParams: TriageNoteParams!) {
    triageNote(triageNoteParams: $triageNoteParams) {
      noteId
      triageState
    }
  }
`
export type TriageNoteMutationFn = Apollo.MutationFunction<TriageNoteMutation, TriageNoteMutationVariables>

/**
 * __useTriageNoteMutation__
 *
 * To run a mutation, you first call `useTriageNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriageNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triageNoteMutation, { data, loading, error }] = useTriageNoteMutation({
 *   variables: {
 *      triageNoteParams: // value for 'triageNoteParams'
 *   },
 * });
 */
export function useTriageNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<TriageNoteMutation, TriageNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<TriageNoteMutation, TriageNoteMutationVariables>(TriageNoteDocument, options)
}
export type TriageNoteMutationHookResult = ReturnType<typeof useTriageNoteMutation>
export type TriageNoteMutationResult = Apollo.MutationResult<TriageNoteMutation>
export type TriageNoteMutationOptions = Apollo.BaseMutationOptions<TriageNoteMutation, TriageNoteMutationVariables>
export const TriageNoteSearchDocument = gql`
  query triageNoteSearch($triageSearchParams: TriageSearchParams!) {
    triageNoteSearch(triageSearchParams: $triageSearchParams) {
      totalCount
      results {
        ...galleryNoteInfo
      }
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useTriageNoteSearchQuery__
 *
 * To run a query within a React component, call `useTriageNoteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriageNoteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriageNoteSearchQuery({
 *   variables: {
 *      triageSearchParams: // value for 'triageSearchParams'
 *   },
 * });
 */
export function useTriageNoteSearchQuery(
  baseOptions: Apollo.QueryHookOptions<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>(TriageNoteSearchDocument, options)
}
export function useTriageNoteSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>(TriageNoteSearchDocument, options)
}
export type TriageNoteSearchQueryHookResult = ReturnType<typeof useTriageNoteSearchQuery>
export type TriageNoteSearchLazyQueryHookResult = ReturnType<typeof useTriageNoteSearchLazyQuery>
export type TriageNoteSearchQueryResult = Apollo.QueryResult<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>
export const HiddenProfilesDocument = gql`
  query hiddenProfiles($hiddenProfilesParams: HiddenProfilesParams!) {
    hiddenProfiles(hiddenProfilesParams: $hiddenProfilesParams) {
      totalCount
      results {
        id
        screenname
        user {
          id
          profile {
            screenname
          }
        }
      }
    }
  }
`

/**
 * __useHiddenProfilesQuery__
 *
 * To run a query within a React component, call `useHiddenProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiddenProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiddenProfilesQuery({
 *   variables: {
 *      hiddenProfilesParams: // value for 'hiddenProfilesParams'
 *   },
 * });
 */
export function useHiddenProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<HiddenProfilesQuery, HiddenProfilesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<HiddenProfilesQuery, HiddenProfilesQueryVariables>(HiddenProfilesDocument, options)
}
export function useHiddenProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HiddenProfilesQuery, HiddenProfilesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<HiddenProfilesQuery, HiddenProfilesQueryVariables>(HiddenProfilesDocument, options)
}
export type HiddenProfilesQueryHookResult = ReturnType<typeof useHiddenProfilesQuery>
export type HiddenProfilesLazyQueryHookResult = ReturnType<typeof useHiddenProfilesLazyQuery>
export type HiddenProfilesQueryResult = Apollo.QueryResult<HiddenProfilesQuery, HiddenProfilesQueryVariables>
export const UnlikeNoteDocument = gql`
  mutation unlikeNote($unlikeNoteParams: LikeParams!) {
    unlikeNote(unlikeParams: $unlikeNoteParams) {
      id
    }
  }
`
export type UnlikeNoteMutationFn = Apollo.MutationFunction<UnlikeNoteMutation, UnlikeNoteMutationVariables>

/**
 * __useUnlikeNoteMutation__
 *
 * To run a mutation, you first call `useUnlikeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeNoteMutation, { data, loading, error }] = useUnlikeNoteMutation({
 *   variables: {
 *      unlikeNoteParams: // value for 'unlikeNoteParams'
 *   },
 * });
 */
export function useUnlikeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<UnlikeNoteMutation, UnlikeNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnlikeNoteMutation, UnlikeNoteMutationVariables>(UnlikeNoteDocument, options)
}
export type UnlikeNoteMutationHookResult = ReturnType<typeof useUnlikeNoteMutation>
export type UnlikeNoteMutationResult = Apollo.MutationResult<UnlikeNoteMutation>
export type UnlikeNoteMutationOptions = Apollo.BaseMutationOptions<UnlikeNoteMutation, UnlikeNoteMutationVariables>
export const PreparePublishDocument = gql`
  mutation preparePublish($publishParams: PublishParams!) {
    preparePublish(publishParams: $publishParams) {
      galleryNote {
        id
      }
      noteUploadPolicy
      pdfUploadPolicy
      imageUploadPolicies
    }
  }
`
export type PreparePublishMutationFn = Apollo.MutationFunction<PreparePublishMutation, PreparePublishMutationVariables>

/**
 * __usePreparePublishMutation__
 *
 * To run a mutation, you first call `usePreparePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreparePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preparePublishMutation, { data, loading, error }] = usePreparePublishMutation({
 *   variables: {
 *      publishParams: // value for 'publishParams'
 *   },
 * });
 */
export function usePreparePublishMutation(
  baseOptions?: Apollo.MutationHookOptions<PreparePublishMutation, PreparePublishMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<PreparePublishMutation, PreparePublishMutationVariables>(PreparePublishDocument, options)
}
export type PreparePublishMutationHookResult = ReturnType<typeof usePreparePublishMutation>
export type PreparePublishMutationResult = Apollo.MutationResult<PreparePublishMutation>
export type PreparePublishMutationOptions = Apollo.BaseMutationOptions<
  PreparePublishMutation,
  PreparePublishMutationVariables
>
export const UnpublishDocument = gql`
  mutation unpublish($unpublishParams: UnpublishParams!) {
    unpublish(unpublishParams: $unpublishParams)
  }
`
export type UnpublishMutationFn = Apollo.MutationFunction<UnpublishMutation, UnpublishMutationVariables>

/**
 * __useUnpublishMutation__
 *
 * To run a mutation, you first call `useUnpublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishMutation, { data, loading, error }] = useUnpublishMutation({
 *   variables: {
 *      unpublishParams: // value for 'unpublishParams'
 *   },
 * });
 */
export function useUnpublishMutation(
  baseOptions?: Apollo.MutationHookOptions<UnpublishMutation, UnpublishMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnpublishMutation, UnpublishMutationVariables>(UnpublishDocument, options)
}
export type UnpublishMutationHookResult = ReturnType<typeof useUnpublishMutation>
export type UnpublishMutationResult = Apollo.MutationResult<UnpublishMutation>
export type UnpublishMutationOptions = Apollo.BaseMutationOptions<UnpublishMutation, UnpublishMutationVariables>
export const NoteViewedDocument = gql`
  mutation noteViewed($viewedNoteParams: ViewedNoteParameters!) {
    noteViewed(viewedNote: $viewedNoteParams)
  }
`
export type NoteViewedMutationFn = Apollo.MutationFunction<NoteViewedMutation, NoteViewedMutationVariables>

/**
 * __useNoteViewedMutation__
 *
 * To run a mutation, you first call `useNoteViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteViewedMutation, { data, loading, error }] = useNoteViewedMutation({
 *   variables: {
 *      viewedNoteParams: // value for 'viewedNoteParams'
 *   },
 * });
 */
export function useNoteViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<NoteViewedMutation, NoteViewedMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<NoteViewedMutation, NoteViewedMutationVariables>(NoteViewedDocument, options)
}
export type NoteViewedMutationHookResult = ReturnType<typeof useNoteViewedMutation>
export type NoteViewedMutationResult = Apollo.MutationResult<NoteViewedMutation>
export type NoteViewedMutationOptions = Apollo.BaseMutationOptions<NoteViewedMutation, NoteViewedMutationVariables>
export const FollowUserDocument = gql`
  mutation followUser($followParams: FollowParams!) {
    followUser(followParams: $followParams) {
      followedId
      followerId
      isFollowing
    }
  }
`
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      followParams: // value for 'followParams'
 *   },
 * });
 */
export function useFollowUserMutation(
  baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options)
}
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>
export const UnfollowUserDocument = gql`
  mutation unfollowUser($unfollowParams: UnfollowParams!) {
    unfollowUser(unfollowParams: $unfollowParams) {
      followedId
      followerId
      isFollowing
    }
  }
`
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      unfollowParams: // value for 'unfollowParams'
 *   },
 * });
 */
export function useUnfollowUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options)
}
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<
  UnfollowUserMutation,
  UnfollowUserMutationVariables
>
export const GetUserIsFollowedDocument = gql`
  query getUserIsFollowed($getUserIsFollowedParams: GetUserIsFollowedParams!) {
    getUserIsFollowed(getUserIsFollowedParams: $getUserIsFollowedParams) {
      followedId
      followerId
      isFollowing
    }
  }
`

/**
 * __useGetUserIsFollowedQuery__
 *
 * To run a query within a React component, call `useGetUserIsFollowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIsFollowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIsFollowedQuery({
 *   variables: {
 *      getUserIsFollowedParams: // value for 'getUserIsFollowedParams'
 *   },
 * });
 */
export function useGetUserIsFollowedQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>(GetUserIsFollowedDocument, options)
}
export function useGetUserIsFollowedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>(
    GetUserIsFollowedDocument,
    options
  )
}
export type GetUserIsFollowedQueryHookResult = ReturnType<typeof useGetUserIsFollowedQuery>
export type GetUserIsFollowedLazyQueryHookResult = ReturnType<typeof useGetUserIsFollowedLazyQuery>
export type GetUserIsFollowedQueryResult = Apollo.QueryResult<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>
export const UnlockUserAccountDocument = gql`
  mutation unlockUserAccount($unlockUserAccountParams: UnlockUserAccountParams!) {
    unlockUserAccount(unlockUserAccountParams: $unlockUserAccountParams)
  }
`
export type UnlockUserAccountMutationFn = Apollo.MutationFunction<
  UnlockUserAccountMutation,
  UnlockUserAccountMutationVariables
>

/**
 * __useUnlockUserAccountMutation__
 *
 * To run a mutation, you first call `useUnlockUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockUserAccountMutation, { data, loading, error }] = useUnlockUserAccountMutation({
 *   variables: {
 *      unlockUserAccountParams: // value for 'unlockUserAccountParams'
 *   },
 * });
 */
export function useUnlockUserAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<UnlockUserAccountMutation, UnlockUserAccountMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnlockUserAccountMutation, UnlockUserAccountMutationVariables>(
    UnlockUserAccountDocument,
    options
  )
}
export type UnlockUserAccountMutationHookResult = ReturnType<typeof useUnlockUserAccountMutation>
export type UnlockUserAccountMutationResult = Apollo.MutationResult<UnlockUserAccountMutation>
export type UnlockUserAccountMutationOptions = Apollo.BaseMutationOptions<
  UnlockUserAccountMutation,
  UnlockUserAccountMutationVariables
>
export const AdminGetUserDataDocument = gql`
  query adminGetUserData($adminGetUserDataParams: AdminGetUserDataParams!) {
    adminGetUserData(adminGetUserDataParams: $adminGetUserDataParams) {
      id
      name
      email
      emailVerifiedAt
      userStatus
      isAdmin
      isBlocked
      isLocked
      accountDeletionTime
      createdAt
      loginProviders {
        provider
        verified
      }
      bestAvailableSubscription {
        tier
      }
      baseSubscription {
        tier
      }
      numComments
      numHiddenComments
      subscriptions {
        originalTransactionId
        originalPurchaseDate
        productId
        expirationDate
        status
        isTrialPeriod
        isInIntroOfferPeriod
        refundedDate
        refundedReason
        deviceLimitEnforcementEnabled
        overDeviceLimit
        activeDeviceCount
        gracePeriodExpiresAt
        expirationIntent
        isInBillingRetryPeriod
        tier
      }
      subscriptionOverrides {
        id
        createdAt
        expirationDate
        overrideTier
        overrideReason
        createdBy {
          email
        }
      }
      stripeConsumerSubscription {
        status
        updatedAt
        createdAt
        endedAt
        trialEndAt
        trialEndedAt
        tier
        stripeSubscriptionId
        stripePriceId
        stripeProductId
      }
      classicStatus {
        id
        originalApplicationVersion
        originalPurchaseDate
        deviceId
        likelyFraud
        createdAt
        updatedAt
      }
      profile {
        screenname
        ignoreFlagging
      }
      subscriber {
        id
      }
      business(status: ALL) {
        id
        name
        industry
      }
      businessUser(status: ALL) {
        role
        status
        tokenExpiresAt
      }
      adminOrganization {
        role
        status
        organization {
          id
          organizationName
          organizationType
          status
          subscriptionStatus
          usedSeats
          maxSeats
        }
      }
      quizStatistics {
        questionsCorrect
        questionsSkipped
        questionsAnswered
        quizCount
      }
    }
  }
`

/**
 * __useAdminGetUserDataQuery__
 *
 * To run a query within a React component, call `useAdminGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetUserDataQuery({
 *   variables: {
 *      adminGetUserDataParams: // value for 'adminGetUserDataParams'
 *   },
 * });
 */
export function useAdminGetUserDataQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>(AdminGetUserDataDocument, options)
}
export function useAdminGetUserDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>(AdminGetUserDataDocument, options)
}
export type AdminGetUserDataQueryHookResult = ReturnType<typeof useAdminGetUserDataQuery>
export type AdminGetUserDataLazyQueryHookResult = ReturnType<typeof useAdminGetUserDataLazyQuery>
export type AdminGetUserDataQueryResult = Apollo.QueryResult<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>
export const GetLibraryCountsDocument = gql`
  query getLibraryCounts($getLibraryCountsParams: GetLibraryCountsParams!) {
    getLibraryCounts(getLibraryCountsParams: $getLibraryCountsParams) {
      notesCount
      legacyNotesCount
      organizersCount
      notesWithoutOpsCount
      unfiledNotesCount
    }
  }
`

/**
 * __useGetLibraryCountsQuery__
 *
 * To run a query within a React component, call `useGetLibraryCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryCountsQuery({
 *   variables: {
 *      getLibraryCountsParams: // value for 'getLibraryCountsParams'
 *   },
 * });
 */
export function useGetLibraryCountsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLibraryCountsQuery, GetLibraryCountsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetLibraryCountsQuery, GetLibraryCountsQueryVariables>(GetLibraryCountsDocument, options)
}
export function useGetLibraryCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryCountsQuery, GetLibraryCountsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetLibraryCountsQuery, GetLibraryCountsQueryVariables>(GetLibraryCountsDocument, options)
}
export type GetLibraryCountsQueryHookResult = ReturnType<typeof useGetLibraryCountsQuery>
export type GetLibraryCountsLazyQueryHookResult = ReturnType<typeof useGetLibraryCountsLazyQuery>
export type GetLibraryCountsQueryResult = Apollo.QueryResult<GetLibraryCountsQuery, GetLibraryCountsQueryVariables>
export const GetMigrationsDocument = gql`
  query getMigrations($getMigrationsParams: GetMigrationsParams!) {
    getMigrations(getMigrationsParams: $getMigrationsParams) {
      id
      controllingDeviceName
      controllingDeviceId
      startDate
      source {
        type
        icloudUserId
        serverUserId
        workspaceId
      }
      target {
        type
        icloudUserId
        serverUserId
        workspaceId
      }
    }
  }
`

/**
 * __useGetMigrationsQuery__
 *
 * To run a query within a React component, call `useGetMigrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMigrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMigrationsQuery({
 *   variables: {
 *      getMigrationsParams: // value for 'getMigrationsParams'
 *   },
 * });
 */
export function useGetMigrationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetMigrationsQuery, GetMigrationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetMigrationsQuery, GetMigrationsQueryVariables>(GetMigrationsDocument, options)
}
export function useGetMigrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMigrationsQuery, GetMigrationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetMigrationsQuery, GetMigrationsQueryVariables>(GetMigrationsDocument, options)
}
export type GetMigrationsQueryHookResult = ReturnType<typeof useGetMigrationsQuery>
export type GetMigrationsLazyQueryHookResult = ReturnType<typeof useGetMigrationsLazyQuery>
export type GetMigrationsQueryResult = Apollo.QueryResult<GetMigrationsQuery, GetMigrationsQueryVariables>
export const GetUserAdminEventsDocument = gql`
  query getUserAdminEvents($adminEventSearchParams: AdminEventSearchParams!) {
    getUserAdminEvents(adminEventSearchParams: $adminEventSearchParams) {
      id
      eventType
      createdAt
      systemNotes
      triggeringUserEmail
      triggeringUserNotes
    }
  }
`

/**
 * __useGetUserAdminEventsQuery__
 *
 * To run a query within a React component, call `useGetUserAdminEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAdminEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAdminEventsQuery({
 *   variables: {
 *      adminEventSearchParams: // value for 'adminEventSearchParams'
 *   },
 * });
 */
export function useGetUserAdminEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>(GetUserAdminEventsDocument, options)
}
export function useGetUserAdminEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>(
    GetUserAdminEventsDocument,
    options
  )
}
export type GetUserAdminEventsQueryHookResult = ReturnType<typeof useGetUserAdminEventsQuery>
export type GetUserAdminEventsLazyQueryHookResult = ReturnType<typeof useGetUserAdminEventsLazyQuery>
export type GetUserAdminEventsQueryResult = Apollo.QueryResult<
  GetUserAdminEventsQuery,
  GetUserAdminEventsQueryVariables
>
export const GetUserNoteAdminEventsDocument = gql`
  query getUserNoteAdminEvents($adminEventSearchParams: AdminEventSearchParams!) {
    getUserNoteAdminEvents(adminEventSearchParams: $adminEventSearchParams) {
      id
      eventType
      createdAt
      systemNotes
      triggeringUserEmail
      triggeringUserNotes
      galleryNote {
        ...galleryNoteInfo
      }
      flaggedReason
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserNoteAdminEventsQuery__
 *
 * To run a query within a React component, call `useGetUserNoteAdminEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNoteAdminEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNoteAdminEventsQuery({
 *   variables: {
 *      adminEventSearchParams: // value for 'adminEventSearchParams'
 *   },
 * });
 */
export function useGetUserNoteAdminEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>(
    GetUserNoteAdminEventsDocument,
    options
  )
}
export function useGetUserNoteAdminEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>(
    GetUserNoteAdminEventsDocument,
    options
  )
}
export type GetUserNoteAdminEventsQueryHookResult = ReturnType<typeof useGetUserNoteAdminEventsQuery>
export type GetUserNoteAdminEventsLazyQueryHookResult = ReturnType<typeof useGetUserNoteAdminEventsLazyQuery>
export type GetUserNoteAdminEventsQueryResult = Apollo.QueryResult<
  GetUserNoteAdminEventsQuery,
  GetUserNoteAdminEventsQueryVariables
>
export const GetPublishersFollowedByUserDocument = gql`
  query getPublishersFollowedByUser($followingUsersParameters: FollowingUsersParameters!) {
    getPublishersFollowedByUser(followingUsersParameters: $followingUsersParameters) {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useGetPublishersFollowedByUserQuery__
 *
 * To run a query within a React component, call `useGetPublishersFollowedByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishersFollowedByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishersFollowedByUserQuery({
 *   variables: {
 *      followingUsersParameters: // value for 'followingUsersParameters'
 *   },
 * });
 */
export function useGetPublishersFollowedByUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>(
    GetPublishersFollowedByUserDocument,
    options
  )
}
export function useGetPublishersFollowedByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>(
    GetPublishersFollowedByUserDocument,
    options
  )
}
export type GetPublishersFollowedByUserQueryHookResult = ReturnType<typeof useGetPublishersFollowedByUserQuery>
export type GetPublishersFollowedByUserLazyQueryHookResult = ReturnType<typeof useGetPublishersFollowedByUserLazyQuery>
export type GetPublishersFollowedByUserQueryResult = Apollo.QueryResult<
  GetPublishersFollowedByUserQuery,
  GetPublishersFollowedByUserQueryVariables
>
export const GetUsersFollowingPublisherDocument = gql`
  query getUsersFollowingPublisher($followingUsersParameters: FollowingUsersParameters!) {
    getUsersFollowingPublisher(followingUsersParameters: $followingUsersParameters) {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useGetUsersFollowingPublisherQuery__
 *
 * To run a query within a React component, call `useGetUsersFollowingPublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersFollowingPublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersFollowingPublisherQuery({
 *   variables: {
 *      followingUsersParameters: // value for 'followingUsersParameters'
 *   },
 * });
 */
export function useGetUsersFollowingPublisherQuery(
  baseOptions: Apollo.QueryHookOptions<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>(
    GetUsersFollowingPublisherDocument,
    options
  )
}
export function useGetUsersFollowingPublisherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>(
    GetUsersFollowingPublisherDocument,
    options
  )
}
export type GetUsersFollowingPublisherQueryHookResult = ReturnType<typeof useGetUsersFollowingPublisherQuery>
export type GetUsersFollowingPublisherLazyQueryHookResult = ReturnType<typeof useGetUsersFollowingPublisherLazyQuery>
export type GetUsersFollowingPublisherQueryResult = Apollo.QueryResult<
  GetUsersFollowingPublisherQuery,
  GetUsersFollowingPublisherQueryVariables
>
export const GetUsersWhoLikedNoteDocument = gql`
  query getUsersWhoLikedNote($likingUsersParameters: LikingUsersParameters!) {
    getUsersWhoLikedNote(likingUsersParameters: $likingUsersParameters) {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useGetUsersWhoLikedNoteQuery__
 *
 * To run a query within a React component, call `useGetUsersWhoLikedNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWhoLikedNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWhoLikedNoteQuery({
 *   variables: {
 *      likingUsersParameters: // value for 'likingUsersParameters'
 *   },
 * });
 */
export function useGetUsersWhoLikedNoteQuery(
  baseOptions: Apollo.QueryHookOptions<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>(
    GetUsersWhoLikedNoteDocument,
    options
  )
}
export function useGetUsersWhoLikedNoteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>(
    GetUsersWhoLikedNoteDocument,
    options
  )
}
export type GetUsersWhoLikedNoteQueryHookResult = ReturnType<typeof useGetUsersWhoLikedNoteQuery>
export type GetUsersWhoLikedNoteLazyQueryHookResult = ReturnType<typeof useGetUsersWhoLikedNoteLazyQuery>
export type GetUsersWhoLikedNoteQueryResult = Apollo.QueryResult<
  GetUsersWhoLikedNoteQuery,
  GetUsersWhoLikedNoteQueryVariables
>
export const GetNoteRendererDataDocument = gql`
  query getNoteRendererData($noteRendererParams: NoteRendererParams!) {
    getNoteRendererData(noteRendererParams: $noteRendererParams) {
      data
    }
  }
`

/**
 * __useGetNoteRendererDataQuery__
 *
 * To run a query within a React component, call `useGetNoteRendererDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteRendererDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteRendererDataQuery({
 *   variables: {
 *      noteRendererParams: // value for 'noteRendererParams'
 *   },
 * });
 */
export function useGetNoteRendererDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>(
    GetNoteRendererDataDocument,
    options
  )
}
export function useGetNoteRendererDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>(
    GetNoteRendererDataDocument,
    options
  )
}
export type GetNoteRendererDataQueryHookResult = ReturnType<typeof useGetNoteRendererDataQuery>
export type GetNoteRendererDataLazyQueryHookResult = ReturnType<typeof useGetNoteRendererDataLazyQuery>
export type GetNoteRendererDataQueryResult = Apollo.QueryResult<
  GetNoteRendererDataQuery,
  GetNoteRendererDataQueryVariables
>
export const GetQuestionableNoteContentDocument = gql`
  query getQuestionableNoteContent($questionableNoteContentParams: QuestionableNoteContentParams!) {
    getQuestionableNoteContent(questionableNoteContentParams: $questionableNoteContentParams) {
      reason
      origin
      content {
        flaggedTerm
        context
      }
    }
  }
`

/**
 * __useGetQuestionableNoteContentQuery__
 *
 * To run a query within a React component, call `useGetQuestionableNoteContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionableNoteContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionableNoteContentQuery({
 *   variables: {
 *      questionableNoteContentParams: // value for 'questionableNoteContentParams'
 *   },
 * });
 */
export function useGetQuestionableNoteContentQuery(
  baseOptions: Apollo.QueryHookOptions<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>(
    GetQuestionableNoteContentDocument,
    options
  )
}
export function useGetQuestionableNoteContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>(
    GetQuestionableNoteContentDocument,
    options
  )
}
export type GetQuestionableNoteContentQueryHookResult = ReturnType<typeof useGetQuestionableNoteContentQuery>
export type GetQuestionableNoteContentLazyQueryHookResult = ReturnType<typeof useGetQuestionableNoteContentLazyQuery>
export type GetQuestionableNoteContentQueryResult = Apollo.QueryResult<
  GetQuestionableNoteContentQuery,
  GetQuestionableNoteContentQueryVariables
>
export const MarkFeedAsViewedDocument = gql`
  mutation markFeedAsViewed($markFeedAsViewedParams: MarkFeedAsViewedParams!) {
    markFeedAsViewed(markFeedAsViewedParams: $markFeedAsViewedParams)
  }
`
export type MarkFeedAsViewedMutationFn = Apollo.MutationFunction<
  MarkFeedAsViewedMutation,
  MarkFeedAsViewedMutationVariables
>

/**
 * __useMarkFeedAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkFeedAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFeedAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFeedAsViewedMutation, { data, loading, error }] = useMarkFeedAsViewedMutation({
 *   variables: {
 *      markFeedAsViewedParams: // value for 'markFeedAsViewedParams'
 *   },
 * });
 */
export function useMarkFeedAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkFeedAsViewedMutation, MarkFeedAsViewedMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<MarkFeedAsViewedMutation, MarkFeedAsViewedMutationVariables>(
    MarkFeedAsViewedDocument,
    options
  )
}
export type MarkFeedAsViewedMutationHookResult = ReturnType<typeof useMarkFeedAsViewedMutation>
export type MarkFeedAsViewedMutationResult = Apollo.MutationResult<MarkFeedAsViewedMutation>
export type MarkFeedAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkFeedAsViewedMutation,
  MarkFeedAsViewedMutationVariables
>
export const UpdateCookiesDocument = gql`
  mutation updateCookies($updateCookiesParams: UpdateCookiesParams!) {
    updateCookies(updateCookiesParams: $updateCookiesParams)
  }
`
export type UpdateCookiesMutationFn = Apollo.MutationFunction<UpdateCookiesMutation, UpdateCookiesMutationVariables>

/**
 * __useUpdateCookiesMutation__
 *
 * To run a mutation, you first call `useUpdateCookiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCookiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCookiesMutation, { data, loading, error }] = useUpdateCookiesMutation({
 *   variables: {
 *      updateCookiesParams: // value for 'updateCookiesParams'
 *   },
 * });
 */
export function useUpdateCookiesMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCookiesMutation, UpdateCookiesMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCookiesMutation, UpdateCookiesMutationVariables>(UpdateCookiesDocument, options)
}
export type UpdateCookiesMutationHookResult = ReturnType<typeof useUpdateCookiesMutation>
export type UpdateCookiesMutationResult = Apollo.MutationResult<UpdateCookiesMutation>
export type UpdateCookiesMutationOptions = Apollo.BaseMutationOptions<
  UpdateCookiesMutation,
  UpdateCookiesMutationVariables
>
export const ChangeScreennameDocument = gql`
  mutation changeScreenname($changeScreennameParams: ChangeScreennameParams!) {
    changeScreenname(changeScreennameParams: $changeScreennameParams)
  }
`
export type ChangeScreennameMutationFn = Apollo.MutationFunction<
  ChangeScreennameMutation,
  ChangeScreennameMutationVariables
>

/**
 * __useChangeScreennameMutation__
 *
 * To run a mutation, you first call `useChangeScreennameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeScreennameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeScreennameMutation, { data, loading, error }] = useChangeScreennameMutation({
 *   variables: {
 *      changeScreennameParams: // value for 'changeScreennameParams'
 *   },
 * });
 */
export function useChangeScreennameMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeScreennameMutation, ChangeScreennameMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeScreennameMutation, ChangeScreennameMutationVariables>(
    ChangeScreennameDocument,
    options
  )
}
export type ChangeScreennameMutationHookResult = ReturnType<typeof useChangeScreennameMutation>
export type ChangeScreennameMutationResult = Apollo.MutationResult<ChangeScreennameMutation>
export type ChangeScreennameMutationOptions = Apollo.BaseMutationOptions<
  ChangeScreennameMutation,
  ChangeScreennameMutationVariables
>
export const ChangeEmailDocument = gql`
  mutation changeEmail($changeEmailParams: ChangeEmailParams!) {
    changeEmail(changeEmailParams: $changeEmailParams)
  }
`
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      changeEmailParams: // value for 'changeEmailParams'
 *   },
 * });
 */
export function useChangeEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options)
}
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>
export const ChangeAdminStatusDocument = gql`
  mutation changeAdminStatus($changeAdminStatusParams: ChangeAdminStatusParams!) {
    changeAdminStatus(changeAdminStatusParams: $changeAdminStatusParams)
  }
`
export type ChangeAdminStatusMutationFn = Apollo.MutationFunction<
  ChangeAdminStatusMutation,
  ChangeAdminStatusMutationVariables
>

/**
 * __useChangeAdminStatusMutation__
 *
 * To run a mutation, you first call `useChangeAdminStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAdminStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAdminStatusMutation, { data, loading, error }] = useChangeAdminStatusMutation({
 *   variables: {
 *      changeAdminStatusParams: // value for 'changeAdminStatusParams'
 *   },
 * });
 */
export function useChangeAdminStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeAdminStatusMutation, ChangeAdminStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeAdminStatusMutation, ChangeAdminStatusMutationVariables>(
    ChangeAdminStatusDocument,
    options
  )
}
export type ChangeAdminStatusMutationHookResult = ReturnType<typeof useChangeAdminStatusMutation>
export type ChangeAdminStatusMutationResult = Apollo.MutationResult<ChangeAdminStatusMutation>
export type ChangeAdminStatusMutationOptions = Apollo.BaseMutationOptions<
  ChangeAdminStatusMutation,
  ChangeAdminStatusMutationVariables
>
export const ChangeBlockStatusDocument = gql`
  mutation changeBlockStatus($changeBlockStatusParams: ChangeBlockStatusParams!) {
    changeBlockStatus(changeBlockStatusParams: $changeBlockStatusParams)
  }
`
export type ChangeBlockStatusMutationFn = Apollo.MutationFunction<
  ChangeBlockStatusMutation,
  ChangeBlockStatusMutationVariables
>

/**
 * __useChangeBlockStatusMutation__
 *
 * To run a mutation, you first call `useChangeBlockStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBlockStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBlockStatusMutation, { data, loading, error }] = useChangeBlockStatusMutation({
 *   variables: {
 *      changeBlockStatusParams: // value for 'changeBlockStatusParams'
 *   },
 * });
 */
export function useChangeBlockStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeBlockStatusMutation, ChangeBlockStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeBlockStatusMutation, ChangeBlockStatusMutationVariables>(
    ChangeBlockStatusDocument,
    options
  )
}
export type ChangeBlockStatusMutationHookResult = ReturnType<typeof useChangeBlockStatusMutation>
export type ChangeBlockStatusMutationResult = Apollo.MutationResult<ChangeBlockStatusMutation>
export type ChangeBlockStatusMutationOptions = Apollo.BaseMutationOptions<
  ChangeBlockStatusMutation,
  ChangeBlockStatusMutationVariables
>
export const GetFuzzyScreennameMatchesDocument = gql`
  query getFuzzyScreennameMatches($getFuzzyScreennameMatchesParams: GetFuzzyScreennameMatchesParams!) {
    getFuzzyScreennameMatches(getFuzzyScreennameMatchesParams: $getFuzzyScreennameMatchesParams)
  }
`

/**
 * __useGetFuzzyScreennameMatchesQuery__
 *
 * To run a query within a React component, call `useGetFuzzyScreennameMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuzzyScreennameMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuzzyScreennameMatchesQuery({
 *   variables: {
 *      getFuzzyScreennameMatchesParams: // value for 'getFuzzyScreennameMatchesParams'
 *   },
 * });
 */
export function useGetFuzzyScreennameMatchesQuery(
  baseOptions: Apollo.QueryHookOptions<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>(
    GetFuzzyScreennameMatchesDocument,
    options
  )
}
export function useGetFuzzyScreennameMatchesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>(
    GetFuzzyScreennameMatchesDocument,
    options
  )
}
export type GetFuzzyScreennameMatchesQueryHookResult = ReturnType<typeof useGetFuzzyScreennameMatchesQuery>
export type GetFuzzyScreennameMatchesLazyQueryHookResult = ReturnType<typeof useGetFuzzyScreennameMatchesLazyQuery>
export type GetFuzzyScreennameMatchesQueryResult = Apollo.QueryResult<
  GetFuzzyScreennameMatchesQuery,
  GetFuzzyScreennameMatchesQueryVariables
>
export const AdminFuzzyUserSearchDocument = gql`
  query adminFuzzyUserSearch($adminFuzzyUserSearchParams: AdminFuzzyUserSearchParams!) {
    adminFuzzyUserSearch(adminFuzzyUserSearchParams: $adminFuzzyUserSearchParams)
  }
`

/**
 * __useAdminFuzzyUserSearchQuery__
 *
 * To run a query within a React component, call `useAdminFuzzyUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFuzzyUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFuzzyUserSearchQuery({
 *   variables: {
 *      adminFuzzyUserSearchParams: // value for 'adminFuzzyUserSearchParams'
 *   },
 * });
 */
export function useAdminFuzzyUserSearchQuery(
  baseOptions: Apollo.QueryHookOptions<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>(
    AdminFuzzyUserSearchDocument,
    options
  )
}
export function useAdminFuzzyUserSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>(
    AdminFuzzyUserSearchDocument,
    options
  )
}
export type AdminFuzzyUserSearchQueryHookResult = ReturnType<typeof useAdminFuzzyUserSearchQuery>
export type AdminFuzzyUserSearchLazyQueryHookResult = ReturnType<typeof useAdminFuzzyUserSearchLazyQuery>
export type AdminFuzzyUserSearchQueryResult = Apollo.QueryResult<
  AdminFuzzyUserSearchQuery,
  AdminFuzzyUserSearchQueryVariables
>
export const GetNotificationsDocument = gql`
  query getNotifications($getNotificationsParams: GetNotificationsParams!) {
    getNotifications(getNotificationsParams: $getNotificationsParams) {
      id
      type
      seen
      eventCount
      createdAt
      lastNotificationActionAt
      galleryNote {
        id
        name
        previewImages
      }
      promoNotification {
        translationKey
        href
      }
      notificationEvents {
        id
        triggeringUser {
          id
          profile {
            screenname
            avatarUpdatedAt
          }
        }
      }
    }
  }
`

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      getNotificationsParams: // value for 'getNotificationsParams'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options)
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options)
}
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>
export const MarkNotificationsSeenDocument = gql`
  mutation markNotificationsSeen($markNotificationsSeenParams: MarkNotificationsSeenParams!) {
    markNotificationsSeen(markNotificationsSeenParams: $markNotificationsSeenParams)
  }
`
export type MarkNotificationsSeenMutationFn = Apollo.MutationFunction<
  MarkNotificationsSeenMutation,
  MarkNotificationsSeenMutationVariables
>

/**
 * __useMarkNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsSeenMutation, { data, loading, error }] = useMarkNotificationsSeenMutation({
 *   variables: {
 *      markNotificationsSeenParams: // value for 'markNotificationsSeenParams'
 *   },
 * });
 */
export function useMarkNotificationsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>(
    MarkNotificationsSeenDocument,
    options
  )
}
export type MarkNotificationsSeenMutationHookResult = ReturnType<typeof useMarkNotificationsSeenMutation>
export type MarkNotificationsSeenMutationResult = Apollo.MutationResult<MarkNotificationsSeenMutation>
export type MarkNotificationsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationsSeenMutation,
  MarkNotificationsSeenMutationVariables
>
export const CreatePromoNotificationDocument = gql`
  mutation createPromoNotification($promoNotificationParams: PromoNotificationParams!) {
    createPromoNotification(promoNotificationParams: $promoNotificationParams) {
      ...promoNotification
    }
  }
  ${PromoNotificationFragmentDoc}
`
export type CreatePromoNotificationMutationFn = Apollo.MutationFunction<
  CreatePromoNotificationMutation,
  CreatePromoNotificationMutationVariables
>

/**
 * __useCreatePromoNotificationMutation__
 *
 * To run a mutation, you first call `useCreatePromoNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromoNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromoNotificationMutation, { data, loading, error }] = useCreatePromoNotificationMutation({
 *   variables: {
 *      promoNotificationParams: // value for 'promoNotificationParams'
 *   },
 * });
 */
export function useCreatePromoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePromoNotificationMutation, CreatePromoNotificationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreatePromoNotificationMutation, CreatePromoNotificationMutationVariables>(
    CreatePromoNotificationDocument,
    options
  )
}
export type CreatePromoNotificationMutationHookResult = ReturnType<typeof useCreatePromoNotificationMutation>
export type CreatePromoNotificationMutationResult = Apollo.MutationResult<CreatePromoNotificationMutation>
export type CreatePromoNotificationMutationOptions = Apollo.BaseMutationOptions<
  CreatePromoNotificationMutation,
  CreatePromoNotificationMutationVariables
>
export const DeletePromoNotificationDocument = gql`
  mutation deletePromoNotification($deletePromoParams: DeletePromoParams!) {
    deletePromoNotification(deletePromoParams: $deletePromoParams)
  }
`
export type DeletePromoNotificationMutationFn = Apollo.MutationFunction<
  DeletePromoNotificationMutation,
  DeletePromoNotificationMutationVariables
>

/**
 * __useDeletePromoNotificationMutation__
 *
 * To run a mutation, you first call `useDeletePromoNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromoNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromoNotificationMutation, { data, loading, error }] = useDeletePromoNotificationMutation({
 *   variables: {
 *      deletePromoParams: // value for 'deletePromoParams'
 *   },
 * });
 */
export function useDeletePromoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePromoNotificationMutation, DeletePromoNotificationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeletePromoNotificationMutation, DeletePromoNotificationMutationVariables>(
    DeletePromoNotificationDocument,
    options
  )
}
export type DeletePromoNotificationMutationHookResult = ReturnType<typeof useDeletePromoNotificationMutation>
export type DeletePromoNotificationMutationResult = Apollo.MutationResult<DeletePromoNotificationMutation>
export type DeletePromoNotificationMutationOptions = Apollo.BaseMutationOptions<
  DeletePromoNotificationMutation,
  DeletePromoNotificationMutationVariables
>
export const EditPromoNotificationDocument = gql`
  mutation editPromoNotification($promoNotificationParams: PromoNotificationParams!) {
    editPromoNotification(promoNotificationParams: $promoNotificationParams) {
      ...promoNotification
    }
  }
  ${PromoNotificationFragmentDoc}
`
export type EditPromoNotificationMutationFn = Apollo.MutationFunction<
  EditPromoNotificationMutation,
  EditPromoNotificationMutationVariables
>

/**
 * __useEditPromoNotificationMutation__
 *
 * To run a mutation, you first call `useEditPromoNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPromoNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPromoNotificationMutation, { data, loading, error }] = useEditPromoNotificationMutation({
 *   variables: {
 *      promoNotificationParams: // value for 'promoNotificationParams'
 *   },
 * });
 */
export function useEditPromoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<EditPromoNotificationMutation, EditPromoNotificationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditPromoNotificationMutation, EditPromoNotificationMutationVariables>(
    EditPromoNotificationDocument,
    options
  )
}
export type EditPromoNotificationMutationHookResult = ReturnType<typeof useEditPromoNotificationMutation>
export type EditPromoNotificationMutationResult = Apollo.MutationResult<EditPromoNotificationMutation>
export type EditPromoNotificationMutationOptions = Apollo.BaseMutationOptions<
  EditPromoNotificationMutation,
  EditPromoNotificationMutationVariables
>
export const SetPromoAsDraftDocument = gql`
  mutation setPromoAsDraft($promoDraftParams: PromoDraftParams!) {
    setPromoAsDraft(promoDraftParams: $promoDraftParams) {
      ...promoNotification
    }
  }
  ${PromoNotificationFragmentDoc}
`
export type SetPromoAsDraftMutationFn = Apollo.MutationFunction<
  SetPromoAsDraftMutation,
  SetPromoAsDraftMutationVariables
>

/**
 * __useSetPromoAsDraftMutation__
 *
 * To run a mutation, you first call `useSetPromoAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPromoAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPromoAsDraftMutation, { data, loading, error }] = useSetPromoAsDraftMutation({
 *   variables: {
 *      promoDraftParams: // value for 'promoDraftParams'
 *   },
 * });
 */
export function useSetPromoAsDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<SetPromoAsDraftMutation, SetPromoAsDraftMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetPromoAsDraftMutation, SetPromoAsDraftMutationVariables>(SetPromoAsDraftDocument, options)
}
export type SetPromoAsDraftMutationHookResult = ReturnType<typeof useSetPromoAsDraftMutation>
export type SetPromoAsDraftMutationResult = Apollo.MutationResult<SetPromoAsDraftMutation>
export type SetPromoAsDraftMutationOptions = Apollo.BaseMutationOptions<
  SetPromoAsDraftMutation,
  SetPromoAsDraftMutationVariables
>
export const GetDesktopStatusesDocument = gql`
  query getDesktopStatuses($includeRemoved: Boolean!) {
    desktopStatuses(includeRemoved: $includeRemoved) {
      ...desktopStatus
    }
  }
  ${DesktopStatusFragmentDoc}
`

/**
 * __useGetDesktopStatusesQuery__
 *
 * To run a query within a React component, call `useGetDesktopStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesktopStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesktopStatusesQuery({
 *   variables: {
 *      includeRemoved: // value for 'includeRemoved'
 *   },
 * });
 */
export function useGetDesktopStatusesQuery(
  baseOptions: Apollo.QueryHookOptions<GetDesktopStatusesQuery, GetDesktopStatusesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetDesktopStatusesQuery, GetDesktopStatusesQueryVariables>(GetDesktopStatusesDocument, options)
}
export function useGetDesktopStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDesktopStatusesQuery, GetDesktopStatusesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetDesktopStatusesQuery, GetDesktopStatusesQueryVariables>(
    GetDesktopStatusesDocument,
    options
  )
}
export type GetDesktopStatusesQueryHookResult = ReturnType<typeof useGetDesktopStatusesQuery>
export type GetDesktopStatusesLazyQueryHookResult = ReturnType<typeof useGetDesktopStatusesLazyQuery>
export type GetDesktopStatusesQueryResult = Apollo.QueryResult<
  GetDesktopStatusesQuery,
  GetDesktopStatusesQueryVariables
>
export const PreviewDesktopStatusDocument = gql`
  query previewDesktopStatus($previewDesktopStatusParams: PreviewDesktopStatusParams!) {
    previewDesktopStatus(previewDesktopStatusParams: $previewDesktopStatusParams) {
      shows
      message
      url
      blocks
      suppressedBy
    }
  }
`

/**
 * __usePreviewDesktopStatusQuery__
 *
 * To run a query within a React component, call `usePreviewDesktopStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDesktopStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDesktopStatusQuery({
 *   variables: {
 *      previewDesktopStatusParams: // value for 'previewDesktopStatusParams'
 *   },
 * });
 */
export function usePreviewDesktopStatusQuery(
  baseOptions: Apollo.QueryHookOptions<PreviewDesktopStatusQuery, PreviewDesktopStatusQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PreviewDesktopStatusQuery, PreviewDesktopStatusQueryVariables>(
    PreviewDesktopStatusDocument,
    options
  )
}
export function usePreviewDesktopStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PreviewDesktopStatusQuery, PreviewDesktopStatusQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PreviewDesktopStatusQuery, PreviewDesktopStatusQueryVariables>(
    PreviewDesktopStatusDocument,
    options
  )
}
export type PreviewDesktopStatusQueryHookResult = ReturnType<typeof usePreviewDesktopStatusQuery>
export type PreviewDesktopStatusLazyQueryHookResult = ReturnType<typeof usePreviewDesktopStatusLazyQuery>
export type PreviewDesktopStatusQueryResult = Apollo.QueryResult<
  PreviewDesktopStatusQuery,
  PreviewDesktopStatusQueryVariables
>
export const PreviewLiveDesktopStatusDocument = gql`
  query previewLiveDesktopStatus($context: DesktopStatusContextParams!) {
    previewLiveDesktopStatus(context: $context) {
      shows
      message
      url
      blocks
      suppressedBy
    }
  }
`

/**
 * __usePreviewLiveDesktopStatusQuery__
 *
 * To run a query within a React component, call `usePreviewLiveDesktopStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewLiveDesktopStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewLiveDesktopStatusQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function usePreviewLiveDesktopStatusQuery(
  baseOptions: Apollo.QueryHookOptions<PreviewLiveDesktopStatusQuery, PreviewLiveDesktopStatusQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PreviewLiveDesktopStatusQuery, PreviewLiveDesktopStatusQueryVariables>(
    PreviewLiveDesktopStatusDocument,
    options
  )
}
export function usePreviewLiveDesktopStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PreviewLiveDesktopStatusQuery, PreviewLiveDesktopStatusQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PreviewLiveDesktopStatusQuery, PreviewLiveDesktopStatusQueryVariables>(
    PreviewLiveDesktopStatusDocument,
    options
  )
}
export type PreviewLiveDesktopStatusQueryHookResult = ReturnType<typeof usePreviewLiveDesktopStatusQuery>
export type PreviewLiveDesktopStatusLazyQueryHookResult = ReturnType<typeof usePreviewLiveDesktopStatusLazyQuery>
export type PreviewLiveDesktopStatusQueryResult = Apollo.QueryResult<
  PreviewLiveDesktopStatusQuery,
  PreviewLiveDesktopStatusQueryVariables
>
export const CreateDesktopStatusDocument = gql`
  mutation createDesktopStatus($desktopStatusParams: DesktopStatusParams!) {
    createDesktopStatus(desktopStatusParams: $desktopStatusParams) {
      ...desktopStatus
    }
  }
  ${DesktopStatusFragmentDoc}
`
export type CreateDesktopStatusMutationFn = Apollo.MutationFunction<
  CreateDesktopStatusMutation,
  CreateDesktopStatusMutationVariables
>

/**
 * __useCreateDesktopStatusMutation__
 *
 * To run a mutation, you first call `useCreateDesktopStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesktopStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesktopStatusMutation, { data, loading, error }] = useCreateDesktopStatusMutation({
 *   variables: {
 *      desktopStatusParams: // value for 'desktopStatusParams'
 *   },
 * });
 */
export function useCreateDesktopStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDesktopStatusMutation, CreateDesktopStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateDesktopStatusMutation, CreateDesktopStatusMutationVariables>(
    CreateDesktopStatusDocument,
    options
  )
}
export type CreateDesktopStatusMutationHookResult = ReturnType<typeof useCreateDesktopStatusMutation>
export type CreateDesktopStatusMutationResult = Apollo.MutationResult<CreateDesktopStatusMutation>
export type CreateDesktopStatusMutationOptions = Apollo.BaseMutationOptions<
  CreateDesktopStatusMutation,
  CreateDesktopStatusMutationVariables
>
export const EditDesktopStatusDocument = gql`
  mutation editDesktopStatus($desktopStatusParams: DesktopStatusParams!) {
    editDesktopStatus(desktopStatusParams: $desktopStatusParams) {
      ...desktopStatus
    }
  }
  ${DesktopStatusFragmentDoc}
`
export type EditDesktopStatusMutationFn = Apollo.MutationFunction<
  EditDesktopStatusMutation,
  EditDesktopStatusMutationVariables
>

/**
 * __useEditDesktopStatusMutation__
 *
 * To run a mutation, you first call `useEditDesktopStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDesktopStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDesktopStatusMutation, { data, loading, error }] = useEditDesktopStatusMutation({
 *   variables: {
 *      desktopStatusParams: // value for 'desktopStatusParams'
 *   },
 * });
 */
export function useEditDesktopStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<EditDesktopStatusMutation, EditDesktopStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditDesktopStatusMutation, EditDesktopStatusMutationVariables>(
    EditDesktopStatusDocument,
    options
  )
}
export type EditDesktopStatusMutationHookResult = ReturnType<typeof useEditDesktopStatusMutation>
export type EditDesktopStatusMutationResult = Apollo.MutationResult<EditDesktopStatusMutation>
export type EditDesktopStatusMutationOptions = Apollo.BaseMutationOptions<
  EditDesktopStatusMutation,
  EditDesktopStatusMutationVariables
>
export const RemoveDesktopStatusDocument = gql`
  mutation removeDesktopStatus($removeDesktopStatusParams: RemoveDesktopStatusParams!) {
    removeDesktopStatus(removeDesktopStatusParams: $removeDesktopStatusParams) {
      ...desktopStatus
    }
  }
  ${DesktopStatusFragmentDoc}
`
export type RemoveDesktopStatusMutationFn = Apollo.MutationFunction<
  RemoveDesktopStatusMutation,
  RemoveDesktopStatusMutationVariables
>

/**
 * __useRemoveDesktopStatusMutation__
 *
 * To run a mutation, you first call `useRemoveDesktopStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDesktopStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDesktopStatusMutation, { data, loading, error }] = useRemoveDesktopStatusMutation({
 *   variables: {
 *      removeDesktopStatusParams: // value for 'removeDesktopStatusParams'
 *   },
 * });
 */
export function useRemoveDesktopStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveDesktopStatusMutation, RemoveDesktopStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RemoveDesktopStatusMutation, RemoveDesktopStatusMutationVariables>(
    RemoveDesktopStatusDocument,
    options
  )
}
export type RemoveDesktopStatusMutationHookResult = ReturnType<typeof useRemoveDesktopStatusMutation>
export type RemoveDesktopStatusMutationResult = Apollo.MutationResult<RemoveDesktopStatusMutation>
export type RemoveDesktopStatusMutationOptions = Apollo.BaseMutationOptions<
  RemoveDesktopStatusMutation,
  RemoveDesktopStatusMutationVariables
>
export const GetTranslationMappingsDocument = gql`
  query getTranslationMappings($translationMappingParams: TranslationMappingParams!) {
    getTranslationMappings(translationMappingParams: $translationMappingParams) {
      locale
      tKey
      text
    }
  }
`

/**
 * __useGetTranslationMappingsQuery__
 *
 * To run a query within a React component, call `useGetTranslationMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationMappingsQuery({
 *   variables: {
 *      translationMappingParams: // value for 'translationMappingParams'
 *   },
 * });
 */
export function useGetTranslationMappingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>(
    GetTranslationMappingsDocument,
    options
  )
}
export function useGetTranslationMappingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>(
    GetTranslationMappingsDocument,
    options
  )
}
export type GetTranslationMappingsQueryHookResult = ReturnType<typeof useGetTranslationMappingsQuery>
export type GetTranslationMappingsLazyQueryHookResult = ReturnType<typeof useGetTranslationMappingsLazyQuery>
export type GetTranslationMappingsQueryResult = Apollo.QueryResult<
  GetTranslationMappingsQuery,
  GetTranslationMappingsQueryVariables
>
export const DeleteSubscriptionOverrideDocument = gql`
  mutation deleteSubscriptionOverride($deleteSubscriptionOverrideParams: DeleteSubscriptionOverrideParams!) {
    deleteSubscriptionOverride(deleteSubscriptionOverrideParams: $deleteSubscriptionOverrideParams)
  }
`
export type DeleteSubscriptionOverrideMutationFn = Apollo.MutationFunction<
  DeleteSubscriptionOverrideMutation,
  DeleteSubscriptionOverrideMutationVariables
>

/**
 * __useDeleteSubscriptionOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionOverrideMutation, { data, loading, error }] = useDeleteSubscriptionOverrideMutation({
 *   variables: {
 *      deleteSubscriptionOverrideParams: // value for 'deleteSubscriptionOverrideParams'
 *   },
 * });
 */
export function useDeleteSubscriptionOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSubscriptionOverrideMutation,
    DeleteSubscriptionOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteSubscriptionOverrideMutation, DeleteSubscriptionOverrideMutationVariables>(
    DeleteSubscriptionOverrideDocument,
    options
  )
}
export type DeleteSubscriptionOverrideMutationHookResult = ReturnType<typeof useDeleteSubscriptionOverrideMutation>
export type DeleteSubscriptionOverrideMutationResult = Apollo.MutationResult<DeleteSubscriptionOverrideMutation>
export type DeleteSubscriptionOverrideMutationOptions = Apollo.BaseMutationOptions<
  DeleteSubscriptionOverrideMutation,
  DeleteSubscriptionOverrideMutationVariables
>
export const GrantSubscriptionOverrideDocument = gql`
  mutation grantSubscriptionOverride($grantSubscriptionOverrideParams: GrantSubscriptionOverrideParams!) {
    grantSubscriptionOverride(grantSubscriptionOverrideParams: $grantSubscriptionOverrideParams)
  }
`
export type GrantSubscriptionOverrideMutationFn = Apollo.MutationFunction<
  GrantSubscriptionOverrideMutation,
  GrantSubscriptionOverrideMutationVariables
>

/**
 * __useGrantSubscriptionOverrideMutation__
 *
 * To run a mutation, you first call `useGrantSubscriptionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantSubscriptionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantSubscriptionOverrideMutation, { data, loading, error }] = useGrantSubscriptionOverrideMutation({
 *   variables: {
 *      grantSubscriptionOverrideParams: // value for 'grantSubscriptionOverrideParams'
 *   },
 * });
 */
export function useGrantSubscriptionOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GrantSubscriptionOverrideMutation,
    GrantSubscriptionOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<GrantSubscriptionOverrideMutation, GrantSubscriptionOverrideMutationVariables>(
    GrantSubscriptionOverrideDocument,
    options
  )
}
export type GrantSubscriptionOverrideMutationHookResult = ReturnType<typeof useGrantSubscriptionOverrideMutation>
export type GrantSubscriptionOverrideMutationResult = Apollo.MutationResult<GrantSubscriptionOverrideMutation>
export type GrantSubscriptionOverrideMutationOptions = Apollo.BaseMutationOptions<
  GrantSubscriptionOverrideMutation,
  GrantSubscriptionOverrideMutationVariables
>
export const RecoverDeletedNoteDocument = gql`
  mutation recoverDeletedNote($recoverDeletedNoteParams: RecoverDeletedNoteParams!) {
    recoverDeletedNote(recoverDeletedNoteParams: $recoverDeletedNoteParams)
  }
`
export type RecoverDeletedNoteMutationFn = Apollo.MutationFunction<
  RecoverDeletedNoteMutation,
  RecoverDeletedNoteMutationVariables
>

/**
 * __useRecoverDeletedNoteMutation__
 *
 * To run a mutation, you first call `useRecoverDeletedNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverDeletedNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverDeletedNoteMutation, { data, loading, error }] = useRecoverDeletedNoteMutation({
 *   variables: {
 *      recoverDeletedNoteParams: // value for 'recoverDeletedNoteParams'
 *   },
 * });
 */
export function useRecoverDeletedNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<RecoverDeletedNoteMutation, RecoverDeletedNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RecoverDeletedNoteMutation, RecoverDeletedNoteMutationVariables>(
    RecoverDeletedNoteDocument,
    options
  )
}
export type RecoverDeletedNoteMutationHookResult = ReturnType<typeof useRecoverDeletedNoteMutation>
export type RecoverDeletedNoteMutationResult = Apollo.MutationResult<RecoverDeletedNoteMutation>
export type RecoverDeletedNoteMutationOptions = Apollo.BaseMutationOptions<
  RecoverDeletedNoteMutation,
  RecoverDeletedNoteMutationVariables
>
export const DisableDevicesForSubscriptionsDocument = gql`
  mutation disableDevicesForSubscriptions(
    $disableDevicesForSubscriptionsParams: DisableDevicesForSubscriptionsParams!
  ) {
    disableDevicesForSubscriptions(disableDevicesForSubscriptionsParams: $disableDevicesForSubscriptionsParams)
  }
`
export type DisableDevicesForSubscriptionsMutationFn = Apollo.MutationFunction<
  DisableDevicesForSubscriptionsMutation,
  DisableDevicesForSubscriptionsMutationVariables
>

/**
 * __useDisableDevicesForSubscriptionsMutation__
 *
 * To run a mutation, you first call `useDisableDevicesForSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDevicesForSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDevicesForSubscriptionsMutation, { data, loading, error }] = useDisableDevicesForSubscriptionsMutation({
 *   variables: {
 *      disableDevicesForSubscriptionsParams: // value for 'disableDevicesForSubscriptionsParams'
 *   },
 * });
 */
export function useDisableDevicesForSubscriptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableDevicesForSubscriptionsMutation,
    DisableDevicesForSubscriptionsMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DisableDevicesForSubscriptionsMutation, DisableDevicesForSubscriptionsMutationVariables>(
    DisableDevicesForSubscriptionsDocument,
    options
  )
}
export type DisableDevicesForSubscriptionsMutationHookResult = ReturnType<
  typeof useDisableDevicesForSubscriptionsMutation
>
export type DisableDevicesForSubscriptionsMutationResult = Apollo.MutationResult<DisableDevicesForSubscriptionsMutation>
export type DisableDevicesForSubscriptionsMutationOptions = Apollo.BaseMutationOptions<
  DisableDevicesForSubscriptionsMutation,
  DisableDevicesForSubscriptionsMutationVariables
>
export const GetUserLikesNotesDocument = gql`
  query getUserLikesNotes($userLikesNotesParameters: UserLikesNotesParameters!) {
    getUserLikesNotes(userLikesNotesParameters: $userLikesNotesParameters) {
      noteId
      likesNote
    }
  }
`

/**
 * __useGetUserLikesNotesQuery__
 *
 * To run a query within a React component, call `useGetUserLikesNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLikesNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLikesNotesQuery({
 *   variables: {
 *      userLikesNotesParameters: // value for 'userLikesNotesParameters'
 *   },
 * });
 */
export function useGetUserLikesNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>(GetUserLikesNotesDocument, options)
}
export function useGetUserLikesNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>(
    GetUserLikesNotesDocument,
    options
  )
}
export type GetUserLikesNotesQueryHookResult = ReturnType<typeof useGetUserLikesNotesQuery>
export type GetUserLikesNotesLazyQueryHookResult = ReturnType<typeof useGetUserLikesNotesLazyQuery>
export type GetUserLikesNotesQueryResult = Apollo.QueryResult<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>
export const GetAllCommentsDocument = gql`
  query getAllComments($getAllCommentsParams: GetAllCommentsParams!) {
    getAllComments(getAllCommentsParams: $getAllCommentsParams) {
      id
      parent {
        id
      }
      author {
        id
        profile {
          screenname
          avatarUrl
        }
      }
      galleryNote {
        id
        name
      }
      createdAt
      commentText
      approvalState
      rejectionReason
    }
  }
`

/**
 * __useGetAllCommentsQuery__
 *
 * To run a query within a React component, call `useGetAllCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCommentsQuery({
 *   variables: {
 *      getAllCommentsParams: // value for 'getAllCommentsParams'
 *   },
 * });
 */
export function useGetAllCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllCommentsQuery, GetAllCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllCommentsQuery, GetAllCommentsQueryVariables>(GetAllCommentsDocument, options)
}
export function useGetAllCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllCommentsQuery, GetAllCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllCommentsQuery, GetAllCommentsQueryVariables>(GetAllCommentsDocument, options)
}
export type GetAllCommentsQueryHookResult = ReturnType<typeof useGetAllCommentsQuery>
export type GetAllCommentsLazyQueryHookResult = ReturnType<typeof useGetAllCommentsLazyQuery>
export type GetAllCommentsQueryResult = Apollo.QueryResult<GetAllCommentsQuery, GetAllCommentsQueryVariables>
export const GetNoteRootCommentsDocument = gql`
  query getNoteRootComments($getNoteRootCommentsParams: GetNoteRootCommentsParams!) {
    getNoteRootComments(getNoteRootCommentsParams: $getNoteRootCommentsParams) {
      id
      parent {
        id
      }
      author {
        id
        profile {
          screenname
          avatarUrl
        }
      }
      createdAt
      commentText
    }
  }
`

/**
 * __useGetNoteRootCommentsQuery__
 *
 * To run a query within a React component, call `useGetNoteRootCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteRootCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteRootCommentsQuery({
 *   variables: {
 *      getNoteRootCommentsParams: // value for 'getNoteRootCommentsParams'
 *   },
 * });
 */
export function useGetNoteRootCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>(
    GetNoteRootCommentsDocument,
    options
  )
}
export function useGetNoteRootCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>(
    GetNoteRootCommentsDocument,
    options
  )
}
export type GetNoteRootCommentsQueryHookResult = ReturnType<typeof useGetNoteRootCommentsQuery>
export type GetNoteRootCommentsLazyQueryHookResult = ReturnType<typeof useGetNoteRootCommentsLazyQuery>
export type GetNoteRootCommentsQueryResult = Apollo.QueryResult<
  GetNoteRootCommentsQuery,
  GetNoteRootCommentsQueryVariables
>
export const ApproveCommentDocument = gql`
  mutation approveComment($approveCommentParams: ApproveCommentParams!) {
    approveComment(approveCommentParams: $approveCommentParams)
  }
`
export type ApproveCommentMutationFn = Apollo.MutationFunction<ApproveCommentMutation, ApproveCommentMutationVariables>

/**
 * __useApproveCommentMutation__
 *
 * To run a mutation, you first call `useApproveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCommentMutation, { data, loading, error }] = useApproveCommentMutation({
 *   variables: {
 *      approveCommentParams: // value for 'approveCommentParams'
 *   },
 * });
 */
export function useApproveCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<ApproveCommentMutation, ApproveCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ApproveCommentMutation, ApproveCommentMutationVariables>(ApproveCommentDocument, options)
}
export type ApproveCommentMutationHookResult = ReturnType<typeof useApproveCommentMutation>
export type ApproveCommentMutationResult = Apollo.MutationResult<ApproveCommentMutation>
export type ApproveCommentMutationOptions = Apollo.BaseMutationOptions<
  ApproveCommentMutation,
  ApproveCommentMutationVariables
>
export const SetGalleryDegradedDocument = gql`
  mutation setGalleryDegraded($degradedStateParams: DegradedStateParams!) {
    setGalleryDegraded(degradedStateParams: $degradedStateParams)
  }
`
export type SetGalleryDegradedMutationFn = Apollo.MutationFunction<
  SetGalleryDegradedMutation,
  SetGalleryDegradedMutationVariables
>

/**
 * __useSetGalleryDegradedMutation__
 *
 * To run a mutation, you first call `useSetGalleryDegradedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGalleryDegradedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGalleryDegradedMutation, { data, loading, error }] = useSetGalleryDegradedMutation({
 *   variables: {
 *      degradedStateParams: // value for 'degradedStateParams'
 *   },
 * });
 */
export function useSetGalleryDegradedMutation(
  baseOptions?: Apollo.MutationHookOptions<SetGalleryDegradedMutation, SetGalleryDegradedMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetGalleryDegradedMutation, SetGalleryDegradedMutationVariables>(
    SetGalleryDegradedDocument,
    options
  )
}
export type SetGalleryDegradedMutationHookResult = ReturnType<typeof useSetGalleryDegradedMutation>
export type SetGalleryDegradedMutationResult = Apollo.MutationResult<SetGalleryDegradedMutation>
export type SetGalleryDegradedMutationOptions = Apollo.BaseMutationOptions<
  SetGalleryDegradedMutation,
  SetGalleryDegradedMutationVariables
>
export const HideCommentDocument = gql`
  mutation hideComment($hideCommentParams: HideCommentParams!) {
    hideComment(hideCommentParams: $hideCommentParams)
  }
`
export type HideCommentMutationFn = Apollo.MutationFunction<HideCommentMutation, HideCommentMutationVariables>

/**
 * __useHideCommentMutation__
 *
 * To run a mutation, you first call `useHideCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideCommentMutation, { data, loading, error }] = useHideCommentMutation({
 *   variables: {
 *      hideCommentParams: // value for 'hideCommentParams'
 *   },
 * });
 */
export function useHideCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<HideCommentMutation, HideCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<HideCommentMutation, HideCommentMutationVariables>(HideCommentDocument, options)
}
export type HideCommentMutationHookResult = ReturnType<typeof useHideCommentMutation>
export type HideCommentMutationResult = Apollo.MutationResult<HideCommentMutation>
export type HideCommentMutationOptions = Apollo.BaseMutationOptions<HideCommentMutation, HideCommentMutationVariables>
export const CreateCommentDocument = gql`
  mutation createComment($createCommentParams: CreateCommentParams!) {
    createComment(createCommentParams: $createCommentParams) {
      ...commentInfo
    }
  }
  ${CommentInfoFragmentDoc}
`
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      createCommentParams: // value for 'createCommentParams'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options)
}
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>
export const ReportCommentDocument = gql`
  mutation reportComment($reportCommentParams: ReportCommentParams!) {
    reportComment(reportCommentParams: $reportCommentParams)
  }
`
export type ReportCommentMutationFn = Apollo.MutationFunction<ReportCommentMutation, ReportCommentMutationVariables>

/**
 * __useReportCommentMutation__
 *
 * To run a mutation, you first call `useReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCommentMutation, { data, loading, error }] = useReportCommentMutation({
 *   variables: {
 *      reportCommentParams: // value for 'reportCommentParams'
 *   },
 * });
 */
export function useReportCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<ReportCommentMutation, ReportCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReportCommentMutation, ReportCommentMutationVariables>(ReportCommentDocument, options)
}
export type ReportCommentMutationHookResult = ReturnType<typeof useReportCommentMutation>
export type ReportCommentMutationResult = Apollo.MutationResult<ReportCommentMutation>
export type ReportCommentMutationOptions = Apollo.BaseMutationOptions<
  ReportCommentMutation,
  ReportCommentMutationVariables
>
export const DeleteCommentDocument = gql`
  mutation deleteComment($deleteCommentParams: DeleteCommentParams!) {
    deleteComment(deleteCommentParams: $deleteCommentParams)
  }
`
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      deleteCommentParams: // value for 'deleteCommentParams'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options)
}
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>
export const GetAllSubscriptionsOverDeviceLimitDocument = gql`
  query getAllSubscriptionsOverDeviceLimit(
    $getAllSubscriptionsOverDeviceLimitParams: GetAllSubscriptionsOverDeviceLimitParams!
  ) {
    getAllSubscriptionsOverDeviceLimit(
      getAllSubscriptionsOverDeviceLimitParams: $getAllSubscriptionsOverDeviceLimitParams
    ) {
      subscriptionId
      numDevices
      deviceLimitEnforcementEnabled
    }
  }
`

/**
 * __useGetAllSubscriptionsOverDeviceLimitQuery__
 *
 * To run a query within a React component, call `useGetAllSubscriptionsOverDeviceLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubscriptionsOverDeviceLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubscriptionsOverDeviceLimitQuery({
 *   variables: {
 *      getAllSubscriptionsOverDeviceLimitParams: // value for 'getAllSubscriptionsOverDeviceLimitParams'
 *   },
 * });
 */
export function useGetAllSubscriptionsOverDeviceLimitQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllSubscriptionsOverDeviceLimitQuery,
    GetAllSubscriptionsOverDeviceLimitQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllSubscriptionsOverDeviceLimitQuery, GetAllSubscriptionsOverDeviceLimitQueryVariables>(
    GetAllSubscriptionsOverDeviceLimitDocument,
    options
  )
}
export function useGetAllSubscriptionsOverDeviceLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllSubscriptionsOverDeviceLimitQuery,
    GetAllSubscriptionsOverDeviceLimitQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllSubscriptionsOverDeviceLimitQuery, GetAllSubscriptionsOverDeviceLimitQueryVariables>(
    GetAllSubscriptionsOverDeviceLimitDocument,
    options
  )
}
export type GetAllSubscriptionsOverDeviceLimitQueryHookResult = ReturnType<
  typeof useGetAllSubscriptionsOverDeviceLimitQuery
>
export type GetAllSubscriptionsOverDeviceLimitLazyQueryHookResult = ReturnType<
  typeof useGetAllSubscriptionsOverDeviceLimitLazyQuery
>
export type GetAllSubscriptionsOverDeviceLimitQueryResult = Apollo.QueryResult<
  GetAllSubscriptionsOverDeviceLimitQuery,
  GetAllSubscriptionsOverDeviceLimitQueryVariables
>
export const ToggleDeviceLimitEnforcementDocument = gql`
  mutation toggleDeviceLimitEnforcement($toggleDeviceLimitEnforcementParams: ToggleDeviceLimitEnforcementParams!) {
    toggleDeviceLimitEnforcement(toggleDeviceLimitEnforcementParams: $toggleDeviceLimitEnforcementParams) {
      deviceLimitEnforcementEnabled
    }
  }
`
export type ToggleDeviceLimitEnforcementMutationFn = Apollo.MutationFunction<
  ToggleDeviceLimitEnforcementMutation,
  ToggleDeviceLimitEnforcementMutationVariables
>

/**
 * __useToggleDeviceLimitEnforcementMutation__
 *
 * To run a mutation, you first call `useToggleDeviceLimitEnforcementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDeviceLimitEnforcementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDeviceLimitEnforcementMutation, { data, loading, error }] = useToggleDeviceLimitEnforcementMutation({
 *   variables: {
 *      toggleDeviceLimitEnforcementParams: // value for 'toggleDeviceLimitEnforcementParams'
 *   },
 * });
 */
export function useToggleDeviceLimitEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleDeviceLimitEnforcementMutation,
    ToggleDeviceLimitEnforcementMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ToggleDeviceLimitEnforcementMutation, ToggleDeviceLimitEnforcementMutationVariables>(
    ToggleDeviceLimitEnforcementDocument,
    options
  )
}
export type ToggleDeviceLimitEnforcementMutationHookResult = ReturnType<typeof useToggleDeviceLimitEnforcementMutation>
export type ToggleDeviceLimitEnforcementMutationResult = Apollo.MutationResult<ToggleDeviceLimitEnforcementMutation>
export type ToggleDeviceLimitEnforcementMutationOptions = Apollo.BaseMutationOptions<
  ToggleDeviceLimitEnforcementMutation,
  ToggleDeviceLimitEnforcementMutationVariables
>
export const DismissGuidelinesDocument = gql`
  mutation dismissGuidelines {
    dismissGuidelines
  }
`
export type DismissGuidelinesMutationFn = Apollo.MutationFunction<
  DismissGuidelinesMutation,
  DismissGuidelinesMutationVariables
>

/**
 * __useDismissGuidelinesMutation__
 *
 * To run a mutation, you first call `useDismissGuidelinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissGuidelinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissGuidelinesMutation, { data, loading, error }] = useDismissGuidelinesMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissGuidelinesMutation(
  baseOptions?: Apollo.MutationHookOptions<DismissGuidelinesMutation, DismissGuidelinesMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DismissGuidelinesMutation, DismissGuidelinesMutationVariables>(
    DismissGuidelinesDocument,
    options
  )
}
export type DismissGuidelinesMutationHookResult = ReturnType<typeof useDismissGuidelinesMutation>
export type DismissGuidelinesMutationResult = Apollo.MutationResult<DismissGuidelinesMutation>
export type DismissGuidelinesMutationOptions = Apollo.BaseMutationOptions<
  DismissGuidelinesMutation,
  DismissGuidelinesMutationVariables
>
export const CreateExperimentDocument = gql`
  mutation createExperiment($experimentParams: ExperimentParams!) {
    createExperiment(experimentParams: $experimentParams) {
      id
      description
      targetEnrollmentPct
    }
  }
`
export type CreateExperimentMutationFn = Apollo.MutationFunction<
  CreateExperimentMutation,
  CreateExperimentMutationVariables
>

/**
 * __useCreateExperimentMutation__
 *
 * To run a mutation, you first call `useCreateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExperimentMutation, { data, loading, error }] = useCreateExperimentMutation({
 *   variables: {
 *      experimentParams: // value for 'experimentParams'
 *   },
 * });
 */
export function useCreateExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateExperimentMutation, CreateExperimentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateExperimentMutation, CreateExperimentMutationVariables>(
    CreateExperimentDocument,
    options
  )
}
export type CreateExperimentMutationHookResult = ReturnType<typeof useCreateExperimentMutation>
export type CreateExperimentMutationResult = Apollo.MutationResult<CreateExperimentMutation>
export type CreateExperimentMutationOptions = Apollo.BaseMutationOptions<
  CreateExperimentMutation,
  CreateExperimentMutationVariables
>
export const AssignAllUsersToExperimentsDocument = gql`
  mutation assignAllUsersToExperiments {
    assignAllUsersToExperiments
  }
`
export type AssignAllUsersToExperimentsMutationFn = Apollo.MutationFunction<
  AssignAllUsersToExperimentsMutation,
  AssignAllUsersToExperimentsMutationVariables
>

/**
 * __useAssignAllUsersToExperimentsMutation__
 *
 * To run a mutation, you first call `useAssignAllUsersToExperimentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllUsersToExperimentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllUsersToExperimentsMutation, { data, loading, error }] = useAssignAllUsersToExperimentsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllUsersToExperimentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllUsersToExperimentsMutation,
    AssignAllUsersToExperimentsMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AssignAllUsersToExperimentsMutation, AssignAllUsersToExperimentsMutationVariables>(
    AssignAllUsersToExperimentsDocument,
    options
  )
}
export type AssignAllUsersToExperimentsMutationHookResult = ReturnType<typeof useAssignAllUsersToExperimentsMutation>
export type AssignAllUsersToExperimentsMutationResult = Apollo.MutationResult<AssignAllUsersToExperimentsMutation>
export type AssignAllUsersToExperimentsMutationOptions = Apollo.BaseMutationOptions<
  AssignAllUsersToExperimentsMutation,
  AssignAllUsersToExperimentsMutationVariables
>
export const EditExperimentDocument = gql`
  mutation editExperiment($experimentParams: ExperimentParams!) {
    editExperiment(experimentParams: $experimentParams)
  }
`
export type EditExperimentMutationFn = Apollo.MutationFunction<EditExperimentMutation, EditExperimentMutationVariables>

/**
 * __useEditExperimentMutation__
 *
 * To run a mutation, you first call `useEditExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExperimentMutation, { data, loading, error }] = useEditExperimentMutation({
 *   variables: {
 *      experimentParams: // value for 'experimentParams'
 *   },
 * });
 */
export function useEditExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<EditExperimentMutation, EditExperimentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditExperimentMutation, EditExperimentMutationVariables>(EditExperimentDocument, options)
}
export type EditExperimentMutationHookResult = ReturnType<typeof useEditExperimentMutation>
export type EditExperimentMutationResult = Apollo.MutationResult<EditExperimentMutation>
export type EditExperimentMutationOptions = Apollo.BaseMutationOptions<
  EditExperimentMutation,
  EditExperimentMutationVariables
>
export const DeleteExperimentDocument = gql`
  mutation deleteExperiment($deleteExperimentParams: DeleteExperimentParams!) {
    deleteExperiment(deleteExperimentParams: $deleteExperimentParams)
  }
`
export type DeleteExperimentMutationFn = Apollo.MutationFunction<
  DeleteExperimentMutation,
  DeleteExperimentMutationVariables
>

/**
 * __useDeleteExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperimentMutation, { data, loading, error }] = useDeleteExperimentMutation({
 *   variables: {
 *      deleteExperimentParams: // value for 'deleteExperimentParams'
 *   },
 * });
 */
export function useDeleteExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteExperimentMutation, DeleteExperimentMutationVariables>(
    DeleteExperimentDocument,
    options
  )
}
export type DeleteExperimentMutationHookResult = ReturnType<typeof useDeleteExperimentMutation>
export type DeleteExperimentMutationResult = Apollo.MutationResult<DeleteExperimentMutation>
export type DeleteExperimentMutationOptions = Apollo.BaseMutationOptions<
  DeleteExperimentMutation,
  DeleteExperimentMutationVariables
>
export const GetExperimentEnrollmentOverridesDocument = gql`
  query getExperimentEnrollmentOverrides(
    $experimentEnrollmentOverrideQueryParams: ExperimentEnrollmentOverrideQueryParams!
  ) {
    getExperimentEnrollmentOverrides(
      experimentEnrollmentOverrideQueryParams: $experimentEnrollmentOverrideQueryParams
    ) {
      ...testOverride
    }
  }
  ${TestOverrideFragmentDoc}
`

/**
 * __useGetExperimentEnrollmentOverridesQuery__
 *
 * To run a query within a React component, call `useGetExperimentEnrollmentOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExperimentEnrollmentOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExperimentEnrollmentOverridesQuery({
 *   variables: {
 *      experimentEnrollmentOverrideQueryParams: // value for 'experimentEnrollmentOverrideQueryParams'
 *   },
 * });
 */
export function useGetExperimentEnrollmentOverridesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExperimentEnrollmentOverridesQuery,
    GetExperimentEnrollmentOverridesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetExperimentEnrollmentOverridesQuery, GetExperimentEnrollmentOverridesQueryVariables>(
    GetExperimentEnrollmentOverridesDocument,
    options
  )
}
export function useGetExperimentEnrollmentOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExperimentEnrollmentOverridesQuery,
    GetExperimentEnrollmentOverridesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetExperimentEnrollmentOverridesQuery, GetExperimentEnrollmentOverridesQueryVariables>(
    GetExperimentEnrollmentOverridesDocument,
    options
  )
}
export type GetExperimentEnrollmentOverridesQueryHookResult = ReturnType<
  typeof useGetExperimentEnrollmentOverridesQuery
>
export type GetExperimentEnrollmentOverridesLazyQueryHookResult = ReturnType<
  typeof useGetExperimentEnrollmentOverridesLazyQuery
>
export type GetExperimentEnrollmentOverridesQueryResult = Apollo.QueryResult<
  GetExperimentEnrollmentOverridesQuery,
  GetExperimentEnrollmentOverridesQueryVariables
>
export const RemoveExperimentEnrollmentOverrideDocument = gql`
  mutation removeExperimentEnrollmentOverride(
    $removeExperimentEnrollmentOverrideParams: RemoveExperimentEnrollmentOverrideParams!
  ) {
    removeExperimentEnrollmentOverride(
      removeExperimentEnrollmentOverrideParams: $removeExperimentEnrollmentOverrideParams
    )
  }
`
export type RemoveExperimentEnrollmentOverrideMutationFn = Apollo.MutationFunction<
  RemoveExperimentEnrollmentOverrideMutation,
  RemoveExperimentEnrollmentOverrideMutationVariables
>

/**
 * __useRemoveExperimentEnrollmentOverrideMutation__
 *
 * To run a mutation, you first call `useRemoveExperimentEnrollmentOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExperimentEnrollmentOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExperimentEnrollmentOverrideMutation, { data, loading, error }] = useRemoveExperimentEnrollmentOverrideMutation({
 *   variables: {
 *      removeExperimentEnrollmentOverrideParams: // value for 'removeExperimentEnrollmentOverrideParams'
 *   },
 * });
 */
export function useRemoveExperimentEnrollmentOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveExperimentEnrollmentOverrideMutation,
    RemoveExperimentEnrollmentOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<
    RemoveExperimentEnrollmentOverrideMutation,
    RemoveExperimentEnrollmentOverrideMutationVariables
  >(RemoveExperimentEnrollmentOverrideDocument, options)
}
export type RemoveExperimentEnrollmentOverrideMutationHookResult = ReturnType<
  typeof useRemoveExperimentEnrollmentOverrideMutation
>
export type RemoveExperimentEnrollmentOverrideMutationResult =
  Apollo.MutationResult<RemoveExperimentEnrollmentOverrideMutation>
export type RemoveExperimentEnrollmentOverrideMutationOptions = Apollo.BaseMutationOptions<
  RemoveExperimentEnrollmentOverrideMutation,
  RemoveExperimentEnrollmentOverrideMutationVariables
>
export const UpdateUserExperimentEnrollmentOverrideDocument = gql`
  mutation updateUserExperimentEnrollmentOverride($experimentEnrollmentParams: ExperimentEnrollmentParams!) {
    updateUserExperimentEnrollmentOverride(experimentEnrollmentParams: $experimentEnrollmentParams) {
      ...testOverride
    }
  }
  ${TestOverrideFragmentDoc}
`
export type UpdateUserExperimentEnrollmentOverrideMutationFn = Apollo.MutationFunction<
  UpdateUserExperimentEnrollmentOverrideMutation,
  UpdateUserExperimentEnrollmentOverrideMutationVariables
>

/**
 * __useUpdateUserExperimentEnrollmentOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateUserExperimentEnrollmentOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserExperimentEnrollmentOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserExperimentEnrollmentOverrideMutation, { data, loading, error }] = useUpdateUserExperimentEnrollmentOverrideMutation({
 *   variables: {
 *      experimentEnrollmentParams: // value for 'experimentEnrollmentParams'
 *   },
 * });
 */
export function useUpdateUserExperimentEnrollmentOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserExperimentEnrollmentOverrideMutation,
    UpdateUserExperimentEnrollmentOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<
    UpdateUserExperimentEnrollmentOverrideMutation,
    UpdateUserExperimentEnrollmentOverrideMutationVariables
  >(UpdateUserExperimentEnrollmentOverrideDocument, options)
}
export type UpdateUserExperimentEnrollmentOverrideMutationHookResult = ReturnType<
  typeof useUpdateUserExperimentEnrollmentOverrideMutation
>
export type UpdateUserExperimentEnrollmentOverrideMutationResult =
  Apollo.MutationResult<UpdateUserExperimentEnrollmentOverrideMutation>
export type UpdateUserExperimentEnrollmentOverrideMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserExperimentEnrollmentOverrideMutation,
  UpdateUserExperimentEnrollmentOverrideMutationVariables
>
export const CreateAsrJobDocument = gql`
  mutation createASRJob($createASRJobParams: CreateASRJobParams!) {
    createASRJob(createASRJobParams: $createASRJobParams) {
      success
      errorCode
      job {
        uploadPolicy
        status
        whisperImplementation
        beamSize
        results {
          text
          segments {
            startTime
            endTime
            confidence
            text
            speaker
          }
          speakers {
            id
          }
        }
      }
    }
  }
`
export type CreateAsrJobMutationFn = Apollo.MutationFunction<CreateAsrJobMutation, CreateAsrJobMutationVariables>

/**
 * __useCreateAsrJobMutation__
 *
 * To run a mutation, you first call `useCreateAsrJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAsrJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAsrJobMutation, { data, loading, error }] = useCreateAsrJobMutation({
 *   variables: {
 *      createASRJobParams: // value for 'createASRJobParams'
 *   },
 * });
 */
export function useCreateAsrJobMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAsrJobMutation, CreateAsrJobMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateAsrJobMutation, CreateAsrJobMutationVariables>(CreateAsrJobDocument, options)
}
export type CreateAsrJobMutationHookResult = ReturnType<typeof useCreateAsrJobMutation>
export type CreateAsrJobMutationResult = Apollo.MutationResult<CreateAsrJobMutation>
export type CreateAsrJobMutationOptions = Apollo.BaseMutationOptions<
  CreateAsrJobMutation,
  CreateAsrJobMutationVariables
>
export const ReprocessAsrJobDocument = gql`
  mutation reprocessASRJob($reprocessASRJobParams: ReprocessASRJobParams!) {
    reprocessASRJob(reprocessASRJobParams: $reprocessASRJobParams) {
      success
      errorCode
      job {
        uploadPolicy
        status
        results {
          text
          segments {
            startTime
            endTime
            confidence
            text
          }
        }
      }
    }
  }
`
export type ReprocessAsrJobMutationFn = Apollo.MutationFunction<
  ReprocessAsrJobMutation,
  ReprocessAsrJobMutationVariables
>

/**
 * __useReprocessAsrJobMutation__
 *
 * To run a mutation, you first call `useReprocessAsrJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessAsrJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessAsrJobMutation, { data, loading, error }] = useReprocessAsrJobMutation({
 *   variables: {
 *      reprocessASRJobParams: // value for 'reprocessASRJobParams'
 *   },
 * });
 */
export function useReprocessAsrJobMutation(
  baseOptions?: Apollo.MutationHookOptions<ReprocessAsrJobMutation, ReprocessAsrJobMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReprocessAsrJobMutation, ReprocessAsrJobMutationVariables>(ReprocessAsrJobDocument, options)
}
export type ReprocessAsrJobMutationHookResult = ReturnType<typeof useReprocessAsrJobMutation>
export type ReprocessAsrJobMutationResult = Apollo.MutationResult<ReprocessAsrJobMutation>
export type ReprocessAsrJobMutationOptions = Apollo.BaseMutationOptions<
  ReprocessAsrJobMutation,
  ReprocessAsrJobMutationVariables
>
export const GetCurrentAsrProcessorVersionDocument = gql`
  query getCurrentASRProcessorVersion {
    getCurrentASRProcessorVersion {
      processorVersion
    }
  }
`

/**
 * __useGetCurrentAsrProcessorVersionQuery__
 *
 * To run a query within a React component, call `useGetCurrentAsrProcessorVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAsrProcessorVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAsrProcessorVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAsrProcessorVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCurrentAsrProcessorVersionQuery, GetCurrentAsrProcessorVersionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetCurrentAsrProcessorVersionQuery, GetCurrentAsrProcessorVersionQueryVariables>(
    GetCurrentAsrProcessorVersionDocument,
    options
  )
}
export function useGetCurrentAsrProcessorVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentAsrProcessorVersionQuery,
    GetCurrentAsrProcessorVersionQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetCurrentAsrProcessorVersionQuery, GetCurrentAsrProcessorVersionQueryVariables>(
    GetCurrentAsrProcessorVersionDocument,
    options
  )
}
export type GetCurrentAsrProcessorVersionQueryHookResult = ReturnType<typeof useGetCurrentAsrProcessorVersionQuery>
export type GetCurrentAsrProcessorVersionLazyQueryHookResult = ReturnType<
  typeof useGetCurrentAsrProcessorVersionLazyQuery
>
export type GetCurrentAsrProcessorVersionQueryResult = Apollo.QueryResult<
  GetCurrentAsrProcessorVersionQuery,
  GetCurrentAsrProcessorVersionQueryVariables
>
export const GetAsrJobDocument = gql`
  query getASRJob($getASRJobParams: GetASRJobParams!) {
    getASRJob(getASRJobParams: $getASRJobParams) {
      success
      errorCode
      job {
        sha512Hash
        audioDurationMs
        status
        whisperImplementation
        beamSize
        results {
          text
          segments {
            startTime
            endTime
            confidence
            text
            speaker
          }
          speakers {
            id
          }
        }
        quizJobs {
          id
          status
          errorReason
        }
        summaryJobs {
          id
          status
          errorReason
        }
      }
    }
  }
`

/**
 * __useGetAsrJobQuery__
 *
 * To run a query within a React component, call `useGetAsrJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsrJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsrJobQuery({
 *   variables: {
 *      getASRJobParams: // value for 'getASRJobParams'
 *   },
 * });
 */
export function useGetAsrJobQuery(baseOptions: Apollo.QueryHookOptions<GetAsrJobQuery, GetAsrJobQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAsrJobQuery, GetAsrJobQueryVariables>(GetAsrJobDocument, options)
}
export function useGetAsrJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAsrJobQuery, GetAsrJobQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAsrJobQuery, GetAsrJobQueryVariables>(GetAsrJobDocument, options)
}
export type GetAsrJobQueryHookResult = ReturnType<typeof useGetAsrJobQuery>
export type GetAsrJobLazyQueryHookResult = ReturnType<typeof useGetAsrJobLazyQuery>
export type GetAsrJobQueryResult = Apollo.QueryResult<GetAsrJobQuery, GetAsrJobQueryVariables>
export const GetAsrJobMetaDocument = gql`
  query getASRJobMeta($getASRJobParams: GetASRJobParams!) {
    getASRJob(getASRJobParams: $getASRJobParams) {
      success
      errorCode
      job {
        sha512Hash
        audioDurationMs
        status
        whisperImplementation
        beamSize
        audioCreationDate
        language
        quizJobs {
          id
          status
          errorReason
        }
        summaryJobs {
          id
          status
          errorReason
        }
      }
    }
  }
`

/**
 * __useGetAsrJobMetaQuery__
 *
 * To run a query within a React component, call `useGetAsrJobMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsrJobMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsrJobMetaQuery({
 *   variables: {
 *      getASRJobParams: // value for 'getASRJobParams'
 *   },
 * });
 */
export function useGetAsrJobMetaQuery(
  baseOptions: Apollo.QueryHookOptions<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>(GetAsrJobMetaDocument, options)
}
export function useGetAsrJobMetaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>(GetAsrJobMetaDocument, options)
}
export type GetAsrJobMetaQueryHookResult = ReturnType<typeof useGetAsrJobMetaQuery>
export type GetAsrJobMetaLazyQueryHookResult = ReturnType<typeof useGetAsrJobMetaLazyQuery>
export type GetAsrJobMetaQueryResult = Apollo.QueryResult<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>
export const GetUserSharedNotesDocument = gql`
  query getUserSharedNotes($getUserSharedNotesParams: GetUserSharedNotesParams!) {
    getUserSharedNotes(getUserSharedNotesParams: $getUserSharedNotesParams) {
      name
      createdDate
      id
    }
  }
`

/**
 * __useGetUserSharedNotesQuery__
 *
 * To run a query within a React component, call `useGetUserSharedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSharedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSharedNotesQuery({
 *   variables: {
 *      getUserSharedNotesParams: // value for 'getUserSharedNotesParams'
 *   },
 * });
 */
export function useGetUserSharedNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>(GetUserSharedNotesDocument, options)
}
export function useGetUserSharedNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>(
    GetUserSharedNotesDocument,
    options
  )
}
export type GetUserSharedNotesQueryHookResult = ReturnType<typeof useGetUserSharedNotesQuery>
export type GetUserSharedNotesLazyQueryHookResult = ReturnType<typeof useGetUserSharedNotesLazyQuery>
export type GetUserSharedNotesQueryResult = Apollo.QueryResult<
  GetUserSharedNotesQuery,
  GetUserSharedNotesQueryVariables
>
export const SetIgnoreFlagsDocument = gql`
  mutation setIgnoreFlags($setIgnoreFlagsParams: SetIgnoreFlagsParams!) {
    setIgnoreFlags(setIgnoreFlagsParams: $setIgnoreFlagsParams) {
      id
      ignoreFlagging
    }
  }
`
export type SetIgnoreFlagsMutationFn = Apollo.MutationFunction<SetIgnoreFlagsMutation, SetIgnoreFlagsMutationVariables>

/**
 * __useSetIgnoreFlagsMutation__
 *
 * To run a mutation, you first call `useSetIgnoreFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIgnoreFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIgnoreFlagsMutation, { data, loading, error }] = useSetIgnoreFlagsMutation({
 *   variables: {
 *      setIgnoreFlagsParams: // value for 'setIgnoreFlagsParams'
 *   },
 * });
 */
export function useSetIgnoreFlagsMutation(
  baseOptions?: Apollo.MutationHookOptions<SetIgnoreFlagsMutation, SetIgnoreFlagsMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetIgnoreFlagsMutation, SetIgnoreFlagsMutationVariables>(SetIgnoreFlagsDocument, options)
}
export type SetIgnoreFlagsMutationHookResult = ReturnType<typeof useSetIgnoreFlagsMutation>
export type SetIgnoreFlagsMutationResult = Apollo.MutationResult<SetIgnoreFlagsMutation>
export type SetIgnoreFlagsMutationOptions = Apollo.BaseMutationOptions<
  SetIgnoreFlagsMutation,
  SetIgnoreFlagsMutationVariables
>
export const UpdateUserLanguageDocument = gql`
  mutation updateUserLanguage($updateUserLanguageParams: UpdateUserLanguageParams!) {
    updateUserLanguage(updateUserLanguageParams: $updateUserLanguageParams)
  }
`
export type UpdateUserLanguageMutationFn = Apollo.MutationFunction<
  UpdateUserLanguageMutation,
  UpdateUserLanguageMutationVariables
>

/**
 * __useUpdateUserLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateUserLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLanguageMutation, { data, loading, error }] = useUpdateUserLanguageMutation({
 *   variables: {
 *      updateUserLanguageParams: // value for 'updateUserLanguageParams'
 *   },
 * });
 */
export function useUpdateUserLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(
    UpdateUserLanguageDocument,
    options
  )
}
export type UpdateUserLanguageMutationHookResult = ReturnType<typeof useUpdateUserLanguageMutation>
export type UpdateUserLanguageMutationResult = Apollo.MutationResult<UpdateUserLanguageMutation>
export type UpdateUserLanguageMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserLanguageMutation,
  UpdateUserLanguageMutationVariables
>
export const GetAllSubscriptionInfoDocument = gql`
  query getAllSubscriptionInfo($getAllSubscriptionInfoParams: GetAllSubscriptionInfoParams!) {
    getAllSubscriptionInfo(getAllSubscriptionInfoParams: $getAllSubscriptionInfoParams) {
      bestSubscription {
        user {
          id
          profile {
            screenname
          }
        }
        devices {
          id
          deviceId
          countryCode
          latestReceiptAt
          deactivatedAt
          createdAt
          updatedAt
        }
        deviceLimitEnforcementEnabled
        originalTransactionId
        originalPurchaseDate
        productId
        expirationDate
        gracePeriodExpiresAt
        expirationIntent
        status
        isTrialPeriod
        isInIntroOfferPeriod
        isInBillingRetryPeriod
        promotionalOfferId
        offerCodeRefName
        refundedDate
        refundedReason
        tier
      }
      subscriptions {
        deviceLimitEnforcementEnabled
        originalTransactionId
        originalPurchaseDate
        productId
        expirationDate
        gracePeriodExpiresAt
        expirationIntent
        status
        isTrialPeriod
        isInIntroOfferPeriod
        isInBillingRetryPeriod
        promotionalOfferId
        offerCodeRefName
        refundedDate
        refundedReason
        tier
      }
      devices {
        id
        deviceId
        countryCode
        latestReceiptAt
        deactivatedAt
        createdAt
        updatedAt
      }
      users {
        id
        email
        profile {
          screenname
        }
      }
      overrides {
        id
        createdAt
        expirationDate
        overrideTier
        overrideReason
        createdBy {
          id
          email
        }
      }
      classicStatuses {
        id
        deviceId
        originalApplicationVersion
        originalPurchaseDate
        likelyFraud
        createdAt
        updatedAt
      }
      receipts {
        id
        parsedReceipt
        deviceId
        environment
        isValid
        originalTransactionId
        receipt
        receiptCreationDate
        updatedAt
      }
    }
  }
`

/**
 * __useGetAllSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useGetAllSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubscriptionInfoQuery({
 *   variables: {
 *      getAllSubscriptionInfoParams: // value for 'getAllSubscriptionInfoParams'
 *   },
 * });
 */
export function useGetAllSubscriptionInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>(
    GetAllSubscriptionInfoDocument,
    options
  )
}
export function useGetAllSubscriptionInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>(
    GetAllSubscriptionInfoDocument,
    options
  )
}
export type GetAllSubscriptionInfoQueryHookResult = ReturnType<typeof useGetAllSubscriptionInfoQuery>
export type GetAllSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useGetAllSubscriptionInfoLazyQuery>
export type GetAllSubscriptionInfoQueryResult = Apollo.QueryResult<
  GetAllSubscriptionInfoQuery,
  GetAllSubscriptionInfoQueryVariables
>
export const GetCollatedFlaggedNoteInfoDocument = gql`
  query getCollatedFlaggedNoteInfo($getCollatedFlaggedNoteInfoParams: GetCollatedFlaggedNoteInfoParams!) {
    getCollatedFlaggedNoteInfo(getCollatedFlaggedNoteInfoParams: $getCollatedFlaggedNoteInfoParams) {
      flaggingUser {
        id
        email
        profile {
          screenname
          ignoreFlagging
        }
      }
      flaggedNotes {
        id
        name
      }
    }
  }
`

/**
 * __useGetCollatedFlaggedNoteInfoQuery__
 *
 * To run a query within a React component, call `useGetCollatedFlaggedNoteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollatedFlaggedNoteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollatedFlaggedNoteInfoQuery({
 *   variables: {
 *      getCollatedFlaggedNoteInfoParams: // value for 'getCollatedFlaggedNoteInfoParams'
 *   },
 * });
 */
export function useGetCollatedFlaggedNoteInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>(
    GetCollatedFlaggedNoteInfoDocument,
    options
  )
}
export function useGetCollatedFlaggedNoteInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>(
    GetCollatedFlaggedNoteInfoDocument,
    options
  )
}
export type GetCollatedFlaggedNoteInfoQueryHookResult = ReturnType<typeof useGetCollatedFlaggedNoteInfoQuery>
export type GetCollatedFlaggedNoteInfoLazyQueryHookResult = ReturnType<typeof useGetCollatedFlaggedNoteInfoLazyQuery>
export type GetCollatedFlaggedNoteInfoQueryResult = Apollo.QueryResult<
  GetCollatedFlaggedNoteInfoQuery,
  GetCollatedFlaggedNoteInfoQueryVariables
>
export const ComputeTopTagsDocument = gql`
  mutation computeTopTags {
    computeTopTags
  }
`
export type ComputeTopTagsMutationFn = Apollo.MutationFunction<ComputeTopTagsMutation, ComputeTopTagsMutationVariables>

/**
 * __useComputeTopTagsMutation__
 *
 * To run a mutation, you first call `useComputeTopTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeTopTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeTopTagsMutation, { data, loading, error }] = useComputeTopTagsMutation({
 *   variables: {
 *   },
 * });
 */
export function useComputeTopTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<ComputeTopTagsMutation, ComputeTopTagsMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ComputeTopTagsMutation, ComputeTopTagsMutationVariables>(ComputeTopTagsDocument, options)
}
export type ComputeTopTagsMutationHookResult = ReturnType<typeof useComputeTopTagsMutation>
export type ComputeTopTagsMutationResult = Apollo.MutationResult<ComputeTopTagsMutation>
export type ComputeTopTagsMutationOptions = Apollo.BaseMutationOptions<
  ComputeTopTagsMutation,
  ComputeTopTagsMutationVariables
>
export const SetGlobalOverrideValueDocument = gql`
  mutation setGlobalOverrideValue($setGlobalOverrideValueParams: SetGlobalOverrideValueParams!) {
    setGlobalOverrideValue(setGlobalOverrideValueParams: $setGlobalOverrideValueParams)
  }
`
export type SetGlobalOverrideValueMutationFn = Apollo.MutationFunction<
  SetGlobalOverrideValueMutation,
  SetGlobalOverrideValueMutationVariables
>

/**
 * __useSetGlobalOverrideValueMutation__
 *
 * To run a mutation, you first call `useSetGlobalOverrideValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalOverrideValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalOverrideValueMutation, { data, loading, error }] = useSetGlobalOverrideValueMutation({
 *   variables: {
 *      setGlobalOverrideValueParams: // value for 'setGlobalOverrideValueParams'
 *   },
 * });
 */
export function useSetGlobalOverrideValueMutation(
  baseOptions?: Apollo.MutationHookOptions<SetGlobalOverrideValueMutation, SetGlobalOverrideValueMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetGlobalOverrideValueMutation, SetGlobalOverrideValueMutationVariables>(
    SetGlobalOverrideValueDocument,
    options
  )
}
export type SetGlobalOverrideValueMutationHookResult = ReturnType<typeof useSetGlobalOverrideValueMutation>
export type SetGlobalOverrideValueMutationResult = Apollo.MutationResult<SetGlobalOverrideValueMutation>
export type SetGlobalOverrideValueMutationOptions = Apollo.BaseMutationOptions<
  SetGlobalOverrideValueMutation,
  SetGlobalOverrideValueMutationVariables
>
export const DeleteGlobalOverrideValueDocument = gql`
  mutation deleteGlobalOverrideValue($deleteGlobalOverrideValueParams: DeleteGlobalOverrideValueParams!) {
    deleteGlobalOverrideValue(deleteGlobalOverrideValueParams: $deleteGlobalOverrideValueParams)
  }
`
export type DeleteGlobalOverrideValueMutationFn = Apollo.MutationFunction<
  DeleteGlobalOverrideValueMutation,
  DeleteGlobalOverrideValueMutationVariables
>

/**
 * __useDeleteGlobalOverrideValueMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalOverrideValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalOverrideValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalOverrideValueMutation, { data, loading, error }] = useDeleteGlobalOverrideValueMutation({
 *   variables: {
 *      deleteGlobalOverrideValueParams: // value for 'deleteGlobalOverrideValueParams'
 *   },
 * });
 */
export function useDeleteGlobalOverrideValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGlobalOverrideValueMutation,
    DeleteGlobalOverrideValueMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteGlobalOverrideValueMutation, DeleteGlobalOverrideValueMutationVariables>(
    DeleteGlobalOverrideValueDocument,
    options
  )
}
export type DeleteGlobalOverrideValueMutationHookResult = ReturnType<typeof useDeleteGlobalOverrideValueMutation>
export type DeleteGlobalOverrideValueMutationResult = Apollo.MutationResult<DeleteGlobalOverrideValueMutation>
export type DeleteGlobalOverrideValueMutationOptions = Apollo.BaseMutationOptions<
  DeleteGlobalOverrideValueMutation,
  DeleteGlobalOverrideValueMutationVariables
>
export const AdminSimulateQuotaDocument = gql`
  mutation adminSimulateQuota($simulateASRQuotaParams: SimulateASRQuotaParams!) {
    adminSimulateQuota(simulateASRQuotaParams: $simulateASRQuotaParams)
  }
`
export type AdminSimulateQuotaMutationFn = Apollo.MutationFunction<
  AdminSimulateQuotaMutation,
  AdminSimulateQuotaMutationVariables
>

/**
 * __useAdminSimulateQuotaMutation__
 *
 * To run a mutation, you first call `useAdminSimulateQuotaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSimulateQuotaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSimulateQuotaMutation, { data, loading, error }] = useAdminSimulateQuotaMutation({
 *   variables: {
 *      simulateASRQuotaParams: // value for 'simulateASRQuotaParams'
 *   },
 * });
 */
export function useAdminSimulateQuotaMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminSimulateQuotaMutation, AdminSimulateQuotaMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AdminSimulateQuotaMutation, AdminSimulateQuotaMutationVariables>(
    AdminSimulateQuotaDocument,
    options
  )
}
export type AdminSimulateQuotaMutationHookResult = ReturnType<typeof useAdminSimulateQuotaMutation>
export type AdminSimulateQuotaMutationResult = Apollo.MutationResult<AdminSimulateQuotaMutation>
export type AdminSimulateQuotaMutationOptions = Apollo.BaseMutationOptions<
  AdminSimulateQuotaMutation,
  AdminSimulateQuotaMutationVariables
>
export const GetCurrentQuotaUsageDocument = gql`
  query getCurrentQuotaUsage($getCurrentQuotaUsageParams: GetCurrentQuotaUsageParams!) {
    getCurrentQuotaUsage(getCurrentQuotaUsageParams: $getCurrentQuotaUsageParams) {
      exceeded
      quotaUsage
      retryAfter
    }
  }
`

/**
 * __useGetCurrentQuotaUsageQuery__
 *
 * To run a query within a React component, call `useGetCurrentQuotaUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentQuotaUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentQuotaUsageQuery({
 *   variables: {
 *      getCurrentQuotaUsageParams: // value for 'getCurrentQuotaUsageParams'
 *   },
 * });
 */
export function useGetCurrentQuotaUsageQuery(
  baseOptions: Apollo.QueryHookOptions<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>(
    GetCurrentQuotaUsageDocument,
    options
  )
}
export function useGetCurrentQuotaUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>(
    GetCurrentQuotaUsageDocument,
    options
  )
}
export type GetCurrentQuotaUsageQueryHookResult = ReturnType<typeof useGetCurrentQuotaUsageQuery>
export type GetCurrentQuotaUsageLazyQueryHookResult = ReturnType<typeof useGetCurrentQuotaUsageLazyQuery>
export type GetCurrentQuotaUsageQueryResult = Apollo.QueryResult<
  GetCurrentQuotaUsageQuery,
  GetCurrentQuotaUsageQueryVariables
>
export const GetAllOrganizationsDocument = gql`
  query getAllOrganizations($getAllOrganizationsParams: GetAllOrganizationsParams!) {
    getAllOrganizations(getAllOrganizationsParams: $getAllOrganizationsParams) {
      organizations {
        ...organizationDetails
      }
      organizationCount
    }
  }
  ${OrganizationDetailsFragmentDoc}
`

/**
 * __useGetAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationsQuery({
 *   variables: {
 *      getAllOrganizationsParams: // value for 'getAllOrganizationsParams'
 *   },
 * });
 */
export function useGetAllOrganizationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(
    GetAllOrganizationsDocument,
    options
  )
}
export function useGetAllOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(
    GetAllOrganizationsDocument,
    options
  )
}
export type GetAllOrganizationsQueryHookResult = ReturnType<typeof useGetAllOrganizationsQuery>
export type GetAllOrganizationsLazyQueryHookResult = ReturnType<typeof useGetAllOrganizationsLazyQuery>
export type GetAllOrganizationsQueryResult = Apollo.QueryResult<
  GetAllOrganizationsQuery,
  GetAllOrganizationsQueryVariables
>
export const GetAllBusinessesDocument = gql`
  query getAllBusinesses($getAllBusinessesParams: GetAllBusinessesParams!) {
    getAllBusinesses(getAllBusinessesParams: $getAllBusinessesParams) {
      businessCount
      businesses {
        business {
          id
          name
          industry
          createdAt
        }
        admin {
          user {
            id
            name
            email
          }
        }
        subscription {
          id
          status
          tier
          stripeSubscriptionId
          memberLimit
        }
        memberCount
        sharedLibraryCount
        isEmpty
      }
    }
  }
`

/**
 * __useGetAllBusinessesQuery__
 *
 * To run a query within a React component, call `useGetAllBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBusinessesQuery({
 *   variables: {
 *      getAllBusinessesParams: // value for 'getAllBusinessesParams'
 *   },
 * });
 */
export function useGetAllBusinessesQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllBusinessesQuery, GetAllBusinessesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllBusinessesQuery, GetAllBusinessesQueryVariables>(GetAllBusinessesDocument, options)
}
export function useGetAllBusinessesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllBusinessesQuery, GetAllBusinessesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllBusinessesQuery, GetAllBusinessesQueryVariables>(GetAllBusinessesDocument, options)
}
export type GetAllBusinessesQueryHookResult = ReturnType<typeof useGetAllBusinessesQuery>
export type GetAllBusinessesLazyQueryHookResult = ReturnType<typeof useGetAllBusinessesLazyQuery>
export type GetAllBusinessesQueryResult = Apollo.QueryResult<GetAllBusinessesQuery, GetAllBusinessesQueryVariables>
export const UpdateBusinessTrialMemberLimitDocument = gql`
  mutation updateBusinessTrialMemberLimit(
    $updateBusinessTrialMemberLimitParams: UpdateBusinessTrialMemberLimitParams!
  ) {
    updateBusinessTrialMemberLimit(updateBusinessTrialMemberLimitParams: $updateBusinessTrialMemberLimitParams) {
      id
      memberLimit
    }
  }
`
export type UpdateBusinessTrialMemberLimitMutationFn = Apollo.MutationFunction<
  UpdateBusinessTrialMemberLimitMutation,
  UpdateBusinessTrialMemberLimitMutationVariables
>

/**
 * __useUpdateBusinessTrialMemberLimitMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessTrialMemberLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessTrialMemberLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessTrialMemberLimitMutation, { data, loading, error }] = useUpdateBusinessTrialMemberLimitMutation({
 *   variables: {
 *      updateBusinessTrialMemberLimitParams: // value for 'updateBusinessTrialMemberLimitParams'
 *   },
 * });
 */
export function useUpdateBusinessTrialMemberLimitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBusinessTrialMemberLimitMutation,
    UpdateBusinessTrialMemberLimitMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateBusinessTrialMemberLimitMutation, UpdateBusinessTrialMemberLimitMutationVariables>(
    UpdateBusinessTrialMemberLimitDocument,
    options
  )
}
export type UpdateBusinessTrialMemberLimitMutationHookResult = ReturnType<
  typeof useUpdateBusinessTrialMemberLimitMutation
>
export type UpdateBusinessTrialMemberLimitMutationResult = Apollo.MutationResult<UpdateBusinessTrialMemberLimitMutation>
export type UpdateBusinessTrialMemberLimitMutationOptions = Apollo.BaseMutationOptions<
  UpdateBusinessTrialMemberLimitMutation,
  UpdateBusinessTrialMemberLimitMutationVariables
>
export const GetOrganizationsAwaitingApprovalDocument = gql`
  query getOrganizationsAwaitingApproval {
    getOrganizationsAwaitingApproval {
      ...organization
    }
  }
  ${OrganizationFragmentDoc}
`

/**
 * __useGetOrganizationsAwaitingApprovalQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsAwaitingApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsAwaitingApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsAwaitingApprovalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsAwaitingApprovalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationsAwaitingApprovalQuery,
    GetOrganizationsAwaitingApprovalQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOrganizationsAwaitingApprovalQuery, GetOrganizationsAwaitingApprovalQueryVariables>(
    GetOrganizationsAwaitingApprovalDocument,
    options
  )
}
export function useGetOrganizationsAwaitingApprovalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationsAwaitingApprovalQuery,
    GetOrganizationsAwaitingApprovalQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOrganizationsAwaitingApprovalQuery, GetOrganizationsAwaitingApprovalQueryVariables>(
    GetOrganizationsAwaitingApprovalDocument,
    options
  )
}
export type GetOrganizationsAwaitingApprovalQueryHookResult = ReturnType<
  typeof useGetOrganizationsAwaitingApprovalQuery
>
export type GetOrganizationsAwaitingApprovalLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationsAwaitingApprovalLazyQuery
>
export type GetOrganizationsAwaitingApprovalQueryResult = Apollo.QueryResult<
  GetOrganizationsAwaitingApprovalQuery,
  GetOrganizationsAwaitingApprovalQueryVariables
>
export const ReviewOrganizationDocument = gql`
  mutation reviewOrganization($reviewOrganizationParams: ReviewOrganizationParams!) {
    reviewOrganization(reviewOrganizationParams: $reviewOrganizationParams)
  }
`
export type ReviewOrganizationMutationFn = Apollo.MutationFunction<
  ReviewOrganizationMutation,
  ReviewOrganizationMutationVariables
>

/**
 * __useReviewOrganizationMutation__
 *
 * To run a mutation, you first call `useReviewOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOrganizationMutation, { data, loading, error }] = useReviewOrganizationMutation({
 *   variables: {
 *      reviewOrganizationParams: // value for 'reviewOrganizationParams'
 *   },
 * });
 */
export function useReviewOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewOrganizationMutation, ReviewOrganizationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReviewOrganizationMutation, ReviewOrganizationMutationVariables>(
    ReviewOrganizationDocument,
    options
  )
}
export type ReviewOrganizationMutationHookResult = ReturnType<typeof useReviewOrganizationMutation>
export type ReviewOrganizationMutationResult = Apollo.MutationResult<ReviewOrganizationMutation>
export type ReviewOrganizationMutationOptions = Apollo.BaseMutationOptions<
  ReviewOrganizationMutation,
  ReviewOrganizationMutationVariables
>
export const PendingBusinessDomainsDocument = gql`
  query pendingBusinessDomains {
    pendingBusinessDomains {
      ...pendingBusinessDomain
    }
  }
  ${PendingBusinessDomainFragmentDoc}
`

/**
 * __usePendingBusinessDomainsQuery__
 *
 * To run a query within a React component, call `usePendingBusinessDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingBusinessDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingBusinessDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingBusinessDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<PendingBusinessDomainsQuery, PendingBusinessDomainsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PendingBusinessDomainsQuery, PendingBusinessDomainsQueryVariables>(
    PendingBusinessDomainsDocument,
    options
  )
}
export function usePendingBusinessDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PendingBusinessDomainsQuery, PendingBusinessDomainsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PendingBusinessDomainsQuery, PendingBusinessDomainsQueryVariables>(
    PendingBusinessDomainsDocument,
    options
  )
}
export type PendingBusinessDomainsQueryHookResult = ReturnType<typeof usePendingBusinessDomainsQuery>
export type PendingBusinessDomainsLazyQueryHookResult = ReturnType<typeof usePendingBusinessDomainsLazyQuery>
export type PendingBusinessDomainsQueryResult = Apollo.QueryResult<
  PendingBusinessDomainsQuery,
  PendingBusinessDomainsQueryVariables
>
export const ReviewBusinessDomainDocument = gql`
  mutation reviewBusinessDomain($reviewBusinessDomainParams: ReviewBusinessDomainParams!) {
    reviewBusinessDomain(reviewBusinessDomainParams: $reviewBusinessDomainParams)
  }
`
export type ReviewBusinessDomainMutationFn = Apollo.MutationFunction<
  ReviewBusinessDomainMutation,
  ReviewBusinessDomainMutationVariables
>

/**
 * __useReviewBusinessDomainMutation__
 *
 * To run a mutation, you first call `useReviewBusinessDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewBusinessDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewBusinessDomainMutation, { data, loading, error }] = useReviewBusinessDomainMutation({
 *   variables: {
 *      reviewBusinessDomainParams: // value for 'reviewBusinessDomainParams'
 *   },
 * });
 */
export function useReviewBusinessDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewBusinessDomainMutation, ReviewBusinessDomainMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReviewBusinessDomainMutation, ReviewBusinessDomainMutationVariables>(
    ReviewBusinessDomainDocument,
    options
  )
}
export type ReviewBusinessDomainMutationHookResult = ReturnType<typeof useReviewBusinessDomainMutation>
export type ReviewBusinessDomainMutationResult = Apollo.MutationResult<ReviewBusinessDomainMutation>
export type ReviewBusinessDomainMutationOptions = Apollo.BaseMutationOptions<
  ReviewBusinessDomainMutation,
  ReviewBusinessDomainMutationVariables
>
export const ApprovedBusinessDomainsDocument = gql`
  query approvedBusinessDomains {
    approvedBusinessDomains {
      ...approvedBusinessDomain
    }
  }
  ${ApprovedBusinessDomainFragmentDoc}
`

/**
 * __useApprovedBusinessDomainsQuery__
 *
 * To run a query within a React component, call `useApprovedBusinessDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovedBusinessDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovedBusinessDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovedBusinessDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<ApprovedBusinessDomainsQuery, ApprovedBusinessDomainsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ApprovedBusinessDomainsQuery, ApprovedBusinessDomainsQueryVariables>(
    ApprovedBusinessDomainsDocument,
    options
  )
}
export function useApprovedBusinessDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApprovedBusinessDomainsQuery, ApprovedBusinessDomainsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<ApprovedBusinessDomainsQuery, ApprovedBusinessDomainsQueryVariables>(
    ApprovedBusinessDomainsDocument,
    options
  )
}
export type ApprovedBusinessDomainsQueryHookResult = ReturnType<typeof useApprovedBusinessDomainsQuery>
export type ApprovedBusinessDomainsLazyQueryHookResult = ReturnType<typeof useApprovedBusinessDomainsLazyQuery>
export type ApprovedBusinessDomainsQueryResult = Apollo.QueryResult<
  ApprovedBusinessDomainsQuery,
  ApprovedBusinessDomainsQueryVariables
>
export const DeleteBusinessDomainDocument = gql`
  mutation deleteBusinessDomain($domainId: ID!) {
    deleteBusinessDomain(domainId: $domainId)
  }
`
export type DeleteBusinessDomainMutationFn = Apollo.MutationFunction<
  DeleteBusinessDomainMutation,
  DeleteBusinessDomainMutationVariables
>

/**
 * __useDeleteBusinessDomainMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessDomainMutation, { data, loading, error }] = useDeleteBusinessDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDeleteBusinessDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteBusinessDomainMutation, DeleteBusinessDomainMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteBusinessDomainMutation, DeleteBusinessDomainMutationVariables>(
    DeleteBusinessDomainDocument,
    options
  )
}
export type DeleteBusinessDomainMutationHookResult = ReturnType<typeof useDeleteBusinessDomainMutation>
export type DeleteBusinessDomainMutationResult = Apollo.MutationResult<DeleteBusinessDomainMutation>
export type DeleteBusinessDomainMutationOptions = Apollo.BaseMutationOptions<
  DeleteBusinessDomainMutation,
  DeleteBusinessDomainMutationVariables
>
export const RestoreOrganizationDocument = gql`
  mutation restoreOrganization($restoreOrganizationParams: RestoreOrganizationParams!) {
    restoreOrganization(restoreOrganizationParams: $restoreOrganizationParams)
  }
`
export type RestoreOrganizationMutationFn = Apollo.MutationFunction<
  RestoreOrganizationMutation,
  RestoreOrganizationMutationVariables
>

/**
 * __useRestoreOrganizationMutation__
 *
 * To run a mutation, you first call `useRestoreOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrganizationMutation, { data, loading, error }] = useRestoreOrganizationMutation({
 *   variables: {
 *      restoreOrganizationParams: // value for 'restoreOrganizationParams'
 *   },
 * });
 */
export function useRestoreOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>(
    RestoreOrganizationDocument,
    options
  )
}
export type RestoreOrganizationMutationHookResult = ReturnType<typeof useRestoreOrganizationMutation>
export type RestoreOrganizationMutationResult = Apollo.MutationResult<RestoreOrganizationMutation>
export type RestoreOrganizationMutationOptions = Apollo.BaseMutationOptions<
  RestoreOrganizationMutation,
  RestoreOrganizationMutationVariables
>
export const AdminSearchNoteWithTitleDocument = gql`
  query adminSearchNoteWithTitle($adminSearchNoteWithTitleParams: AdminSearchNoteWithTitleParams!) {
    adminSearchNoteWithTitle(adminSearchNoteWithTitleParams: $adminSearchNoteWithTitleParams) {
      notes {
        id
        title
        deletedAt
        permanentlyDeletedAt
        createdAt
        updatedAt
        legacyNoteId
        ownerId
        workspaceId
      }
    }
  }
`

/**
 * __useAdminSearchNoteWithTitleQuery__
 *
 * To run a query within a React component, call `useAdminSearchNoteWithTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchNoteWithTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchNoteWithTitleQuery({
 *   variables: {
 *      adminSearchNoteWithTitleParams: // value for 'adminSearchNoteWithTitleParams'
 *   },
 * });
 */
export function useAdminSearchNoteWithTitleQuery(
  baseOptions: Apollo.QueryHookOptions<AdminSearchNoteWithTitleQuery, AdminSearchNoteWithTitleQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminSearchNoteWithTitleQuery, AdminSearchNoteWithTitleQueryVariables>(
    AdminSearchNoteWithTitleDocument,
    options
  )
}
export function useAdminSearchNoteWithTitleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchNoteWithTitleQuery, AdminSearchNoteWithTitleQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminSearchNoteWithTitleQuery, AdminSearchNoteWithTitleQueryVariables>(
    AdminSearchNoteWithTitleDocument,
    options
  )
}
export type AdminSearchNoteWithTitleQueryHookResult = ReturnType<typeof useAdminSearchNoteWithTitleQuery>
export type AdminSearchNoteWithTitleLazyQueryHookResult = ReturnType<typeof useAdminSearchNoteWithTitleLazyQuery>
export type AdminSearchNoteWithTitleQueryResult = Apollo.QueryResult<
  AdminSearchNoteWithTitleQuery,
  AdminSearchNoteWithTitleQueryVariables
>
export const RenameUserDocument = gql`
  mutation renameUser($renameUserParams: RenameUserParams!) {
    renameUser(renameUserParams: $renameUserParams)
  }
`
export type RenameUserMutationFn = Apollo.MutationFunction<RenameUserMutation, RenameUserMutationVariables>

/**
 * __useRenameUserMutation__
 *
 * To run a mutation, you first call `useRenameUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameUserMutation, { data, loading, error }] = useRenameUserMutation({
 *   variables: {
 *      renameUserParams: // value for 'renameUserParams'
 *   },
 * });
 */
export function useRenameUserMutation(
  baseOptions?: Apollo.MutationHookOptions<RenameUserMutation, RenameUserMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RenameUserMutation, RenameUserMutationVariables>(RenameUserDocument, options)
}
export type RenameUserMutationHookResult = ReturnType<typeof useRenameUserMutation>
export type RenameUserMutationResult = Apollo.MutationResult<RenameUserMutation>
export type RenameUserMutationOptions = Apollo.BaseMutationOptions<RenameUserMutation, RenameUserMutationVariables>
export const GetOrganizationDocument = gql`
  query getOrganization($getOrganizationParams: GetOrganizationParams!) {
    getOrganization(getOrganizationParams: $getOrganizationParams) {
      ...organizationDetails
    }
  }
  ${OrganizationDetailsFragmentDoc}
`

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      getOrganizationParams: // value for 'getOrganizationParams'
 *   },
 * });
 */
export function useGetOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options)
}
export function useGetOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options)
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>
export const ModifyOrganizationLicenseDocument = gql`
  mutation modifyOrganizationLicense($modifyOrganizationLicenseParams: ModifyOrganizationLicenseParams!) {
    modifyOrganizationLicense(modifyOrganizationLicenseParams: $modifyOrganizationLicenseParams)
  }
`
export type ModifyOrganizationLicenseMutationFn = Apollo.MutationFunction<
  ModifyOrganizationLicenseMutation,
  ModifyOrganizationLicenseMutationVariables
>

/**
 * __useModifyOrganizationLicenseMutation__
 *
 * To run a mutation, you first call `useModifyOrganizationLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganizationLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganizationLicenseMutation, { data, loading, error }] = useModifyOrganizationLicenseMutation({
 *   variables: {
 *      modifyOrganizationLicenseParams: // value for 'modifyOrganizationLicenseParams'
 *   },
 * });
 */
export function useModifyOrganizationLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ModifyOrganizationLicenseMutation,
    ModifyOrganizationLicenseMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ModifyOrganizationLicenseMutation, ModifyOrganizationLicenseMutationVariables>(
    ModifyOrganizationLicenseDocument,
    options
  )
}
export type ModifyOrganizationLicenseMutationHookResult = ReturnType<typeof useModifyOrganizationLicenseMutation>
export type ModifyOrganizationLicenseMutationResult = Apollo.MutationResult<ModifyOrganizationLicenseMutation>
export type ModifyOrganizationLicenseMutationOptions = Apollo.BaseMutationOptions<
  ModifyOrganizationLicenseMutation,
  ModifyOrganizationLicenseMutationVariables
>
export const ResetOrganizationSeatUsageDocument = gql`
  mutation resetOrganizationSeatUsage($resetOrganizationSeatUsageParams: ResetOrganizationSeatUsageParams!) {
    resetOrganizationSeatUsage(resetOrganizationSeatUsageParams: $resetOrganizationSeatUsageParams)
  }
`
export type ResetOrganizationSeatUsageMutationFn = Apollo.MutationFunction<
  ResetOrganizationSeatUsageMutation,
  ResetOrganizationSeatUsageMutationVariables
>

/**
 * __useResetOrganizationSeatUsageMutation__
 *
 * To run a mutation, you first call `useResetOrganizationSeatUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOrganizationSeatUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOrganizationSeatUsageMutation, { data, loading, error }] = useResetOrganizationSeatUsageMutation({
 *   variables: {
 *      resetOrganizationSeatUsageParams: // value for 'resetOrganizationSeatUsageParams'
 *   },
 * });
 */
export function useResetOrganizationSeatUsageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetOrganizationSeatUsageMutation,
    ResetOrganizationSeatUsageMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ResetOrganizationSeatUsageMutation, ResetOrganizationSeatUsageMutationVariables>(
    ResetOrganizationSeatUsageDocument,
    options
  )
}
export type ResetOrganizationSeatUsageMutationHookResult = ReturnType<typeof useResetOrganizationSeatUsageMutation>
export type ResetOrganizationSeatUsageMutationResult = Apollo.MutationResult<ResetOrganizationSeatUsageMutation>
export type ResetOrganizationSeatUsageMutationOptions = Apollo.BaseMutationOptions<
  ResetOrganizationSeatUsageMutation,
  ResetOrganizationSeatUsageMutationVariables
>
export const GetSummaryJobContentDocument = gql`
  query getSummaryJobContent($getSummaryJobContentParams: GetSummaryJobContentParams!) {
    getSummaryJobContent(getSummaryJobContentParams: $getSummaryJobContentParams)
  }
`

/**
 * __useGetSummaryJobContentQuery__
 *
 * To run a query within a React component, call `useGetSummaryJobContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryJobContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummaryJobContentQuery({
 *   variables: {
 *      getSummaryJobContentParams: // value for 'getSummaryJobContentParams'
 *   },
 * });
 */
export function useGetSummaryJobContentQuery(
  baseOptions: Apollo.QueryHookOptions<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>(
    GetSummaryJobContentDocument,
    options
  )
}
export function useGetSummaryJobContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>(
    GetSummaryJobContentDocument,
    options
  )
}
export type GetSummaryJobContentQueryHookResult = ReturnType<typeof useGetSummaryJobContentQuery>
export type GetSummaryJobContentLazyQueryHookResult = ReturnType<typeof useGetSummaryJobContentLazyQuery>
export type GetSummaryJobContentQueryResult = Apollo.QueryResult<
  GetSummaryJobContentQuery,
  GetSummaryJobContentQueryVariables
>
export const GetQuizJobContentDocument = gql`
  query getQuizJobContent($getQuizJobContentParams: GetQuizJobContentParams!) {
    getQuizJobContent(getQuizJobContentParams: $getQuizJobContentParams)
  }
`

/**
 * __useGetQuizJobContentQuery__
 *
 * To run a query within a React component, call `useGetQuizJobContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizJobContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizJobContentQuery({
 *   variables: {
 *      getQuizJobContentParams: // value for 'getQuizJobContentParams'
 *   },
 * });
 */
export function useGetQuizJobContentQuery(
  baseOptions: Apollo.QueryHookOptions<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>(GetQuizJobContentDocument, options)
}
export function useGetQuizJobContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>(
    GetQuizJobContentDocument,
    options
  )
}
export type GetQuizJobContentQueryHookResult = ReturnType<typeof useGetQuizJobContentQuery>
export type GetQuizJobContentLazyQueryHookResult = ReturnType<typeof useGetQuizJobContentLazyQuery>
export type GetQuizJobContentQueryResult = Apollo.QueryResult<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>
export const GetInstitutionsDocument = gql`
  query getInstitutions($getInstitutionsParams: GetInstitutionsParams!) {
    getInstitutions(getInstitutionsParams: $getInstitutionsParams) {
      institutions {
        id
        name
        deviceCount
        createdAt
        licenseEnforcement
        licenseEnforcementExpiration
      }
      count
    }
  }
`

/**
 * __useGetInstitutionsQuery__
 *
 * To run a query within a React component, call `useGetInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionsQuery({
 *   variables: {
 *      getInstitutionsParams: // value for 'getInstitutionsParams'
 *   },
 * });
 */
export function useGetInstitutionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetInstitutionsQuery, GetInstitutionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetInstitutionsQuery, GetInstitutionsQueryVariables>(GetInstitutionsDocument, options)
}
export function useGetInstitutionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionsQuery, GetInstitutionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetInstitutionsQuery, GetInstitutionsQueryVariables>(GetInstitutionsDocument, options)
}
export type GetInstitutionsQueryHookResult = ReturnType<typeof useGetInstitutionsQuery>
export type GetInstitutionsLazyQueryHookResult = ReturnType<typeof useGetInstitutionsLazyQuery>
export type GetInstitutionsQueryResult = Apollo.QueryResult<GetInstitutionsQuery, GetInstitutionsQueryVariables>
export const SetLicenseEnforcementDocument = gql`
  mutation setLicenseEnforcement($setLicenseEnforcementParams: SetLicenseEnforcementParams!) {
    setLicenseEnforcement(setLicenseEnforcementParams: $setLicenseEnforcementParams)
  }
`
export type SetLicenseEnforcementMutationFn = Apollo.MutationFunction<
  SetLicenseEnforcementMutation,
  SetLicenseEnforcementMutationVariables
>

/**
 * __useSetLicenseEnforcementMutation__
 *
 * To run a mutation, you first call `useSetLicenseEnforcementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLicenseEnforcementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLicenseEnforcementMutation, { data, loading, error }] = useSetLicenseEnforcementMutation({
 *   variables: {
 *      setLicenseEnforcementParams: // value for 'setLicenseEnforcementParams'
 *   },
 * });
 */
export function useSetLicenseEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<SetLicenseEnforcementMutation, SetLicenseEnforcementMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetLicenseEnforcementMutation, SetLicenseEnforcementMutationVariables>(
    SetLicenseEnforcementDocument,
    options
  )
}
export type SetLicenseEnforcementMutationHookResult = ReturnType<typeof useSetLicenseEnforcementMutation>
export type SetLicenseEnforcementMutationResult = Apollo.MutationResult<SetLicenseEnforcementMutation>
export type SetLicenseEnforcementMutationOptions = Apollo.BaseMutationOptions<
  SetLicenseEnforcementMutation,
  SetLicenseEnforcementMutationVariables
>
export const SetLicenseEnforcementExpirationDocument = gql`
  mutation setLicenseEnforcementExpiration(
    $setLicenseEnforcementExpirationParams: SetLicenseEnforcementExpirationParams!
  ) {
    setLicenseEnforcementExpiration(setLicenseEnforcementExpirationParams: $setLicenseEnforcementExpirationParams)
  }
`
export type SetLicenseEnforcementExpirationMutationFn = Apollo.MutationFunction<
  SetLicenseEnforcementExpirationMutation,
  SetLicenseEnforcementExpirationMutationVariables
>

/**
 * __useSetLicenseEnforcementExpirationMutation__
 *
 * To run a mutation, you first call `useSetLicenseEnforcementExpirationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLicenseEnforcementExpirationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLicenseEnforcementExpirationMutation, { data, loading, error }] = useSetLicenseEnforcementExpirationMutation({
 *   variables: {
 *      setLicenseEnforcementExpirationParams: // value for 'setLicenseEnforcementExpirationParams'
 *   },
 * });
 */
export function useSetLicenseEnforcementExpirationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetLicenseEnforcementExpirationMutation,
    SetLicenseEnforcementExpirationMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetLicenseEnforcementExpirationMutation, SetLicenseEnforcementExpirationMutationVariables>(
    SetLicenseEnforcementExpirationDocument,
    options
  )
}
export type SetLicenseEnforcementExpirationMutationHookResult = ReturnType<
  typeof useSetLicenseEnforcementExpirationMutation
>
export type SetLicenseEnforcementExpirationMutationResult =
  Apollo.MutationResult<SetLicenseEnforcementExpirationMutation>
export type SetLicenseEnforcementExpirationMutationOptions = Apollo.BaseMutationOptions<
  SetLicenseEnforcementExpirationMutation,
  SetLicenseEnforcementExpirationMutationVariables
>
export const GenerateStudyMaterialsBatchDocument = gql`
  mutation generateStudyMaterialsBatch($generateStudyMaterialsBatchParams: GenerateStudyMaterialsBatchParams!) {
    generateStudyMaterialsBatch(generateStudyMaterialsBatchParams: $generateStudyMaterialsBatchParams) {
      id
      promptGroup
      language
      studyMaterials {
        contentHash
        source
        quizJob {
          id
          status
          errorReason
        }
        summaryJob {
          id
          status
          errorReason
        }
      }
    }
  }
`
export type GenerateStudyMaterialsBatchMutationFn = Apollo.MutationFunction<
  GenerateStudyMaterialsBatchMutation,
  GenerateStudyMaterialsBatchMutationVariables
>

/**
 * __useGenerateStudyMaterialsBatchMutation__
 *
 * To run a mutation, you first call `useGenerateStudyMaterialsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStudyMaterialsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateStudyMaterialsBatchMutation, { data, loading, error }] = useGenerateStudyMaterialsBatchMutation({
 *   variables: {
 *      generateStudyMaterialsBatchParams: // value for 'generateStudyMaterialsBatchParams'
 *   },
 * });
 */
export function useGenerateStudyMaterialsBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateStudyMaterialsBatchMutation,
    GenerateStudyMaterialsBatchMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<GenerateStudyMaterialsBatchMutation, GenerateStudyMaterialsBatchMutationVariables>(
    GenerateStudyMaterialsBatchDocument,
    options
  )
}
export type GenerateStudyMaterialsBatchMutationHookResult = ReturnType<typeof useGenerateStudyMaterialsBatchMutation>
export type GenerateStudyMaterialsBatchMutationResult = Apollo.MutationResult<GenerateStudyMaterialsBatchMutation>
export type GenerateStudyMaterialsBatchMutationOptions = Apollo.BaseMutationOptions<
  GenerateStudyMaterialsBatchMutation,
  GenerateStudyMaterialsBatchMutationVariables
>
export const GetStudyMaterialsBatchDocument = gql`
  query getStudyMaterialsBatch($getStudyMaterialsBatchParams: GetStudyMaterialsBatchParams!) {
    getStudyMaterialsBatch(getStudyMaterialsBatchParams: $getStudyMaterialsBatchParams) {
      id
      promptGroup
      language
      studyMaterials {
        contentHash
        source
        quizJob {
          id
          status
          errorReason
        }
        summaryJob {
          id
          status
          errorReason
        }
      }
    }
  }
`

/**
 * __useGetStudyMaterialsBatchQuery__
 *
 * To run a query within a React component, call `useGetStudyMaterialsBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyMaterialsBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyMaterialsBatchQuery({
 *   variables: {
 *      getStudyMaterialsBatchParams: // value for 'getStudyMaterialsBatchParams'
 *   },
 * });
 */
export function useGetStudyMaterialsBatchQuery(
  baseOptions: Apollo.QueryHookOptions<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>(
    GetStudyMaterialsBatchDocument,
    options
  )
}
export function useGetStudyMaterialsBatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>(
    GetStudyMaterialsBatchDocument,
    options
  )
}
export type GetStudyMaterialsBatchQueryHookResult = ReturnType<typeof useGetStudyMaterialsBatchQuery>
export type GetStudyMaterialsBatchLazyQueryHookResult = ReturnType<typeof useGetStudyMaterialsBatchLazyQuery>
export type GetStudyMaterialsBatchQueryResult = Apollo.QueryResult<
  GetStudyMaterialsBatchQuery,
  GetStudyMaterialsBatchQueryVariables
>
export const CreateOrganizationDocument = gql`
  mutation CreateOrganization($createOrgParams: CreateOrgParams!) {
    createOrganization(createOrgParams: $createOrgParams) {
      id
      name
      approved
      isAsmEnrolled
      educationLevelsProvided
      mdmPlatform
      license {
        id
        maxSeats
      }
      organizationType
      industry
      contractAcceptedAt
    }
  }
`
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      createOrgParams: // value for 'createOrgParams'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(
    CreateOrganizationDocument,
    options
  )
}
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>
export const ChangeBusinessOwnerDocument = gql`
  mutation changeBusinessOwner($changeBusinessOwnerParams: ChangeBusinessOwnerParams!) {
    changeBusinessOwner(changeBusinessOwnerParams: $changeBusinessOwnerParams) {
      id
      name
    }
  }
`
export type ChangeBusinessOwnerMutationFn = Apollo.MutationFunction<
  ChangeBusinessOwnerMutation,
  ChangeBusinessOwnerMutationVariables
>

/**
 * __useChangeBusinessOwnerMutation__
 *
 * To run a mutation, you first call `useChangeBusinessOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBusinessOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBusinessOwnerMutation, { data, loading, error }] = useChangeBusinessOwnerMutation({
 *   variables: {
 *      changeBusinessOwnerParams: // value for 'changeBusinessOwnerParams'
 *   },
 * });
 */
export function useChangeBusinessOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeBusinessOwnerMutation, ChangeBusinessOwnerMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeBusinessOwnerMutation, ChangeBusinessOwnerMutationVariables>(
    ChangeBusinessOwnerDocument,
    options
  )
}
export type ChangeBusinessOwnerMutationHookResult = ReturnType<typeof useChangeBusinessOwnerMutation>
export type ChangeBusinessOwnerMutationResult = Apollo.MutationResult<ChangeBusinessOwnerMutation>
export type ChangeBusinessOwnerMutationOptions = Apollo.BaseMutationOptions<
  ChangeBusinessOwnerMutation,
  ChangeBusinessOwnerMutationVariables
>
export const AdminSyncBusinessSubscriptionDocument = gql`
  mutation adminSyncBusinessSubscription($adminSyncBusinessSubscriptionParams: AdminSyncBusinessSubscriptionParams!) {
    adminSyncBusinessSubscription(adminSyncBusinessSubscriptionParams: $adminSyncBusinessSubscriptionParams)
  }
`
export type AdminSyncBusinessSubscriptionMutationFn = Apollo.MutationFunction<
  AdminSyncBusinessSubscriptionMutation,
  AdminSyncBusinessSubscriptionMutationVariables
>

/**
 * __useAdminSyncBusinessSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminSyncBusinessSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSyncBusinessSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSyncBusinessSubscriptionMutation, { data, loading, error }] = useAdminSyncBusinessSubscriptionMutation({
 *   variables: {
 *      adminSyncBusinessSubscriptionParams: // value for 'adminSyncBusinessSubscriptionParams'
 *   },
 * });
 */
export function useAdminSyncBusinessSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminSyncBusinessSubscriptionMutation,
    AdminSyncBusinessSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AdminSyncBusinessSubscriptionMutation, AdminSyncBusinessSubscriptionMutationVariables>(
    AdminSyncBusinessSubscriptionDocument,
    options
  )
}
export type AdminSyncBusinessSubscriptionMutationHookResult = ReturnType<
  typeof useAdminSyncBusinessSubscriptionMutation
>
export type AdminSyncBusinessSubscriptionMutationResult = Apollo.MutationResult<AdminSyncBusinessSubscriptionMutation>
export type AdminSyncBusinessSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  AdminSyncBusinessSubscriptionMutation,
  AdminSyncBusinessSubscriptionMutationVariables
>
export const AdminUpdateBusinessSubscriptionDocument = gql`
  mutation adminUpdateBusinessSubscription(
    $adminUpdateBusinessSubscriptionParams: AdminUpdateBusinessSubscriptionParams!
  ) {
    adminUpdateBusinessSubscription(adminUpdateBusinessSubscriptionParams: $adminUpdateBusinessSubscriptionParams)
  }
`
export type AdminUpdateBusinessSubscriptionMutationFn = Apollo.MutationFunction<
  AdminUpdateBusinessSubscriptionMutation,
  AdminUpdateBusinessSubscriptionMutationVariables
>

/**
 * __useAdminUpdateBusinessSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateBusinessSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateBusinessSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateBusinessSubscriptionMutation, { data, loading, error }] = useAdminUpdateBusinessSubscriptionMutation({
 *   variables: {
 *      adminUpdateBusinessSubscriptionParams: // value for 'adminUpdateBusinessSubscriptionParams'
 *   },
 * });
 */
export function useAdminUpdateBusinessSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminUpdateBusinessSubscriptionMutation,
    AdminUpdateBusinessSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AdminUpdateBusinessSubscriptionMutation, AdminUpdateBusinessSubscriptionMutationVariables>(
    AdminUpdateBusinessSubscriptionDocument,
    options
  )
}
export type AdminUpdateBusinessSubscriptionMutationHookResult = ReturnType<
  typeof useAdminUpdateBusinessSubscriptionMutation
>
export type AdminUpdateBusinessSubscriptionMutationResult =
  Apollo.MutationResult<AdminUpdateBusinessSubscriptionMutation>
export type AdminUpdateBusinessSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  AdminUpdateBusinessSubscriptionMutation,
  AdminUpdateBusinessSubscriptionMutationVariables
>
export const CreateTestBusinessDocument = gql`
  mutation CreateTestBusiness($createTestBusinessParams: CreateTestBusinessParams!) {
    createTestBusiness(createTestBusinessParams: $createTestBusinessParams) {
      business {
        name
      }
      owner {
        id
        email
      }
    }
  }
`
export type CreateTestBusinessMutationFn = Apollo.MutationFunction<
  CreateTestBusinessMutation,
  CreateTestBusinessMutationVariables
>

/**
 * __useCreateTestBusinessMutation__
 *
 * To run a mutation, you first call `useCreateTestBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestBusinessMutation, { data, loading, error }] = useCreateTestBusinessMutation({
 *   variables: {
 *      createTestBusinessParams: // value for 'createTestBusinessParams'
 *   },
 * });
 */
export function useCreateTestBusinessMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTestBusinessMutation, CreateTestBusinessMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateTestBusinessMutation, CreateTestBusinessMutationVariables>(
    CreateTestBusinessDocument,
    options
  )
}
export type CreateTestBusinessMutationHookResult = ReturnType<typeof useCreateTestBusinessMutation>
export type CreateTestBusinessMutationResult = Apollo.MutationResult<CreateTestBusinessMutation>
export type CreateTestBusinessMutationOptions = Apollo.BaseMutationOptions<
  CreateTestBusinessMutation,
  CreateTestBusinessMutationVariables
>
export const PatchBusinessSubscriptionDocument = gql`
  mutation PatchBusinessSubscription($patchBusinessSubscriptionParams: PatchBusinessSubscriptionParams!) {
    patchBusinessSubscription(patchBusinessSubscriptionParams: $patchBusinessSubscriptionParams) {
      success
    }
  }
`
export type PatchBusinessSubscriptionMutationFn = Apollo.MutationFunction<
  PatchBusinessSubscriptionMutation,
  PatchBusinessSubscriptionMutationVariables
>

/**
 * __usePatchBusinessSubscriptionMutation__
 *
 * To run a mutation, you first call `usePatchBusinessSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchBusinessSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchBusinessSubscriptionMutation, { data, loading, error }] = usePatchBusinessSubscriptionMutation({
 *   variables: {
 *      patchBusinessSubscriptionParams: // value for 'patchBusinessSubscriptionParams'
 *   },
 * });
 */
export function usePatchBusinessSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PatchBusinessSubscriptionMutation,
    PatchBusinessSubscriptionMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<PatchBusinessSubscriptionMutation, PatchBusinessSubscriptionMutationVariables>(
    PatchBusinessSubscriptionDocument,
    options
  )
}
export type PatchBusinessSubscriptionMutationHookResult = ReturnType<typeof usePatchBusinessSubscriptionMutation>
export type PatchBusinessSubscriptionMutationResult = Apollo.MutationResult<PatchBusinessSubscriptionMutation>
export type PatchBusinessSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  PatchBusinessSubscriptionMutation,
  PatchBusinessSubscriptionMutationVariables
>
export const GetViableSubscriptionDocument = gql`
  query getViableSubscription($getViableSubscriptionParams: GetViableSubscriptionParams!) {
    getViableSubscription(getViableSubscriptionParams: $getViableSubscriptionParams) {
      originalTransactionId
      originalPurchaseDate
      productId
      expirationDate
      status
      isTrialPeriod
      isInIntroOfferPeriod
      refundedDate
      refundedReason
      overDeviceLimit
      gracePeriodExpiresAt
      expirationIntent
      isInBillingRetryPeriod
      tier
    }
  }
`

/**
 * __useGetViableSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetViableSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViableSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViableSubscriptionQuery({
 *   variables: {
 *      getViableSubscriptionParams: // value for 'getViableSubscriptionParams'
 *   },
 * });
 */
export function useGetViableSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>(
    GetViableSubscriptionDocument,
    options
  )
}
export function useGetViableSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>(
    GetViableSubscriptionDocument,
    options
  )
}
export type GetViableSubscriptionQueryHookResult = ReturnType<typeof useGetViableSubscriptionQuery>
export type GetViableSubscriptionLazyQueryHookResult = ReturnType<typeof useGetViableSubscriptionLazyQuery>
export type GetViableSubscriptionQueryResult = Apollo.QueryResult<
  GetViableSubscriptionQuery,
  GetViableSubscriptionQueryVariables
>
export const GetSendGridEventsDocument = gql`
  query getSendGridEvents($getSendGridEventsParams: GetSendGridEventsParams!) {
    getSendGridEvents(getSendGridEventsParams: $getSendGridEventsParams) {
      events {
        id
        email
        createdAt
        event
      }
      count
    }
  }
`

/**
 * __useGetSendGridEventsQuery__
 *
 * To run a query within a React component, call `useGetSendGridEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridEventsQuery({
 *   variables: {
 *      getSendGridEventsParams: // value for 'getSendGridEventsParams'
 *   },
 * });
 */
export function useGetSendGridEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>(GetSendGridEventsDocument, options)
}
export function useGetSendGridEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>(
    GetSendGridEventsDocument,
    options
  )
}
export type GetSendGridEventsQueryHookResult = ReturnType<typeof useGetSendGridEventsQuery>
export type GetSendGridEventsLazyQueryHookResult = ReturnType<typeof useGetSendGridEventsLazyQuery>
export type GetSendGridEventsQueryResult = Apollo.QueryResult<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>
export const AdminGetSendGridSuppressionsDocument = gql`
  query adminGetSendGridSuppressions($adminGetSendGridSuppressionsParams: AdminGetSendGridSuppressionsParams!) {
    adminGetSendGridSuppressions(adminGetSendGridSuppressionsParams: $adminGetSendGridSuppressionsParams) {
      name
      listed
      listedAt
      reason
      error
    }
  }
`

/**
 * __useAdminGetSendGridSuppressionsQuery__
 *
 * To run a query within a React component, call `useAdminGetSendGridSuppressionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSendGridSuppressionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSendGridSuppressionsQuery({
 *   variables: {
 *      adminGetSendGridSuppressionsParams: // value for 'adminGetSendGridSuppressionsParams'
 *   },
 * });
 */
export function useAdminGetSendGridSuppressionsQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetSendGridSuppressionsQuery, AdminGetSendGridSuppressionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminGetSendGridSuppressionsQuery, AdminGetSendGridSuppressionsQueryVariables>(
    AdminGetSendGridSuppressionsDocument,
    options
  )
}
export function useAdminGetSendGridSuppressionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetSendGridSuppressionsQuery,
    AdminGetSendGridSuppressionsQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminGetSendGridSuppressionsQuery, AdminGetSendGridSuppressionsQueryVariables>(
    AdminGetSendGridSuppressionsDocument,
    options
  )
}
export type AdminGetSendGridSuppressionsQueryHookResult = ReturnType<typeof useAdminGetSendGridSuppressionsQuery>
export type AdminGetSendGridSuppressionsLazyQueryHookResult = ReturnType<
  typeof useAdminGetSendGridSuppressionsLazyQuery
>
export type AdminGetSendGridSuppressionsQueryResult = Apollo.QueryResult<
  AdminGetSendGridSuppressionsQuery,
  AdminGetSendGridSuppressionsQueryVariables
>
export const CreateTrialSubscriptionDocument = gql`
  mutation createTrialSubscription($createTrialSubscriptionParams: CreateTrialSubscriptionParams!) {
    createTrialSubscription(createTrialSubscriptionParams: $createTrialSubscriptionParams) {
      id
      expirationDate
      canceledAt
      trialLengthInDays
      daysRemainingOnTrial
    }
  }
`
export type CreateTrialSubscriptionMutationFn = Apollo.MutationFunction<
  CreateTrialSubscriptionMutation,
  CreateTrialSubscriptionMutationVariables
>

/**
 * __useCreateTrialSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateTrialSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrialSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrialSubscriptionMutation, { data, loading, error }] = useCreateTrialSubscriptionMutation({
 *   variables: {
 *      createTrialSubscriptionParams: // value for 'createTrialSubscriptionParams'
 *   },
 * });
 */
export function useCreateTrialSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTrialSubscriptionMutation, CreateTrialSubscriptionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateTrialSubscriptionMutation, CreateTrialSubscriptionMutationVariables>(
    CreateTrialSubscriptionDocument,
    options
  )
}
export type CreateTrialSubscriptionMutationHookResult = ReturnType<typeof useCreateTrialSubscriptionMutation>
export type CreateTrialSubscriptionMutationResult = Apollo.MutationResult<CreateTrialSubscriptionMutation>
export type CreateTrialSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CreateTrialSubscriptionMutation,
  CreateTrialSubscriptionMutationVariables
>
export const ModifyTrialExpirationDocument = gql`
  mutation modifyTrialExpiration($modifyTrialExpirationParams: ModifyTrialExpirationParams!) {
    modifyTrialExpiration(modifyTrialExpirationParams: $modifyTrialExpirationParams)
  }
`
export type ModifyTrialExpirationMutationFn = Apollo.MutationFunction<
  ModifyTrialExpirationMutation,
  ModifyTrialExpirationMutationVariables
>

/**
 * __useModifyTrialExpirationMutation__
 *
 * To run a mutation, you first call `useModifyTrialExpirationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyTrialExpirationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyTrialExpirationMutation, { data, loading, error }] = useModifyTrialExpirationMutation({
 *   variables: {
 *      modifyTrialExpirationParams: // value for 'modifyTrialExpirationParams'
 *   },
 * });
 */
export function useModifyTrialExpirationMutation(
  baseOptions?: Apollo.MutationHookOptions<ModifyTrialExpirationMutation, ModifyTrialExpirationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ModifyTrialExpirationMutation, ModifyTrialExpirationMutationVariables>(
    ModifyTrialExpirationDocument,
    options
  )
}
export type ModifyTrialExpirationMutationHookResult = ReturnType<typeof useModifyTrialExpirationMutation>
export type ModifyTrialExpirationMutationResult = Apollo.MutationResult<ModifyTrialExpirationMutation>
export type ModifyTrialExpirationMutationOptions = Apollo.BaseMutationOptions<
  ModifyTrialExpirationMutation,
  ModifyTrialExpirationMutationVariables
>
export const CancelTrialDocument = gql`
  mutation cancelTrial($cancelUserTrialSubscriptionParams: CancelUserTrialSubscriptionParams!) {
    cancelTrial(cancelUserTrialSubscriptionParams: $cancelUserTrialSubscriptionParams)
  }
`
export type CancelTrialMutationFn = Apollo.MutationFunction<CancelTrialMutation, CancelTrialMutationVariables>

/**
 * __useCancelTrialMutation__
 *
 * To run a mutation, you first call `useCancelTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTrialMutation, { data, loading, error }] = useCancelTrialMutation({
 *   variables: {
 *      cancelUserTrialSubscriptionParams: // value for 'cancelUserTrialSubscriptionParams'
 *   },
 * });
 */
export function useCancelTrialMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelTrialMutation, CancelTrialMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CancelTrialMutation, CancelTrialMutationVariables>(CancelTrialDocument, options)
}
export type CancelTrialMutationHookResult = ReturnType<typeof useCancelTrialMutation>
export type CancelTrialMutationResult = Apollo.MutationResult<CancelTrialMutation>
export type CancelTrialMutationOptions = Apollo.BaseMutationOptions<CancelTrialMutation, CancelTrialMutationVariables>
export const GetUserTrialSubscriptionDocument = gql`
  query getUserTrialSubscription($getUserTrialSubscriptionParams: GetUserTrialSubscriptionParams!) {
    getUserTrialSubscription(getUserTrialSubscriptionParams: $getUserTrialSubscriptionParams) {
      id
      expirationDate
      canceledAt
      trialLengthInDays
      daysRemainingOnTrial
    }
  }
`

/**
 * __useGetUserTrialSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetUserTrialSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTrialSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTrialSubscriptionQuery({
 *   variables: {
 *      getUserTrialSubscriptionParams: // value for 'getUserTrialSubscriptionParams'
 *   },
 * });
 */
export function useGetUserTrialSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserTrialSubscriptionQuery, GetUserTrialSubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserTrialSubscriptionQuery, GetUserTrialSubscriptionQueryVariables>(
    GetUserTrialSubscriptionDocument,
    options
  )
}
export function useGetUserTrialSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserTrialSubscriptionQuery, GetUserTrialSubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserTrialSubscriptionQuery, GetUserTrialSubscriptionQueryVariables>(
    GetUserTrialSubscriptionDocument,
    options
  )
}
export type GetUserTrialSubscriptionQueryHookResult = ReturnType<typeof useGetUserTrialSubscriptionQuery>
export type GetUserTrialSubscriptionLazyQueryHookResult = ReturnType<typeof useGetUserTrialSubscriptionLazyQuery>
export type GetUserTrialSubscriptionQueryResult = Apollo.QueryResult<
  GetUserTrialSubscriptionQuery,
  GetUserTrialSubscriptionQueryVariables
>
export const GetUserSubscriptionInfoDocument = gql`
  query getUserSubscriptionInfo($getSubscriptionInfoParams: GetSubscriptionInfoParams!) {
    getUserSubscriptionInfo(getSubscriptionInfoParams: $getSubscriptionInfoParams) {
      isClassicUser
      subscriptionTier
      subscriptionSource
      trialLengthInDays
      trialExpirationDate
      subscriptionRenewalDate
    }
  }
`

/**
 * __useGetUserSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionInfoQuery({
 *   variables: {
 *      getSubscriptionInfoParams: // value for 'getSubscriptionInfoParams'
 *   },
 * });
 */
export function useGetUserSubscriptionInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserSubscriptionInfoQuery, GetUserSubscriptionInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserSubscriptionInfoQuery, GetUserSubscriptionInfoQueryVariables>(
    GetUserSubscriptionInfoDocument,
    options
  )
}
export function useGetUserSubscriptionInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSubscriptionInfoQuery, GetUserSubscriptionInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserSubscriptionInfoQuery, GetUserSubscriptionInfoQueryVariables>(
    GetUserSubscriptionInfoDocument,
    options
  )
}
export type GetUserSubscriptionInfoQueryHookResult = ReturnType<typeof useGetUserSubscriptionInfoQuery>
export type GetUserSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useGetUserSubscriptionInfoLazyQuery>
export type GetUserSubscriptionInfoQueryResult = Apollo.QueryResult<
  GetUserSubscriptionInfoQuery,
  GetUserSubscriptionInfoQueryVariables
>
export const AdminGetCurrentLearnUsageDocument = gql`
  query adminGetCurrentLearnUsage($adminGetCurrentLearnUsageParams: AdminGetCurrentLearnUsageParams!) {
    adminGetCurrentLearnUsage(adminGetCurrentLearnUsageParams: $adminGetCurrentLearnUsageParams) {
      usage {
        hasExceededLearnQuotaUsage
        quotaUsagePercentage
      }
      quotaWindowStart
      counts {
        quizCount
        summaryCount
      }
      calculation {
        mode
        cost {
          used
          limit
          hasExceededLearnQuotaUsage
          quotaUsagePercentage
        }
        questions {
          used
          limit
          hasExceededLearnQuotaUsage
          quotaUsagePercentage
        }
      }
    }
  }
`

/**
 * __useAdminGetCurrentLearnUsageQuery__
 *
 * To run a query within a React component, call `useAdminGetCurrentLearnUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCurrentLearnUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCurrentLearnUsageQuery({
 *   variables: {
 *      adminGetCurrentLearnUsageParams: // value for 'adminGetCurrentLearnUsageParams'
 *   },
 * });
 */
export function useAdminGetCurrentLearnUsageQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetCurrentLearnUsageQuery, AdminGetCurrentLearnUsageQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminGetCurrentLearnUsageQuery, AdminGetCurrentLearnUsageQueryVariables>(
    AdminGetCurrentLearnUsageDocument,
    options
  )
}
export function useAdminGetCurrentLearnUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCurrentLearnUsageQuery, AdminGetCurrentLearnUsageQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminGetCurrentLearnUsageQuery, AdminGetCurrentLearnUsageQueryVariables>(
    AdminGetCurrentLearnUsageDocument,
    options
  )
}
export type AdminGetCurrentLearnUsageQueryHookResult = ReturnType<typeof useAdminGetCurrentLearnUsageQuery>
export type AdminGetCurrentLearnUsageLazyQueryHookResult = ReturnType<typeof useAdminGetCurrentLearnUsageLazyQuery>
export type AdminGetCurrentLearnUsageQueryResult = Apollo.QueryResult<
  AdminGetCurrentLearnUsageQuery,
  AdminGetCurrentLearnUsageQueryVariables
>
export const AdminGetSubscriptionOverviewDocument = gql`
  query adminGetSubscriptionOverview($adminGetSubscriptionOverviewParams: AdminGetSubscriptionOverviewParams!) {
    adminGetSubscriptionOverview(adminGetSubscriptionOverviewParams: $adminGetSubscriptionOverviewParams) {
      tier
      quotas {
        learnQuestions {
          isUsageExceeded
          usagePercentage
        }
        learnQuestionUploads {
          isUsageExceeded
          usagePercentage
        }
        learnSummaries {
          isUsageExceeded
          usagePercentage
        }
        liveTranscription {
          isUsageExceeded
          usagePercentage
        }
        youtubeTranscripts {
          isUsageExceeded
          usagePercentage
        }
      }
      current {
        details {
          __typename
          ... on AppStoreSubscription {
            expirationDate
          }
          ... on StripeConsumerSubscription {
            subscriptionRenewalDate
          }
          ... on SubscriptionOverride {
            expirationDate
          }
          ... on TrialSubscription {
            daysRemainingOnTrial
            expirationDate
            trialLengthInDays
          }
        }
        expirationDate
        renewalDate
        source
        tier
      }
      prior {
        details {
          __typename
          ... on AppStoreSubscription {
            expirationDate
          }
          ... on StripeConsumerSubscription {
            endedAt
          }
          ... on SubscriptionOverride {
            expirationDate
          }
          ... on TrialSubscription {
            expirationDate
            trialLengthInDays
          }
        }
        expirationDate
        source
        tier
      }
    }
  }
`

/**
 * __useAdminGetSubscriptionOverviewQuery__
 *
 * To run a query within a React component, call `useAdminGetSubscriptionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSubscriptionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSubscriptionOverviewQuery({
 *   variables: {
 *      adminGetSubscriptionOverviewParams: // value for 'adminGetSubscriptionOverviewParams'
 *   },
 * });
 */
export function useAdminGetSubscriptionOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetSubscriptionOverviewQuery, AdminGetSubscriptionOverviewQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminGetSubscriptionOverviewQuery, AdminGetSubscriptionOverviewQueryVariables>(
    AdminGetSubscriptionOverviewDocument,
    options
  )
}
export function useAdminGetSubscriptionOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminGetSubscriptionOverviewQuery,
    AdminGetSubscriptionOverviewQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminGetSubscriptionOverviewQuery, AdminGetSubscriptionOverviewQueryVariables>(
    AdminGetSubscriptionOverviewDocument,
    options
  )
}
export type AdminGetSubscriptionOverviewQueryHookResult = ReturnType<typeof useAdminGetSubscriptionOverviewQuery>
export type AdminGetSubscriptionOverviewLazyQueryHookResult = ReturnType<
  typeof useAdminGetSubscriptionOverviewLazyQuery
>
export type AdminGetSubscriptionOverviewQueryResult = Apollo.QueryResult<
  AdminGetSubscriptionOverviewQuery,
  AdminGetSubscriptionOverviewQueryVariables
>
export const GetStripeCustomerPortalDocument = gql`
  query getStripeCustomerPortal($getStripeCustomerPortalParams: GetStripeCustomerPortalParams!) {
    getStripeCustomerPortal(getStripeCustomerPortalParams: $getStripeCustomerPortalParams) {
      url
      redirectUrl
    }
  }
`

/**
 * __useGetStripeCustomerPortalQuery__
 *
 * To run a query within a React component, call `useGetStripeCustomerPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCustomerPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCustomerPortalQuery({
 *   variables: {
 *      getStripeCustomerPortalParams: // value for 'getStripeCustomerPortalParams'
 *   },
 * });
 */
export function useGetStripeCustomerPortalQuery(
  baseOptions: Apollo.QueryHookOptions<GetStripeCustomerPortalQuery, GetStripeCustomerPortalQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetStripeCustomerPortalQuery, GetStripeCustomerPortalQueryVariables>(
    GetStripeCustomerPortalDocument,
    options
  )
}
export function useGetStripeCustomerPortalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomerPortalQuery, GetStripeCustomerPortalQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetStripeCustomerPortalQuery, GetStripeCustomerPortalQueryVariables>(
    GetStripeCustomerPortalDocument,
    options
  )
}
export type GetStripeCustomerPortalQueryHookResult = ReturnType<typeof useGetStripeCustomerPortalQuery>
export type GetStripeCustomerPortalLazyQueryHookResult = ReturnType<typeof useGetStripeCustomerPortalLazyQuery>
export type GetStripeCustomerPortalQueryResult = Apollo.QueryResult<
  GetStripeCustomerPortalQuery,
  GetStripeCustomerPortalQueryVariables
>
export const OpCountsDocument = gql`
  query opCounts($getOpCountsParams: GetOpCountsParams!) {
    opCounts(getOpCountsParams: $getOpCountsParams) {
      onstream
      coldStorage
    }
  }
`

/**
 * __useOpCountsQuery__
 *
 * To run a query within a React component, call `useOpCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpCountsQuery({
 *   variables: {
 *      getOpCountsParams: // value for 'getOpCountsParams'
 *   },
 * });
 */
export function useOpCountsQuery(baseOptions: Apollo.QueryHookOptions<OpCountsQuery, OpCountsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<OpCountsQuery, OpCountsQueryVariables>(OpCountsDocument, options)
}
export function useOpCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpCountsQuery, OpCountsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<OpCountsQuery, OpCountsQueryVariables>(OpCountsDocument, options)
}
export type OpCountsQueryHookResult = ReturnType<typeof useOpCountsQuery>
export type OpCountsLazyQueryHookResult = ReturnType<typeof useOpCountsLazyQuery>
export type OpCountsQueryResult = Apollo.QueryResult<OpCountsQuery, OpCountsQueryVariables>
export const FeatureFlagEvaluationDocument = gql`
  query featureFlagEvaluation($featureFlagEvaluationParams: FeatureFlagEvaluationParams!) {
    featureFlagEvaluation(featureFlagEvaluationParams: $featureFlagEvaluationParams) {
      flag
      status
      available
      remoteValue
      remoteValueSource
      hasInternalAccess
      remotelyEnabled
    }
  }
`

/**
 * __useFeatureFlagEvaluationQuery__
 *
 * To run a query within a React component, call `useFeatureFlagEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagEvaluationQuery({
 *   variables: {
 *      featureFlagEvaluationParams: // value for 'featureFlagEvaluationParams'
 *   },
 * });
 */
export function useFeatureFlagEvaluationQuery(
  baseOptions: Apollo.QueryHookOptions<FeatureFlagEvaluationQuery, FeatureFlagEvaluationQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<FeatureFlagEvaluationQuery, FeatureFlagEvaluationQueryVariables>(
    FeatureFlagEvaluationDocument,
    options
  )
}
export function useFeatureFlagEvaluationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagEvaluationQuery, FeatureFlagEvaluationQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<FeatureFlagEvaluationQuery, FeatureFlagEvaluationQueryVariables>(
    FeatureFlagEvaluationDocument,
    options
  )
}
export type FeatureFlagEvaluationQueryHookResult = ReturnType<typeof useFeatureFlagEvaluationQuery>
export type FeatureFlagEvaluationLazyQueryHookResult = ReturnType<typeof useFeatureFlagEvaluationLazyQuery>
export type FeatureFlagEvaluationQueryResult = Apollo.QueryResult<
  FeatureFlagEvaluationQuery,
  FeatureFlagEvaluationQueryVariables
>
export const FetchUserCollabDevicesDocument = gql`
  query fetchUserCollabDevices($userId: String!) {
    adminGetUserData(adminGetUserDataParams: {userId: $userId}) {
      id
      collabDevices {
        deviceId
        platform
        users {
          id
          email
        }
      }
    }
  }
`

/**
 * __useFetchUserCollabDevicesQuery__
 *
 * To run a query within a React component, call `useFetchUserCollabDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserCollabDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserCollabDevicesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserCollabDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<FetchUserCollabDevicesQuery, FetchUserCollabDevicesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<FetchUserCollabDevicesQuery, FetchUserCollabDevicesQueryVariables>(
    FetchUserCollabDevicesDocument,
    options
  )
}
export function useFetchUserCollabDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FetchUserCollabDevicesQuery, FetchUserCollabDevicesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<FetchUserCollabDevicesQuery, FetchUserCollabDevicesQueryVariables>(
    FetchUserCollabDevicesDocument,
    options
  )
}
export type FetchUserCollabDevicesQueryHookResult = ReturnType<typeof useFetchUserCollabDevicesQuery>
export type FetchUserCollabDevicesLazyQueryHookResult = ReturnType<typeof useFetchUserCollabDevicesLazyQuery>
export type FetchUserCollabDevicesQueryResult = Apollo.QueryResult<
  FetchUserCollabDevicesQuery,
  FetchUserCollabDevicesQueryVariables
>
export const ResetSubscriberQuotasDocument = gql`
  mutation resetSubscriberQuotas($resetSubscriberQuotasParams: ResetSubscriberQuotasParams!) {
    resetSubscriberQuotas(resetSubscriberQuotasParams: $resetSubscriberQuotasParams) {
      usage {
        hasExceededLearnQuotaUsage
        quotaUsagePercentage
      }
      quotaWindowStart
      counts {
        quizCount
        summaryCount
      }
      calculation {
        mode
        cost {
          used
          limit
          hasExceededLearnQuotaUsage
          quotaUsagePercentage
        }
        questions {
          used
          limit
          hasExceededLearnQuotaUsage
          quotaUsagePercentage
        }
      }
    }
  }
`
export type ResetSubscriberQuotasMutationFn = Apollo.MutationFunction<
  ResetSubscriberQuotasMutation,
  ResetSubscriberQuotasMutationVariables
>

/**
 * __useResetSubscriberQuotasMutation__
 *
 * To run a mutation, you first call `useResetSubscriberQuotasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSubscriberQuotasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSubscriberQuotasMutation, { data, loading, error }] = useResetSubscriberQuotasMutation({
 *   variables: {
 *      resetSubscriberQuotasParams: // value for 'resetSubscriberQuotasParams'
 *   },
 * });
 */
export function useResetSubscriberQuotasMutation(
  baseOptions?: Apollo.MutationHookOptions<ResetSubscriberQuotasMutation, ResetSubscriberQuotasMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ResetSubscriberQuotasMutation, ResetSubscriberQuotasMutationVariables>(
    ResetSubscriberQuotasDocument,
    options
  )
}
export type ResetSubscriberQuotasMutationHookResult = ReturnType<typeof useResetSubscriberQuotasMutation>
export type ResetSubscriberQuotasMutationResult = Apollo.MutationResult<ResetSubscriberQuotasMutation>
export type ResetSubscriberQuotasMutationOptions = Apollo.BaseMutationOptions<
  ResetSubscriberQuotasMutation,
  ResetSubscriberQuotasMutationVariables
>
export const AddSubscriberQuotaDummyUsageDocument = gql`
  mutation addSubscriberQuotaDummyUsage($addSubscriberQuotaDummyUsageParams: AddSubscriberQuotaDummyUsageParams!) {
    addSubscriberQuotaDummyUsage(addSubscriberQuotaDummyUsageParams: $addSubscriberQuotaDummyUsageParams) {
      usage {
        hasExceededLearnQuotaUsage
        quotaUsagePercentage
      }
      quotaWindowStart
      counts {
        quizCount
        summaryCount
      }
      calculation {
        mode
        cost {
          used
          limit
          hasExceededLearnQuotaUsage
          quotaUsagePercentage
        }
        questions {
          used
          limit
          hasExceededLearnQuotaUsage
          quotaUsagePercentage
        }
      }
    }
  }
`
export type AddSubscriberQuotaDummyUsageMutationFn = Apollo.MutationFunction<
  AddSubscriberQuotaDummyUsageMutation,
  AddSubscriberQuotaDummyUsageMutationVariables
>

/**
 * __useAddSubscriberQuotaDummyUsageMutation__
 *
 * To run a mutation, you first call `useAddSubscriberQuotaDummyUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriberQuotaDummyUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriberQuotaDummyUsageMutation, { data, loading, error }] = useAddSubscriberQuotaDummyUsageMutation({
 *   variables: {
 *      addSubscriberQuotaDummyUsageParams: // value for 'addSubscriberQuotaDummyUsageParams'
 *   },
 * });
 */
export function useAddSubscriberQuotaDummyUsageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSubscriberQuotaDummyUsageMutation,
    AddSubscriberQuotaDummyUsageMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AddSubscriberQuotaDummyUsageMutation, AddSubscriberQuotaDummyUsageMutationVariables>(
    AddSubscriberQuotaDummyUsageDocument,
    options
  )
}
export type AddSubscriberQuotaDummyUsageMutationHookResult = ReturnType<typeof useAddSubscriberQuotaDummyUsageMutation>
export type AddSubscriberQuotaDummyUsageMutationResult = Apollo.MutationResult<AddSubscriberQuotaDummyUsageMutation>
export type AddSubscriberQuotaDummyUsageMutationOptions = Apollo.BaseMutationOptions<
  AddSubscriberQuotaDummyUsageMutation,
  AddSubscriberQuotaDummyUsageMutationVariables
>
export const GetSubscriptionDisputeInfoDocument = gql`
  query getSubscriptionDisputeInfo($getSubscriptionDisputeInfoParams: GetSubscriptionDisputeInfoParams!) {
    getSubscriptionDisputeInfo(getSubscriptionDisputeInfoParams: $getSubscriptionDisputeInfoParams) {
      query
      stripeSubscriptionId
      stripeLookupError
      warnings {
        severity
        message
      }
      stripe {
        stripeSubscriptionId
        status
        tier
        stripePriceId
        stripeProductId
        stripeProductName
        stripeCustomerId
        customerEmail
        customerName
        createdAt
        startDate
        currentPeriodEnd
        cancelAt
        canceledAt
        endedAt
        trialEnd
        collectionMethod
        latestInvoiceId
        dashboardSubscriptionUrl
        dashboardCustomerUrl
      }
      database {
        id
        status
        tier
        stripeSubscriptionId
        stripePriceId
        stripeProductId
        subscriptionRenewalDate
        trialEndAt
        cancelAt
        canceledAt
        endedAt
        createdAt
        updatedAt
      }
      owner {
        ...subscriptionDisputeUser
      }
      relatedUsers {
        ...subscriptionDisputeUser
      }
      auditRows {
        id
        type
        createdAt
        changes {
          field
          oldValue
          newValue
        }
      }
    }
  }
  ${SubscriptionDisputeUserFragmentDoc}
`

/**
 * __useGetSubscriptionDisputeInfoQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionDisputeInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionDisputeInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionDisputeInfoQuery({
 *   variables: {
 *      getSubscriptionDisputeInfoParams: // value for 'getSubscriptionDisputeInfoParams'
 *   },
 * });
 */
export function useGetSubscriptionDisputeInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetSubscriptionDisputeInfoQuery, GetSubscriptionDisputeInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetSubscriptionDisputeInfoQuery, GetSubscriptionDisputeInfoQueryVariables>(
    GetSubscriptionDisputeInfoDocument,
    options
  )
}
export function useGetSubscriptionDisputeInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionDisputeInfoQuery, GetSubscriptionDisputeInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetSubscriptionDisputeInfoQuery, GetSubscriptionDisputeInfoQueryVariables>(
    GetSubscriptionDisputeInfoDocument,
    options
  )
}
export type GetSubscriptionDisputeInfoQueryHookResult = ReturnType<typeof useGetSubscriptionDisputeInfoQuery>
export type GetSubscriptionDisputeInfoLazyQueryHookResult = ReturnType<typeof useGetSubscriptionDisputeInfoLazyQuery>
export type GetSubscriptionDisputeInfoQueryResult = Apollo.QueryResult<
  GetSubscriptionDisputeInfoQuery,
  GetSubscriptionDisputeInfoQueryVariables
>
export const SearchSubscriptionDisputesDocument = gql`
  query searchSubscriptionDisputes($searchSubscriptionDisputesParams: SearchSubscriptionDisputesParams!) {
    searchSubscriptionDisputes(searchSubscriptionDisputesParams: $searchSubscriptionDisputesParams) {
      query
      warnings {
        severity
        message
      }
      matches {
        stripeSubscriptionId
        status
        tier
        stripeCustomerId
        createdAt
        matchReasons
      }
    }
  }
`

/**
 * __useSearchSubscriptionDisputesQuery__
 *
 * To run a query within a React component, call `useSearchSubscriptionDisputesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSubscriptionDisputesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSubscriptionDisputesQuery({
 *   variables: {
 *      searchSubscriptionDisputesParams: // value for 'searchSubscriptionDisputesParams'
 *   },
 * });
 */
export function useSearchSubscriptionDisputesQuery(
  baseOptions: Apollo.QueryHookOptions<SearchSubscriptionDisputesQuery, SearchSubscriptionDisputesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SearchSubscriptionDisputesQuery, SearchSubscriptionDisputesQueryVariables>(
    SearchSubscriptionDisputesDocument,
    options
  )
}
export function useSearchSubscriptionDisputesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchSubscriptionDisputesQuery, SearchSubscriptionDisputesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SearchSubscriptionDisputesQuery, SearchSubscriptionDisputesQueryVariables>(
    SearchSubscriptionDisputesDocument,
    options
  )
}
export type SearchSubscriptionDisputesQueryHookResult = ReturnType<typeof useSearchSubscriptionDisputesQuery>
export type SearchSubscriptionDisputesLazyQueryHookResult = ReturnType<typeof useSearchSubscriptionDisputesLazyQuery>
export type SearchSubscriptionDisputesQueryResult = Apollo.QueryResult<
  SearchSubscriptionDisputesQuery,
  SearchSubscriptionDisputesQueryVariables
>
